import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // ── New UI chrome keys (round: rest day, biometric, share, country picker) ──
      'home.totalWorkouts': 'Total Workouts',
      'restDay.title': 'Rest Day',
      'restDay.empty': 'Complete a workout to track recovery',
      'restDay.today': 'Trained today. Recover well.',
      'restDay.rested': "You're recovered — keep the momentum.",
      'restDay.recommendRest': 'High weekly load — consider resting today.',
      'restDay.recommendTrain': 'Well rested — ready to train.',
      'restDay.daysSince_one': '{{count}} day since',
      'restDay.daysSince_other': '{{count}} days since',
      'biometric.noData': 'no data',
      'biometric.connectWearable': 'Connect a wearable for live data',
      'workout.shareUnavailable': 'Sharing is not available on this device.',
      'workout.shareFailed': 'Could not share right now. Please try again.',
      'country.TR': 'Turkey',
      'country.US': 'United States',
      'country.RU': 'Russia',
      'country.DE': 'Germany',
      'country.GB': 'United Kingdom',
      'country.FR': 'France',
      'country.ES': 'Spain',
      'country.IT': 'Italy',
      'country.NL': 'Netherlands',
      'country.SA': 'Saudi Arabia',
      'country.AE': 'United Arab Emirates',
      'country.EG': 'Egypt',
      'country.ID': 'Indonesia',
      'country.KR': 'South Korea',
      'country.JP': 'Japan',
      'country.CN': 'China',
      'country.IN': 'India',
      'country.BR': 'Brazil',
      'country.MX': 'Mexico',
      'country.CA': 'Canada',
      'country.AU': 'Australia',
      'country.NZ': 'New Zealand',
      'country.ZA': 'South Africa',
      'country.SE': 'Sweden',
      'country.NO': 'Norway',
      'country.DK': 'Denmark',
      'country.FI': 'Finland',
      'country.CH': 'Switzerland',
      'country.BE': 'Belgium',
      'country.AT': 'Austria',
      'profile.dayStreak': 'day streak',
      'profile.companionAlt': 'Your companion',
      'profile.ninetyDayActivity': '90-Day Activity',
      'profile.restDay': 'Rest day',
      'profile.viewAllRecordsAria': 'View all personal records',
      'profile.copyLinkAria': 'Copy referral link',
      'profile.shareAria': 'Share referral link',
      'referral.tagline': '1 month Pro — for you and your friend',
      'referral.noLimit': 'No limit — refer as many as you like',
      'shop.celliva.bestSellers': 'Best Sellers',
      'shop.celliva.featuredTitle': 'Protocol Essentials',
      'shop.celliva.benefits': 'Benefits',
      'shop.celliva.pairsWith': 'How it fits your goals',
      'shop.celliva.added': 'Added to cart!',
      'shop.celliva.cartTitle': 'Your Cart',
      'shop.celliva.items': 'items',
      'shop.celliva.clearCart': 'Clear all',
      'shop.celliva.emptyCartTitle': 'Cart is empty',
      'shop.celliva.emptyCartDesc': 'Add supplements from the catalog to build your protocol.',
      'shop.celliva.browseCatalog': 'Browse Catalog',
      'shop.celliva.subtotal': 'Subtotal',
      'shop.celliva.fulfillmentNote': 'Fulfilled by Celliva Life. Shipping calculated at checkout.',
      'shop.celliva.viewCart': 'View Cart',
      'shop.celliva.remove': 'Remove',
      'shop.prev': 'Previous',
      'shop.next': 'Next',
      'avatar.rarityCommon': 'COMMON',
      'avatar.rarityRare': 'RARE',
      'avatar.rarityEpic': 'EPIC',
      'avatar.rarityLegendary': 'LEGENDARY',
      'avatar.pro': 'PRO',
      'avatar.saved': 'Saved!',
      'avatar.skin.default': 'Default',
      'avatar.skin.cyber': 'Cyber',
      'avatar.skin.neon': 'Neon',
      'avatar.skin.shadow': 'Shadow',
      'avatar.skin.gold': 'Gold',
      'avatar.outfit.basic': 'Basic Gear',
      'avatar.outfit.cyber': 'Cyber Suit',
      'avatar.outfit.runner': 'Neon Runner',
      'avatar.outfit.iron': 'Iron Armor',
      'avatar.acc.none': 'None',
      'avatar.acc.visor': 'Visor',
      'avatar.acc.earbuds': 'Earbuds',
      'avatar.acc.chain': 'Chain',
      'avatar.acc.halo': 'Halo',
      'coach.selectedLabel': 'SELECTED',
      'coach.selectLabel': 'Select',
      'coach.languageSection': 'COACH LANGUAGE',
      'coach.languageLabel': 'Select language',
      'coach.languageHint': 'Voice phrases play in the selected language',
      'workout.exerciseOf': 'Exercise {{current}} of {{total}}',
      'workout.paused': 'Paused',
      'workout.endSessionSub': 'Progress will be saved up to this point.',
      'workout.keepGoing': 'Keep going',
      'workout.endNow': 'End now',
      'workout.repsLabel': 'reps',
      'workout.next': 'Next',
      'workout.strainElite': 'Elite effort',
      'workout.strainHard': 'Hard session',
      'workout.strainModerate': 'Solid work',
      'workout.selectLevel': 'Select level',
      'common.error_title': 'Something went wrong',
      'common.error_description': 'Please try again.',
      'common.network_error': 'No connection',
      'oracle.subtitle': 'AI Food Scanner & Tracker',
      'oracle.emptyTitle': 'AI Food Scanner',
      'oracle.emptyDesc': 'Point your camera at any meal. Instant macro breakdown in seconds.',
      'oracle.scanningSubtitle': 'Analyzing with Gemini Vision',
      'oracle.confidence': 'Confidence',
      'oracle.detectedItems': 'Detected Items',
      'oracle.macroBreakdown': 'Macro Breakdown',
      'oracle.limitReached': 'Limit Reached',
      'oracle.proUnlimited': 'Pro Unlimited',
      'oracle.proDesc': 'Unlimited scans + meal plans + AI coaching',
      'oracle.kcalRemaining': '{{n}} kcal remaining',
      'oracle.goalReached': 'Goal reached!',
      'calendar.streakDays': '{{n}}-day streak',
      'calendar.april2026': 'April 2026',
      'calendar.prevMonth': 'Previous month',
      'calendar.nextMonth': 'Next month',
      'login.tagline': 'YOUR LONGEVITY STARTS HERE',
      'login.otpHint': 'Enter the 6-digit code below',
      'login.connecting': 'Connecting...',
      'login.connectingLongevity': 'Connecting to Longevity OS...',
      'login.continueLongevity': 'Continue with Omnisio Longevity ID',
      'paywall.paymentMethod': 'Payment Method',
      'social.timeMin': '{{n}}m ago',
      'social.timeHour': '{{n}}h ago',
      'social.timeDay': '{{n}}d ago',
      'syndicates.joined': 'Joined',
      'syndicates.joinToChat': 'Join to unlock clan chat',
      'syndicates.requirement': 'Min. {{xp}} XP to join',
      'syndicates.teamChallenges': 'Team Challenges',
      'syndicates.myClan': 'My Syndicate',
      'syndicates.discover': 'Discover',
      'syndicates.createTitle': 'Create Syndicate',
      'biohacks.challenges': 'Challenges',
      'biohacks.activeChallenges': 'Active — {{n}}',
      'biohacks.availableChallenges': 'Available',
      'biohacks.completedChallenges': 'Completed',
      'biohacks.joinChallenge': 'Join',
      'biohacks.claimReward': 'Claim +{{reward}} XP',
      'memory.tabNEW': 'New',
      'memory.tabMY': 'My',
      'memory.tabTOP': 'Top',
      'memory.tabCORE': 'Core',
      'nav.progress': 'Progress',
      'home.defaultName': 'Athlete',
      'home.greetingSub': 'Your body. Your goals.',
      'home.greetingSub2': "Let's build something stronger today.",
      'home.energyScore': 'Energy Score',
      'home.companionLabel': 'Companion',
      'home.companionTagline': 'Here to coach. Here to support.',
      'home.companion.phoenix': 'Omni',
      'home.companion.bonsai': 'Sage',
      'home.companion.orb': 'Orb',
      'home.companion.avatar': 'Titan',
      'home.companion.avatar_female': 'Luna',
      'home.moodHigh': 'High',
      'home.moodGood': 'Good',
      'home.moodFair': 'Fair',
      'home.moodLow': 'Low',
      'home.moodHighSub': "You're ready to perform.",
      'home.moodGoodSub': 'Solid base — keep pushing.',
      'home.moodFairSub': 'Warm up easy today.',
      'home.moodLowSub': 'Prioritize recovery.',
      'home.recommendedForYou': 'Recommended for You',
      'home.aiRecommended': 'AI Recommended',
      'home.recTitle': 'Strength & Balance',
      'home.recSub': 'Build power. Improve control.',
      'home.dayStreak': 'Day Streak',
      'home.workoutsThisWeek': 'Workouts This Week',
      'home.badgesEarned': 'Badges Earned',
      'workout.level.intermediate': 'Intermediate',
      'progress.title': 'Progress',
      'progress.level': 'Level {{level}}',
      'progress.stage1': 'Spark Form',
      'progress.stage2': 'Awakened Form',
      'progress.stage3': 'Evolved Form',
      'progress.stage4': 'Ascended Form',
      'progress.stage5': 'Elemental Form',
      'progress.stage6': 'Mythic Form',
      'progress.stage7': 'Transcendent Form',
      'progress.rarityCommon': 'COMMON',
      'progress.rarityRare': 'RARE',
      'progress.rarityEpic': 'EPIC',
      'progress.rarityLegendary': 'LEGENDARY',
      'progress.stageChip': '{{stage}}. Evolution Stage',
      'progress.dayStreakInline': '{{count}} day streak',
      'progress.streakSub': 'Keep it burning!',
      'progress.xpProgress': 'XP Progress',
      'progress.nextStage': 'Next Stage: Stage {{stage}} - {{name}}',
      'progress.dayStreak': 'Day Streak',
      'progress.workouts': 'Workouts',
      'progress.stagesReached': 'Stages Reached',
      'progress.achievements': 'Achievements',
      'progress.viewAll': 'View All',
      'progress.achievement.discipline': 'Discipline',
      'progress.achievement.consistency': 'Consistency',
      'progress.achievement.endurance': 'Endurance',
      'progress.achievement.resilience': 'Resilience',
      'progress.achievement.days': 'Days',
      'progress.achievement.workouts': 'Workouts',
      'paywall.disclosureTitle': 'Subscription Terms',
      'paywall.disclosureLength': 'Subscription auto-renews monthly or yearly until canceled',
      'paywall.disclosurePrice': 'Charged to your Apple ID at the price shown above',
      'paywall.disclosureRenewal': 'Auto-renews within 24 hours before the period ends unless turned off',
      'paywall.disclosureCancel': 'Manage or cancel anytime in iPhone Settings → Apple ID → Subscriptions',
      'paywall.disclosureRefund': 'No refund for the unused portion of the current period',
      'paywall.legalFooter': 'Subscription managed via Apple ID. Cancel anytime in iPhone Settings.',
      'profile.editTitle': 'Edit Profile',
      'profile.firstName': 'First Name',
      'profile.firstNamePh': 'Your first name',
      'profile.lastName': 'Last Name',
      'profile.lastNamePh': 'Your last name',
      'profile.displayName': 'Display Name',
      'profile.displayNamePh': 'How others see you',
      'profile.email': 'Email',
      'profile.publicId': 'Public ID',
      'common.cancel': 'Cancel',
      'common.save': 'Save',
      'common.saving': 'Saving…',
      'coach.active': 'ACTIVE',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'Step count + active energy',
      'coach.tab.voice': 'Voice',
      'coach.tab.soundscape': 'Soundscape',
      'coach.tab.music': 'Music',
      'coach.sample.workoutStart': 'Pre-workout',
      'coach.sample.setComplete': 'Set complete',
      'coach.sample.halfway': 'Halfway motivation',
      'coach.sample.finalSet': 'Final set push',
      'coach.sample.workoutDone': 'Workout done',
      'coach.soundscape.focus': 'Focus',
      'coach.soundscape.focusDesc': 'Deep alpha waves for laser focus',
      'coach.soundscape.cardio': 'Cardio Boost',
      'coach.soundscape.cardioDesc': 'High BPM pulses to push harder',
      'coach.soundscape.recovery': 'Recovery',
      'coach.soundscape.recoveryDesc': 'Soothing tones for muscle repair',
      'coach.soundscape.sleep': 'Sleep Prep',
      'coach.soundscape.sleepDesc': 'Delta wave drift for deep rest',
      'coach.service.spotify.desc': 'Beast Mode Workout',
      'coach.service.applemusic.desc': 'Pure Pump',
      'coach.service.ytmusic.desc': 'Workout Playlist',
      'coach.companion.phoenix.name': 'Phoenix',
      'coach.companion.phoenix.desc': 'Epic, motivational',
      'coach.companion.bonsai.name': 'Bonsai',
      'coach.companion.bonsai.desc': 'Calm, mindful',
      'coach.companion.orb.name': 'Energy Orb',
      'coach.companion.orb.desc': 'Futuristic, robotic',
      'coach.companion.avatar.name': 'Warrior',
      'coach.companion.avatar.desc': 'Strong, intense',
      'coach.companion.avatar_female.name': 'Goddess',
      'coach.companion.avatar_female.desc': 'Empowering, warm',
      'coach.musicTitle': 'WORKOUT PLAYLISTS',
      'coach.openIn': 'Open',
      'coach.play': 'Play',
      'coach.playing': 'Playing',
      'biometric.insufficientScope': 'Missing permissions',
      'biometric.missingScopes': 'Missing: {{scopes}}',
      'biometric.grantScopesCta': 'Grant',
      'biometric.rateLimited': 'Rate limit — retry in {{seconds}}s',
      'common.continue': 'Continue',
      'onboarding.goalTitle': "What's your goal?",
      'onboarding.goalSubtitle': 'Choose your primary goal',
      'onboarding.goal.cut': 'Cut',
      'onboarding.goal.cutSub': 'Lose fat, get leaner',
      'onboarding.goal.bulk': 'Bulk',
      'onboarding.goal.bulkSub': 'Gain muscle & strength',
      'onboarding.goal.maintain': 'Maintain',
      'onboarding.goal.maintainSub': 'Keep current physique',
      'onboarding.awakeningTitle': "You're ready",
      'onboarding.awakeningSubtitle': 'What should we call you?',
      'onboarding.namePlaceholder': 'Your name or nickname',
      'onboarding.getStarted': 'Get started',
      'sport.bench_press.name': 'Bench Press',
      'sport.lunges.name': 'Lunges',
      'sport.jumping_rope.name': 'Jumping Rope',
      'sport.kickboxing.name': 'Kickboxing',
      'sport.volleyball.name': 'Volleyball',
      'sport.ice_skating.name': 'Ice Skating',
      'sport.crossfit_wod.name': 'CrossFit WOD',
      'sport.foam_rolling.name': 'Foam Rolling',
      'sport.mobility_flow.name': 'Mobility Flow',
      'common.skip': 'Skip',
      'common.next': 'Next',
      'onboarding.injuryTitle': 'Any injuries?',
      'onboarding.injurySubtitle': "We'll adapt workouts to avoid stress on these areas. Optional.",
      'onboarding.injuryNoneSelected': 'No injuries selected — full intensity workouts',
      'onboarding.injuryCount_one': '{{count}} area protected',
      'onboarding.injuryCount_other': '{{count}} areas protected',
      'onboarding.injuries.neck': 'Neck',
      'onboarding.injuries.shoulders': 'Shoulders',
      'onboarding.injuries.lowerBack': 'Lower back',
      'onboarding.injuries.elbows': 'Elbows',
      'onboarding.injuries.wrists': 'Wrists',
      'onboarding.injuries.hips': 'Hips',
      'onboarding.injuries.knees': 'Knees',
      'onboarding.injuries.ankles': 'Ankles',
      'common.back': 'Back',
      'common.gotIt': 'Got it',
      'leaderboard.title': 'Leaderboard',
      'leaderboard.global': 'Global',
      'leaderboard.friends': 'Friends',
      'leaderboard.weekly': 'Weekly',
      'leaderboard.you': 'You',
      'leaderboard.energy': 'Energy',
      'leaderboard.howItWorks': 'How it works',
      'leaderboard.noFriends': 'No friends yet',
      'leaderboard.noFriendsDesc': 'Invite friends to compete',
      'leaderboard.rule1Title': 'Earn Energy',
      'leaderboard.rule1': 'Complete workouts to earn Energy. Higher difficulty + longer streaks = more Energy.',
      'leaderboard.rule2Title': 'Three boards',
      'leaderboard.rule2': 'Global ranks everyone, Friends only your follows, Weekly resets every Monday.',
      'leaderboard.rule3Title': 'Decay rule',
      'leaderboard.rule3': 'Energy decays 5% per inactive day — consistency beats burst.',
      'leaderboard.rule4Title': 'Rewards',
      'leaderboard.rule4': 'Top 3 of each board unlock gold/silver/bronze profile frames.',
      'referral.title': 'Refer & earn',
      'referral.description': 'Invite a friend — they get 1 month free, you get 1 month free. No limit.',
      'referral.yourId': 'Your ID',
      'referral.reward': 'Reward',
      'referral.daysFree': 'days free',
      'referral.copy': 'Copy',
      'referral.copied': 'Copied',
      'referral.share': 'Share',
      'referral.shareTitle': 'Try Omnisio Workout',
      'referral.shareText': 'Join me on Omnisio Workout — we both get 1 month of Pro free.',
      'referral.activeStatus': 'Pro active until',
      'oracle.recentMeals': 'Recent Meals',
      'oracle.entryCount_one': '{{count}} entry',
      'oracle.entryCount_other': '{{count}} entries',
      'oracle.noScans': 'No scans yet',
      'oracle.noScansDesc': 'Tap Scan to track your first meal',
      'oracle.scanNow': 'Scan now',
      'oracle.todaysTotal': "Today's Total",
      'oracle.kcal': 'kcal',
      'oracle.macro.protein': 'Protein',
      'oracle.macro.carbs': 'Carbs',
      'oracle.macro.fat': 'Fat',
      'oracle.macro.calories': 'Calories',
      'oracle.meal.breakfast': 'Breakfast',
      'oracle.meal.lunch': 'Lunch',
      'oracle.meal.dinner': 'Dinner',
      'oracle.meal.snack': 'Snack',
      'sport.pushups.name': 'Push-Ups',
      'sport.squats.name': 'Squats',
      'sport.plank.name': 'Plank',
      'sport.running.name': 'Running',
      'sport.yoga.name': 'Yoga',
      'sport.boxing.name': 'Boxing',
      'sport.cycling.name': 'Cycling',
      'sport.swimming.name': 'Swimming',
      'sport.basketball.name': 'Basketball',
      'sport.skiing.name': 'Skiing',
      'sport.pullups.name': 'Pull-Ups',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'Tennis',
      'sport.deadlift.name': 'Deadlift',
      'sport.pilates.name': 'Pilates',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'Rowing',
      'sport.dance.name': 'Dance Fitness',
      'sport.stretching.name': 'Stretching',
      'sport.kettlebell.name': 'Kettlebell',
      'sport.football.name': 'Football',
      'workout.cat.all': 'ALL',
      'workout.cat.strength': 'STRENGTH',
      'workout.cat.cardio': 'CARDIO',
      'workout.cat.flexibility': 'FLEXIBILITY',
      'workout.cat.combat': 'COMBAT',
      'workout.cat.team': 'TEAM',
      'workout.cat.winter': 'WINTER',
      'workout.cat.functional': 'FUNCTIONAL',
      'workout.noEquipment': 'No equipment',
      'workout.instructions': 'Instructions',
      'workout.commonMistakes': 'Common Mistakes',
      'workout.easier': 'Easier',
      'workout.harder': 'Harder',
      'workout.repsCount_one': '{{count}} rep',
      'workout.repsCount_other': '{{count}} reps',
      'workout.countSports_one': '{{count}} sport',
      'workout.countSports_other': '{{count}} sports',
      'workout.noSports': 'No sports found',
      'settings.general': 'General',
      'settings.proActive': 'Pro Active',
      'settings.freeTrial': 'Free Trial',
      'settings.allUnlocked': 'All features unlocked',
      'settings.upgradeFull': 'Upgrade for full access',
      'settings.upgrade': 'Upgrade',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Data Sync',
      'settings.dataSyncDesc': 'Sync health data with Omnisio ecosystem',
      'settings.logout': 'Log Out',
      // App
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Your Complete Workout Companion',

      // Navigation
      'nav.home': 'Home',
      'nav.workout': 'Workout',
      'nav.nutri': 'Nutri',
      'nav.history': 'History',
      'nav.memory': 'Memory',
      'nav.radio': 'Radio',
      'nav.shop': 'Shop',
      'nav.profile': 'Profile',
      'nav.more': 'More',
      'nav.coach': 'Coach',

      // Home
      'home.welcome': 'Welcome, {{name}}',
      'home.dailyEnergy': 'Daily Energy',
      'home.startWorkout': 'Start Workout',
      'home.yourTotem': 'Your Mascot',
      'home.todaysMissions': "Today's Goals",
      'home.leaderboard': 'Leaderboard',
      'home.syndicates': 'Teams',
      'home.biohacks': 'Challenges',

      // Energy
      'energy.exercise': 'Exercise',
      'energy.music': 'Music',
      'energy.total': 'Total Energy',
      'energy.streak': '{{count}} day streak',
      'energy.streakFire': 'Streak',

      // Workout
      'workout.title': 'Workout',
      'workout.camera': 'Camera Tracking',
      'workout.startSession': 'Start Session',
      'workout.endSession': 'End Session',
      'workout.reps': 'Reps',
      'workout.calories': 'Calories',
      'workout.duration': 'Duration',
      'workout.exerciseComplete': 'Exercise Complete!',
      'workout.energyEarned': '+{{amount}} Energy',
      'workout.plank': 'Plank',
      'workout.pushups': 'Push-ups',
      'workout.squats': 'Squats',
      'workout.overview': 'Overview',
      'workout.history': 'History',
      'workout.progress': 'Progress',
      'workout.personalRecords': 'Personal Records',
      'workout.share': 'Share',
      'workout.done': 'Done',

      // Oracle / Nutri Vision
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Scan Food',
      'oracle.history': 'Scan History',
      'oracle.scanning': 'Analyzing...',
      'oracle.dailyNorm': 'Daily Norm',
      'oracle.scansLeft': '{{count}} scans left',
      'oracle.upgrade': 'Upgrade for unlimited',
      'oracle.protein': 'Protein',
      'oracle.carbs': 'Carbs',
      'oracle.fat': 'Fat',
      'oracle.calories': 'Calories',

      // Memory
      'memory.title': 'Memory',
      'memory.upload': 'Upload Memory',
      'memory.stake': 'Stake Energy',
      'memory.network': 'Global Proof-of-Energy Network',

      // Calendar / History
      'calendar.title': 'History',
      'calendar.fitness': 'Fitness',
      'calendar.nutrition': 'Nutrition',
      'calendar.protocols': 'Protocols',

      // Shop
      'shop.title': 'Shop',
      'shop.avatars': 'Avatars',
      'shop.boosters': 'Boosters',
      'shop.cosmetics': 'Cosmetics',
      'shop.buy': 'Buy',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Owned',
      'shop.equipped': 'Equipped',

      // Profile
      'profile.title': 'Profile',
      'profile.level': 'Level {{level}}',
      'profile.totalWorkouts': 'Total Workouts',
      'profile.totalTokens': 'Total Tokens',
      'profile.achievements': 'Achievements',
      'profile.settings': 'Settings',
      'profile.totem': 'Mascot',

      // Leaderboard
      'leaderboard.title': 'Leaderboard',
      'leaderboard.global': 'Global',
      'leaderboard.syndicate': 'Team',
      'leaderboard.weekly': 'Weekly',
      'leaderboard.allTime': 'All Time',
      'leaderboard.rank': 'Rank',

      // Syndicates/Teams
      'syndicates.title': 'Teams',
      'syndicates.join': 'Join',
      'syndicates.create': 'Create Team',
      'syndicates.members': '{{count}} members',
      'syndicates.power': 'Power',

      // Biohacks/Challenges
      'biohacks.title': 'Challenges',
      'biohacks.protocols': 'Programs',
      'biohacks.missions': 'Goals',
      'biohacks.active': 'Active',
      'biohacks.completed': 'Completed',
      'biohacks.reward': 'Reward: {{amount}} TKN',

      // Avatar
      'avatar.title': 'Avatar',
      'avatar.customize': 'Customize',
      'avatar.skin': 'Skin',
      'avatar.outfit': 'Outfit',
      'avatar.accessories': 'Accessories',
      'avatar.save': 'Save',

      // Radio
      'radio.title': 'Gym Radio',
      'radio.nowPlaying': 'Now Playing',
      'radio.stations': 'Stations',
      'radio.energyBonus': '+Energy while listening',

      // Coach
      'coach.title': 'Coach',
      'coach.subtitle': 'Your AI fitness companion, in your ear',
      'coach.tabVoice': 'Voice',
      'coach.tabSoundscape': 'Soundscape',
      'coach.tabMusic': 'Music',
      'coach.chooseVoice': 'Choose your coach voice',
      'coach.samples': 'Listen to samples',
      'coach.samplePreWorkout': 'Pre-workout',
      'coach.sampleSetComplete': 'Set complete',
      'coach.sampleHalfway': 'Halfway',
      'coach.sampleFinalSet': 'Final set',
      'coach.sampleWorkoutDone': 'Workout done',
      'coach.voiceCoachToggle': 'Voice coach during workouts',
      'coach.proRequired': 'Pro required to unlock all voices',
      'coach.upgrade': 'Upgrade',
      'coach.soundscapeFocus': 'Focus',
      'coach.soundscapeFocusDesc': 'Alpha waves for deep concentration',
      'coach.soundscapeCardio': 'Cardio Boost',
      'coach.soundscapeCardioDesc': 'High BPM ambient for running and HIIT',
      'coach.soundscapeRecovery': 'Recovery',
      'coach.soundscapeRecoveryDesc': 'Slow rhythm for cooldown and stretch',
      'coach.soundscapeSleep': 'Sleep Prep',
      'coach.soundscapeSleepDesc': 'Pink noise and nature sounds',
      'coach.soundscapeComingSoon': 'Coming soon',
      'coach.musicHeader': 'Open your favorite music app',
      'coach.musicSpotify': 'Open in Spotify',
      'coach.musicApple': 'Open in Apple Music',
      'coach.musicYoutube': 'Open in YouTube Music',
      'coach.workoutPlaylist': 'Workout playlist',

      // Settings
      'settings.title': 'Settings',
      'settings.language': 'Language',
      'settings.notifications': 'Notifications',
      'settings.sound': 'Sound',
      'settings.haptics': 'Haptics',
      'settings.about': 'About',
      'settings.version': 'Version',
      'settings.aiEngine': 'AI Engine',
      'settings.wearables': 'Bio-Wearables',
      'settings.bioWearables': 'Bio-Wearables',
      'settings.omnisioBand': 'Omnisio Band',
      'settings.omnisioBandDesc': 'Native SDK · Real-time biometrics',
      'settings.omnisioRing': 'Omnisio Ring',
      'settings.omnisioRingDesc': 'Native SDK · 7-day battery, sleep + HRV',
      'settings.thirdPartySync': 'Third-party · Connect to sync',
      'settings.dataSync': 'Data Sync',
      'settings.upgrade': 'Upgrade',
      'settings.logout': 'Log Out',

      // Onboarding
      'onboarding.welcome': 'Welcome to Omnisio Workout',
      'onboarding.subtitle': 'Your private group fitness journey starts here',
      'onboarding.selectExercise': 'Choose your first exercise',
      'onboarding.pushups': 'Push-ups',
      'onboarding.squats': 'Squats',
      'onboarding.getStarted': 'Get Started',
      'onboarding.skip': 'Skip',

      // Common
      'common.loading': 'Loading...',
      'common.error': 'Something went wrong',
      'common.retry': 'Retry',
      'common.back': 'Back',
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.confirm': 'Confirm',
      'common.close': 'Close',
      'common.tokens': 'Tokens',
      'common.soon': 'Soon',
      'common.viewAll': 'View all',

      // Profile (extended)
      'profile.workouts': 'Workouts',
      'profile.hours': 'Hours',
      'profile.totalXP': 'Total XP',
      'profile.personalRecords': 'Personal Records',
      'profile.connectedServices': 'Connected Services',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Connected',
      'profile.connect': 'Connect',
      'profile.helpSupport': 'Help & Support',
      'profile.signOut': 'Sign Out',
      'profile.contactShipping': 'Contact & Shipping',
      'profile.complete': 'Complete',
      'profile.incompleteForOrders': 'Needed for supplement orders',
      'profile.email': 'Email',
      'profile.phone': 'Phone',
      'profile.address': 'Address',
      'profile.country': 'Country',
      'profile.addressPlaceholder': 'Street, City, Postal Code',
      'profile.privacyNote': 'Your contact info is stored locally and only shared with Celliva when you place an order. KVKK/GDPR compliant.',
      'profile.invalidEmail': 'Invalid email format',
      'profile.invalidPhone': 'Phone too short',
      'profile.invalidAddress': 'Address too short',

      // Achievements
      'achievements.firstWorkout': 'First Workout',
      'achievements.sevenDayStreak': '7-Day Streak',
      'achievements.plankMaster': 'Plank Master',
      'achievements.earlyBird': 'Early Bird',
      'achievements.perfectionist': 'Perfectionist',
      'achievements.hundredWorkouts': '100 Workouts',
      'achievements.marathon': 'Marathon',
      'achievements.nightOwl': 'Night Owl',

      // Shop (extended)
      'shop.subtitle': 'Unlock companions, boosters, and gear',
      'shop.tabCompanions': 'Companions',
      'shop.tabBoosters': 'Boosters',
      'shop.tabOutfits': 'Outfits',
      'shop.tabThemes': 'Themes',
      'shop.free': 'Free',
      'shop.levelRequired': 'Level {{level}} required',
      'shop.unlockFor': 'Unlock for {{price}} ⚡',
      'shop.insufficientXP': 'Insufficient XP ({{price}} ⚡ needed)',
      'shop.viewPack': 'View Pack',
      'shop.recentActivity': 'Recent activity',
      'shop.earnMoreXP': 'Earn more XP',
      'shop.completeWorkout': 'Complete a workout',
      'shop.startWorkout': 'Start Workout',
      'shop.tabSupplements': 'Supplements',
      'shop.poweredByCelliva': 'Powered by Celliva',
      'shop.cellivaTagline': 'Premium supplements · Free shipping over $50',
      'shop.buyOnCelliva': 'Buy on Celliva',
      'shop.supplementsHeader': 'Fuel your training',
      'shop.supplementsSubtitle': 'Lab-tested, third-party verified',

      // Game-store catalog (companions / boosters / outfits / themes)
      'shop.item.phoenix.name': 'Phoenix',
      'shop.item.phoenix.desc': 'Rises from ashes',
      'shop.item.phoenix.long': 'The immortal Phoenix has chosen you as its partner. Born from fire and reborn stronger each time, it fuels your drive to push past every limit.',
      'shop.item.phoenix.stat.0.label': 'Bonus XP',
      'shop.item.phoenix.stat.0.value': '+10% on all workouts',
      'shop.item.bonsai.name': 'Bonsai Tree',
      'shop.item.bonsai.desc': 'Grows with patience',
      'shop.item.bonsai.long': 'A living sculpture that mirrors your discipline. The Bonsai evolves as you build habits, rewarding consistency with rare visual upgrades.',
      'shop.item.bonsai.stat.0.label': 'Streak Bonus',
      'shop.item.bonsai.stat.0.value': '+15% after 7-day streak',
      'shop.item.orb.name': 'Energy Orb',
      'shop.item.orb.desc': 'Channel pure energy',
      'shop.item.orb.long': 'A sphere of condensed bio-energy that amplifies every rep you do. Pulses brighter the harder you train.',
      'shop.item.orb.stat.0.label': 'Energy Regen',
      'shop.item.orb.stat.0.value': '+5 Energy per workout',
      'shop.item.avatar.name': 'Warrior',
      'shop.item.avatar.desc': 'Forge your strength',
      'shop.item.avatar.long': 'A battle-hardened avatar that embodies peak physical potential. Unlocks special warrior challenge animations.',
      'shop.item.avatar.stat.0.label': 'Strength XP',
      'shop.item.avatar.stat.0.value': '+12% on strength sessions',
      'shop.item.avatar_female.name': 'Goddess',
      'shop.item.avatar_female.desc': 'Unleash your power',
      'shop.item.avatar_female.long': 'She channels the full spectrum of human potential — grace, endurance, and raw power. A mythic presence that elevates every session.',
      'shop.item.avatar_female.stat.0.label': 'All XP',
      'shop.item.avatar_female.stat.0.value': '+20% from every source',
      'shop.item.wolf.name': '???',
      'shop.item.wolf.desc': 'Coming soon',
      'shop.item.wolf.long': 'A creature of shadow and instinct. Reach Level 7 to unveil this companion.',
      'shop.item.xp_2x_24h.name': '2x XP for 24h',
      'shop.item.xp_2x_24h.desc': 'Double XP from all sources for 24 hours',
      'shop.item.xp_2x_24h.long': 'Every workout, habit check-in, and streak bonus is doubled for a full day. Stack with a workout session for maximum gains.',
      'shop.item.xp_2x_24h.stat.0.label': 'Effect',
      'shop.item.xp_2x_24h.stat.0.value': '2× XP multiplier',
      'shop.item.xp_2x_24h.stat.1.label': 'Duration',
      'shop.item.xp_2x_24h.stat.1.value': '24 hours',
      'shop.item.streak_freeze.name': 'Streak Freeze',
      'shop.item.streak_freeze.desc': 'Protect your streak for one missed day',
      'shop.item.streak_freeze.long': 'Life happens. A Streak Freeze preserves your hard-earned streak through one missed day — no questions asked.',
      'shop.item.streak_freeze.stat.0.label': 'Effect',
      'shop.item.streak_freeze.stat.0.value': 'Skip 1 day, streak intact',
      'shop.item.streak_freeze.stat.1.label': 'Uses',
      'shop.item.streak_freeze.stat.1.value': 'Single use',
      'shop.item.energy_boost.name': 'Instant +50 Energy',
      'shop.item.energy_boost.desc': 'Add 50 energy to today instantly',
      'shop.item.energy_boost.long': "A direct injection of 50 Energy points credited immediately to today's total.",
      'shop.item.energy_boost.stat.0.label': 'Effect',
      'shop.item.energy_boost.stat.0.value': '+50 Energy now',
      'shop.item.energy_boost.stat.1.label': 'Uses',
      'shop.item.energy_boost.stat.1.value': 'Single use',
      'shop.item.workout_quick.name': '5-min Energy Boost',
      'shop.item.workout_quick.desc': 'Skip warm-up, start fresh',
      'shop.item.workout_quick.long': 'Pre-activates your muscles digitally so you can jump straight into your workout at peak efficiency.',
      'shop.item.workout_quick.stat.0.label': 'Effect',
      'shop.item.workout_quick.stat.0.value': 'Skip warm-up phase',
      'shop.item.workout_quick.stat.1.label': 'Uses',
      'shop.item.workout_quick.stat.1.value': 'Single use',
      'shop.item.cyber.name': 'Cyber Skin',
      'shop.item.cyber.desc': 'Neon-lit companion outfit',
      'shop.item.cyber.long': "A futuristic neon-grid suit that wraps your companion in the aesthetic of tomorrow's athlete.",
      'shop.item.cyber.stat.0.label': 'Visual',
      'shop.item.cyber.stat.0.value': 'Neon glow + particle trail',
      'shop.item.royal.name': 'Royal Robe',
      'shop.item.royal.desc': 'Premium gold accents',
      'shop.item.royal.long': 'Draped in deep crimson with gold thread embroidery — reserved for champions who have earned the right to reign.',
      'shop.item.royal.stat.0.label': 'Visual',
      'shop.item.royal.stat.0.value': 'Gold shimmer aura',
      'shop.item.royal.stat.1.label': 'XP Aura',
      'shop.item.royal.stat.1.value': '+5% from streak days',
      'shop.item.minimal.name': 'Minimal',
      'shop.item.minimal.desc': 'Clean monochrome look',
      'shop.item.minimal.long': 'Less is more. A stripped-back monochrome outfit that lets your results do the talking.',
      'shop.item.minimal.stat.0.label': 'Visual',
      'shop.item.minimal.stat.0.value': 'Monochrome palette',
      'shop.item.cosmic.name': 'Cosmic',
      'shop.item.cosmic.desc': 'Stars and nebula effects',
      'shop.item.cosmic.long': 'Your companion becomes a galaxy in motion — swirling nebulas and star-field particles follow every move.',
      'shop.item.cosmic.stat.0.label': 'Visual',
      'shop.item.cosmic.stat.0.value': 'Galaxy particle system',
      'shop.item.midnight.name': 'Midnight',
      'shop.item.midnight.desc': 'Default dark theme',
      'shop.item.midnight.long': 'The classic Omnisio dark theme. Deep blacks and turquoise highlights — clinical, precise, powerful.',
      'shop.item.midnight.stat.0.label': 'Palette',
      'shop.item.midnight.stat.0.value': 'Black + turquoise',
      'shop.item.aurora.name': 'Aurora',
      'shop.item.aurora.desc': 'Northern lights gradient',
      'shop.item.aurora.long': 'Sweeping green-to-violet gradients inspired by the aurora borealis. A living sky overhead.',
      'shop.item.aurora.stat.0.label': 'Palette',
      'shop.item.aurora.stat.0.value': 'Emerald + violet',
      'shop.item.sunset.name': 'Sunset',
      'shop.item.sunset.desc': 'Warm gold + magenta',
      'shop.item.sunset.long': 'The last light of day — amber, gold, and deep magenta layered like a horizon on fire.',
      'shop.item.sunset.stat.0.label': 'Palette',
      'shop.item.sunset.stat.0.value': 'Gold + magenta',
      'shop.item.ocean.name': 'Ocean Depths',
      'shop.item.ocean.desc': 'Deep teal aesthetic',
      'shop.item.ocean.long': 'Dive into the abyss. Deep teal backgrounds with bioluminescent blue accents evoke the crushing quiet of the deep ocean.',
      'shop.item.ocean.stat.0.label': 'Palette',
      'shop.item.ocean.stat.0.value': 'Deep teal + blue',
      'shop.featuredPack.name': 'Spring Pack',
      'shop.featuredPack.tagline': 'Bundle of 3 items — save 40%',
      'shop.featuredPack.countdown': 'Ends in 3d 14h',
      'shop.featuredPack.item.0': 'Bonsai Tree',
      'shop.featuredPack.item.1': 'Aurora Theme',
      'shop.featuredPack.item.2': '2x XP for 24h',

      // Celliva Dispensary
      'shop.celliva.title': 'Celliva Dispensary',
      'shop.celliva.eyebrow': 'Autonomous Fulfillment',
      'shop.celliva.tabMarketplace': 'Marketplace',
      'shop.celliva.tabGameStore': 'Game Store',
      'shop.celliva.predictiveTitle': 'Predictive Engine',
      'shop.celliva.predictiveBody': 'Your {{product}} supply will deplete in {{days}} days.',
      'shop.celliva.authorizeDispatch': 'Authorize Dispatch',
      'shop.celliva.calibrationTitle': 'Protocol Calibration',
      'shop.celliva.calibrationQuestion': 'Did {{product}} improve your {{outcome}}?',
      'shop.celliva.calibrationYes': 'Yes — optimal',
      'shop.celliva.calibrationNo': 'No change',
      'shop.celliva.calibrationDismiss': 'Dismiss',
      'shop.celliva.calibrationThanks': 'Calibration recorded. Protocol refined.',
      'shop.celliva.closedLoopTitle': 'Closed-Loop Active',
      'shop.celliva.closedLoopBody': 'Biomarkers feed the dispensary. Reorders adjust to your data.',
      'shop.celliva.targetedInterventions': 'Targeted Interventions',
      'shop.celliva.viewDetails': 'Details',
      'shop.celliva.hideDetails': 'Hide details',
      'shop.celliva.dosage': 'Dosage',
      'shop.celliva.ingredients': 'Ingredients',
      'shop.celliva.studies': 'Clinical references',
      'shop.celliva.addToCart': 'Add to cart',
      'shop.celliva.inCart': 'In cart ({{qty}})',
      'shop.celliva.checkout': 'Checkout on Celliva',
      'shop.celliva.cartEmpty': 'Cart is empty',
      'shop.celliva.cartTotal': 'Total',
      'shop.celliva.catLongevity': 'Longevity',
      'shop.celliva.catCognitive': 'Cognitive',
      'shop.celliva.catRecovery': 'Recovery',
      'shop.celliva.catPerformance': 'Performance',
      'shop.celliva.catAll': 'All',
      'shop.celliva.downloadCatalog': 'Download catalog',
      'shop.celliva.bestseller': 'Bestseller',
      'shop.celliva.clinical': 'Clinical',
      'shop.celliva.verified': 'Lab verified',
      'shop.celliva.proRequired': 'Pro tier unlocks Smart Reorder and Calibration',
      'shop.celliva.eliteDnaBanner': 'Based on your APOE ε4 status, prioritized for cognitive support',
      'shop.celliva.kvkkNote': 'Your shipping data only leaves the device when you place an order on Celliva.life.',

      // Rarity
      'rarity.common': 'Common',
      'rarity.rare': 'Rare',
      'rarity.epic': 'Epic',
      'rarity.legendary': 'Legendary',

      // Memory (extended)
      'memory.community': 'Community',
      'memory.demoMode': 'Demo mode · Connect Supabase for real data',
      'memory.boost': 'Boost',
      'memory.boostXPNote': '+10 XP for posting energy',
      'memory.noPostsTitle': 'No posts yet',
      'memory.noPostsDesc': 'Be the first to share your workout',
      'memory.allCaughtUp': 'All caught up',

      // Calendar (extended)
      'calendar.history': 'History',
      'calendar.workouts': 'Workouts',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'Streak',
      'calendar.energy': 'Energy',
      'calendar.tabFitness': 'Fitness',
      'calendar.tabNutrition': 'Nutrition',
      'calendar.tabProtocols': 'Protocols',
      'calendar.restDay': 'Rest day',
      'calendar.restDayDesc': 'No activity recorded. Every champion needs recovery.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'CALORIE DEFICIT',
      'oracle.alertLowProtein': 'LOW PROTEIN ALERT',
      'oracle.alertPerfectDay': 'PERFECT DAY',
      'oracle.dailyCalories': 'Daily calories',
      'oracle.tabScan': 'Scan',
      'oracle.tabHistory': 'History',
      'oracle.tapToScan': 'Point camera at your food and tap the button below',
      'oracle.freeScans': '{{used}}/{{max}} free scans',
      'oracle.upgradePro': 'Upgrade Pro',
      'oracle.scanFood': 'Scan Food',
      'oracle.scanAgain': 'Scan Again',
      'oracle.addToLog': 'Add to Food Log',

      // Paywall
      'paywall.chooseLevel': 'Choose your level',
      'paywall.restorePurchase': 'Restore Purchase',
      'paywall.maybeLater': 'Maybe Later',

      // Workout (extended)
      'workout.searchPlaceholder': 'Search sports...',
      'workout.musclesWorked': 'Muscles Worked',
      'workout.primary': 'Primary',
      'workout.secondary': 'Secondary',
      'workout.exercises': 'Exercises',
      'workout.warmUp': 'Warm-Up',
      'workout.coolDown': 'Cool-Down',
      'workout.startCTA': 'Start {{level}} {{sport}}',
      'workout.rest': 'Rest',
      'workout.skipRest': 'Skip rest',
      'workout.upNext': 'Up Next',
      'workout.setOf': 'Set {{current}} of {{total}}',
      'workout.formTips': 'Form Tips',
      'workout.resume': 'Resume',
      'workout.pause': 'Pause',
      'workout.skip': 'Skip',
      'workout.complete': 'Workout complete',
      'workout.sets': 'Sets',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Next: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Form check: {{tip}}',

      // Onboarding — gender & age step
      'onboarding.aboutTitle': 'About you',
      'onboarding.aboutSubtitle': 'Tell us about you',
      'onboarding.gender.male': 'Male',
      'onboarding.gender.female': 'Female',
      'onboarding.gender.other': 'Other',
      'onboarding.howOld': 'How old are you?',
      'onboarding.yearsOld': 'years old',

      // Onboarding — body step
      'onboarding.bodyTitle': 'Your body',
      'onboarding.bodySubtitle': 'So we can calculate your plan',
      'onboarding.weight': 'Weight',
      'onboarding.height': 'Height',
      'onboarding.targetWeight': 'Target weight (optional)',

      // Onboarding — activity step
      'onboarding.activityTitle': 'Activity level',
      'onboarding.activitySubtitle': 'Affects your daily calorie needs',
      'onboarding.activity.sedentary': 'Sedentary',
      'onboarding.activity.sedentarySub': 'Little or no exercise',
      'onboarding.activity.light': 'Light',
      'onboarding.activity.lightSub': '1–3 days per week',
      'onboarding.activity.moderate': 'Moderate',
      'onboarding.activity.moderateSub': '3–5 days per week',
      'onboarding.activity.high': 'High',
      'onboarding.activity.highSub': '6–7 days per week',
      'onboarding.activity.extreme': 'Extreme',
      'onboarding.activity.extremeSub': 'Athlete / twice per day',
      'onboarding.calculatePlan': 'Calculate My Plan',

      // Onboarding — calculation step
      'onboarding.calculatingTitle': 'Calculating your plan…',
      'onboarding.calcMsg1': 'Analyzing your metabolism…',
      'onboarding.calcMsg2': 'Computing TDEE…',
      'onboarding.calcMsg3': 'Optimizing macro split…',
      'onboarding.calcMsg4': 'Building your personal plan…',
      'onboarding.calcMsg5': 'Almost done…',
      'onboarding.planReadyTitle': 'Plan ready!',
      'onboarding.planReadySubtitle': 'Your personalized daily targets',
      'onboarding.dailyCalories': 'Daily calories',
      'onboarding.kcalPerDay': 'kcal / day',
      'onboarding.macroSplit': 'Macro Split',
      'onboarding.macroProtein': 'Protein',
      'onboarding.macroCarbs': 'Carbs',
      'onboarding.macroFat': 'Fat',
      'onboarding.timeframe': 'Timeframe',
      'onboarding.timeframe1m': '1 Month',
      'onboarding.timeframe3m': '3 Months',
      'onboarding.timeframe6m': '6 Months',
      'onboarding.timeframe12m': '1 Year',
      'onboarding.chooseCompanion': 'Choose My Companion',

      // Onboarding — companion step
      'onboarding.companionTitle': 'Choose Your Companion',
      'onboarding.companionSubtitle': 'Your companion evolves as you train',

      // Calendar
      'calendar.noMealsTitle': 'No meals logged',
      'calendar.noMealsDesc': 'Tap the nutrition tab to track your food for this day.',
      'calendar.noProtocolsTitle': 'No protocols logged',
      'calendar.noProtocolsDesc': 'No biohacks recorded for this day. Keep up your routines.',

      // Memory
      'memory.loadError': 'Could not load posts',

      // Syndicates
      'syndicates.messagePlaceholder': 'Message the clan…',
      'syndicates.noClanTitle': 'No clan yet',
      'syndicates.noClanDesc': 'Join a syndicate to compete with others',
      'syndicates.browseCta': 'Browse clans',

      // Biometric Strip
      'biometric.recovery': 'Recovery',
      'biometric.bodyBattery': 'Body Battery',
      'biometric.hrv': 'HRV',
      'biometric.hrvDelta': '{{delta}} from baseline',
      'biometric.todayBadge': 'Today',
      'biometric.rest': 'Rest day',
      'biometric.moderate': 'Moderate',
      'biometric.intense': 'Intense',
      'biometric.consentRequired': 'Connect to Longevity',
      'biometric.consentRequiredDesc': 'Enable Workout access in Longevity Settings',
      'biometric.baselineNotSet': 'Complete baseline in Longevity',
      'biometric.offline': 'Offline',
      'biometric.demoData': 'Demo data',
      'biometric.staleBadge': '{{minutes}} min ago',
      'biometric.connectCta': 'Connect',
      'biometric.connectingFromYou': 'Show in Workout',

      // Notifications
      'notif.morning.title': 'Good morning!',
      'notif.morning.body': '{{companion}} is ready to train with you.',
      'notif.evening.title': 'Workout today?',
      'notif.evening.body': 'Even a 10-minute set keeps your streak alive.',
      'notif.streak.title': '{{streak}}-day streak at risk!',
      'notif.streak.body': 'Quick mobility flow will keep your streak going.',
      'notif.companion.title': '{{companion}} is here',
      'notif.companion.body': 'Got a moment to move today?',
      'notif.recovery.title': 'Recovery mode active',
      'notif.recovery.body': 'NMN + Magnesium recommended after yesterday\'s hard session.',
      'notif.defaultCompanion': 'Your companion',
      // Pre-prompt sheet
      'notif.preprompt.title': 'Stay consistent',
      'notif.preprompt.subtitle': 'Daily reminders for discipline — turn off anytime.',
      'notif.preprompt.benefit1': 'Morning motivation to kick off your day',
      'notif.preprompt.benefit2': 'Streak protection so you never lose progress',
      'notif.preprompt.benefit3': 'Recovery reminders after hard sessions',
      'notif.preprompt.benefit4': 'Your companion checks in 1–2×/week',
      'notif.preprompt.allow': 'Turn on notifications',
      'notif.preprompt.skip': 'Not now',
      'home.longevityId': 'Longevity ID',
      'home.sleep': 'Sleep',
      'home.water': 'Water',
      'home.steps': 'Steps',
      'profile.activity': 'Activity',
      'profile.emptyJourney': 'Your journey begins with one workout.',
      'profile.startNow': 'Start now →',
      'profile.thisWeek': 'this week',
      'profile.editProfileAria': 'Edit profile',
      'profile.phoneCountryAria': 'Phone country code',
      'memory.energyPoints': 'Energy points',
      'memory.uploadAria': 'Upload Memory',
      'calendar.synergy': 'SYNERGY',
      'calendar.today': 'Today',
      'biohacks.synergyBonus': 'Synergy bonus',
      'biohacks.synergyDesc': 'Complete all protocols in a category for x1.5 energy bonus',
      'shop.featured': 'Featured',
      'syndicates.clanPower': 'Clan Power',
      'biometric.alternatives': 'Alternatives',
      'biometric.loadingAria': 'Loading biometric data',
      'biometric.overviewAria': 'Biometric overview from Longevity',
      'dragon.energy': 'Energy',
      'nav.openSettingsAria': 'Open settings',
      'nav.dismissAria': 'Dismiss',
      'nav.moreOptionsAria': 'More options',
      'nav.closeMenuAria': 'Close menu',
      'nav.primaryAria': 'Primary navigation',
      'nav.moreNavAria': 'More navigation options',
      'common.copiedToClipboard': 'Copied to clipboard!',
      'paywall.noPreviousPurchase': 'No previous purchase found. Subscribe to unlock Pro features.',
      'common.back': 'Back',
      'dragon.stage': 'Stage',
      'dragon.levelShort': 'Lv.',
      'dragon.evolved': 'EVOLVED!',
      'dragon.evolving': 'Evolving...',
      'dragon.feeding': 'Feeding...',
      'dragon.notEnoughEnergy': 'Not enough energy',
      'dragon.feedToEvolve': 'Feed to evolve',
      'dragon.maxEvolution': 'Max evolution reached',
      'dragon.elderFormUnlocked': 'Avatar Elder · Divine Form Unlocked',
      'dragon.stageName.initiate': 'Initiate',
      'dragon.stageName.apprentice': 'Apprentice',
      'dragon.stageName.adept': 'Adept',
      'dragon.stageName.warrior': 'Warrior',
      'dragon.stageName.master': 'Master',
      'dragon.stageName.grandmaster': 'Grandmaster',
      'dragon.stageName.elder': 'Avatar Elder',
      'syndicates.roleCommanderShort': 'CMD',
      'syndicates.roleOfficerShort': 'OFC',
      'syndicates.kick': 'Kick',
      'syndicates.overview': 'Overview',
      'syndicates.roster': 'Roster',
      'syndicates.comms': 'Comms',
      'syndicates.globalRankShort': 'Global',
      'syndicates.membersLabel': 'members',
      'syndicates.joinBattle': 'Join Battle',
      'syndicates.globalRank': 'Global Rank',
      'syndicates.weeklyEp': 'Weekly EP',
      'syndicates.inviteRecruits': 'Invite Recruits',
      'syndicates.activeMembers': '{{count}} active members',
      'syndicates.epThisWeek': '{{ep}} EP this week',
      'syndicates.clanChat': 'Clan Chat',
      'syndicates.online': '{{count}} online',
      'leaderboard.dayStreak': '{{count}} day streak',
      'leaderboard.lvlShort': 'Lv.',
      'calendar.weeklyEnergy': '7-Day Energy',
      'calendar.legendWorkout': 'Workout',
      'calendar.legendPerfect': 'Perfect',
      'calendar.legendRest': 'Rest',
      'calendar.activityLog': 'Activity Log',
      'calendar.showAll': 'Show All',
      'calendar.monthApr': 'Apr',
      'calendar.month.january': 'January',
      'calendar.month.february': 'February',
      'calendar.month.march': 'March',
      'calendar.month.april': 'April',
      'calendar.month.may': 'May',
      'calendar.month.june': 'June',
      'calendar.month.july': 'July',
      'calendar.month.august': 'August',
      'calendar.month.september': 'September',
      'calendar.month.october': 'October',
      'calendar.month.november': 'November',
      'calendar.month.december': 'December',
      'calendar.day.sun': 'SUN',
      'calendar.day.mon': 'MON',
      'calendar.day.tue': 'TUE',
      'calendar.day.wed': 'WED',
      'calendar.day.thu': 'THU',
      'calendar.day.fri': 'FRI',
      'calendar.day.sat': 'SAT',
      'biohacks.cat.sport': 'SPORT',
      'biohacks.cat.mind': 'MIND',
      'biohacks.cat.ascetic': 'ASCETIC',
      'biohacks.progress': '{{done}}/{{total}} completed',
      'biohacks.synergyX': 'x1.5 Synergy',
      'biohacks.diff.EASY': 'EASY',
      'biohacks.diff.MEDIUM': 'MEDIUM',
      'biohacks.diff.HARD': 'HARD',
      'biohacks.diff.LEGEND': 'LEGEND',
      'biohacks.proto.s1.name': 'Running',
      'biohacks.proto.s1.desc': '30min outdoor run',
      'biohacks.proto.s2.name': 'Combat Arts',
      'biohacks.proto.s2.desc': 'Boxing or martial arts session',
      'biohacks.proto.s3.name': 'Iron Forge',
      'biohacks.proto.s3.desc': 'Weight training session',
      'biohacks.proto.s4.name': 'Aqua Flow',
      'biohacks.proto.s4.desc': 'Swimming 20min+',
      'biohacks.proto.s5.name': 'Flex Protocol',
      'biohacks.proto.s5.desc': 'Stretching & mobility 15min',
      'biohacks.proto.m1.name': 'Meditation',
      'biohacks.proto.m1.desc': '10min mindfulness session',
      'biohacks.proto.m2.name': 'Wim Hof Breathing',
      'biohacks.proto.m2.desc': '3 rounds breathwork',
      'biohacks.proto.m3.name': 'Neural Creation',
      'biohacks.proto.m3.desc': 'Creative visualization 10min',
      'biohacks.proto.m4.name': 'Deep Read',
      'biohacks.proto.m4.desc': 'Read 20 pages non-fiction',
      'biohacks.proto.m5.name': 'Journal Log',
      'biohacks.proto.m5.desc': 'Write daily journal entry',
      'biohacks.proto.a1.name': 'No Alcohol / No Drugs',
      'biohacks.proto.a1.desc': 'Stay clean today',
      'biohacks.proto.a2.name': 'Clean Fuel',
      'biohacks.proto.a2.desc': 'Eat only whole foods',
      'biohacks.proto.a3.name': 'Digital Detox',
      'biohacks.proto.a3.desc': 'No social media 4h+',
      'biohacks.proto.a4.name': 'Cold Exposure',
      'biohacks.proto.a4.desc': '2min cold shower',
      'biohacks.proto.a5.name': 'Sleep Protocol',
      'biohacks.proto.a5.desc': 'In bed by 10pm, 7h+ sleep',
      'biohacks.mission.1': '100 Push-ups in a Day',
      'biohacks.mission.2': 'Plank 5 Minutes',
      'biohacks.mission.3': '10K Steps',
      'biohacks.mission.4': 'Complete All Protocols',
      'biohacks.mission.5': '7-Day Streak',
      'memory.timeAgoMin': '{{n}}m ago',
      'memory.timeAgoHour': '{{n}}h ago',
      'memory.timeAgoDay': '{{n}}d ago',
      'memory.lvlShort': 'LVL',
      'memory.energyBoost': '{{amount}} Energy boost',
      'memory.boostWithEnergy': 'Boost with Energy',
      'memory.epMin': '10 EP',
      'memory.epMax': '2,000 EP',
      'memory.boostSent': 'Boost Sent!',
      'companion.stage': 'Stage',
      'companion.evolved': 'Evolved',
      'companion.xpProgress': 'XP PROGRESS',
      'companion.nextStage': 'Next stage',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'Maximum evolution reached',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': 'All joined!',
      'biohacks.todayComplete': 'today',
      'coach.chooseCoach': 'CHOOSE YOUR COACH',
      'coach.headphonesHint': 'Use headphones for the full binaural effect',
      'coach.localGenerationHint': 'Generated locally · No internet required · Free forever',
      'coach.musicNote': 'Opens in your installed music app or browser',
      'coach.sampleTitle': 'HEAR THE VOICE',
      'coach.settings': 'SETTINGS',
      'coach.soundscapeTitle': 'BINAURAL MODES',
      'coach.voiceEnabled': 'Voice Coach',
      'coach.voiceEnabledDesc': 'Audio cues during workouts',
      'coach.volume': 'Volume',
      'login.appleError': 'Apple sign-in failed',
      'login.continue': 'Continue',
      'login.continueApple': 'Continue with Apple',
      'login.continueGoogle': 'Continue with Google',
      'login.email': 'Email',
      'login.emailLabel': 'Email Address',
      'login.emailPlaceholder': 'you@example.com',
      'login.googleError': 'Google sign-in failed',
      'login.hidePassword': 'Hide password',
      'login.orContinueWith': 'or',
      'login.password': 'Password',
      'login.passwordMin': 'Password must be at least 6 characters',
      'login.passwordPlaceholder': 'Your password',
      'login.phone': 'Phone',
      'login.privacyLink': 'Privacy Policy',
      'login.showPassword': 'Show password',
      'login.signInError': 'Sign-in failed',
      'login.signingIn': 'Signing in...',
      'login.terms': 'By continuing you agree to our',
      'login.termsLink': 'Terms',
      'memory.boostAmount': 'Boost amount',
      'memory.comment': 'Comment',
      'memory.emptyDesc': 'Your feed will fill up as you and your team train.',
      'memory.emptyTitle': 'No activity yet',
      'memory.like': 'Like',
      'memory.share': 'Share',
      'oracle.errAuth': 'AI service authentication failed.',
      'oracle.errGeneric': 'Could not analyze image. Try again with a clearer photo.',
      'oracle.errLimit': 'Daily scan limit reached. Upgrade for unlimited scans.',
      'oracle.errMissingKey': 'AI service not configured. Please contact support.',
      'oracle.errRate': 'Service busy. Please try again in a moment.',
      'oracle.unlimitedScans': 'Unlimited scans',
      'paywall.everythingUnlocked': 'Everything unlocked',
      'paywall.freeLaunchNote': 'All Pro features are free during our launch.',
      'paywall.noCardNeeded': 'No card needed',
      'paywall.proFreeTitle': 'Pro — Free During Launch',
      'paywall.unlockFree': 'Unlock everything — free',
      'paywall.whatsIncluded': 'What\'s included',
      'profile.noPrs': 'No personal records yet',
      'profile.noPrsDesc': 'Your bests will appear as you train.',
      'progress.emptyCta': 'Start a workout',
      'progress.emptyDesc': 'Complete your first workout to see your stats.',
      'progress.emptyTitle': 'Your progress starts here',
      'referral.copyLinkAria': 'Copy referral link',
      'referral.shareAria': 'Share referral link',
      'settings.cookies': 'Cookie Policy',
      'settings.deleteAccount': 'Delete Account',
      'settings.deleteAccountWarning': 'This permanently deletes your account and all your data (workouts, progress, profile). This cannot be undone.',
      'settings.deleteConfirm': 'Delete',
      'settings.deleteError': 'Could not delete account. Please try again.',
      'settings.kvkk': 'KVKK / Data Protection',
      'settings.legalSupport': 'Legal & Support',
      'settings.privacy': 'Privacy Policy',
      'settings.support': 'Help & Support',
      'settings.terms': 'Terms of Service',
      'shop.celliva.allProducts': 'Full Catalog',
      'shop.celliva.autonomousFulfillment': 'Autonomous Fulfillment',
      'shop.celliva.calibrationRecorded': 'Calibration recorded. Protocol refined.',
      'shop.celliva.cart': 'Cart',
      'shop.celliva.closedLoopActive': 'Closed-Loop Active',
      'shop.celliva.decrease': 'Decrease quantity',
      'shop.celliva.depleteWarning': 'Your {{product}} supply will deplete in {{days}} days.',
      'shop.celliva.details': 'Details',
      'shop.celliva.dismiss': 'Dismiss',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'Elite required',
      'shop.celliva.increase': 'Increase quantity',
      'shop.celliva.noChange': 'No change',
      'shop.celliva.outcomeDeepSleep': 'deep sleep',
      'shop.celliva.predictiveEngine': 'Predictive Engine',
      'shop.celliva.protocolCalibration': 'Protocol Calibration',
      'shop.celliva.yesOptimal': 'Yes — optimal',
      'shop.tabGameStore': 'Game Store',
      'shop.tabMarketplace': 'Marketplace',
      'shop.unlocked': '{{name}} unlocked!',
      'syndicates.createCta': 'Create',
      'syndicates.namePlaceholder': 'Syndicate name…',
      'syndicates.newClanDesc': 'A new syndicate ready to rise.',
      'syndicates.send': 'Send',
      'syndicates.tagPlaceholder': 'Tag (3–4 chars)',
      'workout.end': 'End',
      'workout.endWorkout': 'End workout',
      'workout.noResults': 'No workouts found',
      'workout.noResultsDesc': 'Try a different search or category.',

    },
  },

  tr: {
    translation: {
      // ── Yeni arayüz anahtarları (dinlenme günü, biyometri, paylaşım, ülke seçici) ──
      'home.totalWorkouts': 'Toplam Antrenman',
      'restDay.title': 'Dinlenme Günü',
      'restDay.empty': 'Toparlanmayı takip etmek için bir antrenman tamamla',
      'restDay.today': 'Bugün çalıştın. İyi dinlen.',
      'restDay.rested': 'Toparlandın — ivmeyi koru.',
      'restDay.recommendRest': 'Haftalık yük yüksek — bugün dinlenmeyi düşün.',
      'restDay.recommendTrain': 'İyi dinlenmişsin — antrenmana hazırsın.',
      'restDay.daysSince_one': '{{count}} gün önce',
      'restDay.daysSince_other': '{{count}} gün önce',
      'biometric.noData': 'veri yok',
      'biometric.connectWearable': 'Canlı veri için bir giyilebilir cihaz bağla',
      'workout.shareUnavailable': 'Bu cihazda paylaşım kullanılamıyor.',
      'workout.shareFailed': 'Şu anda paylaşılamadı. Lütfen tekrar dene.',
      'country.TR': 'Türkiye',
      'country.US': 'Amerika Birleşik Devletleri',
      'country.RU': 'Rusya',
      'country.DE': 'Almanya',
      'country.GB': 'Birleşik Krallık',
      'country.FR': 'Fransa',
      'country.ES': 'İspanya',
      'country.IT': 'İtalya',
      'country.NL': 'Hollanda',
      'country.SA': 'Suudi Arabistan',
      'country.AE': 'Birleşik Arap Emirlikleri',
      'country.EG': 'Mısır',
      'country.ID': 'Endonezya',
      'country.KR': 'Güney Kore',
      'country.JP': 'Japonya',
      'country.CN': 'Çin',
      'country.IN': 'Hindistan',
      'country.BR': 'Brezilya',
      'country.MX': 'Meksika',
      'country.CA': 'Kanada',
      'country.AU': 'Avustralya',
      'country.NZ': 'Yeni Zelanda',
      'country.ZA': 'Güney Afrika',
      'country.SE': 'İsveç',
      'country.NO': 'Norveç',
      'country.DK': 'Danimarka',
      'country.FI': 'Finlandiya',
      'country.CH': 'İsviçre',
      'country.BE': 'Belçika',
      'country.AT': 'Avusturya',
      'profile.dayStreak': 'günlük seri',
      'profile.companionAlt': 'Rehberiniz',
      'profile.ninetyDayActivity': '90 Günlük Aktivite',
      'profile.restDay': 'Dinlenme günü',
      'profile.viewAllRecordsAria': 'Tüm kişisel rekorları görüntüle',
      'profile.copyLinkAria': 'Davet bağlantısını kopyala',
      'profile.shareAria': 'Davet bağlantısını paylaş',
      'referral.tagline': '1 ay Pro — sen ve arkadaşın için',
      'referral.noLimit': 'Sınır yok — istediğin kadar davet et',
      'shop.celliva.bestSellers': 'En Çok Satanlar',
      'shop.celliva.featuredTitle': 'Protokol Temelleri',
      'shop.celliva.benefits': 'Faydaları',
      'shop.celliva.pairsWith': 'Hedeflerinize nasıl uyar',
      'shop.celliva.added': 'Sepete eklendi!',
      'shop.celliva.cartTitle': 'Sepetiniz',
      'shop.celliva.items': 'ürün',
      'shop.celliva.clearCart': 'Tümünü temizle',
      'shop.celliva.emptyCartTitle': 'Sepet boş',
      'shop.celliva.emptyCartDesc': 'Protokolünüzü oluşturmak için katalogdan takviye ekleyin.',
      'shop.celliva.browseCatalog': 'Kataloğa Bak',
      'shop.celliva.subtotal': 'Ara Toplam',
      'shop.celliva.fulfillmentNote': 'Celliva Life tarafından karşılanır. Kargo ödeme aşamasında hesaplanır.',
      'shop.celliva.viewCart': 'Sepeti Gör',
      'shop.celliva.remove': 'Kaldır',
      'shop.prev': 'Önceki',
      'shop.next': 'Sonraki',
      'avatar.rarityCommon': 'YAYGIN',
      'avatar.rarityRare': 'NADİR',
      'avatar.rarityEpic': 'EPİK',
      'avatar.rarityLegendary': 'EFSANEVİ',
      'avatar.pro': 'PRO',
      'avatar.saved': 'Kaydedildi!',
      'avatar.skin.default': 'Varsayılan',
      'avatar.skin.cyber': 'Cyber',
      'avatar.skin.neon': 'Neon',
      'avatar.skin.shadow': 'Gölge',
      'avatar.skin.gold': 'Altın',
      'avatar.outfit.basic': 'Temel Kıyafet',
      'avatar.outfit.cyber': 'Cyber Takım',
      'avatar.outfit.runner': 'Neon Koşucu',
      'avatar.outfit.iron': 'Demir Zırh',
      'avatar.acc.none': 'Yok',
      'avatar.acc.visor': 'Vizör',
      'avatar.acc.earbuds': 'Kulaklık',
      'avatar.acc.chain': 'Zincir',
      'avatar.acc.halo': 'Hale',
      'coach.selectedLabel': 'SEÇİLDİ',
      'coach.selectLabel': 'Seç',
      'coach.languageSection': 'ANTRENÖR DİLİ',
      'coach.languageLabel': 'Dil seçin',
      'coach.languageHint': 'Ses cümleleri seçilen dilde çalar',
      'workout.exerciseOf': '{{current}}. egzersiz / {{total}}',
      'workout.paused': 'Duraklatıldı',
      'workout.endSessionSub': 'İlerleme bu noktaya kadar kaydedilecek.',
      'workout.keepGoing': 'Devam et',
      'workout.endNow': 'Şimdi bitir',
      'workout.repsLabel': 'tekrar',
      'workout.next': 'Sonraki',
      'workout.strainElite': 'Elit çaba',
      'workout.strainHard': 'Zorlu antrenman',
      'workout.strainModerate': 'Güzel iş',
      'workout.selectLevel': 'Seviye seç',
      'common.error_title': 'Bir şeyler ters gitti',
      'common.error_description': 'Lütfen tekrar deneyin.',
      'common.network_error': 'Bağlantı yok',
      'oracle.subtitle': 'AI Yemek Tarayıcı & Takip',
      'oracle.emptyTitle': 'AI Yemek Tarayıcı',
      'oracle.emptyDesc': 'Kameranı yemeğe tut. Anlık makro analizi.',
      'oracle.scanningSubtitle': 'Gemini Vision ile analiz ediliyor',
      'oracle.confidence': 'Güven',
      'oracle.detectedItems': 'Tespit Edilen Besinler',
      'oracle.macroBreakdown': 'Makro Analizi',
      'oracle.limitReached': 'Limite Ulaşıldı',
      'oracle.proUnlimited': 'Pro Sınırsız',
      'oracle.proDesc': 'Sınırsız tarama + öğün planları + AI koçluk',
      'oracle.kcalRemaining': '{{n}} kcal kaldı',
      'oracle.goalReached': 'Hedefe ulaşıldı!',
      'calendar.streakDays': '{{n}} günlük seri',
      'calendar.april2026': 'Nisan 2026',
      'calendar.prevMonth': 'Önceki ay',
      'calendar.nextMonth': 'Sonraki ay',
      'login.tagline': 'UZUN YAŞAM YOLCULUĞUN BAŞLIYOR',
      'login.otpHint': 'Aşağıdaki 6 haneli kodu girin',
      'login.connecting': 'Bağlanıyor...',
      'login.connectingLongevity': "Longevity OS'e bağlanıyor...",
      'login.continueLongevity': 'Omnisio Longevity ID ile devam et',
      'paywall.paymentMethod': 'Ödeme Yöntemi',
      'social.timeMin': '{{n}}dk önce',
      'social.timeHour': '{{n}}sa önce',
      'social.timeDay': '{{n}}g önce',
      'syndicates.joined': 'Katıldı',
      'syndicates.joinToChat': 'Katıl, clan sohbetini aç',
      'syndicates.requirement': 'Katılmak için min. {{xp}} XP',
      'syndicates.teamChallenges': 'Takım Görevleri',
      'syndicates.myClan': 'Benim Sendikam',
      'syndicates.discover': 'Keşfet',
      'syndicates.createTitle': 'Sendika Oluştur',
      'biohacks.challenges': 'Görevler',
      'biohacks.activeChallenges': 'Aktif — {{n}}',
      'biohacks.availableChallenges': 'Mevcut',
      'biohacks.completedChallenges': 'Tamamlandı',
      'biohacks.joinChallenge': 'Katıl',
      'biohacks.claimReward': '+{{reward}} XP Al',
      'memory.tabNEW': 'Yeni',
      'memory.tabMY': 'Benim',
      'memory.tabTOP': 'En İyi',
      'memory.tabCORE': 'Core',
      'nav.progress': 'İlerleme',
      'home.defaultName': 'Sporcu',
      'home.greetingSub': 'Vücudun. Hedeflerin.',
      'home.greetingSub2': 'Bugün daha güçlüsünü inşa edelim.',
      'home.energyScore': 'Enerji Skoru',
      'home.companionLabel': 'Yoldaş',
      'home.companionTagline': 'Koçluk için. Destek için.',
      'home.companion.phoenix': 'Omni',
      'home.companion.bonsai': 'Sage',
      'home.companion.orb': 'Orb',
      'home.companion.avatar': 'Titan',
      'home.companion.avatar_female': 'Luna',
      'home.moodHigh': 'Yüksek',
      'home.moodGood': 'İyi',
      'home.moodFair': 'Orta',
      'home.moodLow': 'Düşük',
      'home.moodHighSub': 'Performansa hazırsın.',
      'home.moodGoodSub': 'Sağlam zemin — devam et.',
      'home.moodFairSub': 'Bugün hafif ısın.',
      'home.moodLowSub': 'Toparlanmaya öncelik ver.',
      'home.recommendedForYou': 'Senin İçin Önerilen',
      'home.aiRecommended': 'AI Önerisi',
      'home.recTitle': 'Güç & Denge',
      'home.recSub': 'Güç kazan. Kontrolü geliştir.',
      'home.dayStreak': 'Gün Serisi',
      'home.workoutsThisWeek': 'Bu Hafta Antrenman',
      'home.badgesEarned': 'Kazanılan Rozet',
      'workout.level.intermediate': 'Orta Seviye',
      'progress.title': 'İlerleme',
      'progress.level': 'Seviye {{level}}',
      'progress.stage1': 'Kıvılcım Hali',
      'progress.stage2': 'Uyanmış Hali',
      'progress.stage3': 'Evrilmiş Hali',
      'progress.stage4': 'Yükselen Hali',
      'progress.stage5': 'Element Hali',
      'progress.stage6': 'Mitik Hali',
      'progress.stage7': 'Aşkın Hali',
      'progress.rarityCommon': 'YAYGIN',
      'progress.rarityRare': 'NADİR',
      'progress.rarityEpic': 'EPİK',
      'progress.rarityLegendary': 'EFSANEVİ',
      'progress.stageChip': '{{stage}}. Evrim Aşaması',
      'progress.dayStreakInline': '{{count}} günlük seri',
      'progress.streakSub': 'Bu ateşi söndürme!',
      'progress.xpProgress': 'XP İlerleme',
      'progress.nextStage': 'Sonraki Aşama: Aşama {{stage}} - {{name}}',
      'progress.dayStreak': 'Gün Serisi',
      'progress.workouts': 'Antrenman',
      'progress.stagesReached': 'Ulaşılan Aşama',
      'progress.achievements': 'Başarımlar',
      'progress.viewAll': 'Tümünü Gör',
      'progress.achievement.discipline': 'Disiplin',
      'progress.achievement.consistency': 'Tutarlılık',
      'progress.achievement.endurance': 'Dayanıklılık',
      'progress.achievement.resilience': 'Direnç',
      'progress.achievement.days': 'Gün',
      'progress.achievement.workouts': 'Antrenman',
      'paywall.disclosureTitle': 'Abonelik Şartları',
      'paywall.disclosureLength': 'Abonelik iptal edilmediği sürece aylık veya yıllık otomatik yenilenir',
      'paywall.disclosurePrice': 'Yukarıda gösterilen fiyat üzerinden Apple ID hesabınızdan tahsil edilir',
      'paywall.disclosureRenewal': 'Dönem bitiminden 24 saat önce otomatik yenilenir (kapatılmadığı sürece)',
      'paywall.disclosureCancel': 'iPhone Ayarlar → Apple ID → Abonelikler bölümünden istediğiniz zaman yönetin veya iptal edin',
      'paywall.disclosureRefund': 'Mevcut dönemin kullanılmayan kısmı için geri ödeme yapılmaz',
      'paywall.legalFooter': "Abonelik Apple ID üzerinden yönetilir. İstediğiniz zaman iPhone Ayarlar'dan iptal edebilirsiniz.",
      'profile.editTitle': 'Profili Düzenle',
      'profile.firstName': 'Ad',
      'profile.firstNamePh': 'Adın',
      'profile.lastName': 'Soyad',
      'profile.lastNamePh': 'Soyadın',
      'profile.displayName': 'Görünen İsim',
      'profile.displayNamePh': 'Başkaları seni nasıl görüyor',
      'profile.email': 'E-posta',
      'profile.publicId': 'Genel Kimlik',
      'common.cancel': 'İptal',
      'common.save': 'Kaydet',
      'common.saving': 'Kaydediliyor…',
      'coach.active': 'AKTİF',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'Adım sayısı + aktif enerji',
      'coach.tab.voice': 'Ses',
      'coach.tab.soundscape': 'Ortam Sesi',
      'coach.tab.music': 'Müzik',
      'coach.sample.workoutStart': 'Antrenman öncesi',
      'coach.sample.setComplete': 'Set tamam',
      'coach.sample.halfway': 'Yarı motivasyon',
      'coach.sample.finalSet': 'Son set tetik',
      'coach.sample.workoutDone': 'Antrenman bitti',
      'coach.soundscape.focus': 'Odak',
      'coach.soundscape.focusDesc': 'Lazer odağa derin alfa dalgaları',
      'coach.soundscape.cardio': 'Kardiyo Patlama',
      'coach.soundscape.cardioDesc': 'Daha sert itmek için yüksek BPM',
      'coach.soundscape.recovery': 'Toparlanma',
      'coach.soundscape.recoveryDesc': 'Kas tamiri için yumuşak tonlar',
      'coach.soundscape.sleep': 'Uyku Hazırlığı',
      'coach.soundscape.sleepDesc': 'Derin dinlenme için delta dalgalar',
      'coach.service.spotify.desc': 'Beast Mode Antrenmanı',
      'coach.service.applemusic.desc': 'Saf Pompa',
      'coach.service.ytmusic.desc': 'Antrenman Listesi',
      'coach.companion.phoenix.name': 'Phoenix',
      'coach.companion.phoenix.desc': 'Epik, motive edici',
      'coach.companion.bonsai.name': 'Bonsai',
      'coach.companion.bonsai.desc': 'Sakin, farkındalıklı',
      'coach.companion.orb.name': 'Enerji Küresi',
      'coach.companion.orb.desc': 'Fütüristik, robotik',
      'coach.companion.avatar.name': 'Savaşçı',
      'coach.companion.avatar.desc': 'Güçlü, yoğun',
      'coach.companion.avatar_female.name': 'Tanrıça',
      'coach.companion.avatar_female.desc': 'Güç veren, sıcak',
      'coach.musicTitle': 'ANTRENMAN LİSTELERİ',
      'coach.openIn': 'Aç',
      'coach.play': 'Çal',
      'coach.playing': 'Çalıyor',
      'biometric.insufficientScope': 'Eksik izinler',
      'biometric.missingScopes': 'Eksik: {{scopes}}',
      'biometric.grantScopesCta': 'İzin ver',
      'biometric.rateLimited': 'Hız limiti — {{seconds}}s sonra tekrar',
      'common.continue': 'Devam',
      'onboarding.goalTitle': 'Hedefin ne?',
      'onboarding.goalSubtitle': 'Birincil hedefini seç',
      'onboarding.goal.cut': 'Yağ Yak',
      'onboarding.goal.cutSub': 'Yağ kaybet, sıkı görün',
      'onboarding.goal.bulk': 'Kas Kazan',
      'onboarding.goal.bulkSub': 'Kas + güç kazan',
      'onboarding.goal.maintain': 'Koru',
      'onboarding.goal.maintainSub': 'Mevcut formu koru',
      'onboarding.awakeningTitle': 'Hazırsın',
      'onboarding.awakeningSubtitle': 'Sana nasıl hitap edelim?',
      'onboarding.namePlaceholder': 'Adın veya rumuzun',
      'onboarding.getStarted': 'Başla',
      'sport.bench_press.name': 'Bench Press',
      'sport.lunges.name': 'Lunge',
      'sport.jumping_rope.name': 'İp Atlama',
      'sport.kickboxing.name': 'Kickboks',
      'sport.volleyball.name': 'Voleybol',
      'sport.ice_skating.name': 'Buz Pateni',
      'sport.crossfit_wod.name': 'CrossFit WOD',
      'sport.foam_rolling.name': 'Foam Roller',
      'sport.mobility_flow.name': 'Hareketlilik Akışı',
      'common.skip': 'Atla',
      'common.next': 'İleri',
      'onboarding.injuryTitle': 'Sakatlığın var mı?',
      'onboarding.injurySubtitle': 'Bu bölgelere yük binmeyecek şekilde antrenmanları uyarlayacağız. İsteğe bağlı.',
      'onboarding.injuryNoneSelected': 'Sakatlık yok — tam yoğunluk antrenman',
      'onboarding.injuryCount_one': '{{count}} bölge korunuyor',
      'onboarding.injuryCount_other': '{{count}} bölge korunuyor',
      'onboarding.injuries.neck': 'Boyun',
      'onboarding.injuries.shoulders': 'Omuz',
      'onboarding.injuries.lowerBack': 'Bel',
      'onboarding.injuries.elbows': 'Dirsek',
      'onboarding.injuries.wrists': 'Bilek',
      'onboarding.injuries.hips': 'Kalça',
      'onboarding.injuries.knees': 'Diz',
      'onboarding.injuries.ankles': 'Ayak bileği',
      'common.back': 'Geri',
      'common.gotIt': 'Anladım',
      'leaderboard.title': 'Sıralama',
      'leaderboard.global': 'Genel',
      'leaderboard.friends': 'Arkadaşlar',
      'leaderboard.weekly': 'Haftalık',
      'leaderboard.you': 'Sen',
      'leaderboard.energy': 'Enerji',
      'leaderboard.howItWorks': 'Nasıl çalışır',
      'leaderboard.noFriends': 'Henüz arkadaş yok',
      'leaderboard.noFriendsDesc': 'Arkadaşlarını davet et',
      'leaderboard.rule1Title': 'Enerji kazan',
      'leaderboard.rule1': 'Antrenmanları tamamla. Yüksek zorluk + uzun seri = daha çok enerji.',
      'leaderboard.rule2Title': 'Üç sıralama',
      'leaderboard.rule2': 'Genel herkesi, Arkadaşlar sadece takip ettiklerini, Haftalık her Pazartesi sıfırlanır.',
      'leaderboard.rule3Title': 'Azalma kuralı',
      'leaderboard.rule3': 'Pasif kalınan her gün %5 enerji azalır — istikrar patlamadan değerli.',
      'leaderboard.rule4Title': 'Ödüller',
      'leaderboard.rule4': "Her sıralamanın ilk 3'ü altın/gümüş/bronz profil çerçevesi kazanır.",
      'referral.title': 'Davet et & kazan',
      'referral.description': "Bir arkadaşını davet et — onun da senin de 1 ay Pro'n bedava. Sınır yok.",
      'referral.yourId': "ID'n",
      'referral.reward': 'Ödül',
      'referral.daysFree': 'gün bedava',
      'referral.copy': 'Kopyala',
      'referral.copied': 'Kopyalandı',
      'referral.share': 'Paylaş',
      'referral.shareTitle': "Omnisio Workout'u Dene",
      'referral.shareText': "Omnisio Workout'a katıl — ikimiz de 1 ay Pro hediye alıyoruz.",
      'referral.activeStatus': 'Pro aktif:',
      'oracle.recentMeals': 'Son Öğünler',
      'oracle.entryCount_one': '{{count}} kayıt',
      'oracle.entryCount_other': '{{count}} kayıt',
      'oracle.noScans': 'Henüz tarama yok',
      'oracle.noScansDesc': 'İlk öğününüzü takip etmek için Tara butonuna dokunun',
      'oracle.scanNow': 'Şimdi tara',
      'oracle.todaysTotal': 'Bugünün Toplamı',
      'oracle.kcal': 'kcal',
      'oracle.macro.protein': 'Protein',
      'oracle.macro.carbs': 'Karbonhidrat',
      'oracle.macro.fat': 'Yağ',
      'oracle.macro.calories': 'Kalori',
      'oracle.meal.breakfast': 'Kahvaltı',
      'oracle.meal.lunch': 'Öğle',
      'oracle.meal.dinner': 'Akşam',
      'oracle.meal.snack': 'Atıştırma',
      'sport.pushups.name': 'Şınav',
      'sport.squats.name': 'Squat',
      'sport.plank.name': 'Plank',
      'sport.running.name': 'Koşu',
      'sport.yoga.name': 'Yoga',
      'sport.boxing.name': 'Boks',
      'sport.cycling.name': 'Bisiklet',
      'sport.swimming.name': 'Yüzme',
      'sport.basketball.name': 'Basketbol',
      'sport.skiing.name': 'Kayak',
      'sport.pullups.name': 'Barfiks',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'Tenis',
      'sport.deadlift.name': 'Deadlift',
      'sport.pilates.name': 'Pilates',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'Kürek',
      'sport.dance.name': 'Dans Fitness',
      'sport.stretching.name': 'Esneme',
      'sport.kettlebell.name': 'Kettlebell',
      'sport.football.name': 'Futbol',
      'workout.cat.all': 'TÜMÜ',
      'workout.cat.strength': 'GÜÇ',
      'workout.cat.cardio': 'KARDİYO',
      'workout.cat.flexibility': 'ESNEKLİK',
      'workout.cat.combat': 'DÖVÜŞ',
      'workout.cat.team': 'TAKIM',
      'workout.cat.winter': 'KIŞ',
      'workout.cat.functional': 'FONKSİYONEL',
      'workout.noEquipment': 'Ekipmansız',
      'workout.instructions': 'Talimatlar',
      'workout.commonMistakes': 'Sık Yapılan Hatalar',
      'workout.easier': 'Daha Kolay',
      'workout.harder': 'Daha Zor',
      'workout.repsCount_one': '{{count}} tekrar',
      'workout.repsCount_other': '{{count}} tekrar',
      'workout.countSports_one': '{{count}} spor',
      'workout.countSports_other': '{{count}} spor',
      'workout.noSports': 'Spor bulunamadı',
      'settings.general': 'Genel',
      'settings.proActive': 'Pro Aktif',
      'settings.freeTrial': 'Ücretsiz Deneme',
      'settings.allUnlocked': 'Tüm özellikler açık',
      'settings.upgradeFull': 'Tam erişim için yükselt',
      'settings.upgrade': 'Yükselt',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Veri Senkronizasyonu',
      'settings.dataSyncDesc': 'Sağlık verilerini Omnisio ekosistemiyle senkronize et',
      'settings.logout': 'Çıkış Yap',
      // App
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Özel Grup Fitness',

      // Navigation
      'nav.home': 'Ana Sayfa',
      'nav.workout': 'Antrenman',
      'nav.nutri': 'Beslenme',
      'nav.history': 'Geçmiş',
      'nav.memory': 'Anılar',
      'nav.radio': 'Radyo',
      'nav.shop': 'Mağaza',
      'nav.profile': 'Profil',
      'nav.more': 'Daha Fazla',
      'nav.coach': 'Koç',

      // Home
      'home.welcome': 'Hoş geldin, {{name}}',
      'home.dailyEnergy': 'Günlük Enerji',
      'home.startWorkout': 'Antrenmana Başla',
      'home.yourTotem': 'Maskotun',
      'home.todaysMissions': 'Bugünün Hedefleri',
      'home.leaderboard': 'Sıralama',
      'home.syndicates': 'Takımlar',
      'home.biohacks': 'Meydan Okumalar',

      // Energy
      'energy.exercise': 'Egzersiz',
      'energy.music': 'Müzik',
      'energy.total': 'Toplam Enerji',
      'energy.streak': '{{count}} gün seri',
      'energy.streakFire': 'Seri',

      // Workout
      'workout.title': 'Antrenman',
      'workout.camera': 'Kamera Takip',
      'workout.startSession': 'Oturumu Başlat',
      'workout.endSession': 'Oturumu Bitir',
      'workout.reps': 'Tekrar',
      'workout.calories': 'Kalori',
      'workout.duration': 'Süre',
      'workout.exerciseComplete': 'Egzersiz Tamamlandı!',
      'workout.energyEarned': '+{{amount}} Enerji',
      'workout.plank': 'Plank',
      'workout.pushups': 'Şınav',
      'workout.squats': 'Squat',
      'workout.overview': 'Genel Bakış',
      'workout.history': 'Geçmiş',
      'workout.progress': 'İlerleme',
      'workout.personalRecords': 'Kişisel Rekorlar',
      'workout.share': 'Paylaş',
      'workout.done': 'Tamam',

      // Oracle / Nutri Vision
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Yiyecek Tara',
      'oracle.history': 'Tarama Geçmişi',
      'oracle.scanning': 'Analiz Ediliyor...',
      'oracle.dailyNorm': 'Günlük Norm',
      'oracle.scansLeft': '{{count}} tarama kaldı',
      'oracle.upgrade': 'Sınırsız için yükselt',
      'oracle.protein': 'Protein',
      'oracle.carbs': 'Karbonhidrat',
      'oracle.fat': 'Yağ',
      'oracle.calories': 'Kalori',

      // Memory
      'memory.title': 'Anılar',
      'memory.upload': 'Anı Yükle',
      'memory.stake': 'Enerji Kilitle',
      'memory.network': 'Küresel Enerji Kanıtı Ağı',

      // Calendar / History
      'calendar.title': 'Geçmiş',
      'calendar.fitness': 'Fitness',
      'calendar.nutrition': 'Beslenme',
      'calendar.protocols': 'Protokoller',

      // Shop
      'shop.title': 'Mağaza',
      'shop.avatars': 'Avatarlar',
      'shop.boosters': 'Güçlendiriciler',
      'shop.cosmetics': 'Kozmetik',
      'shop.buy': 'Satın Al',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Sahip Olunan',
      'shop.equipped': 'Kullanımda',

      // Profile
      'profile.title': 'Profil',
      'profile.level': 'Seviye {{level}}',
      'profile.totalWorkouts': 'Toplam Antrenman',
      'profile.totalTokens': 'Toplam Token',
      'profile.achievements': 'Başarılar',
      'profile.settings': 'Ayarlar',
      'profile.totem': 'Maskot',

      // Leaderboard
      'leaderboard.title': 'Sıralama',
      'leaderboard.global': 'Genel',
      'leaderboard.syndicate': 'Takım',
      'leaderboard.weekly': 'Haftalık',
      'leaderboard.allTime': 'Tüm Zamanlar',
      'leaderboard.rank': 'Sıra',

      // Syndicates/Teams
      'syndicates.title': 'Takımlar',
      'syndicates.join': 'Katıl',
      'syndicates.create': 'Takım Oluştur',
      'syndicates.members': '{{count}} üye',
      'syndicates.power': 'Güç',

      // Biohacks/Challenges
      'biohacks.title': 'Meydan Okumalar',
      'biohacks.protocols': 'Programlar',
      'biohacks.missions': 'Hedefler',
      'biohacks.active': 'Aktif',
      'biohacks.completed': 'Tamamlanan',
      'biohacks.reward': 'Ödül: {{amount}} TKN',

      // Avatar
      'avatar.title': 'Avatar',
      'avatar.customize': 'Özelleştir',
      'avatar.skin': 'Ten',
      'avatar.outfit': 'Kıyafet',
      'avatar.accessories': 'Aksesuarlar',
      'avatar.save': 'Kaydet',

      // Radio
      'radio.title': 'Gym Radyo',
      'radio.nowPlaying': 'Şimdi Çalıyor',
      'radio.stations': 'İstasyonlar',
      'radio.energyBonus': 'Dinlerken +Enerji',

      // Coach
      'coach.title': 'Koç',
      'coach.subtitle': 'Kulağında AI fitness arkadaşın',
      'coach.tabVoice': 'Ses',
      'coach.tabSoundscape': 'Ortam Sesi',
      'coach.tabMusic': 'Müzik',
      'coach.chooseVoice': 'Koç sesini seç',
      'coach.samples': 'Örnekleri dinle',
      'coach.samplePreWorkout': 'Antrenman öncesi',
      'coach.sampleSetComplete': 'Set tamamlandı',
      'coach.sampleHalfway': 'Yarı yol',
      'coach.sampleFinalSet': 'Son set',
      'coach.sampleWorkoutDone': 'Antrenman bitti',
      'coach.voiceCoachToggle': 'Antrenman sırasında sesli koç',
      'coach.proRequired': 'Tüm sesleri açmak için Pro gerekli',
      'coach.upgrade': 'Yükselt',
      'coach.soundscapeFocus': 'Odak',
      'coach.soundscapeFocusDesc': 'Derin konsantrasyon için alfa dalgaları',
      'coach.soundscapeCardio': 'Kardiyo',
      'coach.soundscapeCardioDesc': 'Koşu ve HIIT için yüksek tempolu ortam',
      'coach.soundscapeRecovery': 'Toparlanma',
      'coach.soundscapeRecoveryDesc': 'Soğuma ve esneme için yavaş ritim',
      'coach.soundscapeSleep': 'Uyku Hazırlığı',
      'coach.soundscapeSleepDesc': 'Pembe gürültü ve doğa sesleri',
      'coach.soundscapeComingSoon': 'Yakında',
      'coach.musicHeader': 'Sevdiğin müzik uygulamasını aç',
      'coach.musicSpotify': "Spotify'da aç",
      'coach.musicApple': "Apple Music'te aç",
      'coach.musicYoutube': 'YouTube Music\'te aç',
      'coach.workoutPlaylist': 'Antrenman listesi',

      // Settings
      'settings.title': 'Ayarlar',
      'settings.language': 'Dil',
      'settings.notifications': 'Bildirimler',
      'settings.sound': 'Ses',
      'settings.haptics': 'Titreşim',
      'settings.about': 'Hakkında',
      'settings.version': 'Sürüm',
      'settings.aiEngine': 'Yapay Zeka Motoru',
      'settings.wearables': 'Biyo-Giyilebilirler',
      'settings.bioWearables': 'Biyo-Giyilebilirler',
      'settings.omnisioBand': 'Omnisio Bant',
      'settings.omnisioBandDesc': 'Yerli SDK · Gerçek zamanlı biyometri',
      'settings.omnisioRing': 'Omnisio Yüzük',
      'settings.omnisioRingDesc': 'Yerli SDK · 7 gün pil, uyku + HRV',
      'settings.thirdPartySync': 'Üçüncü taraf · Senkronizasyon için bağlan',
      'settings.dataSync': 'Veri Senkronizasyonu',
      'settings.upgrade': 'Yükselt',
      'settings.logout': 'Çıkış Yap',

      // Onboarding
      'onboarding.welcome': "Omnisio Workout'a Hoş Geldin",
      'onboarding.subtitle': 'Özel grup fitness yolculuğun burada başlıyor',
      'onboarding.selectExercise': 'İlk egzersizini seç',
      'onboarding.pushups': 'Şınav',
      'onboarding.squats': 'Squat',
      'onboarding.getStarted': 'Başla',
      'onboarding.skip': 'Atla',

      // Common
      'common.loading': 'Yükleniyor...',
      'common.error': 'Bir şeyler ters gitti',
      'common.retry': 'Tekrar Dene',
      'common.back': 'Geri',
      'common.save': 'Kaydet',
      'common.cancel': 'İptal',
      'common.confirm': 'Onayla',
      'common.close': 'Kapat',
      'common.tokens': 'Token',
      'common.soon': 'Yakında',
      'common.viewAll': 'Tümünü gör',

      // Profile (extended)
      'profile.workouts': 'Antrenmanlar',
      'profile.hours': 'Saat',
      'profile.totalXP': 'Toplam XP',
      'profile.personalRecords': 'Kişisel Rekorlar',
      'profile.connectedServices': 'Bağlı Servisler',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Bağlı',
      'profile.connect': 'Bağlan',
      'profile.helpSupport': 'Yardım ve Destek',
      'profile.signOut': 'Çıkış Yap',
      'profile.contactShipping': 'İletişim & Kargo',
      'profile.complete': 'Tamamlandı',
      'profile.incompleteForOrders': 'Takviye siparişleri için gerekli',
      'profile.email': 'E-posta',
      'profile.phone': 'Telefon',
      'profile.address': 'Adres',
      'profile.country': 'Ülke',
      'profile.addressPlaceholder': 'Sokak, Şehir, Posta Kodu',
      'profile.privacyNote': 'İletişim bilgileriniz yerel olarak saklanır ve yalnızca sipariş verdiğinizde Celliva ile paylaşılır. KVKK/GDPR uyumludur.',
      'profile.invalidEmail': 'Geçersiz e-posta formatı',
      'profile.invalidPhone': 'Telefon çok kısa',
      'profile.invalidAddress': 'Adres çok kısa',

      // Achievements
      'achievements.firstWorkout': 'İlk Antrenman',
      'achievements.sevenDayStreak': '7 Günlük Seri',
      'achievements.plankMaster': 'Plank Ustası',
      'achievements.earlyBird': 'Erkenci',
      'achievements.perfectionist': 'Mükemmeliyetçi',
      'achievements.hundredWorkouts': '100 Antrenman',
      'achievements.marathon': 'Maraton',
      'achievements.nightOwl': 'Gece Kuşu',

      // Shop (extended)
      'shop.subtitle': 'Yoldaşları, güçlendiricileri ve ekipmanları aç',
      'shop.tabCompanions': 'Yoldaşlar',
      'shop.tabBoosters': 'Güçlendiriciler',
      'shop.tabOutfits': 'Kıyafetler',
      'shop.tabThemes': 'Temalar',
      'shop.free': 'Ücretsiz',
      'shop.levelRequired': 'Seviye {{level}} gerekli',
      'shop.unlockFor': '{{price}} ⚡ ile aç',
      'shop.insufficientXP': 'Yetersiz XP ({{price}} ⚡ gerekli)',
      'shop.viewPack': 'Paketi Gör',
      'shop.recentActivity': 'Son etkinlik',
      'shop.earnMoreXP': 'Daha fazla XP kazan',
      'shop.completeWorkout': 'Bir antrenman tamamla',
      'shop.startWorkout': 'Antrenmana Başla',
      'shop.tabSupplements': 'Takviyeler',
      'shop.poweredByCelliva': 'Powered by Celliva',
      'shop.cellivaTagline': 'Premium takviyeler · 50$ üzeri ücretsiz kargo',
      'shop.buyOnCelliva': "Celliva'da satın al",
      'shop.supplementsHeader': 'Antrenmanına yakıt kat',
      'shop.supplementsSubtitle': 'Lab-tested, üçüncü taraf doğrulamalı',

      // Oyun mağazası kataloğu (companion / booster / kıyafet / tema)
      'shop.item.phoenix.name': 'Phoenix',
      'shop.item.phoenix.desc': 'Küllerinden doğar',
      'shop.item.phoenix.long': 'Ölümsüz Phoenix seni partneri olarak seçti. Ateşten doğan ve her seferinde daha güçlü dirilen bu varlık, her sınırı aşma azmini körükler.',
      'shop.item.phoenix.stat.0.label': 'Bonus XP',
      'shop.item.phoenix.stat.0.value': 'Tüm antrenmanlarda +%10',
      'shop.item.bonsai.name': 'Bonsai Ağacı',
      'shop.item.bonsai.desc': 'Sabırla büyür',
      'shop.item.bonsai.long': 'Disiplinini yansıtan canlı bir heykel. Bonsai, alışkanlıklar edindikçe gelişir ve istikrarını nadir görsel yükseltmelerle ödüllendirir.',
      'shop.item.bonsai.stat.0.label': 'Seri Bonusu',
      'shop.item.bonsai.stat.0.value': '7 günlük seriden sonra +%15',
      'shop.item.orb.name': 'Enerji Küresi',
      'shop.item.orb.desc': 'Saf enerjiyi yönlendir',
      'shop.item.orb.long': 'Yaptığın her tekrarı güçlendiren, yoğunlaştırılmış biyo-enerjiden oluşan bir küre. Sen sıkı çalıştıkça daha parlak atar.',
      'shop.item.orb.stat.0.label': 'Enerji Yenilenmesi',
      'shop.item.orb.stat.0.value': 'Antrenman başına +5 Enerji',
      'shop.item.avatar.name': 'Savaşçı',
      'shop.item.avatar.desc': 'Gücünü dövüp şekillendir',
      'shop.item.avatar.long': 'Zirve fiziksel potansiyeli simgeleyen, savaşta sertleşmiş bir avatar. Özel savaşçı meydan okuma animasyonlarını açar.',
      'shop.item.avatar.stat.0.label': 'Güç XP',
      'shop.item.avatar.stat.0.value': 'Güç seanslarında +%12',
      'shop.item.avatar_female.name': 'Tanrıça',
      'shop.item.avatar_female.desc': 'Gücünü serbest bırak',
      'shop.item.avatar_female.long': 'İnsan potansiyelinin tüm yelpazesini yönlendirir — zarafet, dayanıklılık ve ham güç. Her seansı yücelten efsanevi bir varlık.',
      'shop.item.avatar_female.stat.0.label': 'Tüm XP',
      'shop.item.avatar_female.stat.0.value': 'Her kaynaktan +%20',
      'shop.item.wolf.name': '???',
      'shop.item.wolf.desc': 'Çok yakında',
      'shop.item.wolf.long': 'Gölge ve içgüdüden bir yaratık. Bu companion\'ı açığa çıkarmak için Seviye 7\'ye ulaş.',
      'shop.item.xp_2x_24h.name': '24 saat 2× XP',
      'shop.item.xp_2x_24h.desc': '24 saat boyunca tüm kaynaklardan 2× XP',
      'shop.item.xp_2x_24h.long': 'Her antrenman, alışkanlık kaydı ve seri bonusu tam bir gün boyunca ikiye katlanır. Maksimum kazanç için bir antrenman seansıyla birleştir.',
      'shop.item.xp_2x_24h.stat.0.label': 'Etki',
      'shop.item.xp_2x_24h.stat.0.value': '2× XP çarpanı',
      'shop.item.xp_2x_24h.stat.1.label': 'Süre',
      'shop.item.xp_2x_24h.stat.1.value': '24 saat',
      'shop.item.streak_freeze.name': 'Seri Dondurma',
      'shop.item.streak_freeze.desc': 'Kaçırdığın bir gün için serini koru',
      'shop.item.streak_freeze.long': 'Hayat bu. Seri Dondurma, zorlukla kazandığın seriyi kaçırılan bir gün boyunca korur — hiçbir soru sorulmaz.',
      'shop.item.streak_freeze.stat.0.label': 'Etki',
      'shop.item.streak_freeze.stat.0.value': '1 gün atla, seri bozulmaz',
      'shop.item.streak_freeze.stat.1.label': 'Kullanım',
      'shop.item.streak_freeze.stat.1.value': 'Tek kullanımlık',
      'shop.item.energy_boost.name': 'Anında +50 Enerji',
      'shop.item.energy_boost.desc': 'Bugüne anında 50 enerji ekle',
      'shop.item.energy_boost.long': 'Bugünkü toplamına anında işlenen 50 Enerji puanlık doğrudan bir enjeksiyon.',
      'shop.item.energy_boost.stat.0.label': 'Etki',
      'shop.item.energy_boost.stat.0.value': 'Hemen +50 Enerji',
      'shop.item.energy_boost.stat.1.label': 'Kullanım',
      'shop.item.energy_boost.stat.1.value': 'Tek kullanımlık',
      'shop.item.workout_quick.name': '5 dakikalık Enerji Boost',
      'shop.item.workout_quick.desc': 'Isınmayı atla, taze başla',
      'shop.item.workout_quick.long': 'Kaslarını dijital olarak önceden aktive eder, böylece doğrudan zirve verimle antrenmanına geçebilirsin.',
      'shop.item.workout_quick.stat.0.label': 'Etki',
      'shop.item.workout_quick.stat.0.value': 'Isınma aşamasını atla',
      'shop.item.workout_quick.stat.1.label': 'Kullanım',
      'shop.item.workout_quick.stat.1.value': 'Tek kullanımlık',
      'shop.item.cyber.name': 'Siber Kostüm',
      'shop.item.cyber.desc': 'Neon ışıklı companion kıyafeti',
      'shop.item.cyber.long': 'Companion\'ını yarının atletinin estetiğine saran fütüristik bir neon-ızgara takım.',
      'shop.item.cyber.stat.0.label': 'Görsel',
      'shop.item.cyber.stat.0.value': 'Neon parıltı + parçacık izi',
      'shop.item.royal.name': 'Kraliyet Cübbesi',
      'shop.item.royal.desc': 'Premium altın detaylar',
      'shop.item.royal.long': 'Altın iplik işlemeli koyu kızıl renge bürünmüş — hüküm sürme hakkını kazanmış şampiyonlara ayrılmıştır.',
      'shop.item.royal.stat.0.label': 'Görsel',
      'shop.item.royal.stat.0.value': 'Altın parıltı aurası',
      'shop.item.royal.stat.1.label': 'XP Aurası',
      'shop.item.royal.stat.1.value': 'Seri günlerinden +%5',
      'shop.item.minimal.name': 'Minimal',
      'shop.item.minimal.desc': 'Sade monokrom görünüm',
      'shop.item.minimal.long': 'Az çoktur. Sonuçlarının konuşmasına izin veren sadeleştirilmiş monokrom bir kıyafet.',
      'shop.item.minimal.stat.0.label': 'Görsel',
      'shop.item.minimal.stat.0.value': 'Monokrom palet',
      'shop.item.cosmic.name': 'Kozmik',
      'shop.item.cosmic.desc': 'Yıldız ve nebula efektleri',
      'shop.item.cosmic.long': 'Companion\'ın hareket halinde bir galaksiye dönüşür — dönen nebulalar ve yıldız tozu parçacıkları her hareketini izler.',
      'shop.item.cosmic.stat.0.label': 'Görsel',
      'shop.item.cosmic.stat.0.value': 'Galaksi parçacık sistemi',
      'shop.item.midnight.name': 'Geceyarısı',
      'shop.item.midnight.desc': 'Varsayılan koyu tema',
      'shop.item.midnight.long': 'Klasik Omnisio koyu teması. Derin siyahlar ve turkuaz vurgular — klinik, hassas, güçlü.',
      'shop.item.midnight.stat.0.label': 'Palet',
      'shop.item.midnight.stat.0.value': 'Siyah + turkuaz',
      'shop.item.aurora.name': 'Aurora',
      'shop.item.aurora.desc': 'Kuzey ışıkları gradyanı',
      'shop.item.aurora.long': 'Kuzey ışıklarından (aurora borealis) ilham alan, yeşilden mora geçişli gradyanlar. Başının üstünde canlı bir gökyüzü.',
      'shop.item.aurora.stat.0.label': 'Palet',
      'shop.item.aurora.stat.0.value': 'Zümrüt + mor',
      'shop.item.sunset.name': 'Günbatımı',
      'shop.item.sunset.desc': 'Sıcak altın + magenta',
      'shop.item.sunset.long': 'Günün son ışığı — kehribar, altın ve derin magenta, alev almış bir ufuk gibi katman katman.',
      'shop.item.sunset.stat.0.label': 'Palet',
      'shop.item.sunset.stat.0.value': 'Altın + magenta',
      'shop.item.ocean.name': 'Okyanus Derinlikleri',
      'shop.item.ocean.desc': 'Derin teal estetiği',
      'shop.item.ocean.long': 'Dipsizliğe dal. Biyolüminesan mavi vurgulu derin teal arka planlar, derin okyanusun ezici sessizliğini çağrıştırır.',
      'shop.item.ocean.stat.0.label': 'Palet',
      'shop.item.ocean.stat.0.value': 'Derin teal + mavi',
      'shop.featuredPack.name': 'Bahar Paketi',
      'shop.featuredPack.tagline': '3 ürünlük paket — %40 tasarruf',
      'shop.featuredPack.countdown': '3g 14s içinde sona erer',
      'shop.featuredPack.item.0': 'Bonsai Ağacı',
      'shop.featuredPack.item.1': 'Aurora Teması',
      'shop.featuredPack.item.2': '24 saat 2× XP',

      // Celliva Eczanesi
      'shop.celliva.title': 'Celliva Eczanesi',
      'shop.celliva.eyebrow': 'Otonom İkmal',
      'shop.celliva.tabMarketplace': 'Marketplace',
      'shop.celliva.tabGameStore': 'Oyun Mağazası',
      'shop.celliva.predictiveTitle': 'Öngörü Motoru',
      'shop.celliva.predictiveBody': '{{product}} stokunuz {{days}} gün içinde tükenecek.',
      'shop.celliva.authorizeDispatch': 'Sevkiyatı Onayla',
      'shop.celliva.calibrationTitle': 'Protokol Kalibrasyonu',
      'shop.celliva.calibrationQuestion': '{{product}} {{outcome}} sonucunu iyileştirdi mi?',
      'shop.celliva.calibrationYes': 'Evet — optimal',
      'shop.celliva.calibrationNo': 'Değişiklik yok',
      'shop.celliva.calibrationDismiss': 'Kapat',
      'shop.celliva.calibrationThanks': 'Kalibrasyon kaydedildi. Protokol rafine edildi.',
      'shop.celliva.closedLoopTitle': 'Kapalı Döngü Aktif',
      'shop.celliva.closedLoopBody': 'Biyobelirteçler eczaneyi besliyor. Yeniden siparişler verinize göre ayarlanıyor.',
      'shop.celliva.targetedInterventions': 'Hedefli Müdahaleler',
      'shop.celliva.viewDetails': 'Detaylar',
      'shop.celliva.hideDetails': 'Detayları gizle',
      'shop.celliva.dosage': 'Dozaj',
      'shop.celliva.ingredients': 'İçerikler',
      'shop.celliva.studies': 'Klinik referanslar',
      'shop.celliva.addToCart': 'Sepete ekle',
      'shop.celliva.inCart': 'Sepette ({{qty}})',
      'shop.celliva.checkout': "Celliva'da ödeme yap",
      'shop.celliva.cartEmpty': 'Sepet boş',
      'shop.celliva.cartTotal': 'Toplam',
      'shop.celliva.catLongevity': 'Uzun Yaşam',
      'shop.celliva.catCognitive': 'Bilişsel',
      'shop.celliva.catRecovery': 'Toparlanma',
      'shop.celliva.catPerformance': 'Performans',
      'shop.celliva.catAll': 'Tümü',
      'shop.celliva.downloadCatalog': 'Katalog indir',
      'shop.celliva.bestseller': 'Çok Satan',
      'shop.celliva.clinical': 'Klinik',
      'shop.celliva.verified': 'Lab doğrulamalı',
      'shop.celliva.proRequired': 'Pro üyelik Akıllı Yeniden Sipariş ve Kalibrasyon kilidini açar',
      'shop.celliva.eliteDnaBanner': 'APOE ε4 durumunuza göre bilişsel destek için önceliklendirildi',
      'shop.celliva.kvkkNote': 'Kargo bilgileriniz yalnızca Celliva.life üzerinden sipariş verdiğinizde cihazı terk eder.',

      // Rarity
      'rarity.common': 'Sıradan',
      'rarity.rare': 'Nadir',
      'rarity.epic': 'Epik',
      'rarity.legendary': 'Efsanevi',

      // Memory (extended)
      'memory.community': 'Topluluk',
      'memory.demoMode': 'Demo modu · Gerçek veri için Supabase bağla',
      'memory.boost': 'Boost',
      'memory.boostXPNote': 'Enerji paylaştığın için +10 XP',
      'memory.noPostsTitle': 'Henüz gönderi yok',
      'memory.noPostsDesc': 'Antrenmanını paylaşan ilk kişi ol',
      'memory.allCaughtUp': 'Hepsi güncel',

      // Calendar (extended)
      'calendar.history': 'Geçmiş',
      'calendar.workouts': 'Antrenmanlar',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'Seri',
      'calendar.energy': 'Enerji',
      'calendar.tabFitness': 'Fitness',
      'calendar.tabNutrition': 'Beslenme',
      'calendar.tabProtocols': 'Protokoller',
      'calendar.restDay': 'Dinlenme günü',
      'calendar.restDayDesc': 'Etkinlik kaydı yok. Her şampiyonun toparlanmaya ihtiyacı var.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'KALORİ AÇIĞI',
      'oracle.alertLowProtein': 'DÜŞÜK PROTEİN UYARISI',
      'oracle.alertPerfectDay': 'MÜKEMMEL GÜN',
      'oracle.dailyCalories': 'Günlük kalori',
      'oracle.tabScan': 'Tara',
      'oracle.tabHistory': 'Geçmiş',
      'oracle.tapToScan': 'Kamerayı yiyeceğine doğrult ve aşağıdaki tuşa bas',
      'oracle.freeScans': '{{used}}/{{max}} ücretsiz tarama',
      'oracle.upgradePro': "Pro'ya Yükselt",
      'oracle.scanFood': 'Yiyecek Tara',
      'oracle.scanAgain': 'Tekrar Tara',
      'oracle.addToLog': 'Yemek Günlüğüne Ekle',

      // Paywall
      'paywall.chooseLevel': 'Seviyeni seç',
      'paywall.restorePurchase': 'Satın Alımı Geri Yükle',
      'paywall.maybeLater': 'Belki Sonra',

      // Workout (extended)
      'workout.searchPlaceholder': 'Spor ara...',
      'workout.musclesWorked': 'Çalışan Kaslar',
      'workout.primary': 'Birincil',
      'workout.secondary': 'İkincil',
      'workout.exercises': 'Egzersizler',
      'workout.warmUp': 'Isınma',
      'workout.coolDown': 'Soğuma',
      'workout.startCTA': '{{level}} {{sport}} Başlat',
      'workout.rest': 'Dinlen',
      'workout.skipRest': 'Dinlenmeyi atla',
      'workout.upNext': 'Sırada',
      'workout.setOf': 'Set {{current}} / {{total}}',
      'workout.formTips': 'Form İpuçları',
      'workout.resume': 'Devam Et',
      'workout.pause': 'Duraklat',
      'workout.skip': 'Atla',
      'workout.complete': 'Antrenman tamamlandı',
      'workout.sets': 'Set',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Sıradaki: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Form kontrolü: {{tip}}',

      // Onboarding — cinsiyet & yaş adımı
      'onboarding.aboutTitle': 'Hakkında',
      'onboarding.aboutSubtitle': 'Bize kendinden bahset',
      'onboarding.gender.male': 'Erkek',
      'onboarding.gender.female': 'Kadın',
      'onboarding.gender.other': 'Diğer',
      'onboarding.howOld': 'Kaç yaşındasın?',
      'onboarding.yearsOld': 'yaşında',

      // Onboarding — vücut adımı
      'onboarding.bodyTitle': 'Vücudun',
      'onboarding.bodySubtitle': 'Planını hesaplayabilmemiz için',
      'onboarding.weight': 'Kilo',
      'onboarding.height': 'Boy',
      'onboarding.targetWeight': 'Hedef kilo (isteğe bağlı)',

      // Onboarding — aktivite adımı
      'onboarding.activityTitle': 'Aktivite seviyesi',
      'onboarding.activitySubtitle': 'Günlük kalori ihtiyacını etkiler',
      'onboarding.activity.sedentary': 'Hareketsiz',
      'onboarding.activity.sedentarySub': 'Az ya da hiç egzersiz yok',
      'onboarding.activity.light': 'Hafif',
      'onboarding.activity.lightSub': 'Haftada 1–3 gün',
      'onboarding.activity.moderate': 'Orta',
      'onboarding.activity.moderateSub': 'Haftada 3–5 gün',
      'onboarding.activity.high': 'Yoğun',
      'onboarding.activity.highSub': 'Haftada 6–7 gün',
      'onboarding.activity.extreme': 'Ekstrem',
      'onboarding.activity.extremeSub': 'Atlet / günde iki antrenman',
      'onboarding.calculatePlan': 'Planımı Hesapla',

      // Onboarding — hesaplama adımı
      'onboarding.calculatingTitle': 'Planın hesaplanıyor…',
      'onboarding.calcMsg1': 'Metabolizman analiz ediliyor…',
      'onboarding.calcMsg2': 'TDEE hesaplanıyor…',
      'onboarding.calcMsg3': 'Makro dağılımı optimize ediliyor…',
      'onboarding.calcMsg4': 'Kişisel planın oluşturuluyor…',
      'onboarding.calcMsg5': 'Neredeyse tamam…',
      'onboarding.planReadyTitle': 'Plan hazır!',
      'onboarding.planReadySubtitle': 'Kişiselleştirilmiş günlük hedeflerin',
      'onboarding.dailyCalories': 'Günlük kalori',
      'onboarding.kcalPerDay': 'kcal / gün',
      'onboarding.macroSplit': 'Makro Dağılımı',
      'onboarding.macroProtein': 'Protein',
      'onboarding.macroCarbs': 'Karbonhidrat',
      'onboarding.macroFat': 'Yağ',
      'onboarding.timeframe': 'Süre',
      'onboarding.timeframe1m': '1 Ay',
      'onboarding.timeframe3m': '3 Ay',
      'onboarding.timeframe6m': '6 Ay',
      'onboarding.timeframe12m': '1 Yıl',
      'onboarding.chooseCompanion': 'Yoldaşımı Seç',

      // Onboarding — yoldaş adımı
      'onboarding.companionTitle': 'Yoldaşını Seç',
      'onboarding.companionSubtitle': 'Yoldaşın antrenmanınla birlikte gelişir',

      // Takvim
      'calendar.noMealsTitle': 'Öğün kaydedilmedi',
      'calendar.noMealsDesc': 'Bu güne ait yiyecekleri takip etmek için beslenme sekmesine dokun.',
      'calendar.noProtocolsTitle': 'Protokol kaydedilmedi',
      'calendar.noProtocolsDesc': 'Bu gün için biyohack kaydı yok. Rutinlerin devam etsin.',

      // Anılar
      'memory.loadError': 'Gönderiler yüklenemedi',

      // Takımlar
      'syndicates.messagePlaceholder': 'Klana mesaj gönder…',
      'syndicates.noClanTitle': 'Henüz klan yok',
      'syndicates.noClanDesc': 'Diğerleriyle rekabet etmek için bir sendikaya katıl',
      'syndicates.browseCta': 'Klanları keşfet',

      // Biyometrik Şerit
      'biometric.recovery': 'Toparlanma',
      'biometric.bodyBattery': 'Vücut Bataryası',
      'biometric.hrv': 'KRV',
      'biometric.hrvDelta': 'Baz çizgisinden {{delta}}',
      'biometric.todayBadge': 'Bugün',
      'biometric.rest': 'Dinlenme günü',
      'biometric.moderate': 'Orta yoğunluk',
      'biometric.intense': 'Yoğun',
      'biometric.consentRequired': 'Longevity\'e bağlan',
      'biometric.consentRequiredDesc': 'Longevity Ayarları\'nda Antrenman erişimine izin ver',
      'biometric.baselineNotSet': 'Longevity\'de baz çizgisini tamamla',
      'biometric.offline': 'Çevrimdışı',
      'biometric.demoData': 'Demo verisi',
      'biometric.staleBadge': '{{minutes}} dk önce',
      'biometric.connectCta': 'Bağlan',
      'biometric.connectingFromYou': 'Antrenman\'da göster',

      // Bildirimler
      'notif.morning.title': 'Günaydın!',
      'notif.morning.body': '{{companion}} seninle antrenmana hazır.',
      'notif.evening.title': 'Bugünkü antrenmanın?',
      'notif.evening.body': '10 dakikalık bir set bile streak\'ini korur.',
      'notif.streak.title': '{{streak}} günlük streak\'in tehlikede!',
      'notif.streak.body': 'Hızlı bir hareketlilik akışı streak\'ini devam ettirir.',
      'notif.companion.title': '{{companion}} burada',
      'notif.companion.body': 'Bugün biraz hareket etmek için zamanın var mı?',
      'notif.recovery.title': 'Toparlanma modu aktif',
      'notif.recovery.body': 'Dünkü yoğun antrenman için NMN + Magnesium öneriliyor.',
      'notif.defaultCompanion': 'Arkadaşın',
      'notif.preprompt.title': 'Tutarlı kal',
      'notif.preprompt.subtitle': 'Günlük hatırlatmalar — istediğin zaman kapatabilirsin.',
      'notif.preprompt.benefit1': 'Güne motivasyonlu başlamak için sabah mesajı',
      'notif.preprompt.benefit2': 'Streak\'ini kaybetmemen için koruma uyarısı',
      'notif.preprompt.benefit3': 'Yoğun antrenman sonrası toparlanma hatırlatması',
      'notif.preprompt.benefit4': 'Arkadaşın haftada 1–2 kez seni kontrol eder',
      'notif.preprompt.allow': 'Bildirimleri aç',
      'notif.preprompt.skip': 'Şimdi değil',
      'home.longevityId': 'Uzun Ömür Kimliği',
      'home.sleep': 'Uyku',
      'home.water': 'Su',
      'home.steps': 'Adım',
      'profile.activity': 'Etkinlik',
      'profile.emptyJourney': 'Yolculuğun tek bir antrenmanla başlar.',
      'profile.startNow': 'Hemen başla →',
      'profile.thisWeek': 'bu hafta',
      'profile.editProfileAria': 'Profili düzenle',
      'profile.phoneCountryAria': 'Telefon ülke kodu',
      'memory.energyPoints': 'Enerji puanı',
      'memory.uploadAria': 'Hafıza yükle',
      'calendar.synergy': 'SİNERJİ',
      'calendar.today': 'Bugün',
      'biohacks.synergyBonus': 'Sinerji bonusu',
      'biohacks.synergyDesc': 'Bir kategorideki tüm protokolleri tamamla, x1.5 enerji bonusu kazan',
      'shop.featured': 'Öne çıkan',
      'syndicates.clanPower': 'Klan Gücü',
      'biometric.alternatives': 'Alternatifler',
      'biometric.loadingAria': 'Biyometrik veri yükleniyor',
      'biometric.overviewAria': 'Longevity\'den biyometrik özet',
      'dragon.energy': 'Enerji',
      'nav.openSettingsAria': 'Ayarları aç',
      'nav.dismissAria': 'Kapat',
      'nav.moreOptionsAria': 'Daha fazla seçenek',
      'nav.closeMenuAria': 'Menüyü kapat',
      'nav.primaryAria': 'Ana gezinti',
      'nav.moreNavAria': 'Daha fazla gezinti seçeneği',
      'common.copiedToClipboard': 'Panoya kopyalandı!',
      'paywall.noPreviousPurchase': 'Önceki satın alma bulunamadı. Pro özelliklerin kilidini açmak için abone ol.',
      'common.back': 'Geri',
      'dragon.stage': 'Aşama',
      'dragon.levelShort': 'Sv.',
      'dragon.evolved': 'GELİŞTİ!',
      'dragon.evolving': 'Gelişiyor...',
      'dragon.feeding': 'Besleniyor...',
      'dragon.notEnoughEnergy': 'Yetersiz enerji',
      'dragon.feedToEvolve': 'Geliştirmek için besle',
      'dragon.maxEvolution': 'Maksimum gelişime ulaşıldı',
      'dragon.elderFormUnlocked': 'Avatar Yaşlısı · İlahi Form Açıldı',
      'dragon.stageName.initiate': 'Acemi',
      'dragon.stageName.apprentice': 'Çırak',
      'dragon.stageName.adept': 'Usta Adayı',
      'dragon.stageName.warrior': 'Savaşçı',
      'dragon.stageName.master': 'Usta',
      'dragon.stageName.grandmaster': 'Büyük Usta',
      'dragon.stageName.elder': 'Avatar Yaşlısı',
      'syndicates.roleCommanderShort': 'KMT',
      'syndicates.roleOfficerShort': 'SBY',
      'syndicates.kick': 'Çıkar',
      'syndicates.overview': 'Genel',
      'syndicates.roster': 'Kadro',
      'syndicates.comms': 'Sohbet',
      'syndicates.globalRankShort': 'Global',
      'syndicates.membersLabel': 'üye',
      'syndicates.joinBattle': 'Savaşa Katıl',
      'syndicates.globalRank': 'Global Sıra',
      'syndicates.weeklyEp': 'Haftalık EP',
      'syndicates.inviteRecruits': 'Yeni Üye Davet Et',
      'syndicates.activeMembers': '{{count}} aktif üye',
      'syndicates.epThisWeek': 'Bu hafta {{ep}} EP',
      'syndicates.clanChat': 'Klan Sohbeti',
      'syndicates.online': '{{count}} çevrimiçi',
      'leaderboard.dayStreak': '{{count}} günlük seri',
      'leaderboard.lvlShort': 'Sv.',
      'calendar.weeklyEnergy': '7 Günlük Enerji',
      'calendar.legendWorkout': 'Antrenman',
      'calendar.legendPerfect': 'Mükemmel',
      'calendar.legendRest': 'Dinlenme',
      'calendar.activityLog': 'Aktivite Kaydı',
      'calendar.showAll': 'Tümünü Göster',
      'calendar.monthApr': 'Nis',
      'calendar.month.january': 'Ocak',
      'calendar.month.february': 'Şubat',
      'calendar.month.march': 'Mart',
      'calendar.month.april': 'Nisan',
      'calendar.month.may': 'Mayıs',
      'calendar.month.june': 'Haziran',
      'calendar.month.july': 'Temmuz',
      'calendar.month.august': 'Ağustos',
      'calendar.month.september': 'Eylül',
      'calendar.month.october': 'Ekim',
      'calendar.month.november': 'Kasım',
      'calendar.month.december': 'Aralık',
      'calendar.day.sun': 'PAZ',
      'calendar.day.mon': 'PZT',
      'calendar.day.tue': 'SAL',
      'calendar.day.wed': 'ÇAR',
      'calendar.day.thu': 'PER',
      'calendar.day.fri': 'CUM',
      'calendar.day.sat': 'CMT',
      'biohacks.cat.sport': 'SPOR',
      'biohacks.cat.mind': 'ZİHİN',
      'biohacks.cat.ascetic': 'RİYAZET',
      'biohacks.progress': '{{done}}/{{total}} tamamlandı',
      'biohacks.synergyX': 'x1.5 Sinerji',
      'biohacks.diff.EASY': 'KOLAY',
      'biohacks.diff.MEDIUM': 'ORTA',
      'biohacks.diff.HARD': 'ZOR',
      'biohacks.diff.LEGEND': 'EFSANE',
      'biohacks.proto.s1.name': 'Koşu',
      'biohacks.proto.s1.desc': '30dk açık hava koşusu',
      'biohacks.proto.s2.name': 'Dövüş Sanatları',
      'biohacks.proto.s2.desc': 'Boks veya dövüş sanatları seansı',
      'biohacks.proto.s3.name': 'Demir Atölyesi',
      'biohacks.proto.s3.desc': 'Ağırlık antrenmanı seansı',
      'biohacks.proto.s4.name': 'Su Akışı',
      'biohacks.proto.s4.desc': '20dk+ yüzme',
      'biohacks.proto.s5.name': 'Esneklik Protokolü',
      'biohacks.proto.s5.desc': 'Esneme ve hareketlilik 15dk',
      'biohacks.proto.m1.name': 'Meditasyon',
      'biohacks.proto.m1.desc': '10dk farkındalık seansı',
      'biohacks.proto.m2.name': 'Wim Hof Nefes',
      'biohacks.proto.m2.desc': '3 tur nefes çalışması',
      'biohacks.proto.m3.name': 'Nöral Yaratım',
      'biohacks.proto.m3.desc': 'Yaratıcı görselleştirme 10dk',
      'biohacks.proto.m4.name': 'Derin Okuma',
      'biohacks.proto.m4.desc': '20 sayfa kurgu dışı oku',
      'biohacks.proto.m5.name': 'Günlük Kaydı',
      'biohacks.proto.m5.desc': 'Günlük girdisi yaz',
      'biohacks.proto.a1.name': 'Alkol Yok / Madde Yok',
      'biohacks.proto.a1.desc': 'Bugün temiz kal',
      'biohacks.proto.a2.name': 'Temiz Yakıt',
      'biohacks.proto.a2.desc': 'Yalnızca tam gıda ye',
      'biohacks.proto.a3.name': 'Dijital Detoks',
      'biohacks.proto.a3.desc': '4 saat+ sosyal medya yok',
      'biohacks.proto.a4.name': 'Soğuğa Maruziyet',
      'biohacks.proto.a4.desc': '2dk soğuk duş',
      'biohacks.proto.a5.name': 'Uyku Protokolü',
      'biohacks.proto.a5.desc': '22:00 yatakta, 7+ saat uyku',
      'biohacks.mission.1': 'Bir Günde 100 Şınav',
      'biohacks.mission.2': '5 Dakika Plank',
      'biohacks.mission.3': '10 Bin Adım',
      'biohacks.mission.4': 'Tüm Protokolleri Tamamla',
      'biohacks.mission.5': '7 Günlük Seri',
      'memory.timeAgoMin': '{{n}}dk önce',
      'memory.timeAgoHour': '{{n}}sa önce',
      'memory.timeAgoDay': '{{n}}g önce',
      'memory.lvlShort': 'SVY',
      'memory.energyBoost': '{{amount}} Enerji takviyesi',
      'memory.boostWithEnergy': 'Enerjiyle Destekle',
      'memory.epMin': '10 EP',
      'memory.epMax': '2.000 EP',
      'memory.boostSent': 'Takviye Gönderildi!',
      'companion.stage': 'Aşama',
      'companion.evolved': 'Gelişti',
      'companion.xpProgress': 'XP İLERLEMESİ',
      'companion.nextStage': 'Sıradaki aşama',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'Maksimum gelişime ulaşıldı',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': 'Hepsine katıldın!',
      'biohacks.todayComplete': 'bugün',
      'coach.chooseCoach': 'KOÇUNU SEÇ',
      'coach.headphonesHint': 'Tam binaural etki için kulaklık kullan',
      'coach.localGenerationHint': 'Cihazda üretilir · İnternet gerekmez · Sonsuza dek ücretsiz',
      'coach.musicNote': 'Yüklü müzik uygulamanda veya tarayıcında açılır',
      'coach.sampleTitle': 'SESİ DİNLE',
      'coach.settings': 'AYARLAR',
      'coach.soundscapeTitle': 'BİNAURAL MODLAR',
      'coach.voiceEnabled': 'Sesli Koç',
      'coach.voiceEnabledDesc': 'Antrenman sırasında sesli ipuçları',
      'coach.volume': 'Ses seviyesi',
      'login.appleError': 'Apple ile giriş başarısız',
      'login.continue': 'Devam et',
      'login.continueApple': 'Apple ile devam et',
      'login.continueGoogle': 'Google ile devam et',
      'login.email': 'E-posta',
      'login.emailLabel': 'E-posta Adresi',
      'login.emailPlaceholder': 'sen@ornek.com',
      'login.googleError': 'Google ile giriş başarısız',
      'login.hidePassword': 'Şifreyi gizle',
      'login.orContinueWith': 'veya',
      'login.password': 'Şifre',
      'login.passwordMin': 'Şifre en az 6 karakter olmalı',
      'login.passwordPlaceholder': 'Şifren',
      'login.phone': 'Telefon',
      'login.privacyLink': 'Gizlilik Politikası',
      'login.showPassword': 'Şifreyi göster',
      'login.signInError': 'Giriş başarısız',
      'login.signingIn': 'Giriş yapılıyor...',
      'login.terms': 'Devam ederek şunları kabul edersin:',
      'login.termsLink': 'Kullanım Koşulları',
      'memory.boostAmount': 'Destek miktarı',
      'memory.comment': 'Yorum yap',
      'memory.emptyDesc': 'Sen ve ekibin antrenman yaptıkça akışın dolacak.',
      'memory.emptyTitle': 'Henüz aktivite yok',
      'memory.like': 'Beğen',
      'memory.share': 'Paylaş',
      'oracle.errAuth': 'AI servis kimlik doğrulaması başarısız.',
      'oracle.errGeneric': 'Görsel analiz edilemedi. Daha net bir fotoğrafla tekrar dene.',
      'oracle.errLimit': 'Günlük tarama limitine ulaşıldı. Sınırsız tarama için yükselt.',
      'oracle.errMissingKey': 'AI servisi yapılandırılmamış. Lütfen destek ile iletişime geç.',
      'oracle.errRate': 'Servis meşgul. Lütfen birazdan tekrar dene.',
      'oracle.unlimitedScans': 'Sınırsız tarama',
      'paywall.everythingUnlocked': 'Her şey açıldı',
      'paywall.freeLaunchNote': 'Tüm Pro özellikleri lansman boyunca ücretsiz.',
      'paywall.noCardNeeded': 'Kart gerekmez',
      'paywall.proFreeTitle': 'Pro — Lansmanda Ücretsiz',
      'paywall.unlockFree': 'Her şeyi aç — ücretsiz',
      'paywall.whatsIncluded': 'Neler dahil',
      'profile.noPrs': 'Henüz kişisel rekor yok',
      'profile.noPrsDesc': 'En iyilerin antrenman yaptıkça görünecek.',
      'progress.emptyCta': 'Antrenmana başla',
      'progress.emptyDesc': 'İstatistiklerini görmek için ilk antrenmanını tamamla.',
      'progress.emptyTitle': 'İlerlemen burada başlıyor',
      'referral.copyLinkAria': 'Davet bağlantısını kopyala',
      'referral.shareAria': 'Davet bağlantısını paylaş',
      'settings.cookies': 'Çerez Politikası',
      'settings.deleteAccount': 'Hesabı Sil',
      'settings.deleteAccountWarning': 'Bu işlem hesabını ve tüm verilerini (antrenmanlar, ilerleme, profil) kalıcı olarak siler. Geri alınamaz.',
      'settings.deleteConfirm': 'Sil',
      'settings.deleteError': 'Hesap silinemedi. Lütfen tekrar dene.',
      'settings.kvkk': 'KVKK / Veri Koruma',
      'settings.legalSupport': 'Yasal ve Destek',
      'settings.privacy': 'Gizlilik Politikası',
      'settings.support': 'Yardım ve Destek',
      'settings.terms': 'Kullanım Koşulları',
      'shop.celliva.allProducts': 'Tüm Katalog',
      'shop.celliva.autonomousFulfillment': 'Otonom Karşılama',
      'shop.celliva.calibrationRecorded': 'Kalibrasyon kaydedildi. Protokol iyileştirildi.',
      'shop.celliva.cart': 'Sepet',
      'shop.celliva.closedLoopActive': 'Kapalı Döngü Aktif',
      'shop.celliva.decrease': 'Adedi azalt',
      'shop.celliva.depleteWarning': '{{product}} stoğun {{days}} gün içinde tükenecek.',
      'shop.celliva.details': 'Ayrıntılar',
      'shop.celliva.dismiss': 'Kapat',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'Elite gerekli',
      'shop.celliva.increase': 'Adedi artır',
      'shop.celliva.noChange': 'Değişiklik yok',
      'shop.celliva.outcomeDeepSleep': 'derin uyku',
      'shop.celliva.predictiveEngine': 'Tahmin Motoru',
      'shop.celliva.protocolCalibration': 'Protokol Kalibrasyonu',
      'shop.celliva.yesOptimal': 'Evet — ideal',
      'shop.tabGameStore': 'Oyun Mağazası',
      'shop.tabMarketplace': 'Pazar Yeri',
      'shop.unlocked': '{{name}} açıldı!',
      'syndicates.createCta': 'Oluştur',
      'syndicates.namePlaceholder': 'Sendika adı…',
      'syndicates.newClanDesc': 'Yükselmeye hazır yeni bir sendika.',
      'syndicates.send': 'Gönder',
      'syndicates.tagPlaceholder': 'Etiket (3–4 karakter)',
      'workout.end': 'Bitir',
      'workout.endWorkout': 'Antrenmanı bitir',
      'workout.noResults': 'Antrenman bulunamadı',
      'workout.noResultsDesc': 'Farklı bir arama veya kategori dene.',

    },
  },

  ru: {
    translation: {
      // ── Новые ключи интерфейса (день отдыха, биометрия, поделиться, выбор страны) ──
      'home.totalWorkouts': 'Всего тренировок',
      'restDay.title': 'День отдыха',
      'restDay.empty': 'Завершите тренировку, чтобы отслеживать восстановление',
      'restDay.today': 'Сегодня была тренировка. Хорошо восстановитесь.',
      'restDay.rested': 'Вы восстановились — не теряйте темп.',
      'restDay.recommendRest': 'Высокая недельная нагрузка — стоит отдохнуть сегодня.',
      'restDay.recommendTrain': 'Вы хорошо отдохнули — можно тренироваться.',
      'restDay.daysSince_one': '{{count}} день назад',
      'restDay.daysSince_few': '{{count}} дня назад',
      'restDay.daysSince_many': '{{count}} дней назад',
      'biometric.noData': 'нет данных',
      'biometric.connectWearable': 'Подключите носимое устройство для данных в реальном времени',
      'workout.shareUnavailable': 'Поделиться на этом устройстве невозможно.',
      'workout.shareFailed': 'Сейчас не удалось поделиться. Попробуйте ещё раз.',
      'country.TR': 'Турция',
      'country.US': 'США',
      'country.RU': 'Россия',
      'country.DE': 'Германия',
      'country.GB': 'Великобритания',
      'country.FR': 'Франция',
      'country.ES': 'Испания',
      'country.IT': 'Италия',
      'country.NL': 'Нидерланды',
      'country.SA': 'Саудовская Аравия',
      'country.AE': 'Объединённые Арабские Эмираты',
      'country.EG': 'Египет',
      'country.ID': 'Индонезия',
      'country.KR': 'Южная Корея',
      'country.JP': 'Япония',
      'country.CN': 'Китай',
      'country.IN': 'Индия',
      'country.BR': 'Бразилия',
      'country.MX': 'Мексика',
      'country.CA': 'Канада',
      'country.AU': 'Австралия',
      'country.NZ': 'Новая Зеландия',
      'country.ZA': 'Южная Африка',
      'country.SE': 'Швеция',
      'country.NO': 'Норвегия',
      'country.DK': 'Дания',
      'country.FI': 'Финляндия',
      'country.CH': 'Швейцария',
      'country.BE': 'Бельгия',
      'country.AT': 'Австрия',
      'profile.dayStreak': 'дней подряд',
      'profile.companionAlt': 'Ваш компаньон',
      'profile.ninetyDayActivity': 'Активность за 90 дней',
      'profile.restDay': 'День отдыха',
      'profile.viewAllRecordsAria': 'Показать все рекорды',
      'profile.copyLinkAria': 'Скопировать реферальную ссылку',
      'profile.shareAria': 'Поделиться ссылкой',
      'referral.tagline': '1 месяц Pro — вам и другу',
      'referral.noLimit': 'Без ограничений — приглашай сколько угодно',
      'shop.celliva.bestSellers': 'Бестселлеры',
      'shop.celliva.featuredTitle': 'Основные протоколы',
      'shop.celliva.benefits': 'Преимущества',
      'shop.celliva.pairsWith': 'Как это соответствует вашим целям',
      'shop.celliva.added': 'Добавлено в корзину!',
      'shop.celliva.cartTitle': 'Ваша корзина',
      'shop.celliva.items': 'товаров',
      'shop.celliva.clearCart': 'Очистить всё',
      'shop.celliva.emptyCartTitle': 'Корзина пуста',
      'shop.celliva.emptyCartDesc': 'Добавьте добавки из каталога для создания протокола.',
      'shop.celliva.browseCatalog': 'Просмотреть каталог',
      'shop.celliva.subtotal': 'Промежуточный итог',
      'shop.celliva.fulfillmentNote': 'Выполняется Celliva Life. Доставка рассчитывается при оформлении.',
      'shop.celliva.viewCart': 'Просмотреть корзину',
      'shop.celliva.remove': 'Удалить',
      'shop.prev': 'Назад',
      'shop.next': 'Вперёд',
      'avatar.rarityCommon': 'ОБЫЧНЫЙ',
      'avatar.rarityRare': 'РЕДКИЙ',
      'avatar.rarityEpic': 'ЭПИК',
      'avatar.rarityLegendary': 'ЛЕГЕНДА',
      'avatar.pro': 'PRO',
      'avatar.saved': 'Сохранено!',
      'avatar.skin.default': 'Стандарт',
      'avatar.skin.cyber': 'Кибер',
      'avatar.skin.neon': 'Неон',
      'avatar.skin.shadow': 'Тень',
      'avatar.skin.gold': 'Золото',
      'avatar.outfit.basic': 'Базовая экипировка',
      'avatar.outfit.cyber': 'Кибер-костюм',
      'avatar.outfit.runner': 'Неоновый бегун',
      'avatar.outfit.iron': 'Железная броня',
      'avatar.acc.none': 'Нет',
      'avatar.acc.visor': 'Визор',
      'avatar.acc.earbuds': 'Наушники',
      'avatar.acc.chain': 'Цепь',
      'avatar.acc.halo': 'Нимб',
      'coach.selectedLabel': 'ВЫБРАН',
      'coach.selectLabel': 'Выбрать',
      'coach.languageSection': 'ЯЗЫК ТРЕНЕРА',
      'coach.languageLabel': 'Выберите язык',
      'coach.languageHint': 'Голосовые фразы воспроизводятся на выбранном языке',
      'workout.exerciseOf': 'Упражнение {{current}} из {{total}}',
      'workout.paused': 'Пауза',
      'workout.endSessionSub': 'Прогресс будет сохранён до этого момента.',
      'workout.keepGoing': 'Продолжить',
      'workout.endNow': 'Завершить',
      'workout.repsLabel': 'повт.',
      'workout.next': 'Далее',
      'workout.strainElite': 'Элитный результат',
      'workout.strainHard': 'Тяжёлая сессия',
      'workout.strainModerate': 'Хорошая работа',
      'workout.selectLevel': 'Выберите уровень',
      'common.error_title': 'Что-то пошло не так',
      'common.error_description': 'Пожалуйста, повторите попытку.',
      'common.network_error': 'Нет соединения',
      'oracle.subtitle': 'ИИ-сканер еды',
      'oracle.emptyTitle': 'ИИ-сканер еды',
      'oracle.emptyDesc': 'Наведите камеру на еду. Мгновенный анализ.',
      'oracle.scanningSubtitle': 'Анализ с Gemini Vision',
      'oracle.confidence': 'Уверенность',
      'oracle.detectedItems': 'Обнаруженные ингредиенты',
      'oracle.macroBreakdown': 'Разбивка по макросам',
      'oracle.limitReached': 'Лимит достигнут',
      'oracle.proUnlimited': 'Про безлимит',
      'oracle.proDesc': 'Безлимитные сканы + планы питания + ИИ-коучинг',
      'oracle.kcalRemaining': 'Осталось {{n}} ккал',
      'oracle.goalReached': 'Цель достигнута!',
      'calendar.streakDays': '{{n}}-дневная серия',
      'calendar.april2026': 'Апрель 2026',
      'calendar.prevMonth': 'Предыдущий месяц',
      'calendar.nextMonth': 'Следующий месяц',
      'login.tagline': 'ВАШ ПУТЬ К ДОЛГОЛЕТИЮ',
      'login.otpHint': 'Введите 6-значный код ниже',
      'login.connecting': 'Подключение...',
      'login.connectingLongevity': 'Подключение к Longevity OS...',
      'login.continueLongevity': 'Войти через Omnisio Longevity ID',
      'paywall.paymentMethod': 'Способ оплаты',
      'social.timeMin': '{{n}}мин назад',
      'social.timeHour': '{{n}}ч назад',
      'social.timeDay': '{{n}}д назад',
      'syndicates.joined': 'Вступил',
      'syndicates.joinToChat': 'Вступи, чтобы открыть чат',
      'syndicates.requirement': 'Мин. {{xp}} XP',
      'syndicates.teamChallenges': 'Командные задания',
      'syndicates.myClan': 'Мой синдикат',
      'syndicates.discover': 'Обзор',
      'syndicates.createTitle': 'Создать синдикат',
      'biohacks.challenges': 'Задания',
      'biohacks.activeChallenges': 'Активные — {{n}}',
      'biohacks.availableChallenges': 'Доступные',
      'biohacks.completedChallenges': 'Завершённые',
      'biohacks.joinChallenge': 'Вступить',
      'biohacks.claimReward': 'Получить +{{reward}} XP',
      'memory.tabNEW': 'Новое',
      'memory.tabMY': 'Мои',
      'memory.tabTOP': 'Топ',
      'memory.tabCORE': 'Ключевые',
      'nav.progress': 'Прогресс',
      'home.defaultName': 'Атлет',
      'home.greetingSub': 'Твоё тело. Твои цели.',
      'home.greetingSub2': 'Сегодня построим что-то сильнее.',
      'home.energyScore': 'Энергия',
      'home.companionLabel': 'Компаньон',
      'home.companionTagline': 'Для коучинга. Для поддержки.',
      'home.companion.phoenix': 'Омни',
      'home.companion.bonsai': 'Сэйдж',
      'home.companion.orb': 'Орб',
      'home.companion.avatar': 'Титан',
      'home.companion.avatar_female': 'Луна',
      'home.moodHigh': 'Высокая',
      'home.moodGood': 'Хорошая',
      'home.moodFair': 'Средняя',
      'home.moodLow': 'Низкая',
      'home.moodHighSub': 'Ты готов выступать.',
      'home.moodGoodSub': 'Хорошая база — дави дальше.',
      'home.moodFairSub': 'Сегодня разомнись легко.',
      'home.moodLowSub': 'Сделай восстановление приоритетом.',
      'home.recommendedForYou': 'Рекомендовано для тебя',
      'home.aiRecommended': 'Совет ИИ',
      'home.recTitle': 'Сила и баланс',
      'home.recSub': 'Получи силу. Улучши контроль.',
      'home.dayStreak': 'Серия дней',
      'home.workoutsThisWeek': 'Тренировки на этой неделе',
      'home.badgesEarned': 'Полученные значки',
      'workout.level.intermediate': 'Средний',
      'progress.title': 'Прогресс',
      'progress.level': 'Уровень {{level}}',
      'progress.stage1': 'Искра',
      'progress.stage2': 'Пробуждение',
      'progress.stage3': 'Эволюция',
      'progress.stage4': 'Восхождение',
      'progress.stage5': 'Стихия',
      'progress.stage6': 'Мифик',
      'progress.stage7': 'Трансцендент',
      'progress.rarityCommon': 'ОБЫЧНЫЙ',
      'progress.rarityRare': 'РЕДКИЙ',
      'progress.rarityEpic': 'ЭПИК',
      'progress.rarityLegendary': 'ЛЕГЕНДА',
      'progress.stageChip': '{{stage}}. Стадия эволюции',
      'progress.dayStreakInline': '{{count}}-дневная серия',
      'progress.streakSub': 'Не дай ей погаснуть!',
      'progress.xpProgress': 'Прогресс XP',
      'progress.nextStage': 'Следующая стадия: {{stage}} - {{name}}',
      'progress.dayStreak': 'Серия дней',
      'progress.workouts': 'Тренировки',
      'progress.stagesReached': 'Стадии пройдены',
      'progress.achievements': 'Достижения',
      'progress.viewAll': 'Все',
      'progress.achievement.discipline': 'Дисциплина',
      'progress.achievement.consistency': 'Постоянство',
      'progress.achievement.endurance': 'Выносливость',
      'progress.achievement.resilience': 'Стойкость',
      'progress.achievement.days': 'дней',
      'progress.achievement.workouts': 'тренировок',
      'paywall.disclosureTitle': 'Условия подписки',
      'paywall.disclosureLength': 'Подписка автоматически продлевается ежемесячно или ежегодно до отмены',
      'paywall.disclosurePrice': 'Списывается с вашего Apple ID по указанной выше цене',
      'paywall.disclosureRenewal': 'Автоматическое продление в течение 24 часов до окончания периода, если не отключено',
      'paywall.disclosureCancel': 'Управление или отмена в любое время: Настройки iPhone → Apple ID → Подписки',
      'paywall.disclosureRefund': 'Возврат за неиспользованную часть текущего периода не производится',
      'paywall.legalFooter': 'Подписка управляется через Apple ID. Отмените в любое время в Настройках iPhone.',
      'profile.editTitle': 'Редактировать профиль',
      'profile.firstName': 'Имя',
      'profile.firstNamePh': 'Ваше имя',
      'profile.lastName': 'Фамилия',
      'profile.lastNamePh': 'Ваша фамилия',
      'profile.displayName': 'Отображаемое имя',
      'profile.displayNamePh': 'Как вас видят другие',
      'profile.email': 'Email',
      'profile.publicId': 'Публичный ID',
      'common.cancel': 'Отмена',
      'common.save': 'Сохранить',
      'common.saving': 'Сохранение…',
      'coach.active': 'АКТИВ',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'Шаги + активная энергия',
      'coach.tab.voice': 'Голос',
      'coach.tab.soundscape': 'Звуковой ландшафт',
      'coach.tab.music': 'Музыка',
      'coach.sample.workoutStart': 'Перед тренировкой',
      'coach.sample.setComplete': 'Подход завершён',
      'coach.sample.halfway': 'Мотивация на полпути',
      'coach.sample.finalSet': 'Толчок последнего сета',
      'coach.sample.workoutDone': 'Тренировка завершена',
      'coach.soundscape.focus': 'Фокус',
      'coach.soundscape.focusDesc': 'Глубокие альфа-волны для лазерной концентрации',
      'coach.soundscape.cardio': 'Кардио Буст',
      'coach.soundscape.cardioDesc': 'Высокий BPM для максимума усилий',
      'coach.soundscape.recovery': 'Восстановление',
      'coach.soundscape.recoveryDesc': 'Мягкие тона для восстановления мышц',
      'coach.soundscape.sleep': 'Подготовка ко сну',
      'coach.soundscape.sleepDesc': 'Дельта-волны для глубокого отдыха',
      'coach.service.spotify.desc': 'Тренировка Beast Mode',
      'coach.service.applemusic.desc': 'Pure Pump',
      'coach.service.ytmusic.desc': 'Плейлист для тренировки',
      'coach.companion.phoenix.name': 'Феникс',
      'coach.companion.phoenix.desc': 'Эпично, мотивирующе',
      'coach.companion.bonsai.name': 'Бонсай',
      'coach.companion.bonsai.desc': 'Спокойно, осознанно',
      'coach.companion.orb.name': 'Энергетическая Сфера',
      'coach.companion.orb.desc': 'Футуристично, роботизированно',
      'coach.companion.avatar.name': 'Воин',
      'coach.companion.avatar.desc': 'Сильно, интенсивно',
      'coach.companion.avatar_female.name': 'Богиня',
      'coach.companion.avatar_female.desc': 'Вдохновляюще, тепло',
      'coach.musicTitle': 'ПЛЕЙЛИСТЫ ДЛЯ ТРЕНИРОВОК',
      'coach.openIn': 'Открыть',
      'coach.play': 'Играть',
      'coach.playing': 'Играет',
      'biometric.insufficientScope': 'Недостаточно прав',
      'biometric.missingScopes': 'Не хватает: {{scopes}}',
      'biometric.grantScopesCta': 'Разрешить',
      'biometric.rateLimited': 'Лимит запросов — повтор через {{seconds}}s',
      'common.continue': 'Далее',
      'onboarding.goalTitle': 'Какова ваша цель?',
      'onboarding.goalSubtitle': 'Выберите главную цель',
      'onboarding.goal.cut': 'Сушка',
      'onboarding.goal.cutSub': 'Сжечь жир, стать рельефным',
      'onboarding.goal.bulk': 'Масса',
      'onboarding.goal.bulkSub': 'Набрать мышцы и силу',
      'onboarding.goal.maintain': 'Поддержание',
      'onboarding.goal.maintainSub': 'Сохранить текущую форму',
      'onboarding.awakeningTitle': 'Вы готовы',
      'onboarding.awakeningSubtitle': 'Как к вам обращаться?',
      'onboarding.namePlaceholder': 'Имя или ник',
      'onboarding.getStarted': 'Начать',
      'sport.bench_press.name': 'Жим лёжа',
      'sport.lunges.name': 'Выпады',
      'sport.jumping_rope.name': 'Скакалка',
      'sport.kickboxing.name': 'Кикбоксинг',
      'sport.volleyball.name': 'Волейбол',
      'sport.ice_skating.name': 'Коньки',
      'sport.crossfit_wod.name': 'CrossFit WOD',
      'sport.foam_rolling.name': 'Миофасциальный релиз',
      'sport.mobility_flow.name': 'Подвижность',
      'common.skip': 'Пропустить',
      'common.next': 'Далее',
      'onboarding.injuryTitle': 'Есть травмы?',
      'onboarding.injurySubtitle': 'Мы адаптируем тренировки, чтобы не нагружать эти зоны. Необязательно.',
      'onboarding.injuryNoneSelected': 'Травм нет — тренировки на полной мощности',
      'onboarding.injuryCount_one': '{{count}} зона защищена',
      'onboarding.injuryCount_few': '{{count}} зоны защищены',
      'onboarding.injuryCount_many': '{{count}} зон защищены',
      'onboarding.injuries.neck': 'Шея',
      'onboarding.injuries.shoulders': 'Плечи',
      'onboarding.injuries.lowerBack': 'Поясница',
      'onboarding.injuries.elbows': 'Локти',
      'onboarding.injuries.wrists': 'Запястья',
      'onboarding.injuries.hips': 'Бёдра',
      'onboarding.injuries.knees': 'Колени',
      'onboarding.injuries.ankles': 'Лодыжки',
      'common.back': 'Назад',
      'common.gotIt': 'Понятно',
      'leaderboard.title': 'Рейтинг',
      'leaderboard.global': 'Глобально',
      'leaderboard.friends': 'Друзья',
      'leaderboard.weekly': 'Неделя',
      'leaderboard.you': 'Вы',
      'leaderboard.energy': 'Энергия',
      'leaderboard.howItWorks': 'Как это работает',
      'leaderboard.noFriends': 'Пока нет друзей',
      'leaderboard.noFriendsDesc': 'Пригласите друзей соревноваться',
      'leaderboard.rule1Title': 'Зарабатывай энергию',
      'leaderboard.rule1': 'Завершай тренировки. Выше сложность + длиннее серия = больше энергии.',
      'leaderboard.rule2Title': 'Три таблицы',
      'leaderboard.rule2': 'Глобальная — все, Друзья — только подписки, Недельная сбрасывается каждый понедельник.',
      'leaderboard.rule3Title': 'Правило угасания',
      'leaderboard.rule3': 'Энергия теряет 5% за неактивный день — постоянство важнее всплесков.',
      'leaderboard.rule4Title': 'Награды',
      'leaderboard.rule4': 'Топ-3 каждой таблицы получают золотую/серебряную/бронзовую рамку профиля.',
      'referral.title': 'Приглашай и зарабатывай',
      'referral.description': 'Пригласи друга — он получит 1 месяц бесплатно, и ты тоже. Без ограничений.',
      'referral.yourId': 'Ваш ID',
      'referral.reward': 'Награда',
      'referral.daysFree': 'дней бесплатно',
      'referral.copy': 'Копировать',
      'referral.copied': 'Скопировано',
      'referral.share': 'Поделиться',
      'referral.shareTitle': 'Попробуй Omnisio Workout',
      'referral.shareText': 'Присоединяйся к Omnisio Workout — мы оба получим месяц Pro бесплатно.',
      'referral.activeStatus': 'Pro активен до',
      'oracle.recentMeals': 'Недавние приёмы',
      'oracle.entryCount_one': '{{count}} запись',
      'oracle.entryCount_few': '{{count}} записи',
      'oracle.entryCount_many': '{{count}} записей',
      'oracle.noScans': 'Сканирований пока нет',
      'oracle.noScansDesc': 'Нажмите «Сканировать», чтобы отслеживать первый приём пищи',
      'oracle.scanNow': 'Сканировать',
      'oracle.todaysTotal': 'Итог за день',
      'oracle.kcal': 'ккал',
      'oracle.macro.protein': 'Белки',
      'oracle.macro.carbs': 'Углеводы',
      'oracle.macro.fat': 'Жиры',
      'oracle.macro.calories': 'Калории',
      'oracle.meal.breakfast': 'Завтрак',
      'oracle.meal.lunch': 'Обед',
      'oracle.meal.dinner': 'Ужин',
      'oracle.meal.snack': 'Перекус',
      'sport.pushups.name': 'Отжимания',
      'sport.squats.name': 'Приседания',
      'sport.plank.name': 'Планка',
      'sport.running.name': 'Бег',
      'sport.yoga.name': 'Йога',
      'sport.boxing.name': 'Бокс',
      'sport.cycling.name': 'Велоспорт',
      'sport.swimming.name': 'Плавание',
      'sport.basketball.name': 'Баскетбол',
      'sport.skiing.name': 'Лыжи',
      'sport.pullups.name': 'Подтягивания',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'Теннис',
      'sport.deadlift.name': 'Становая тяга',
      'sport.pilates.name': 'Пилатес',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'Гребля',
      'sport.dance.name': 'Танцы фитнес',
      'sport.stretching.name': 'Растяжка',
      'sport.kettlebell.name': 'Гиря',
      'sport.football.name': 'Футбол',
      'workout.cat.all': 'ВСЕ',
      'workout.cat.strength': 'СИЛА',
      'workout.cat.cardio': 'КАРДИО',
      'workout.cat.flexibility': 'ГИБКОСТЬ',
      'workout.cat.combat': 'БОЕВЫЕ',
      'workout.cat.team': 'КОМАНДНЫЕ',
      'workout.cat.winter': 'ЗИМНИЕ',
      'workout.cat.functional': 'ФУНКЦИОНАЛЬНЫЕ',
      'workout.noEquipment': 'Без снаряжения',
      'workout.instructions': 'Инструкции',
      'workout.commonMistakes': 'Частые ошибки',
      'workout.easier': 'Легче',
      'workout.harder': 'Сложнее',
      'workout.repsCount_one': '{{count}} повтор',
      'workout.repsCount_few': '{{count}} повтора',
      'workout.repsCount_many': '{{count}} повторов',
      'workout.countSports_one': '{{count}} вид',
      'workout.countSports_few': '{{count}} вида',
      'workout.countSports_many': '{{count}} видов',
      'workout.noSports': 'Виды спорта не найдены',
      'settings.general': 'Общие',
      'settings.proActive': 'Pro Активно',
      'settings.freeTrial': 'Пробная версия',
      'settings.allUnlocked': 'Все функции разблокированы',
      'settings.upgradeFull': 'Получить полный доступ',
      'settings.upgrade': 'Улучшить',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Синхронизация данных',
      'settings.dataSyncDesc': 'Синхронизация со всей экосистемой Omnisio',
      'settings.logout': 'Выйти',
      // App
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Закрытый фитнес-клуб',

      // Navigation
      'nav.home': 'Главная',
      'nav.workout': 'Тренировка',
      'nav.nutri': 'Питание',
      'nav.history': 'История',
      'nav.memory': 'Воспоминания',
      'nav.radio': 'Радио',
      'nav.shop': 'Магазин',
      'nav.profile': 'Профиль',
      'nav.more': 'Ещё',
      'nav.coach': 'Тренер',

      // Home
      'home.welcome': 'Привет, {{name}}',
      'home.dailyEnergy': 'Дневная энергия',
      'home.startWorkout': 'Начать тренировку',
      'home.yourTotem': 'Твой маскот',
      'home.todaysMissions': 'Цели на сегодня',
      'home.leaderboard': 'Рейтинг',
      'home.syndicates': 'Команды',
      'home.biohacks': 'Испытания',

      // Energy
      'energy.exercise': 'Упражнения',
      'energy.music': 'Музыка',
      'energy.total': 'Общая энергия',
      'energy.streak': '{{count}} дн. подряд',
      'energy.streakFire': 'Серия',

      // Workout
      'workout.title': 'Тренировка',
      'workout.camera': 'Камера-трекинг',
      'workout.startSession': 'Начать сессию',
      'workout.endSession': 'Завершить сессию',
      'workout.reps': 'Повторения',
      'workout.calories': 'Калории',
      'workout.duration': 'Длительность',
      'workout.exerciseComplete': 'Упражнение выполнено!',
      'workout.energyEarned': '+{{amount}} Энергии',
      'workout.plank': 'Планка',
      'workout.pushups': 'Отжимания',
      'workout.squats': 'Приседания',
      'workout.overview': 'Обзор',
      'workout.history': 'История',
      'workout.progress': 'Прогресс',
      'workout.personalRecords': 'Личные рекорды',
      'workout.share': 'Поделиться',
      'workout.done': 'Готово',

      // Oracle / Nutri Vision
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Сканировать еду',
      'oracle.history': 'История сканирований',
      'oracle.scanning': 'Анализирую...',
      'oracle.dailyNorm': 'Дневная норма',
      'oracle.scansLeft': 'Осталось {{count}} сканирований',
      'oracle.upgrade': 'Улучшить для безлимита',
      'oracle.protein': 'Белки',
      'oracle.carbs': 'Углеводы',
      'oracle.fat': 'Жиры',
      'oracle.calories': 'Калории',

      // Memory
      'memory.title': 'Воспоминания',
      'memory.upload': 'Загрузить воспоминание',
      'memory.stake': 'Застейкать энергию',
      'memory.network': 'Глобальная сеть Proof-of-Energy',

      // Calendar / History
      'calendar.title': 'История',
      'calendar.fitness': 'Фитнес',
      'calendar.nutrition': 'Питание',
      'calendar.protocols': 'Протоколы',

      // Shop
      'shop.title': 'Магазин',
      'shop.avatars': 'Аватары',
      'shop.boosters': 'Бустеры',
      'shop.cosmetics': 'Косметика',
      'shop.buy': 'Купить',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Куплено',
      'shop.equipped': 'Надето',

      // Profile
      'profile.title': 'Профиль',
      'profile.level': 'Уровень {{level}}',
      'profile.totalWorkouts': 'Всего тренировок',
      'profile.totalTokens': 'Всего токенов',
      'profile.achievements': 'Достижения',
      'profile.settings': 'Настройки',
      'profile.totem': 'Маскот',

      // Leaderboard
      'leaderboard.title': 'Рейтинг',
      'leaderboard.global': 'Глобальный',
      'leaderboard.syndicate': 'Команда',
      'leaderboard.weekly': 'Неделя',
      'leaderboard.allTime': 'Всё время',
      'leaderboard.rank': 'Место',

      // Syndicates/Teams
      'syndicates.title': 'Команды',
      'syndicates.join': 'Вступить',
      'syndicates.create': 'Создать команду',
      'syndicates.members': '{{count}} участников',
      'syndicates.power': 'Мощность',

      // Biohacks/Challenges
      'biohacks.title': 'Испытания',
      'biohacks.protocols': 'Программы',
      'biohacks.missions': 'Цели',
      'biohacks.active': 'Активные',
      'biohacks.completed': 'Завершённые',
      'biohacks.reward': 'Награда: {{amount}} TKN',

      // Avatar
      'avatar.title': 'Аватар',
      'avatar.customize': 'Настроить',
      'avatar.skin': 'Скин',
      'avatar.outfit': 'Одежда',
      'avatar.accessories': 'Аксессуары',
      'avatar.save': 'Сохранить',

      // Radio
      'radio.title': 'Gym Радио',
      'radio.nowPlaying': 'Сейчас играет',
      'radio.stations': 'Станции',
      'radio.energyBonus': '+Энергия при прослушивании',

      // Coach
      'coach.title': 'Тренер',
      'coach.subtitle': 'Твой AI-помощник по фитнесу прямо в наушнике',
      'coach.tabVoice': 'Голос',
      'coach.tabSoundscape': 'Атмосфера',
      'coach.tabMusic': 'Музыка',
      'coach.chooseVoice': 'Выбери голос тренера',
      'coach.samples': 'Послушай примеры',
      'coach.samplePreWorkout': 'Перед тренировкой',
      'coach.sampleSetComplete': 'Подход завершён',
      'coach.sampleHalfway': 'Половина пути',
      'coach.sampleFinalSet': 'Последний подход',
      'coach.sampleWorkoutDone': 'Тренировка завершена',
      'coach.voiceCoachToggle': 'Голосовой тренер во время тренировки',
      'coach.proRequired': 'Pro нужен для всех голосов',
      'coach.upgrade': 'Улучшить',
      'coach.soundscapeFocus': 'Фокус',
      'coach.soundscapeFocusDesc': 'Альфа-волны для глубокой концентрации',
      'coach.soundscapeCardio': 'Кардио',
      'coach.soundscapeCardioDesc': 'Высокий BPM для бега и HIIT',
      'coach.soundscapeRecovery': 'Восстановление',
      'coach.soundscapeRecoveryDesc': 'Медленный ритм для растяжки',
      'coach.soundscapeSleep': 'Подготовка ко сну',
      'coach.soundscapeSleepDesc': 'Розовый шум и звуки природы',
      'coach.soundscapeComingSoon': 'Скоро',
      'coach.musicHeader': 'Открой любимое приложение',
      'coach.musicSpotify': 'Открыть в Spotify',
      'coach.musicApple': 'Открыть в Apple Music',
      'coach.musicYoutube': 'Открыть в YouTube Music',
      'coach.workoutPlaylist': 'Тренировочный плейлист',

      // Settings
      'settings.title': 'Настройки',
      'settings.language': 'Язык',
      'settings.notifications': 'Уведомления',
      'settings.sound': 'Звук',
      'settings.haptics': 'Вибрация',
      'settings.about': 'О приложении',
      'settings.version': 'Версия',
      'settings.aiEngine': 'Движок ИИ',
      'settings.wearables': 'Био-устройства',
      'settings.bioWearables': 'Био-устройства',
      'settings.omnisioBand': 'Omnisio Браслет',
      'settings.omnisioBandDesc': 'Нативный SDK · Биометрия в реальном времени',
      'settings.omnisioRing': 'Omnisio Кольцо',
      'settings.omnisioRingDesc': 'Нативный SDK · Заряд 7 дней, сон + ВСР',
      'settings.thirdPartySync': 'Стороннее · Подключите для синхронизации',
      'settings.dataSync': 'Синхронизация данных',
      'settings.upgrade': 'Улучшить',
      'settings.logout': 'Выйти',

      // Onboarding
      'onboarding.welcome': 'Добро пожаловать в Omnisio Workout',
      'onboarding.subtitle': 'Ваш фитнес-путь начинается здесь',
      'onboarding.selectExercise': 'Выберите первое упражнение',
      'onboarding.pushups': 'Отжимания',
      'onboarding.squats': 'Приседания',
      'onboarding.getStarted': 'Начать',
      'onboarding.skip': 'Пропустить',

      // Common
      'common.loading': 'Загрузка...',
      'common.error': 'Что-то пошло не так',
      'common.retry': 'Повторить',
      'common.back': 'Назад',
      'common.save': 'Сохранить',
      'common.cancel': 'Отмена',
      'common.confirm': 'Подтвердить',
      'common.close': 'Закрыть',
      'common.tokens': 'Токены',
      'common.soon': 'Скоро',
      'common.viewAll': 'Все',

      // Profile (extended)
      'profile.workouts': 'Тренировки',
      'profile.hours': 'Часы',
      'profile.totalXP': 'Всего XP',
      'profile.personalRecords': 'Личные рекорды',
      'profile.connectedServices': 'Подключённые сервисы',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Подключено',
      'profile.connect': 'Подключить',
      'profile.helpSupport': 'Помощь и поддержка',
      'profile.signOut': 'Выйти',
      'profile.contactShipping': 'Контакты и доставка',
      'profile.complete': 'Заполнено',
      'profile.incompleteForOrders': 'Требуется для заказа добавок',
      'profile.email': 'Email',
      'profile.phone': 'Телефон',
      'profile.address': 'Адрес',
      'profile.country': 'Страна',
      'profile.addressPlaceholder': 'Улица, город, индекс',
      'profile.privacyNote': 'Ваши контакты хранятся локально и передаются Celliva только при оформлении заказа. KVKK/GDPR совместимо.',
      'profile.invalidEmail': 'Неверный формат email',
      'profile.invalidPhone': 'Слишком короткий телефон',
      'profile.invalidAddress': 'Слишком короткий адрес',

      // Achievements
      'achievements.firstWorkout': 'Первая тренировка',
      'achievements.sevenDayStreak': 'Серия 7 дней',
      'achievements.plankMaster': 'Мастер планки',
      'achievements.earlyBird': 'Ранняя пташка',
      'achievements.perfectionist': 'Перфекционист',
      'achievements.hundredWorkouts': '100 тренировок',
      'achievements.marathon': 'Марафон',
      'achievements.nightOwl': 'Сова',

      // Shop (extended)
      'shop.subtitle': 'Открывайте спутников, бустеры и экипировку',
      'shop.tabCompanions': 'Спутники',
      'shop.tabBoosters': 'Бустеры',
      'shop.tabOutfits': 'Наряды',
      'shop.tabThemes': 'Темы',
      'shop.free': 'Бесплатно',
      'shop.levelRequired': 'Требуется уровень {{level}}',
      'shop.unlockFor': 'Открыть за {{price}} ⚡',
      'shop.insufficientXP': 'Недостаточно XP (нужно {{price}} ⚡)',
      'shop.viewPack': 'Открыть набор',
      'shop.recentActivity': 'Недавняя активность',
      'shop.earnMoreXP': 'Заработать больше XP',
      'shop.completeWorkout': 'Завершите тренировку',
      'shop.startWorkout': 'Начать тренировку',
      'shop.tabSupplements': 'Добавки',
      'shop.poweredByCelliva': 'Powered by Celliva',
      'shop.cellivaTagline': 'Премиум добавки · Бесплатная доставка от $50',
      'shop.buyOnCelliva': 'Купить на Celliva',
      'shop.supplementsHeader': 'Заряди свою тренировку',
      'shop.supplementsSubtitle': 'Лабораторно проверено, сертифицировано',

      // Каталог игрового магазина (компаньоны / бустеры / наряды / темы)
      'shop.item.phoenix.name': 'Феникс',
      'shop.item.phoenix.desc': 'Восстаёт из пепла',
      'shop.item.phoenix.long': 'Бессмертный Феникс выбрал тебя своим напарником. Рождённый из огня и возрождающийся сильнее с каждым разом, он подпитывает твоё стремление превзойти любой предел.',
      'shop.item.phoenix.stat.0.label': 'Бонус XP',
      'shop.item.phoenix.stat.0.value': '+10% на всех тренировках',
      'shop.item.bonsai.name': 'Дерево бонсай',
      'shop.item.bonsai.desc': 'Растёт с терпением',
      'shop.item.bonsai.long': 'Живая скульптура, отражающая твою дисциплину. Бонсай развивается по мере формирования привычек, награждая постоянство редкими визуальными улучшениями.',
      'shop.item.bonsai.stat.0.label': 'Бонус серии',
      'shop.item.bonsai.stat.0.value': '+15% после 7-дневной серии',
      'shop.item.orb.name': 'Энергосфера',
      'shop.item.orb.desc': 'Направь чистую энергию',
      'shop.item.orb.long': 'Сфера сгущённой биоэнергии, усиливающая каждое твоё повторение. Пульсирует ярче, чем усерднее ты тренируешься.',
      'shop.item.orb.stat.0.label': 'Восстановление энергии',
      'shop.item.orb.stat.0.value': '+5 энергии за тренировку',
      'shop.item.avatar.name': 'Воин',
      'shop.item.avatar.desc': 'Выкуй свою силу',
      'shop.item.avatar.long': 'Закалённый в боях аватар, воплощающий пик физического потенциала. Открывает особые анимации воинских испытаний.',
      'shop.item.avatar.stat.0.label': 'XP силы',
      'shop.item.avatar.stat.0.value': '+12% на силовых тренировках',
      'shop.item.avatar_female.name': 'Богиня',
      'shop.item.avatar_female.desc': 'Высвободи свою мощь',
      'shop.item.avatar_female.long': 'Она направляет весь спектр человеческого потенциала — грацию, выносливость и чистую силу. Мифическое присутствие, возвышающее каждую тренировку.',
      'shop.item.avatar_female.stat.0.label': 'Весь XP',
      'shop.item.avatar_female.stat.0.value': '+20% из любого источника',
      'shop.item.wolf.name': '???',
      'shop.item.wolf.desc': 'Скоро',
      'shop.item.wolf.long': 'Существо тени и инстинкта. Достигни 7 уровня, чтобы открыть этого компаньона.',
      'shop.item.xp_2x_24h.name': '2× XP на 24 ч',
      'shop.item.xp_2x_24h.desc': 'Двойной XP из всех источников в течение 24 часов',
      'shop.item.xp_2x_24h.long': 'Каждая тренировка, отметка привычки и бонус серии удваиваются на целый день. Сочетай с тренировкой для максимального прироста.',
      'shop.item.xp_2x_24h.stat.0.label': 'Эффект',
      'shop.item.xp_2x_24h.stat.0.value': 'Множитель XP 2×',
      'shop.item.xp_2x_24h.stat.1.label': 'Длительность',
      'shop.item.xp_2x_24h.stat.1.value': '24 часа',
      'shop.item.streak_freeze.name': 'Заморозка серии',
      'shop.item.streak_freeze.desc': 'Защити серию при одном пропущенном дне',
      'shop.item.streak_freeze.long': 'Бывает всякое. Заморозка серии сохраняет твою с трудом заработанную серию при одном пропущенном дне — без лишних вопросов.',
      'shop.item.streak_freeze.stat.0.label': 'Эффект',
      'shop.item.streak_freeze.stat.0.value': 'Пропусти 1 день, серия цела',
      'shop.item.streak_freeze.stat.1.label': 'Использований',
      'shop.item.streak_freeze.stat.1.value': 'Одноразовый',
      'shop.item.energy_boost.name': 'Мгновенно +50 энергии',
      'shop.item.energy_boost.desc': 'Мгновенно добавь 50 энергии к сегодняшнему дню',
      'shop.item.energy_boost.long': 'Прямая инъекция 50 очков энергии, мгновенно зачисляемых к сегодняшнему итогу.',
      'shop.item.energy_boost.stat.0.label': 'Эффект',
      'shop.item.energy_boost.stat.0.value': '+50 энергии сейчас',
      'shop.item.energy_boost.stat.1.label': 'Использований',
      'shop.item.energy_boost.stat.1.value': 'Одноразовый',
      'shop.item.workout_quick.name': '5-мин буст энергии',
      'shop.item.workout_quick.desc': 'Пропусти разминку, начни свежим',
      'shop.item.workout_quick.long': 'Цифровым образом предварительно активирует мышцы, чтобы ты сразу приступил к тренировке на пике эффективности.',
      'shop.item.workout_quick.stat.0.label': 'Эффект',
      'shop.item.workout_quick.stat.0.value': 'Пропуск фазы разминки',
      'shop.item.workout_quick.stat.1.label': 'Использований',
      'shop.item.workout_quick.stat.1.value': 'Одноразовый',
      'shop.item.cyber.name': 'Кибер-облик',
      'shop.item.cyber.desc': 'Неоновый наряд для компаньона',
      'shop.item.cyber.long': 'Футуристичный костюм с неоновой сеткой, облекающий твоего компаньона в эстетику атлета будущего.',
      'shop.item.cyber.stat.0.label': 'Визуал',
      'shop.item.cyber.stat.0.value': 'Неоновое свечение + шлейф частиц',
      'shop.item.royal.name': 'Королевская мантия',
      'shop.item.royal.desc': 'Премиальные золотые акценты',
      'shop.item.royal.long': 'Облачённая в глубокий багрянец с вышивкой золотой нитью — предназначена для чемпионов, заслуживших право царствовать.',
      'shop.item.royal.stat.0.label': 'Визуал',
      'shop.item.royal.stat.0.value': 'Золотая мерцающая аура',
      'shop.item.royal.stat.1.label': 'Аура XP',
      'shop.item.royal.stat.1.value': '+5% за дни серии',
      'shop.item.minimal.name': 'Минимал',
      'shop.item.minimal.desc': 'Чистый монохромный вид',
      'shop.item.minimal.long': 'Меньше — значит больше. Лаконичный монохромный наряд, позволяющий говорить твоим результатам.',
      'shop.item.minimal.stat.0.label': 'Визуал',
      'shop.item.minimal.stat.0.value': 'Монохромная палитра',
      'shop.item.cosmic.name': 'Космос',
      'shop.item.cosmic.desc': 'Эффекты звёзд и туманности',
      'shop.item.cosmic.long': 'Твой компаньон становится галактикой в движении — кружащиеся туманности и частицы звёздного поля следуют за каждым движением.',
      'shop.item.cosmic.stat.0.label': 'Визуал',
      'shop.item.cosmic.stat.0.value': 'Галактическая система частиц',
      'shop.item.midnight.name': 'Полночь',
      'shop.item.midnight.desc': 'Тёмная тема по умолчанию',
      'shop.item.midnight.long': 'Классическая тёмная тема Omnisio. Глубокий чёрный и бирюзовые акценты — клинично, точно, мощно.',
      'shop.item.midnight.stat.0.label': 'Палитра',
      'shop.item.midnight.stat.0.value': 'Чёрный + бирюзовый',
      'shop.item.aurora.name': 'Аврора',
      'shop.item.aurora.desc': 'Градиент северного сияния',
      'shop.item.aurora.long': 'Плавные градиенты от зелёного к фиолетовому, вдохновлённые северным сиянием. Живое небо над головой.',
      'shop.item.aurora.stat.0.label': 'Палитра',
      'shop.item.aurora.stat.0.value': 'Изумрудный + фиолетовый',
      'shop.item.sunset.name': 'Закат',
      'shop.item.sunset.desc': 'Тёплое золото + маджента',
      'shop.item.sunset.long': 'Последний свет дня — янтарный, золотой и глубокая маджента, наслоённые, словно пылающий горизонт.',
      'shop.item.sunset.stat.0.label': 'Палитра',
      'shop.item.sunset.stat.0.value': 'Золотой + маджента',
      'shop.item.ocean.name': 'Океанские глубины',
      'shop.item.ocean.desc': 'Эстетика глубокого бирюзового',
      'shop.item.ocean.long': 'Погрузись в бездну. Глубокий бирюзовый фон с биолюминесцентными синими акцентами передаёт давящую тишину глубин океана.',
      'shop.item.ocean.stat.0.label': 'Палитра',
      'shop.item.ocean.stat.0.value': 'Глубокий бирюзовый + синий',
      'shop.featuredPack.name': 'Весенний набор',
      'shop.featuredPack.tagline': 'Набор из 3 предметов — экономия 40%',
      'shop.featuredPack.countdown': 'Заканчивается через 3д 14ч',
      'shop.featuredPack.item.0': 'Дерево бонсай',
      'shop.featuredPack.item.1': 'Тема Аврора',
      'shop.featuredPack.item.2': '2× XP на 24 ч',

      // Celliva Dispensary
      'shop.celliva.title': 'Аптека Celliva',
      'shop.celliva.eyebrow': 'Автономное исполнение',
      'shop.celliva.tabMarketplace': 'Маркетплейс',
      'shop.celliva.tabGameStore': 'Игровой магазин',
      'shop.celliva.predictiveTitle': 'Предиктивный движок',
      'shop.celliva.predictiveBody': 'Запас {{product}} закончится через {{days}} дней.',
      'shop.celliva.authorizeDispatch': 'Подтвердить отправку',
      'shop.celliva.calibrationTitle': 'Калибровка протокола',
      'shop.celliva.calibrationQuestion': '{{product}} улучшил ваш {{outcome}}?',
      'shop.celliva.calibrationYes': 'Да — оптимально',
      'shop.celliva.calibrationNo': 'Без изменений',
      'shop.celliva.calibrationDismiss': 'Закрыть',
      'shop.celliva.calibrationThanks': 'Калибровка записана. Протокол скорректирован.',
      'shop.celliva.closedLoopTitle': 'Замкнутый цикл активен',
      'shop.celliva.closedLoopBody': 'Биомаркеры питают аптеку. Повторные заказы подстраиваются под ваши данные.',
      'shop.celliva.targetedInterventions': 'Точечные вмешательства',
      'shop.celliva.viewDetails': 'Подробнее',
      'shop.celliva.hideDetails': 'Скрыть детали',
      'shop.celliva.dosage': 'Дозировка',
      'shop.celliva.ingredients': 'Ингредиенты',
      'shop.celliva.studies': 'Клинические источники',
      'shop.celliva.addToCart': 'В корзину',
      'shop.celliva.inCart': 'В корзине ({{qty}})',
      'shop.celliva.checkout': 'Оформить на Celliva',
      'shop.celliva.cartEmpty': 'Корзина пуста',
      'shop.celliva.cartTotal': 'Итого',
      'shop.celliva.catLongevity': 'Долголетие',
      'shop.celliva.catCognitive': 'Когниция',
      'shop.celliva.catRecovery': 'Восстановление',
      'shop.celliva.catPerformance': 'Результативность',
      'shop.celliva.catAll': 'Все',
      'shop.celliva.downloadCatalog': 'Скачать каталог',
      'shop.celliva.bestseller': 'Бестселлер',
      'shop.celliva.clinical': 'Клинический',
      'shop.celliva.verified': 'Проверено лабораторией',
      'shop.celliva.proRequired': 'Pro-уровень открывает Smart Reorder и Калибровку',
      'shop.celliva.eliteDnaBanner': 'На основе вашего статуса APOE ε4 — приоритет когнитивной поддержке',
      'shop.celliva.kvkkNote': 'Данные доставки покидают устройство только при оформлении заказа на Celliva.life.',

      // Rarity
      'rarity.common': 'Обычное',
      'rarity.rare': 'Редкое',
      'rarity.epic': 'Эпическое',
      'rarity.legendary': 'Легендарное',

      // Memory (extended)
      'memory.community': 'Сообщество',
      'memory.demoMode': 'Демо-режим · Подключите Supabase для реальных данных',
      'memory.boost': 'Буст',
      'memory.boostXPNote': '+10 XP за публикацию энергии',
      'memory.noPostsTitle': 'Пока нет постов',
      'memory.noPostsDesc': 'Будьте первым, кто поделится тренировкой',
      'memory.allCaughtUp': 'Всё прочитано',

      // Calendar (extended)
      'calendar.history': 'История',
      'calendar.workouts': 'Тренировки',
      'calendar.kcal': 'ккал',
      'calendar.streak': 'Серия',
      'calendar.energy': 'Энергия',
      'calendar.tabFitness': 'Фитнес',
      'calendar.tabNutrition': 'Питание',
      'calendar.tabProtocols': 'Протоколы',
      'calendar.restDay': 'День отдыха',
      'calendar.restDayDesc': 'Активность не записана. Каждому чемпиону нужно восстановление.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'ДЕФИЦИТ КАЛОРИЙ',
      'oracle.alertLowProtein': 'НИЗКИЙ БЕЛОК',
      'oracle.alertPerfectDay': 'ИДЕАЛЬНЫЙ ДЕНЬ',
      'oracle.dailyCalories': 'Калории за день',
      'oracle.tabScan': 'Скан',
      'oracle.tabHistory': 'История',
      'oracle.tapToScan': 'Наведите камеру на еду и нажмите кнопку ниже',
      'oracle.freeScans': '{{used}}/{{max}} бесплатных сканов',
      'oracle.upgradePro': 'Перейти на Pro',
      'oracle.scanFood': 'Сканировать еду',
      'oracle.scanAgain': 'Сканировать снова',
      'oracle.addToLog': 'Добавить в дневник',

      // Paywall
      'paywall.chooseLevel': 'Выберите уровень',
      'paywall.restorePurchase': 'Восстановить покупку',
      'paywall.maybeLater': 'Может позже',

      // Workout (extended)
      'workout.searchPlaceholder': 'Поиск видов спорта...',
      'workout.musclesWorked': 'Задействованные мышцы',
      'workout.primary': 'Основные',
      'workout.secondary': 'Дополнительные',
      'workout.exercises': 'Упражнения',
      'workout.warmUp': 'Разминка',
      'workout.coolDown': 'Заминка',
      'workout.startCTA': 'Начать {{level}} {{sport}}',
      'workout.rest': 'Отдых',
      'workout.skipRest': 'Пропустить отдых',
      'workout.upNext': 'Далее',
      'workout.setOf': 'Подход {{current}} из {{total}}',
      'workout.formTips': 'Советы по технике',
      'workout.resume': 'Продолжить',
      'workout.pause': 'Пауза',
      'workout.skip': 'Пропустить',
      'workout.complete': 'Тренировка завершена',
      'workout.sets': 'Подходы',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Дальше: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Проверь форму: {{tip}}',

      // Онбординг — пол и возраст
      'onboarding.aboutTitle': 'О тебе',
      'onboarding.aboutSubtitle': 'Расскажи нам о себе',
      'onboarding.gender.male': 'Мужской',
      'onboarding.gender.female': 'Женский',
      'onboarding.gender.other': 'Другой',
      'onboarding.howOld': 'Сколько тебе лет?',
      'onboarding.yearsOld': 'лет',

      // Онбординг — тело
      'onboarding.bodyTitle': 'Твоё тело',
      'onboarding.bodySubtitle': 'Чтобы рассчитать твой план',
      'onboarding.weight': 'Вес',
      'onboarding.height': 'Рост',
      'onboarding.targetWeight': 'Целевой вес (необязательно)',

      // Онбординг — уровень активности
      'onboarding.activityTitle': 'Уровень активности',
      'onboarding.activitySubtitle': 'Влияет на суточную потребность в калориях',
      'onboarding.activity.sedentary': 'Малоподвижный',
      'onboarding.activity.sedentarySub': 'Мало или совсем нет тренировок',
      'onboarding.activity.light': 'Лёгкий',
      'onboarding.activity.lightSub': '1–3 дня в неделю',
      'onboarding.activity.moderate': 'Умеренный',
      'onboarding.activity.moderateSub': '3–5 дней в неделю',
      'onboarding.activity.high': 'Высокий',
      'onboarding.activity.highSub': '6–7 дней в неделю',
      'onboarding.activity.extreme': 'Экстремальный',
      'onboarding.activity.extremeSub': 'Атлет / два раза в день',
      'onboarding.calculatePlan': 'Рассчитать мой план',

      // Онбординг — расчёт
      'onboarding.calculatingTitle': 'Рассчитываем твой план…',
      'onboarding.calcMsg1': 'Анализируем метаболизм…',
      'onboarding.calcMsg2': 'Вычисляем TDEE…',
      'onboarding.calcMsg3': 'Оптимизируем баланс макросов…',
      'onboarding.calcMsg4': 'Создаём персональный план…',
      'onboarding.calcMsg5': 'Почти готово…',
      'onboarding.planReadyTitle': 'План готов!',
      'onboarding.planReadySubtitle': 'Твои персональные суточные цели',
      'onboarding.dailyCalories': 'Суточные калории',
      'onboarding.kcalPerDay': 'ккал / день',
      'onboarding.macroSplit': 'Распределение макросов',
      'onboarding.macroProtein': 'Белки',
      'onboarding.macroCarbs': 'Углеводы',
      'onboarding.macroFat': 'Жиры',
      'onboarding.timeframe': 'Срок',
      'onboarding.timeframe1m': '1 месяц',
      'onboarding.timeframe3m': '3 месяца',
      'onboarding.timeframe6m': '6 месяцев',
      'onboarding.timeframe12m': '1 год',
      'onboarding.chooseCompanion': 'Выбрать компаньона',

      // Онбординг — компаньон
      'onboarding.companionTitle': 'Выбери компаньона',
      'onboarding.companionSubtitle': 'Компаньон развивается вместе с тренировками',

      // Календарь
      'calendar.noMealsTitle': 'Нет записей о питании',
      'calendar.noMealsDesc': 'Открой вкладку питания, чтобы записать приёмы пищи за этот день.',
      'calendar.noProtocolsTitle': 'Протоколы не записаны',
      'calendar.noProtocolsDesc': 'За этот день нет биохаков. Продолжай придерживаться режима.',

      // Воспоминания
      'memory.loadError': 'Не удалось загрузить записи',

      // Синдикаты
      'syndicates.messagePlaceholder': 'Написать в клан…',
      'syndicates.noClanTitle': 'Клана пока нет',
      'syndicates.noClanDesc': 'Вступи в синдикат, чтобы соревноваться с другими',
      'syndicates.browseCta': 'Найти кланы',

      // Биометрическая полоса
      'biometric.recovery': 'Восстановление',
      'biometric.bodyBattery': 'Заряд тела',
      'biometric.hrv': 'ВСР',
      'biometric.hrvDelta': '{{delta}} от базовой линии',
      'biometric.todayBadge': 'Сегодня',
      'biometric.rest': 'День отдыха',
      'biometric.moderate': 'Умеренная',
      'biometric.intense': 'Интенсивная',
      'biometric.consentRequired': 'Подключиться к Longevity',
      'biometric.consentRequiredDesc': 'Разреши доступ для Тренировки в настройках Longevity',
      'biometric.baselineNotSet': 'Заполни базовую линию в Longevity',
      'biometric.offline': 'Офлайн',
      'biometric.demoData': 'Демо-данные',
      'biometric.staleBadge': '{{minutes}} мин. назад',
      'biometric.connectCta': 'Подключить',
      'biometric.connectingFromYou': 'Показать в Тренировке',

      // Уведомления
      'notif.morning.title': 'Доброе утро!',
      'notif.morning.body': '{{companion}} готов тренироваться вместе с тобой.',
      'notif.evening.title': 'Тренировка сегодня?',
      'notif.evening.body': 'Даже 10-минутный подход сохранит твою серию.',
      'notif.streak.title': 'Серия {{streak}} дней под угрозой!',
      'notif.streak.body': 'Быстрая разминка поможет сохранить серию.',
      'notif.companion.title': '{{companion}} здесь',
      'notif.companion.body': 'Есть минутка подвигаться сегодня?',
      'notif.recovery.title': 'Режим восстановления активен',
      'notif.recovery.body': 'После вчерашней тяжёлой тренировки рекомендуем NMN + магний.',
      'notif.defaultCompanion': 'Твой компаньон',
      'notif.preprompt.title': 'Оставайся в форме',
      'notif.preprompt.subtitle': 'Ежедневные напоминания — отключи в любой момент.',
      'notif.preprompt.benefit1': 'Утренняя мотивация для начала дня',
      'notif.preprompt.benefit2': 'Защита серии, чтобы не терять прогресс',
      'notif.preprompt.benefit3': 'Напоминание о восстановлении после тяжёлых тренировок',
      'notif.preprompt.benefit4': 'Компаньон проверяет тебя 1–2 раза в неделю',
      'notif.preprompt.allow': 'Включить уведомления',
      'notif.preprompt.skip': 'Не сейчас',
      'home.longevityId': 'ID долголетия',
      'home.sleep': 'Сон',
      'home.water': 'Вода',
      'home.steps': 'Шаги',
      'profile.activity': 'Активность',
      'profile.emptyJourney': 'Твой путь начинается с одной тренировки.',
      'profile.startNow': 'Начать сейчас →',
      'profile.thisWeek': 'на этой неделе',
      'profile.editProfileAria': 'Редактировать профиль',
      'profile.phoneCountryAria': 'Код страны телефона',
      'memory.energyPoints': 'Очки энергии',
      'memory.uploadAria': 'Загрузить воспоминание',
      'calendar.synergy': 'СИНЕРГИЯ',
      'calendar.today': 'Сегодня',
      'biohacks.synergyBonus': 'Бонус синергии',
      'biohacks.synergyDesc': 'Заверши все протоколы категории — получи бонус энергии ×1,5',
      'shop.featured': 'Рекомендуем',
      'syndicates.clanPower': 'Сила клана',
      'biometric.alternatives': 'Альтернативы',
      'biometric.loadingAria': 'Загрузка биометрических данных',
      'biometric.overviewAria': 'Биометрический обзор от Longevity',
      'dragon.energy': 'Энергия',
      'nav.openSettingsAria': 'Открыть настройки',
      'nav.dismissAria': 'Закрыть',
      'nav.moreOptionsAria': 'Больше опций',
      'nav.closeMenuAria': 'Закрыть меню',
      'nav.primaryAria': 'Основная навигация',
      'nav.moreNavAria': 'Больше навигационных опций',
      'common.copiedToClipboard': 'Скопировано в буфер!',
      'paywall.noPreviousPurchase': 'Прошлых покупок не найдено. Оформи подписку, чтобы открыть Pro-функции.',
      'common.back': 'Назад',
      'dragon.stage': 'Стадия',
      'dragon.levelShort': 'Ур.',
      'dragon.evolved': 'ЭВОЛЮЦИЯ!',
      'dragon.evolving': 'Эволюция...',
      'dragon.feeding': 'Кормление...',
      'dragon.notEnoughEnergy': 'Недостаточно энергии',
      'dragon.feedToEvolve': 'Покормить для эволюции',
      'dragon.maxEvolution': 'Достигнута максимальная эволюция',
      'dragon.elderFormUnlocked': 'Аватар-старец · Божественная форма открыта',
      'dragon.stageName.initiate': 'Послушник',
      'dragon.stageName.apprentice': 'Ученик',
      'dragon.stageName.adept': 'Знаток',
      'dragon.stageName.warrior': 'Воин',
      'dragon.stageName.master': 'Мастер',
      'dragon.stageName.grandmaster': 'Гроссмейстер',
      'dragon.stageName.elder': 'Аватар-старец',
      'syndicates.roleCommanderShort': 'КМД',
      'syndicates.roleOfficerShort': 'ОФЦ',
      'syndicates.kick': 'Исключить',
      'syndicates.overview': 'Обзор',
      'syndicates.roster': 'Состав',
      'syndicates.comms': 'Связь',
      'syndicates.globalRankShort': 'Мировой',
      'syndicates.membersLabel': 'участников',
      'syndicates.joinBattle': 'В бой',
      'syndicates.globalRank': 'Мировой ранг',
      'syndicates.weeklyEp': 'ЭП за неделю',
      'syndicates.inviteRecruits': 'Пригласить новичков',
      'syndicates.activeMembers': '{{count}} активных участников',
      'syndicates.epThisWeek': '{{ep}} ЭП на этой неделе',
      'syndicates.clanChat': 'Чат клана',
      'syndicates.online': '{{count}} в сети',
      'leaderboard.dayStreak': 'Серия из {{count}} дней',
      'leaderboard.lvlShort': 'Ур.',
      'calendar.weeklyEnergy': 'Энергия за 7 дней',
      'calendar.legendWorkout': 'Тренировка',
      'calendar.legendPerfect': 'Идеально',
      'calendar.legendRest': 'Отдых',
      'calendar.activityLog': 'Журнал активности',
      'calendar.showAll': 'Показать все',
      'calendar.monthApr': 'Апр',
      'calendar.month.january': 'Январь',
      'calendar.month.february': 'Февраль',
      'calendar.month.march': 'Март',
      'calendar.month.april': 'Апрель',
      'calendar.month.may': 'Май',
      'calendar.month.june': 'Июнь',
      'calendar.month.july': 'Июль',
      'calendar.month.august': 'Август',
      'calendar.month.september': 'Сентябрь',
      'calendar.month.october': 'Октябрь',
      'calendar.month.november': 'Ноябрь',
      'calendar.month.december': 'Декабрь',
      'calendar.day.sun': 'ВС',
      'calendar.day.mon': 'ПН',
      'calendar.day.tue': 'ВТ',
      'calendar.day.wed': 'СР',
      'calendar.day.thu': 'ЧТ',
      'calendar.day.fri': 'ПТ',
      'calendar.day.sat': 'СБ',
      'biohacks.cat.sport': 'СПОРТ',
      'biohacks.cat.mind': 'РАЗУМ',
      'biohacks.cat.ascetic': 'АСКЕТ',
      'biohacks.progress': '{{done}}/{{total}} выполнено',
      'biohacks.synergyX': 'x1.5 Синергия',
      'biohacks.diff.EASY': 'ЛЕГКО',
      'biohacks.diff.MEDIUM': 'СРЕДНЕ',
      'biohacks.diff.HARD': 'ТЯЖЕЛО',
      'biohacks.diff.LEGEND': 'ЛЕГЕНДА',
      'biohacks.proto.s1.name': 'Бег',
      'biohacks.proto.s1.desc': '30 мин бег на улице',
      'biohacks.proto.s2.name': 'Боевые искусства',
      'biohacks.proto.s2.desc': 'Бокс или единоборства',
      'biohacks.proto.s3.name': 'Кузница железа',
      'biohacks.proto.s3.desc': 'Силовая тренировка',
      'biohacks.proto.s4.name': 'Аквапоток',
      'biohacks.proto.s4.desc': 'Плавание 20+ мин',
      'biohacks.proto.s5.name': 'Протокол гибкости',
      'biohacks.proto.s5.desc': 'Растяжка и мобильность 15 мин',
      'biohacks.proto.m1.name': 'Медитация',
      'biohacks.proto.m1.desc': '10 мин майндфулнесс',
      'biohacks.proto.m2.name': 'Дыхание Вима Хофа',
      'biohacks.proto.m2.desc': '3 раунда дыхательных упражнений',
      'biohacks.proto.m3.name': 'Нейротворчество',
      'biohacks.proto.m3.desc': 'Творческая визуализация 10 мин',
      'biohacks.proto.m4.name': 'Глубокое чтение',
      'biohacks.proto.m4.desc': 'Прочесть 20 страниц нон-фикшн',
      'biohacks.proto.m5.name': 'Журнал записей',
      'biohacks.proto.m5.desc': 'Записать дневник',
      'biohacks.proto.a1.name': 'Без алкоголя и наркотиков',
      'biohacks.proto.a1.desc': 'Оставайся чистым сегодня',
      'biohacks.proto.a2.name': 'Чистое топливо',
      'biohacks.proto.a2.desc': 'Ешь только цельную пищу',
      'biohacks.proto.a3.name': 'Цифровой детокс',
      'biohacks.proto.a3.desc': 'Без соцсетей 4+ часа',
      'biohacks.proto.a4.name': 'Холодное воздействие',
      'biohacks.proto.a4.desc': '2 мин холодный душ',
      'biohacks.proto.a5.name': 'Протокол сна',
      'biohacks.proto.a5.desc': 'В постель к 22:00, 7+ часов сна',
      'biohacks.mission.1': '100 отжиманий за день',
      'biohacks.mission.2': 'Планка 5 минут',
      'biohacks.mission.3': '10 тыс. шагов',
      'biohacks.mission.4': 'Выполнить все протоколы',
      'biohacks.mission.5': 'Серия 7 дней',
      'memory.timeAgoMin': '{{n}} мин назад',
      'memory.timeAgoHour': '{{n}} ч назад',
      'memory.timeAgoDay': '{{n}} дн назад',
      'memory.lvlShort': 'УР',
      'memory.energyBoost': '{{amount}} Прирост энергии',
      'memory.boostWithEnergy': 'Усилить Энергией',
      'memory.epMin': '10 ЭП',
      'memory.epMax': '2 000 ЭП',
      'memory.boostSent': 'Усиление отправлено!',
      'companion.stage': 'Стадия',
      'companion.evolved': 'Эволюция',
      'companion.xpProgress': 'ПРОГРЕСС XP',
      'companion.nextStage': 'След. стадия',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'Достигнута максимальная эволюция',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': 'Все присоединены!',
      'biohacks.todayComplete': 'сегодня',
      'coach.chooseCoach': 'ВЫБЕРИТЕ ТРЕНЕРА',
      'coach.headphonesHint': 'Используйте наушники для полного бинаурального эффекта',
      'coach.localGenerationHint': 'Создаётся локально · Интернет не требуется · Бесплатно навсегда',
      'coach.musicNote': 'Откроется в вашем музыкальном приложении или браузере',
      'coach.sampleTitle': 'ПОСЛУШАТЬ ГОЛОС',
      'coach.settings': 'НАСТРОЙКИ',
      'coach.soundscapeTitle': 'БИНАУРАЛЬНЫЕ РЕЖИМЫ',
      'coach.voiceEnabled': 'Голосовой тренер',
      'coach.voiceEnabledDesc': 'Звуковые подсказки во время тренировок',
      'coach.volume': 'Громкость',
      'login.appleError': 'Не удалось войти через Apple',
      'login.continue': 'Продолжить',
      'login.continueApple': 'Продолжить с Apple',
      'login.continueGoogle': 'Продолжить с Google',
      'login.email': 'Эл. почта',
      'login.emailLabel': 'Адрес эл. почты',
      'login.emailPlaceholder': 'you@example.com',
      'login.googleError': 'Не удалось войти через Google',
      'login.hidePassword': 'Скрыть пароль',
      'login.orContinueWith': 'или',
      'login.password': 'Пароль',
      'login.passwordMin': 'Пароль должен содержать не менее 6 символов',
      'login.passwordPlaceholder': 'Ваш пароль',
      'login.phone': 'Телефон',
      'login.privacyLink': 'Политика конфиденциальности',
      'login.showPassword': 'Показать пароль',
      'login.signInError': 'Не удалось войти',
      'login.signingIn': 'Вход...',
      'login.terms': 'Продолжая, вы соглашаетесь с',
      'login.termsLink': 'Условиями',
      'memory.boostAmount': 'Размер буста',
      'memory.comment': 'Комментировать',
      'memory.emptyDesc': 'Ваша лента заполнится, когда вы и ваша команда начнёте тренироваться.',
      'memory.emptyTitle': 'Пока нет активности',
      'memory.like': 'Нравится',
      'memory.share': 'Поделиться',
      'oracle.errAuth': 'Ошибка аутентификации AI-сервиса.',
      'oracle.errGeneric': 'Не удалось проанализировать изображение. Попробуйте ещё раз с более чётким фото.',
      'oracle.errLimit': 'Достигнут дневной лимit сканирований. Оформите подписку для безлимита.',
      'oracle.errMissingKey': 'AI-сервис не настроен. Обратитесь в поддержку.',
      'oracle.errRate': 'Сервис занят. Повторите попытку через момент.',
      'oracle.unlimitedScans': 'Безлимитные сканирования',
      'paywall.everythingUnlocked': 'Всё разблокировано',
      'paywall.freeLaunchNote': 'Все функции Pro бесплатны на время запуска.',
      'paywall.noCardNeeded': 'Карта не нужна',
      'paywall.proFreeTitle': 'Pro — бесплатно на старте',
      'paywall.unlockFree': 'Откройте всё — бесплатно',
      'paywall.whatsIncluded': 'Что включено',
      'profile.noPrs': 'Пока нет личных рекордов',
      'profile.noPrsDesc': 'Ваши рекорды появятся по мере тренировок.',
      'progress.emptyCta': 'Начать тренировку',
      'progress.emptyDesc': 'Завершите первую тренировку, чтобы увидеть статистику.',
      'progress.emptyTitle': 'Ваш прогресс начинается здесь',
      'referral.copyLinkAria': 'Скопировать реферальную ссылку',
      'referral.shareAria': 'Поделиться реферальной ссылкой',
      'settings.cookies': 'Политика использования файлов cookie',
      'settings.deleteAccount': 'Удалить аккаунт',
      'settings.deleteAccountWarning': 'Это безвозвратно удалит ваш аккаунт и все данные (тренировки, прогресс, профиль). Отменить нельзя.',
      'settings.deleteConfirm': 'Удалить',
      'settings.deleteError': 'Не удалось удалить аккаунт. Повторите попытку.',
      'settings.kvkk': 'KVKK / Защита данных',
      'settings.legalSupport': 'Право и поддержка',
      'settings.privacy': 'Политика конфиденциальности',
      'settings.support': 'Помощь и поддержка',
      'settings.terms': 'Условия использования',
      'shop.celliva.allProducts': 'Полный каталог',
      'shop.celliva.autonomousFulfillment': 'Автономная доставка',
      'shop.celliva.calibrationRecorded': 'Калибровка записана. Протокол уточнён.',
      'shop.celliva.cart': 'Корзина',
      'shop.celliva.closedLoopActive': 'Замкнутый контур активен',
      'shop.celliva.decrease': 'Уменьшить количество',
      'shop.celliva.depleteWarning': 'Запас {{product}} закончится через {{days}} дн.',
      'shop.celliva.details': 'Подробнее',
      'shop.celliva.dismiss': 'Закрыть',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'Требуется Elite',
      'shop.celliva.increase': 'Увеличить количество',
      'shop.celliva.noChange': 'Без изменений',
      'shop.celliva.outcomeDeepSleep': 'глубокий сон',
      'shop.celliva.predictiveEngine': 'Прогностический движок',
      'shop.celliva.protocolCalibration': 'Калибровка протокола',
      'shop.celliva.yesOptimal': 'Да — оптимально',
      'shop.tabGameStore': 'Игровой магазин',
      'shop.tabMarketplace': 'Маркетплейс',
      'shop.unlocked': '{{name}} разблокировано!',
      'syndicates.createCta': 'Создать',
      'syndicates.namePlaceholder': 'Название синдиката…',
      'syndicates.newClanDesc': 'Новый синдикат, готовый к восхождению.',
      'syndicates.send': 'Отправить',
      'syndicates.tagPlaceholder': 'Тег (3–4 символа)',
      'workout.end': 'Завершить',
      'workout.endWorkout': 'Завершить тренировку',
      'workout.noResults': 'Тренировки не найдены',
      'workout.noResultsDesc': 'Попробуйте другой запрос или категорию.',

    },
  },

  de: {
    translation: {
      // ── Neue UI-Schlüssel (Ruhetag, Biometrie, Teilen, Länderauswahl) ──
      'home.totalWorkouts': 'Workouts gesamt',
      'restDay.title': 'Ruhetag',
      'restDay.empty': 'Absolviere ein Workout, um die Erholung zu verfolgen',
      'restDay.today': 'Heute trainiert. Erhole dich gut.',
      'restDay.rested': 'Du bist erholt — bleib am Ball.',
      'restDay.recommendRest': 'Hohe Wochenbelastung — ruh dich heute lieber aus.',
      'restDay.recommendTrain': 'Gut erholt — bereit zum Training.',
      'restDay.daysSince_one': 'vor {{count}} Tag',
      'restDay.daysSince_other': 'vor {{count}} Tagen',
      'biometric.noData': 'keine Daten',
      'biometric.connectWearable': 'Verbinde ein Wearable für Live-Daten',
      'workout.shareUnavailable': 'Teilen ist auf diesem Gerät nicht verfügbar.',
      'workout.shareFailed': 'Teilen gerade nicht möglich. Bitte versuche es erneut.',
      'country.TR': 'Türkei',
      'country.US': 'Vereinigte Staaten',
      'country.RU': 'Russland',
      'country.DE': 'Deutschland',
      'country.GB': 'Vereinigtes Königreich',
      'country.FR': 'Frankreich',
      'country.ES': 'Spanien',
      'country.IT': 'Italien',
      'country.NL': 'Niederlande',
      'country.SA': 'Saudi-Arabien',
      'country.AE': 'Vereinigte Arabische Emirate',
      'country.EG': 'Ägypten',
      'country.ID': 'Indonesien',
      'country.KR': 'Südkorea',
      'country.JP': 'Japan',
      'country.CN': 'China',
      'country.IN': 'Indien',
      'country.BR': 'Brasilien',
      'country.MX': 'Mexiko',
      'country.CA': 'Kanada',
      'country.AU': 'Australien',
      'country.NZ': 'Neuseeland',
      'country.ZA': 'Südafrika',
      'country.SE': 'Schweden',
      'country.NO': 'Norwegen',
      'country.DK': 'Dänemark',
      'country.FI': 'Finnland',
      'country.CH': 'Schweiz',
      'country.BE': 'Belgien',
      'country.AT': 'Österreich',
      'profile.dayStreak': 'Tage-Streak',
      'profile.companionAlt': 'Dein Begleiter',
      'profile.ninetyDayActivity': '90-Tage-Aktivität',
      'profile.restDay': 'Ruhetag',
      'profile.viewAllRecordsAria': 'Alle Rekorde anzeigen',
      'profile.copyLinkAria': 'Empfehlungslink kopieren',
      'profile.shareAria': 'Empfehlungslink teilen',
      'referral.tagline': '1 Monat Pro — für dich und deinen Freund',
      'referral.noLimit': 'Kein Limit — lade so viele ein wie du möchtest',
      'shop.celliva.bestSellers': 'Bestseller',
      'shop.celliva.featuredTitle': 'Protokoll-Essentials',
      'shop.celliva.benefits': 'Vorteile',
      'shop.celliva.pairsWith': 'Wie es zu deinen Zielen passt',
      'shop.celliva.added': 'In den Warenkorb gelegt!',
      'shop.celliva.cartTitle': 'Ihr Warenkorb',
      'shop.celliva.items': 'Artikel',
      'shop.celliva.clearCart': 'Alle löschen',
      'shop.celliva.emptyCartTitle': 'Warenkorb ist leer',
      'shop.celliva.emptyCartDesc': 'Füge Nahrungsergänzungsmittel aus dem Katalog hinzu.',
      'shop.celliva.browseCatalog': 'Katalog durchsuchen',
      'shop.celliva.subtotal': 'Zwischensumme',
      'shop.celliva.fulfillmentNote': 'Erfüllt von Celliva Life. Versand wird beim Bezahlen berechnet.',
      'shop.celliva.viewCart': 'Warenkorb ansehen',
      'shop.celliva.remove': 'Entfernen',
      'shop.prev': 'Zurück',
      'shop.next': 'Weiter',
      'avatar.rarityCommon': 'GEWÖHNLICH',
      'avatar.rarityRare': 'SELTEN',
      'avatar.rarityEpic': 'EPISCH',
      'avatar.rarityLegendary': 'LEGENDÄR',
      'avatar.pro': 'PRO',
      'avatar.saved': 'Gespeichert!',
      'avatar.skin.default': 'Standard',
      'avatar.skin.cyber': 'Cyber',
      'avatar.skin.neon': 'Neon',
      'avatar.skin.shadow': 'Schatten',
      'avatar.skin.gold': 'Gold',
      'avatar.outfit.basic': 'Basis-Ausrüstung',
      'avatar.outfit.cyber': 'Cyber-Anzug',
      'avatar.outfit.runner': 'Neon-Runner',
      'avatar.outfit.iron': 'Eisenrüstung',
      'avatar.acc.none': 'Keine',
      'avatar.acc.visor': 'Visier',
      'avatar.acc.earbuds': 'Ohrhörer',
      'avatar.acc.chain': 'Kette',
      'avatar.acc.halo': 'Heiligenschein',
      'coach.selectedLabel': 'GEWÄHLT',
      'coach.selectLabel': 'Auswählen',
      'coach.languageSection': 'TRAINER-SPRACHE',
      'coach.languageLabel': 'Sprache wählen',
      'coach.languageHint': 'Sprachphrasen werden in der gewählten Sprache abgespielt',
      'workout.exerciseOf': 'Übung {{current}} von {{total}}',
      'workout.paused': 'Pausiert',
      'workout.endSessionSub': 'Fortschritt wird bis hierhin gespeichert.',
      'workout.keepGoing': 'Weiter',
      'workout.endNow': 'Jetzt beenden',
      'workout.repsLabel': 'Wdh.',
      'workout.next': 'Nächste',
      'workout.strainElite': 'Elite-Leistung',
      'workout.strainHard': 'Hartes Training',
      'workout.strainModerate': 'Gute Arbeit',
      'workout.selectLevel': 'Niveau wählen',
      'common.error_title': 'Etwas ist schiefgelaufen',
      'common.error_description': 'Bitte versuche es erneut.',
      'common.network_error': 'Keine Verbindung',
      'oracle.subtitle': 'KI-Lebensmittelscanner',
      'oracle.emptyTitle': 'KI-Lebensmittelscanner',
      'oracle.emptyDesc': 'Kamera auf Mahlzeit richten. Sofortige Makroanalyse.',
      'oracle.scanningSubtitle': 'Analyse mit Gemini Vision',
      'oracle.confidence': 'Vertrauen',
      'oracle.detectedItems': 'Erkannte Zutaten',
      'oracle.macroBreakdown': 'Makroverteilung',
      'oracle.limitReached': 'Limit erreicht',
      'oracle.proUnlimited': 'Pro Unbegrenzt',
      'oracle.proDesc': 'Unbegrenzte Scans + Mahlzeitenpläne + KI-Coaching',
      'oracle.kcalRemaining': 'Noch {{n}} kcal',
      'oracle.goalReached': 'Ziel erreicht!',
      'calendar.streakDays': '{{n}}-Tage-Serie',
      'calendar.april2026': 'April 2026',
      'calendar.prevMonth': 'Vorheriger Monat',
      'calendar.nextMonth': 'Nächster Monat',
      'login.tagline': 'DEINE LANGLEBIGKEIT BEGINNT',
      'login.otpHint': 'Gib den 6-stelligen Code ein',
      'login.connecting': 'Verbinden...',
      'login.connectingLongevity': 'Verbindung zu Longevity OS...',
      'login.continueLongevity': 'Mit Omnisio Longevity ID fortfahren',
      'paywall.paymentMethod': 'Zahlungsmethode',
      'social.timeMin': 'vor {{n}}m',
      'social.timeHour': 'vor {{n}}h',
      'social.timeDay': 'vor {{n}}d',
      'syndicates.joined': 'Beigetreten',
      'syndicates.joinToChat': 'Beitrete zum Chat',
      'syndicates.requirement': 'Mind. {{xp}} XP',
      'syndicates.teamChallenges': 'Teamaufgaben',
      'syndicates.myClan': 'Mein Syndikat',
      'syndicates.discover': 'Entdecken',
      'syndicates.createTitle': 'Syndikat erstellen',
      'biohacks.challenges': 'Aufgaben',
      'biohacks.activeChallenges': 'Aktiv — {{n}}',
      'biohacks.availableChallenges': 'Verfügbar',
      'biohacks.completedChallenges': 'Abgeschlossen',
      'biohacks.joinChallenge': 'Beitreten',
      'biohacks.claimReward': '+{{reward}} XP abholen',
      'memory.tabNEW': 'Neu',
      'memory.tabMY': 'Meine',
      'memory.tabTOP': 'Top',
      'memory.tabCORE': 'Kern',
      'nav.progress': 'Fortschritt',
      'home.defaultName': 'Sportler',
      'home.greetingSub': 'Dein Körper. Deine Ziele.',
      'home.greetingSub2': 'Bauen wir heute etwas Stärkeres.',
      'home.energyScore': 'Energiewert',
      'home.companionLabel': 'Begleiter',
      'home.companionTagline': 'Zum Coachen. Zum Unterstützen.',
      'home.companion.phoenix': 'Omni',
      'home.companion.bonsai': 'Sage',
      'home.companion.orb': 'Orb',
      'home.companion.avatar': 'Titan',
      'home.companion.avatar_female': 'Luna',
      'home.moodHigh': 'Hoch',
      'home.moodGood': 'Gut',
      'home.moodFair': 'Mittel',
      'home.moodLow': 'Niedrig',
      'home.moodHighSub': 'Du bist bereit für Höchstleistung.',
      'home.moodGoodSub': 'Solide Basis — weiter pushen.',
      'home.moodFairSub': 'Heute leicht aufwärmen.',
      'home.moodLowSub': 'Erholung priorisieren.',
      'home.recommendedForYou': 'Für dich empfohlen',
      'home.aiRecommended': 'KI-Empfehlung',
      'home.recTitle': 'Kraft & Balance',
      'home.recSub': 'Kraft aufbauen. Kontrolle verbessern.',
      'home.dayStreak': 'Tagesserie',
      'home.workoutsThisWeek': 'Trainings diese Woche',
      'home.badgesEarned': 'Verdiente Abzeichen',
      'workout.level.intermediate': 'Mittel',
      'progress.title': 'Fortschritt',
      'progress.level': 'Level {{level}}',
      'progress.stage1': 'Funkenform',
      'progress.stage2': 'Erwachte Form',
      'progress.stage3': 'Entwickelte Form',
      'progress.stage4': 'Aufgestiegene Form',
      'progress.stage5': 'Elementarform',
      'progress.stage6': 'Mythische Form',
      'progress.stage7': 'Transzendente Form',
      'progress.rarityCommon': 'GEWÖHNLICH',
      'progress.rarityRare': 'SELTEN',
      'progress.rarityEpic': 'EPISCH',
      'progress.rarityLegendary': 'LEGENDÄR',
      'progress.stageChip': '{{stage}}. Evolutionsstufe',
      'progress.dayStreakInline': '{{count}}-Tage-Serie',
      'progress.streakSub': 'Halt sie am Brennen!',
      'progress.xpProgress': 'XP-Fortschritt',
      'progress.nextStage': 'Nächste Stufe: Stufe {{stage}} - {{name}}',
      'progress.dayStreak': 'Tagesserie',
      'progress.workouts': 'Trainings',
      'progress.stagesReached': 'Erreichte Stufen',
      'progress.achievements': 'Erfolge',
      'progress.viewAll': 'Alle anzeigen',
      'progress.achievement.discipline': 'Disziplin',
      'progress.achievement.consistency': 'Beständigkeit',
      'progress.achievement.endurance': 'Ausdauer',
      'progress.achievement.resilience': 'Widerstandskraft',
      'progress.achievement.days': 'Tage',
      'progress.achievement.workouts': 'Trainings',
      'paywall.disclosureTitle': 'Abo-Bedingungen',
      'paywall.disclosureLength': 'Abo verlängert sich monatlich oder jährlich automatisch bis zur Kündigung',
      'paywall.disclosurePrice': 'Wird über deine Apple ID zum oben angegebenen Preis abgebucht',
      'paywall.disclosureRenewal': 'Automatische Verlängerung innerhalb von 24 Stunden vor Periodenende (falls nicht deaktiviert)',
      'paywall.disclosureCancel': 'Verwalten oder kündigen jederzeit in iPhone Einstellungen → Apple ID → Abos',
      'paywall.disclosureRefund': 'Keine Rückerstattung für den ungenutzten Teil der laufenden Periode',
      'paywall.legalFooter': 'Abo wird über die Apple ID verwaltet. Jederzeit in den iPhone-Einstellungen kündbar.',
      'profile.editTitle': 'Profil bearbeiten',
      'profile.firstName': 'Vorname',
      'profile.firstNamePh': 'Dein Vorname',
      'profile.lastName': 'Nachname',
      'profile.lastNamePh': 'Dein Nachname',
      'profile.displayName': 'Anzeigename',
      'profile.displayNamePh': 'Wie dich andere sehen',
      'profile.email': 'E-Mail',
      'profile.publicId': 'Öffentliche ID',
      'common.cancel': 'Abbrechen',
      'common.save': 'Speichern',
      'common.saving': 'Speichern…',
      'coach.active': 'AKTIV',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'Schritte + aktive Energie',
      'coach.tab.voice': 'Stimme',
      'coach.tab.soundscape': 'Klanglandschaft',
      'coach.tab.music': 'Musik',
      'coach.sample.workoutStart': 'Vor dem Training',
      'coach.sample.setComplete': 'Satz fertig',
      'coach.sample.halfway': 'Halbzeit-Motivation',
      'coach.sample.finalSet': 'Letzter Satz Push',
      'coach.sample.workoutDone': 'Training fertig',
      'coach.soundscape.focus': 'Fokus',
      'coach.soundscape.focusDesc': 'Tiefe Alphawellen für laserscharfen Fokus',
      'coach.soundscape.cardio': 'Cardio-Boost',
      'coach.soundscape.cardioDesc': 'Hohe BPM-Pulse für mehr Power',
      'coach.soundscape.recovery': 'Regeneration',
      'coach.soundscape.recoveryDesc': 'Beruhigende Töne für Muskelregeneration',
      'coach.soundscape.sleep': 'Schlafvorbereitung',
      'coach.soundscape.sleepDesc': 'Delta-Wellen für tiefe Ruhe',
      'coach.service.spotify.desc': 'Beast Mode Workout',
      'coach.service.applemusic.desc': 'Pure Pump',
      'coach.service.ytmusic.desc': 'Workout-Playlist',
      'coach.companion.phoenix.name': 'Phoenix',
      'coach.companion.phoenix.desc': 'Episch, motivierend',
      'coach.companion.bonsai.name': 'Bonsai',
      'coach.companion.bonsai.desc': 'Ruhig, achtsam',
      'coach.companion.orb.name': 'Energie-Orb',
      'coach.companion.orb.desc': 'Futuristisch, robotisch',
      'coach.companion.avatar.name': 'Krieger',
      'coach.companion.avatar.desc': 'Stark, intensiv',
      'coach.companion.avatar_female.name': 'Göttin',
      'coach.companion.avatar_female.desc': 'Ermächtigend, warm',
      'coach.musicTitle': 'WORKOUT-PLAYLISTS',
      'coach.openIn': 'Öffnen',
      'coach.play': 'Abspielen',
      'coach.playing': 'Spielt',
      'biometric.insufficientScope': 'Fehlende Berechtigungen',
      'biometric.missingScopes': 'Fehlt: {{scopes}}',
      'biometric.grantScopesCta': 'Erteilen',
      'biometric.rateLimited': 'Rate-Limit — neu in {{seconds}}s',
      'common.continue': 'Weiter',
      'onboarding.goalTitle': 'Was ist dein Ziel?',
      'onboarding.goalSubtitle': 'Wähle dein Hauptziel',
      'onboarding.goal.cut': 'Definition',
      'onboarding.goal.cutSub': 'Fett verlieren, definierter werden',
      'onboarding.goal.bulk': 'Aufbau',
      'onboarding.goal.bulkSub': 'Muskeln & Kraft aufbauen',
      'onboarding.goal.maintain': 'Halten',
      'onboarding.goal.maintainSub': 'Aktuelle Form halten',
      'onboarding.awakeningTitle': 'Du bist bereit',
      'onboarding.awakeningSubtitle': 'Wie sollen wir dich nennen?',
      'onboarding.namePlaceholder': 'Name oder Nickname',
      'onboarding.getStarted': 'Loslegen',
      'sport.bench_press.name': 'Bankdrücken',
      'sport.lunges.name': 'Ausfallschritte',
      'sport.jumping_rope.name': 'Seilspringen',
      'sport.kickboxing.name': 'Kickboxen',
      'sport.volleyball.name': 'Volleyball',
      'sport.ice_skating.name': 'Eislaufen',
      'sport.crossfit_wod.name': 'CrossFit WOD',
      'sport.foam_rolling.name': 'Faszienrollen',
      'sport.mobility_flow.name': 'Mobilitäts-Flow',
      'common.skip': 'Überspringen',
      'common.next': 'Weiter',
      'onboarding.injuryTitle': 'Verletzungen?',
      'onboarding.injurySubtitle': 'Wir passen Workouts an, um diese Bereiche zu schonen. Optional.',
      'onboarding.injuryNoneSelected': 'Keine Verletzungen — volle Intensität',
      'onboarding.injuryCount_one': '{{count}} Bereich geschützt',
      'onboarding.injuryCount_other': '{{count}} Bereiche geschützt',
      'onboarding.injuries.neck': 'Nacken',
      'onboarding.injuries.shoulders': 'Schultern',
      'onboarding.injuries.lowerBack': 'Unterer Rücken',
      'onboarding.injuries.elbows': 'Ellenbogen',
      'onboarding.injuries.wrists': 'Handgelenke',
      'onboarding.injuries.hips': 'Hüften',
      'onboarding.injuries.knees': 'Knie',
      'onboarding.injuries.ankles': 'Knöchel',
      'common.back': 'Zurück',
      'common.gotIt': 'Verstanden',
      'leaderboard.title': 'Bestenliste',
      'leaderboard.global': 'Global',
      'leaderboard.friends': 'Freunde',
      'leaderboard.weekly': 'Wöchentlich',
      'leaderboard.you': 'Du',
      'leaderboard.energy': 'Energie',
      'leaderboard.howItWorks': 'So funktioniert es',
      'leaderboard.noFriends': 'Noch keine Freunde',
      'leaderboard.noFriendsDesc': 'Lade Freunde zum Wettkampf ein',
      'leaderboard.rule1Title': 'Energie verdienen',
      'leaderboard.rule1': 'Workouts abschließen. Höhere Schwierigkeit + längere Streaks = mehr Energie.',
      'leaderboard.rule2Title': 'Drei Listen',
      'leaderboard.rule2': 'Global rankt alle, Freunde nur deine Follows, Wöchentlich resetet jeden Montag.',
      'leaderboard.rule3Title': 'Verfallsregel',
      'leaderboard.rule3': 'Energie verfällt 5% pro inaktivem Tag — Beständigkeit schlägt Burst.',
      'leaderboard.rule4Title': 'Belohnungen',
      'leaderboard.rule4': 'Top 3 jeder Liste schalten Gold/Silber/Bronze Profilrahmen frei.',
      'referral.title': 'Einladen & verdienen',
      'referral.description': 'Lade einen Freund ein — er bekommt 1 Monat gratis, du auch. Kein Limit.',
      'referral.yourId': 'Deine ID',
      'referral.reward': 'Belohnung',
      'referral.daysFree': 'Tage gratis',
      'referral.copy': 'Kopieren',
      'referral.copied': 'Kopiert',
      'referral.share': 'Teilen',
      'referral.shareTitle': 'Omnisio Workout ausprobieren',
      'referral.shareText': 'Komm zu Omnisio Workout — wir bekommen beide 1 Monat Pro gratis.',
      'referral.activeStatus': 'Pro aktiv bis',
      'oracle.recentMeals': 'Letzte Mahlzeiten',
      'oracle.entryCount_one': '{{count}} Eintrag',
      'oracle.entryCount_other': '{{count}} Einträge',
      'oracle.noScans': 'Noch keine Scans',
      'oracle.noScansDesc': 'Tippe auf Scannen, um deine erste Mahlzeit zu erfassen',
      'oracle.scanNow': 'Jetzt scannen',
      'oracle.todaysTotal': 'Heutige Gesamtsumme',
      'oracle.kcal': 'kcal',
      'oracle.macro.protein': 'Protein',
      'oracle.macro.carbs': 'Kohlenhydrate',
      'oracle.macro.fat': 'Fett',
      'oracle.macro.calories': 'Kalorien',
      'oracle.meal.breakfast': 'Frühstück',
      'oracle.meal.lunch': 'Mittagessen',
      'oracle.meal.dinner': 'Abendessen',
      'oracle.meal.snack': 'Snack',
      'sport.pushups.name': 'Liegestütze',
      'sport.squats.name': 'Kniebeugen',
      'sport.plank.name': 'Plank',
      'sport.running.name': 'Laufen',
      'sport.yoga.name': 'Yoga',
      'sport.boxing.name': 'Boxen',
      'sport.cycling.name': 'Radfahren',
      'sport.swimming.name': 'Schwimmen',
      'sport.basketball.name': 'Basketball',
      'sport.skiing.name': 'Skifahren',
      'sport.pullups.name': 'Klimmzüge',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'Tennis',
      'sport.deadlift.name': 'Kreuzheben',
      'sport.pilates.name': 'Pilates',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'Rudern',
      'sport.dance.name': 'Tanzfitness',
      'sport.stretching.name': 'Dehnen',
      'sport.kettlebell.name': 'Kettlebell',
      'sport.football.name': 'Fußball',
      'workout.cat.all': 'ALLE',
      'workout.cat.strength': 'KRAFT',
      'workout.cat.cardio': 'CARDIO',
      'workout.cat.flexibility': 'FLEXIBILITÄT',
      'workout.cat.combat': 'KAMPF',
      'workout.cat.team': 'TEAM',
      'workout.cat.winter': 'WINTER',
      'workout.cat.functional': 'FUNKTIONELL',
      'workout.noEquipment': 'Keine Ausrüstung',
      'workout.instructions': 'Anleitung',
      'workout.commonMistakes': 'Häufige Fehler',
      'workout.easier': 'Leichter',
      'workout.harder': 'Schwerer',
      'workout.repsCount_one': '{{count}} Wdh.',
      'workout.repsCount_other': '{{count}} Wdh.',
      'workout.countSports_one': '{{count}} Sportart',
      'workout.countSports_other': '{{count}} Sportarten',
      'workout.noSports': 'Keine Sportarten gefunden',
      'settings.general': 'Allgemein',
      'settings.proActive': 'Pro Aktiv',
      'settings.freeTrial': 'Kostenlose Testversion',
      'settings.allUnlocked': 'Alle Funktionen freigeschaltet',
      'settings.upgradeFull': 'Auf Vollzugriff upgraden',
      'settings.upgrade': 'Upgrade',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Datensynchronisierung',
      'settings.dataSyncDesc': 'Gesundheitsdaten mit dem Omnisio-Ökosystem synchronisieren',
      'settings.logout': 'Abmelden',
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Private Fitness-Gruppe',
      'nav.home': 'Start',
      'nav.workout': 'Training',
      'nav.nutri': 'Ernährung',
      'nav.history': 'Verlauf',
      'nav.memory': 'Erinnerungen',
      'nav.radio': 'Radio',
      'nav.shop': 'Shop',
      'nav.profile': 'Profil',
      'nav.more': 'Mehr',
      'nav.coach': 'Coach',
      'home.welcome': 'Willkommen, {{name}}',
      'home.dailyEnergy': 'Tagesenergie',
      'home.startWorkout': 'Training starten',
      'home.yourTotem': 'Dein Maskottchen',
      'home.todaysMissions': 'Heutige Ziele',
      'home.leaderboard': 'Rangliste',
      'home.syndicates': 'Teams',
      'home.biohacks': 'Herausforderungen',
      'energy.exercise': 'Übung',
      'energy.music': 'Musik',
      'energy.total': 'Gesamtenergie',
      'energy.streak': '{{count}} Tage Serie',
      'energy.streakFire': 'Serie',
      'workout.title': 'Training',
      'workout.camera': 'Kamera-Tracking',
      'workout.startSession': 'Sitzung starten',
      'workout.endSession': 'Sitzung beenden',
      'workout.reps': 'Wiederholungen',
      'workout.calories': 'Kalorien',
      'workout.duration': 'Dauer',
      'workout.exerciseComplete': 'Übung abgeschlossen!',
      'workout.energyEarned': '+{{amount}} Energie',
      'workout.plank': 'Planke',
      'workout.pushups': 'Liegestütze',
      'workout.squats': 'Kniebeugen',
      'workout.overview': 'Übersicht',
      'workout.history': 'Verlauf',
      'workout.progress': 'Fortschritt',
      'workout.personalRecords': 'Persönliche Rekorde',
      'workout.share': 'Teilen',
      'workout.done': 'Fertig',
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Essen scannen',
      'oracle.history': 'Scan-Verlauf',
      'oracle.scanning': 'Analysiere...',
      'oracle.dailyNorm': 'Tagesnorm',
      'oracle.scansLeft': '{{count}} Scans übrig',
      'oracle.upgrade': 'Upgrade für unbegrenzt',
      'oracle.protein': 'Protein',
      'oracle.carbs': 'Kohlenhydrate',
      'oracle.fat': 'Fett',
      'oracle.calories': 'Kalorien',
      'memory.title': 'Erinnerungen',
      'memory.upload': 'Erinnerung hochladen',
      'memory.stake': 'Energie staken',
      'memory.network': 'Globales Proof-of-Energy-Netzwerk',
      'calendar.title': 'Verlauf',
      'calendar.fitness': 'Fitness',
      'calendar.nutrition': 'Ernährung',
      'calendar.protocols': 'Programme',
      'shop.title': 'Shop',
      'shop.avatars': 'Avatare',
      'shop.boosters': 'Booster',
      'shop.cosmetics': 'Kosmetik',
      'shop.buy': 'Kaufen',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Besitzt',
      'shop.equipped': 'Ausgerüstet',
      'profile.title': 'Profil',
      'profile.level': 'Stufe {{level}}',
      'profile.totalWorkouts': 'Trainings gesamt',
      'profile.totalTokens': 'Token gesamt',
      'profile.achievements': 'Erfolge',
      'profile.settings': 'Einstellungen',
      'profile.totem': 'Maskottchen',
      'leaderboard.title': 'Rangliste',
      'leaderboard.global': 'Global',
      'leaderboard.syndicate': 'Team',
      'leaderboard.weekly': 'Wöchentlich',
      'leaderboard.allTime': 'Alle Zeit',
      'leaderboard.rank': 'Rang',
      'syndicates.title': 'Teams',
      'syndicates.join': 'Beitreten',
      'syndicates.create': 'Team erstellen',
      'syndicates.members': '{{count}} Mitglieder',
      'syndicates.power': 'Stärke',
      'biohacks.title': 'Herausforderungen',
      'biohacks.protocols': 'Programme',
      'biohacks.missions': 'Ziele',
      'biohacks.active': 'Aktiv',
      'biohacks.completed': 'Abgeschlossen',
      'biohacks.reward': 'Belohnung: {{amount}} TKN',
      'avatar.title': 'Avatar',
      'avatar.customize': 'Anpassen',
      'avatar.skin': 'Haut',
      'avatar.outfit': 'Outfit',
      'avatar.accessories': 'Zubehör',
      'avatar.save': 'Speichern',
      'radio.title': 'Gym Radio',
      'radio.nowPlaying': 'Läuft gerade',
      'radio.stations': 'Sender',
      'radio.energyBonus': '+Energie beim Hören',
      'coach.title': 'Coach',
      'coach.subtitle': 'Dein KI-Fitness-Begleiter im Ohr',
      'coach.tabVoice': 'Stimme',
      'coach.tabSoundscape': 'Klanglandschaft',
      'coach.tabMusic': 'Musik',
      'coach.chooseVoice': 'Wähle deine Coach-Stimme',
      'coach.samples': 'Beispiele anhören',
      'coach.samplePreWorkout': 'Vor dem Workout',
      'coach.sampleSetComplete': 'Satz fertig',
      'coach.sampleHalfway': 'Halbzeit',
      'coach.sampleFinalSet': 'Letzter Satz',
      'coach.sampleWorkoutDone': 'Workout fertig',
      'coach.voiceCoachToggle': 'Sprach-Coach während dem Workout',
      'coach.proRequired': 'Pro benötigt für alle Stimmen',
      'coach.upgrade': 'Upgrade',
      'coach.soundscapeFocus': 'Fokus',
      'coach.soundscapeFocusDesc': 'Alpha-Wellen für tiefe Konzentration',
      'coach.soundscapeCardio': 'Cardio',
      'coach.soundscapeCardioDesc': 'Hohe BPM für Laufen und HIIT',
      'coach.soundscapeRecovery': 'Erholung',
      'coach.soundscapeRecoveryDesc': 'Langsamer Rhythmus für Cooldown und Stretching',
      'coach.soundscapeSleep': 'Schlafvorbereitung',
      'coach.soundscapeSleepDesc': 'Rosa Rauschen und Naturgeräusche',
      'coach.soundscapeComingSoon': 'Demnächst',
      'coach.musicHeader': 'Öffne deine Lieblingsmusik-App',
      'coach.musicSpotify': 'In Spotify öffnen',
      'coach.musicApple': 'In Apple Music öffnen',
      'coach.musicYoutube': 'In YouTube Music öffnen',
      'coach.workoutPlaylist': 'Workout-Playlist',
      'settings.title': 'Einstellungen',
      'settings.language': 'Sprache',
      'settings.notifications': 'Benachrichtigungen',
      'settings.sound': 'Ton',
      'settings.haptics': 'Haptik',
      'settings.about': 'Über',
      'settings.version': 'Version',
      'settings.aiEngine': 'KI-Engine',
      'settings.wearables': 'Bio-Wearables',
      'settings.bioWearables': 'Bio-Wearables',
      'settings.omnisioBand': 'Omnisio Band',
      'settings.omnisioBandDesc': 'Nativer SDK · Echtzeit-Biometrie',
      'settings.omnisioRing': 'Omnisio Ring',
      'settings.omnisioRingDesc': 'Nativer SDK · 7 Tage Akku, Schlaf + HRV',
      'settings.thirdPartySync': 'Drittanbieter · Zum Synchronisieren verbinden',
      'settings.dataSync': 'Datensynchronisation',
      'settings.upgrade': 'Upgrade',
      'settings.logout': 'Abmelden',
      'onboarding.welcome': 'Willkommen bei Omnisio Workout',
      'onboarding.subtitle': 'Deine private Fitness-Reise beginnt hier',
      'onboarding.selectExercise': 'Wähle deine erste Übung',
      'onboarding.pushups': 'Liegestütze',
      'onboarding.squats': 'Kniebeugen',
      'onboarding.getStarted': "Los geht's",
      'onboarding.skip': 'Überspringen',
      'common.loading': 'Laden...',
      'common.error': 'Etwas ist schiefgelaufen',
      'common.retry': 'Wiederholen',
      'common.back': 'Zurück',
      'common.save': 'Speichern',
      'common.cancel': 'Abbrechen',
      'common.confirm': 'Bestätigen',
      'common.close': 'Schließen',
      'common.tokens': 'Token',
      'common.soon': 'Bald',
      'common.viewAll': 'Alle ansehen',

      // Profile (extended)
      'profile.workouts': 'Workouts',
      'profile.hours': 'Stunden',
      'profile.totalXP': 'Gesamt-XP',
      'profile.personalRecords': 'Persönliche Bestleistungen',
      'profile.connectedServices': 'Verbundene Dienste',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Verbunden',
      'profile.connect': 'Verbinden',
      'profile.helpSupport': 'Hilfe & Support',
      'profile.signOut': 'Abmelden',
      'profile.contactShipping': 'Kontakt & Versand',
      'profile.complete': 'Vollständig',
      'profile.incompleteForOrders': 'Für Nahrungsergänzungs-Bestellungen erforderlich',
      'profile.email': 'E-Mail',
      'profile.phone': 'Telefon',
      'profile.address': 'Adresse',
      'profile.country': 'Land',
      'profile.addressPlaceholder': 'Straße, Stadt, Postleitzahl',
      'profile.privacyNote': 'Deine Kontaktdaten werden lokal gespeichert und nur bei einer Bestellung an Celliva weitergegeben. KVKK/GDPR-konform.',
      'profile.invalidEmail': 'Ungültiges E-Mail-Format',
      'profile.invalidPhone': 'Telefon zu kurz',
      'profile.invalidAddress': 'Adresse zu kurz',

      // Achievements
      'achievements.firstWorkout': 'Erstes Workout',
      'achievements.sevenDayStreak': '7-Tage-Serie',
      'achievements.plankMaster': 'Planken-Meister',
      'achievements.earlyBird': 'Frühaufsteher',
      'achievements.perfectionist': 'Perfektionist',
      'achievements.hundredWorkouts': '100 Workouts',
      'achievements.marathon': 'Marathon',
      'achievements.nightOwl': 'Nachteule',

      // Shop (extended)
      'shop.subtitle': 'Schalte Begleiter, Booster und Ausrüstung frei',
      'shop.tabCompanions': 'Begleiter',
      'shop.tabBoosters': 'Booster',
      'shop.tabOutfits': 'Outfits',
      'shop.tabThemes': 'Themes',
      'shop.free': 'Gratis',
      'shop.levelRequired': 'Stufe {{level}} erforderlich',
      'shop.unlockFor': 'Freischalten für {{price}} ⚡',
      'shop.insufficientXP': 'Nicht genug XP ({{price}} ⚡ benötigt)',
      'shop.viewPack': 'Paket ansehen',
      'shop.recentActivity': 'Letzte Aktivität',
      'shop.earnMoreXP': 'Mehr XP verdienen',
      'shop.completeWorkout': 'Schließe ein Workout ab',
      'shop.startWorkout': 'Workout starten',
      'shop.tabSupplements': 'Nahrungsergänzung',
      'shop.poweredByCelliva': 'Powered by Celliva',
      'shop.cellivaTagline': 'Premium-Nahrungsergänzung · Versandkostenfrei ab $50',
      'shop.buyOnCelliva': 'Bei Celliva kaufen',
      'shop.supplementsHeader': 'Treibstoff für dein Training',
      'shop.supplementsSubtitle': 'Laborgeprüft, drittverifiziert',

      // Spielshop-Katalog (Begleiter / Booster / Outfits / Themes)
      'shop.item.phoenix.name': 'Phoenix',
      'shop.item.phoenix.desc': 'Steigt aus der Asche empor',
      'shop.item.phoenix.long': 'Der unsterbliche Phoenix hat dich als Partner erwählt. Aus Feuer geboren und jedes Mal stärker wiedergeboren, befeuert er deinen Antrieb, jede Grenze zu sprengen.',
      'shop.item.phoenix.stat.0.label': 'Bonus-XP',
      'shop.item.phoenix.stat.0.value': '+10% auf alle Workouts',
      'shop.item.bonsai.name': 'Bonsai-Baum',
      'shop.item.bonsai.desc': 'Wächst mit Geduld',
      'shop.item.bonsai.long': 'Eine lebende Skulptur, die deine Disziplin widerspiegelt. Der Bonsai entwickelt sich, während du Gewohnheiten aufbaust, und belohnt Beständigkeit mit seltenen visuellen Upgrades.',
      'shop.item.bonsai.stat.0.label': 'Serien-Bonus',
      'shop.item.bonsai.stat.0.value': '+15% nach 7-Tage-Serie',
      'shop.item.orb.name': 'Energiekugel',
      'shop.item.orb.desc': 'Lenke reine Energie',
      'shop.item.orb.long': 'Eine Kugel aus verdichteter Bioenergie, die jede deiner Wiederholungen verstärkt. Pulsiert heller, je härter du trainierst.',
      'shop.item.orb.stat.0.label': 'Energie-Regeneration',
      'shop.item.orb.stat.0.value': '+5 Energie pro Workout',
      'shop.item.avatar.name': 'Krieger',
      'shop.item.avatar.desc': 'Schmiede deine Stärke',
      'shop.item.avatar.long': 'Ein kampferprobter Avatar, der körperliches Höchstpotenzial verkörpert. Schaltet besondere Krieger-Challenge-Animationen frei.',
      'shop.item.avatar.stat.0.label': 'Kraft-XP',
      'shop.item.avatar.stat.0.value': '+12% bei Krafttraining',
      'shop.item.avatar_female.name': 'Göttin',
      'shop.item.avatar_female.desc': 'Entfessle deine Kraft',
      'shop.item.avatar_female.long': 'Sie kanalisiert das gesamte Spektrum menschlichen Potenzials — Anmut, Ausdauer und rohe Kraft. Eine mythische Präsenz, die jede Session veredelt.',
      'shop.item.avatar_female.stat.0.label': 'Gesamt-XP',
      'shop.item.avatar_female.stat.0.value': '+20% aus jeder Quelle',
      'shop.item.wolf.name': '???',
      'shop.item.wolf.desc': 'Bald verfügbar',
      'shop.item.wolf.long': 'Ein Wesen aus Schatten und Instinkt. Erreiche Level 7, um diesen Begleiter zu enthüllen.',
      'shop.item.xp_2x_24h.name': '2× XP für 24 Std.',
      'shop.item.xp_2x_24h.desc': 'Doppelte XP aus allen Quellen für 24 Stunden',
      'shop.item.xp_2x_24h.long': 'Jedes Workout, jeder Gewohnheits-Check-in und jeder Serien-Bonus wird einen ganzen Tag lang verdoppelt. Kombiniere es mit einer Workout-Session für maximalen Zuwachs.',
      'shop.item.xp_2x_24h.stat.0.label': 'Effekt',
      'shop.item.xp_2x_24h.stat.0.value': '2× XP-Multiplikator',
      'shop.item.xp_2x_24h.stat.1.label': 'Dauer',
      'shop.item.xp_2x_24h.stat.1.value': '24 Stunden',
      'shop.item.streak_freeze.name': 'Serien-Einfrieren',
      'shop.item.streak_freeze.desc': 'Schütze deine Serie bei einem verpassten Tag',
      'shop.item.streak_freeze.long': 'Das Leben passiert. Ein Serien-Einfrieren bewahrt deine hart erarbeitete Serie über einen verpassten Tag hinweg — ohne Wenn und Aber.',
      'shop.item.streak_freeze.stat.0.label': 'Effekt',
      'shop.item.streak_freeze.stat.0.value': '1 Tag überspringen, Serie bleibt',
      'shop.item.streak_freeze.stat.1.label': 'Nutzungen',
      'shop.item.streak_freeze.stat.1.value': 'Einmalig',
      'shop.item.energy_boost.name': 'Sofort +50 Energie',
      'shop.item.energy_boost.desc': 'Füge heute sofort 50 Energie hinzu',
      'shop.item.energy_boost.long': 'Eine direkte Injektion von 50 Energiepunkten, die sofort dem heutigen Gesamtwert gutgeschrieben werden.',
      'shop.item.energy_boost.stat.0.label': 'Effekt',
      'shop.item.energy_boost.stat.0.value': '+50 Energie jetzt',
      'shop.item.energy_boost.stat.1.label': 'Nutzungen',
      'shop.item.energy_boost.stat.1.value': 'Einmalig',
      'shop.item.workout_quick.name': '5-Min-Energieschub',
      'shop.item.workout_quick.desc': 'Aufwärmen überspringen, frisch starten',
      'shop.item.workout_quick.long': 'Aktiviert deine Muskeln digital vor, sodass du direkt mit maximaler Effizienz ins Workout einsteigen kannst.',
      'shop.item.workout_quick.stat.0.label': 'Effekt',
      'shop.item.workout_quick.stat.0.value': 'Aufwärmphase überspringen',
      'shop.item.workout_quick.stat.1.label': 'Nutzungen',
      'shop.item.workout_quick.stat.1.value': 'Einmalig',
      'shop.item.cyber.name': 'Cyber-Skin',
      'shop.item.cyber.desc': 'Neonbeleuchtetes Begleiter-Outfit',
      'shop.item.cyber.long': 'Ein futuristischer Neon-Gitter-Anzug, der deinen Begleiter in die Ästhetik des Athleten von morgen hüllt.',
      'shop.item.cyber.stat.0.label': 'Visuell',
      'shop.item.cyber.stat.0.value': 'Neon-Glühen + Partikelspur',
      'shop.item.royal.name': 'Königsrobe',
      'shop.item.royal.desc': 'Edle Goldakzente',
      'shop.item.royal.long': 'In tiefes Karmesinrot mit Goldfaden-Stickerei gehüllt — vorbehalten Champions, die sich das Recht zu herrschen verdient haben.',
      'shop.item.royal.stat.0.label': 'Visuell',
      'shop.item.royal.stat.0.value': 'Goldene Schimmer-Aura',
      'shop.item.royal.stat.1.label': 'XP-Aura',
      'shop.item.royal.stat.1.value': '+5% an Serien-Tagen',
      'shop.item.minimal.name': 'Minimal',
      'shop.item.minimal.desc': 'Schlichter Monochrom-Look',
      'shop.item.minimal.long': 'Weniger ist mehr. Ein reduziertes monochromes Outfit, das deine Ergebnisse sprechen lässt.',
      'shop.item.minimal.stat.0.label': 'Visuell',
      'shop.item.minimal.stat.0.value': 'Monochrome Palette',
      'shop.item.cosmic.name': 'Kosmisch',
      'shop.item.cosmic.desc': 'Sterne- und Nebeleffekte',
      'shop.item.cosmic.long': 'Dein Begleiter wird zu einer Galaxie in Bewegung — wirbelnde Nebel und Sternenfeld-Partikel folgen jeder Bewegung.',
      'shop.item.cosmic.stat.0.label': 'Visuell',
      'shop.item.cosmic.stat.0.value': 'Galaxie-Partikelsystem',
      'shop.item.midnight.name': 'Mitternacht',
      'shop.item.midnight.desc': 'Standard-Dunkeldesign',
      'shop.item.midnight.long': 'Das klassische dunkle Omnisio-Theme. Tiefes Schwarz und türkise Akzente — klinisch, präzise, kraftvoll.',
      'shop.item.midnight.stat.0.label': 'Palette',
      'shop.item.midnight.stat.0.value': 'Schwarz + Türkis',
      'shop.item.aurora.name': 'Aurora',
      'shop.item.aurora.desc': 'Nordlicht-Verlauf',
      'shop.item.aurora.long': 'Geschwungene Grün-zu-Violett-Verläufe, inspiriert von der Aurora Borealis. Ein lebendiger Himmel über dir.',
      'shop.item.aurora.stat.0.label': 'Palette',
      'shop.item.aurora.stat.0.value': 'Smaragd + Violett',
      'shop.item.sunset.name': 'Sonnenuntergang',
      'shop.item.sunset.desc': 'Warmes Gold + Magenta',
      'shop.item.sunset.long': 'Das letzte Licht des Tages — Bernstein, Gold und tiefes Magenta, geschichtet wie ein brennender Horizont.',
      'shop.item.sunset.stat.0.label': 'Palette',
      'shop.item.sunset.stat.0.value': 'Gold + Magenta',
      'shop.item.ocean.name': 'Ozeantiefen',
      'shop.item.ocean.desc': 'Tiefe Petrol-Ästhetik',
      'shop.item.ocean.long': 'Tauche in den Abgrund. Tiefe Petrol-Hintergründe mit biolumineszenten blauen Akzenten beschwören die erdrückende Stille der Tiefsee herauf.',
      'shop.item.ocean.stat.0.label': 'Palette',
      'shop.item.ocean.stat.0.value': 'Tiefes Petrol + Blau',
      'shop.featuredPack.name': 'Frühlingspaket',
      'shop.featuredPack.tagline': 'Bündel aus 3 Artikeln — spare 40%',
      'shop.featuredPack.countdown': 'Endet in 3 T 14 Std.',
      'shop.featuredPack.item.0': 'Bonsai-Baum',
      'shop.featuredPack.item.1': 'Aurora-Theme',
      'shop.featuredPack.item.2': '2× XP für 24 Std.',

      // Celliva Dispensary
      'shop.celliva.title': 'Celliva Apotheke',
      'shop.celliva.eyebrow': 'Autonome Lieferung',
      'shop.celliva.tabMarketplace': 'Marktplatz',
      'shop.celliva.tabGameStore': 'Spieleshop',
      'shop.celliva.predictiveTitle': 'Prognose-Engine',
      'shop.celliva.predictiveBody': 'Ihr {{product}}-Vorrat wird in {{days}} Tagen aufgebraucht sein.',
      'shop.celliva.authorizeDispatch': 'Versand bestätigen',
      'shop.celliva.calibrationTitle': 'Protokoll-Kalibrierung',
      'shop.celliva.calibrationQuestion': 'Hat {{product}} Ihr {{outcome}} verbessert?',
      'shop.celliva.calibrationYes': 'Ja — optimal',
      'shop.celliva.calibrationNo': 'Keine Veränderung',
      'shop.celliva.calibrationDismiss': 'Schließen',
      'shop.celliva.calibrationThanks': 'Kalibrierung gespeichert. Protokoll verfeinert.',
      'shop.celliva.closedLoopTitle': 'Geschlossener Kreislauf aktiv',
      'shop.celliva.closedLoopBody': 'Biomarker speisen die Apotheke. Nachbestellungen passen sich Ihren Daten an.',
      'shop.celliva.targetedInterventions': 'Gezielte Interventionen',
      'shop.celliva.viewDetails': 'Details',
      'shop.celliva.hideDetails': 'Details ausblenden',
      'shop.celliva.dosage': 'Dosierung',
      'shop.celliva.ingredients': 'Zutaten',
      'shop.celliva.studies': 'Klinische Quellen',
      'shop.celliva.addToCart': 'In den Warenkorb',
      'shop.celliva.inCart': 'Im Warenkorb ({{qty}})',
      'shop.celliva.checkout': 'Bezahlen auf Celliva',
      'shop.celliva.cartEmpty': 'Warenkorb ist leer',
      'shop.celliva.cartTotal': 'Gesamt',
      'shop.celliva.catLongevity': 'Langlebigkeit',
      'shop.celliva.catCognitive': 'Kognition',
      'shop.celliva.catRecovery': 'Erholung',
      'shop.celliva.catPerformance': 'Leistung',
      'shop.celliva.catAll': 'Alle',
      'shop.celliva.downloadCatalog': 'Katalog herunterladen',
      'shop.celliva.bestseller': 'Bestseller',
      'shop.celliva.clinical': 'Klinisch',
      'shop.celliva.verified': 'Laborgeprüft',
      'shop.celliva.proRequired': 'Pro-Stufe schaltet Smart Reorder und Kalibrierung frei',
      'shop.celliva.eliteDnaBanner': 'Basierend auf Ihrem APOE ε4-Status — priorisiert für kognitive Unterstützung',
      'shop.celliva.kvkkNote': 'Ihre Versanddaten verlassen das Gerät nur, wenn Sie eine Bestellung auf Celliva.life aufgeben.',

      // Rarity
      'rarity.common': 'Gewöhnlich',
      'rarity.rare': 'Selten',
      'rarity.epic': 'Episch',
      'rarity.legendary': 'Legendär',

      // Memory (extended)
      'memory.community': 'Community',
      'memory.demoMode': 'Demo-Modus · Supabase verbinden für echte Daten',
      'memory.boost': 'Boost',
      'memory.boostXPNote': '+10 XP für das Posten von Energie',
      'memory.noPostsTitle': 'Noch keine Beiträge',
      'memory.noPostsDesc': 'Sei der Erste, der sein Workout teilt',
      'memory.allCaughtUp': 'Alles gelesen',

      // Calendar (extended)
      'calendar.history': 'Verlauf',
      'calendar.workouts': 'Workouts',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'Serie',
      'calendar.energy': 'Energie',
      'calendar.tabFitness': 'Fitness',
      'calendar.tabNutrition': 'Ernährung',
      'calendar.tabProtocols': 'Programme',
      'calendar.restDay': 'Ruhetag',
      'calendar.restDayDesc': 'Keine Aktivität erfasst. Jeder Champion braucht Erholung.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'KALORIENDEFIZIT',
      'oracle.alertLowProtein': 'WENIG PROTEIN',
      'oracle.alertPerfectDay': 'PERFEKTER TAG',
      'oracle.dailyCalories': 'Tägliche Kalorien',
      'oracle.tabScan': 'Scannen',
      'oracle.tabHistory': 'Verlauf',
      'oracle.tapToScan': 'Richte die Kamera auf dein Essen und drücke unten',
      'oracle.freeScans': '{{used}}/{{max}} kostenlose Scans',
      'oracle.upgradePro': 'Pro-Upgrade',
      'oracle.scanFood': 'Essen scannen',
      'oracle.scanAgain': 'Erneut scannen',
      'oracle.addToLog': 'Zum Ernährungstagebuch',

      // Paywall
      'paywall.chooseLevel': 'Wähle dein Level',
      'paywall.restorePurchase': 'Kauf wiederherstellen',
      'paywall.maybeLater': 'Vielleicht später',

      // Workout (extended)
      'workout.searchPlaceholder': 'Sportarten suchen...',
      'workout.musclesWorked': 'Beanspruchte Muskeln',
      'workout.primary': 'Primär',
      'workout.secondary': 'Sekundär',
      'workout.exercises': 'Übungen',
      'workout.warmUp': 'Aufwärmen',
      'workout.coolDown': 'Abkühlen',
      'workout.startCTA': '{{level}} {{sport}} starten',
      'workout.rest': 'Pause',
      'workout.skipRest': 'Pause überspringen',
      'workout.upNext': 'Als Nächstes',
      'workout.setOf': 'Satz {{current}} von {{total}}',
      'workout.formTips': 'Technik-Tipps',
      'workout.resume': 'Fortsetzen',
      'workout.pause': 'Pause',
      'workout.skip': 'Überspringen',
      'workout.complete': 'Workout abgeschlossen',
      'workout.sets': 'Sätze',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Als nächstes: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Form prüfen: {{tip}}',

      // Onboarding — Geschlecht & Alter
      'onboarding.aboutTitle': 'Über dich',
      'onboarding.aboutSubtitle': 'Erzähl uns von dir',
      'onboarding.gender.male': 'Männlich',
      'onboarding.gender.female': 'Weiblich',
      'onboarding.gender.other': 'Divers',
      'onboarding.howOld': 'Wie alt bist du?',
      'onboarding.yearsOld': 'Jahre alt',

      // Onboarding — Körper
      'onboarding.bodyTitle': 'Dein Körper',
      'onboarding.bodySubtitle': 'Damit wir deinen Plan berechnen können',
      'onboarding.weight': 'Gewicht',
      'onboarding.height': 'Größe',
      'onboarding.targetWeight': 'Zielgewicht (optional)',

      // Onboarding — Aktivitätslevel
      'onboarding.activityTitle': 'Aktivitätslevel',
      'onboarding.activitySubtitle': 'Beeinflusst deinen täglichen Kalorienbedarf',
      'onboarding.activity.sedentary': 'Sitzend',
      'onboarding.activity.sedentarySub': 'Wenig oder kein Training',
      'onboarding.activity.light': 'Leicht',
      'onboarding.activity.lightSub': '1–3 Tage pro Woche',
      'onboarding.activity.moderate': 'Moderat',
      'onboarding.activity.moderateSub': '3–5 Tage pro Woche',
      'onboarding.activity.high': 'Hoch',
      'onboarding.activity.highSub': '6–7 Tage pro Woche',
      'onboarding.activity.extreme': 'Extrem',
      'onboarding.activity.extremeSub': 'Athlet / zweimal täglich',
      'onboarding.calculatePlan': 'Meinen Plan berechnen',

      // Onboarding — Berechnung
      'onboarding.calculatingTitle': 'Dein Plan wird berechnet…',
      'onboarding.calcMsg1': 'Metabolismus wird analysiert…',
      'onboarding.calcMsg2': 'TDEE wird berechnet…',
      'onboarding.calcMsg3': 'Makro-Verteilung wird optimiert…',
      'onboarding.calcMsg4': 'Persönlicher Plan wird erstellt…',
      'onboarding.calcMsg5': 'Fast fertig…',
      'onboarding.planReadyTitle': 'Plan fertig!',
      'onboarding.planReadySubtitle': 'Deine personalisierten Tagesziele',
      'onboarding.dailyCalories': 'Tägliche Kalorien',
      'onboarding.kcalPerDay': 'kcal / Tag',
      'onboarding.macroSplit': 'Makro-Verteilung',
      'onboarding.macroProtein': 'Eiweiß',
      'onboarding.macroCarbs': 'Kohlenhydrate',
      'onboarding.macroFat': 'Fett',
      'onboarding.timeframe': 'Zeitraum',
      'onboarding.timeframe1m': '1 Monat',
      'onboarding.timeframe3m': '3 Monate',
      'onboarding.timeframe6m': '6 Monate',
      'onboarding.timeframe12m': '1 Jahr',
      'onboarding.chooseCompanion': 'Meinen Begleiter wählen',

      // Onboarding — Begleiter
      'onboarding.companionTitle': 'Wähle deinen Begleiter',
      'onboarding.companionSubtitle': 'Dein Begleiter wächst mit deinem Training',

      // Kalender
      'calendar.noMealsTitle': 'Keine Mahlzeiten erfasst',
      'calendar.noMealsDesc': 'Öffne den Ernährungs-Tab, um dein Essen für diesen Tag zu tracken.',
      'calendar.noProtocolsTitle': 'Keine Protokolle erfasst',
      'calendar.noProtocolsDesc': 'Für diesen Tag keine Biohacks aufgezeichnet. Bleib dran.',

      // Erinnerungen
      'memory.loadError': 'Beiträge konnten nicht geladen werden',

      // Syndikate
      'syndicates.messagePlaceholder': 'Nachricht an den Clan…',
      'syndicates.noClanTitle': 'Noch kein Clan',
      'syndicates.noClanDesc': 'Tritt einem Syndikat bei, um mit anderen zu konkurrieren',
      'syndicates.browseCta': 'Clans durchsuchen',

      // Biometrischer Streifen
      'biometric.recovery': 'Erholung',
      'biometric.bodyBattery': 'Körperbatterie',
      'biometric.hrv': 'HRV',
      'biometric.hrvDelta': '{{delta}} zur Basislinie',
      'biometric.todayBadge': 'Heute',
      'biometric.rest': 'Ruhetag',
      'biometric.moderate': 'Moderat',
      'biometric.intense': 'Intensiv',
      'biometric.consentRequired': 'Mit Longevity verbinden',
      'biometric.consentRequiredDesc': 'Aktiviere den Workout-Zugriff in den Longevity-Einstellungen',
      'biometric.baselineNotSet': 'Basislinie in Longevity abschließen',
      'biometric.offline': 'Offline',
      'biometric.demoData': 'Demodaten',
      'biometric.staleBadge': 'vor {{minutes}} Min.',
      'biometric.connectCta': 'Verbinden',
      'biometric.connectingFromYou': 'Im Training anzeigen',

      // Benachrichtigungen
      'notif.morning.title': 'Guten Morgen!',
      'notif.morning.body': '{{companion}} ist bereit, mit dir zu trainieren.',
      'notif.evening.title': 'Training heute?',
      'notif.evening.body': 'Schon 10 Minuten halten deine Serie am Leben.',
      'notif.streak.title': '{{streak}}-Tage-Serie in Gefahr!',
      'notif.streak.body': 'Eine kurze Mobilisationseinheit rettet deine Serie.',
      'notif.companion.title': '{{companion}} ist da',
      'notif.companion.body': 'Hast du heute einen Moment zum Bewegen?',
      'notif.recovery.title': 'Erholungsmodus aktiv',
      'notif.recovery.body': 'Nach dem gestrigen intensiven Training: NMN + Magnesium empfohlen.',
      'notif.defaultCompanion': 'Dein Begleiter',
      'notif.preprompt.title': 'Bleib dran',
      'notif.preprompt.subtitle': 'Tägliche Erinnerungen für Disziplin — jederzeit abschaltbar.',
      'notif.preprompt.benefit1': 'Morgendliche Motivation für einen guten Start',
      'notif.preprompt.benefit2': 'Serienschutz, damit du keinen Fortschritt verlierst',
      'notif.preprompt.benefit3': 'Erholungserinnerungen nach harten Einheiten',
      'notif.preprompt.benefit4': 'Dein Begleiter meldet sich 1–2× pro Woche',
      'notif.preprompt.allow': 'Benachrichtigungen aktivieren',
      'notif.preprompt.skip': 'Nicht jetzt',
      'home.longevityId': 'Longevity-ID',
      'home.sleep': 'Schlaf',
      'home.water': 'Wasser',
      'home.steps': 'Schritte',
      'profile.activity': 'Aktivität',
      'profile.emptyJourney': 'Deine Reise beginnt mit einem Workout.',
      'profile.startNow': 'Jetzt starten →',
      'profile.thisWeek': 'diese Woche',
      'profile.editProfileAria': 'Profil bearbeiten',
      'profile.phoneCountryAria': 'Telefon-Ländervorwahl',
      'memory.energyPoints': 'Energiepunkte',
      'memory.uploadAria': 'Erinnerung hochladen',
      'calendar.synergy': 'SYNERGIE',
      'calendar.today': 'Heute',
      'biohacks.synergyBonus': 'Synergie-Bonus',
      'biohacks.synergyDesc': 'Schließe alle Protokolle einer Kategorie ab für x1,5 Energie-Bonus',
      'shop.featured': 'Empfohlen',
      'syndicates.clanPower': 'Clan-Stärke',
      'biometric.alternatives': 'Alternativen',
      'biometric.loadingAria': 'Biometriedaten werden geladen',
      'biometric.overviewAria': 'Biometrieübersicht von Longevity',
      'dragon.energy': 'Energie',
      'nav.openSettingsAria': 'Einstellungen öffnen',
      'nav.dismissAria': 'Schließen',
      'nav.moreOptionsAria': 'Weitere Optionen',
      'nav.closeMenuAria': 'Menü schließen',
      'nav.primaryAria': 'Hauptnavigation',
      'nav.moreNavAria': 'Weitere Navigationsoptionen',
      'common.copiedToClipboard': 'In Zwischenablage kopiert!',
      'paywall.noPreviousPurchase': 'Kein früherer Kauf gefunden. Abonniere, um Pro-Funktionen freizuschalten.',
      'common.back': 'Zurück',
      'dragon.stage': 'Stufe',
      'dragon.levelShort': 'St.',
      'dragon.evolved': 'ENTWICKELT!',
      'dragon.evolving': 'Entwickelt sich...',
      'dragon.feeding': 'Wird gefüttert...',
      'dragon.notEnoughEnergy': 'Nicht genug Energie',
      'dragon.feedToEvolve': 'Füttern zum Entwickeln',
      'dragon.maxEvolution': 'Maximale Entwicklung erreicht',
      'dragon.elderFormUnlocked': 'Avatar-Ältester · Göttliche Form freigeschaltet',
      'dragon.stageName.initiate': 'Anfänger',
      'dragon.stageName.apprentice': 'Lehrling',
      'dragon.stageName.adept': 'Adept',
      'dragon.stageName.warrior': 'Krieger',
      'dragon.stageName.master': 'Meister',
      'dragon.stageName.grandmaster': 'Großmeister',
      'dragon.stageName.elder': 'Avatar-Ältester',
      'syndicates.roleCommanderShort': 'KMD',
      'syndicates.roleOfficerShort': 'OFZ',
      'syndicates.kick': 'Kicken',
      'syndicates.overview': 'Übersicht',
      'syndicates.roster': 'Kader',
      'syndicates.comms': 'Chat',
      'syndicates.globalRankShort': 'Global',
      'syndicates.membersLabel': 'Mitglieder',
      'syndicates.joinBattle': 'Schlacht beitreten',
      'syndicates.globalRank': 'Globaler Rang',
      'syndicates.weeklyEp': 'Wöchentliche EP',
      'syndicates.inviteRecruits': 'Rekruten einladen',
      'syndicates.activeMembers': '{{count}} aktive Mitglieder',
      'syndicates.epThisWeek': '{{ep}} EP diese Woche',
      'syndicates.clanChat': 'Clan-Chat',
      'syndicates.online': '{{count}} online',
      'leaderboard.dayStreak': '{{count}}-Tage-Serie',
      'leaderboard.lvlShort': 'St.',
      'calendar.weeklyEnergy': '7-Tage-Energie',
      'calendar.legendWorkout': 'Training',
      'calendar.legendPerfect': 'Perfekt',
      'calendar.legendRest': 'Ruhe',
      'calendar.activityLog': 'Aktivitätsverlauf',
      'calendar.showAll': 'Alle anzeigen',
      'calendar.monthApr': 'Apr',
      'calendar.month.january': 'Januar',
      'calendar.month.february': 'Februar',
      'calendar.month.march': 'März',
      'calendar.month.april': 'April',
      'calendar.month.may': 'Mai',
      'calendar.month.june': 'Juni',
      'calendar.month.july': 'Juli',
      'calendar.month.august': 'August',
      'calendar.month.september': 'September',
      'calendar.month.october': 'Oktober',
      'calendar.month.november': 'November',
      'calendar.month.december': 'Dezember',
      'calendar.day.sun': 'SO',
      'calendar.day.mon': 'MO',
      'calendar.day.tue': 'DI',
      'calendar.day.wed': 'MI',
      'calendar.day.thu': 'DO',
      'calendar.day.fri': 'FR',
      'calendar.day.sat': 'SA',
      'biohacks.cat.sport': 'SPORT',
      'biohacks.cat.mind': 'GEIST',
      'biohacks.cat.ascetic': 'ASKETISCH',
      'biohacks.progress': '{{done}}/{{total}} abgeschlossen',
      'biohacks.synergyX': 'x1,5 Synergie',
      'biohacks.diff.EASY': 'LEICHT',
      'biohacks.diff.MEDIUM': 'MITTEL',
      'biohacks.diff.HARD': 'SCHWER',
      'biohacks.diff.LEGEND': 'LEGENDÄR',
      'biohacks.proto.s1.name': 'Laufen',
      'biohacks.proto.s1.desc': '30min Outdoor-Lauf',
      'biohacks.proto.s2.name': 'Kampfsport',
      'biohacks.proto.s2.desc': 'Boxen oder Kampfsport-Session',
      'biohacks.proto.s3.name': 'Eisenschmiede',
      'biohacks.proto.s3.desc': 'Krafttraining-Einheit',
      'biohacks.proto.s4.name': 'Aqua Flow',
      'biohacks.proto.s4.desc': 'Schwimmen 20min+',
      'biohacks.proto.s5.name': 'Flex-Protokoll',
      'biohacks.proto.s5.desc': 'Dehnen & Mobilität 15min',
      'biohacks.proto.m1.name': 'Meditation',
      'biohacks.proto.m1.desc': '10min Achtsamkeitssitzung',
      'biohacks.proto.m2.name': 'Wim-Hof-Atmung',
      'biohacks.proto.m2.desc': '3 Runden Atemarbeit',
      'biohacks.proto.m3.name': 'Neurale Schöpfung',
      'biohacks.proto.m3.desc': 'Kreative Visualisierung 10min',
      'biohacks.proto.m4.name': 'Tiefes Lesen',
      'biohacks.proto.m4.desc': '20 Seiten Sachbuch lesen',
      'biohacks.proto.m5.name': 'Tagebucheintrag',
      'biohacks.proto.m5.desc': 'Tagebucheintrag schreiben',
      'biohacks.proto.a1.name': 'Kein Alkohol / Keine Drogen',
      'biohacks.proto.a1.desc': 'Bleib heute clean',
      'biohacks.proto.a2.name': 'Sauberer Treibstoff',
      'biohacks.proto.a2.desc': 'Iss nur Vollwertkost',
      'biohacks.proto.a3.name': 'Digital-Detox',
      'biohacks.proto.a3.desc': 'Keine Social Media 4h+',
      'biohacks.proto.a4.name': 'Kälteexposition',
      'biohacks.proto.a4.desc': '2min kalte Dusche',
      'biohacks.proto.a5.name': 'Schlaf-Protokoll',
      'biohacks.proto.a5.desc': 'Um 22 Uhr im Bett, 7h+ Schlaf',
      'biohacks.mission.1': '100 Liegestütze an einem Tag',
      'biohacks.mission.2': '5 Minuten Plank',
      'biohacks.mission.3': '10K Schritte',
      'biohacks.mission.4': 'Alle Protokolle abschließen',
      'biohacks.mission.5': '7-Tage-Serie',
      'memory.timeAgoMin': 'vor {{n}}m',
      'memory.timeAgoHour': 'vor {{n}}h',
      'memory.timeAgoDay': 'vor {{n}}T',
      'memory.lvlShort': 'ST',
      'memory.energyBoost': '{{amount}} Energie-Boost',
      'memory.boostWithEnergy': 'Mit Energie boosten',
      'memory.epMin': '10 EP',
      'memory.epMax': '2.000 EP',
      'memory.boostSent': 'Boost gesendet!',
      'companion.stage': 'Stufe',
      'companion.evolved': 'Entwickelt',
      'companion.xpProgress': 'XP-FORTSCHRITT',
      'companion.nextStage': 'Nächste Stufe',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'Maximale Entwicklung erreicht',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': 'Allen beigetreten!',
      'biohacks.todayComplete': 'heute',
      'coach.chooseCoach': 'WÄHLE DEINEN COACH',
      'coach.headphonesHint': 'Verwende Kopfhörer für den vollen Binaural-Effekt',
      'coach.localGenerationHint': 'Lokal erzeugt · Kein Internet nötig · Für immer kostenlos',
      'coach.musicNote': 'Öffnet sich in deiner Musik-App oder im Browser',
      'coach.sampleTitle': 'STIMME ANHÖREN',
      'coach.settings': 'EINSTELLUNGEN',
      'coach.soundscapeTitle': 'BINAURALE MODI',
      'coach.voiceEnabled': 'Sprach-Coach',
      'coach.voiceEnabledDesc': 'Audio-Hinweise während des Trainings',
      'coach.volume': 'Lautstärke',
      'login.appleError': 'Apple-Anmeldung fehlgeschlagen',
      'login.continue': 'Weiter',
      'login.continueApple': 'Mit Apple fortfahren',
      'login.continueGoogle': 'Mit Google fortfahren',
      'login.email': 'E-Mail',
      'login.emailLabel': 'E-Mail-Adresse',
      'login.emailPlaceholder': 'du@beispiel.com',
      'login.googleError': 'Google-Anmeldung fehlgeschlagen',
      'login.hidePassword': 'Passwort verbergen',
      'login.orContinueWith': 'oder',
      'login.password': 'Passwort',
      'login.passwordMin': 'Das Passwort muss mindestens 6 Zeichen lang sein',
      'login.passwordPlaceholder': 'Dein Passwort',
      'login.phone': 'Telefon',
      'login.privacyLink': 'Datenschutzrichtlinie',
      'login.showPassword': 'Passwort anzeigen',
      'login.signInError': 'Anmeldung fehlgeschlagen',
      'login.signingIn': 'Anmeldung läuft...',
      'login.terms': 'Wenn du fortfährst, stimmst du unseren',
      'login.termsLink': 'Nutzungsbedingungen',
      'memory.boostAmount': 'Boost-Menge',
      'memory.comment': 'Kommentieren',
      'memory.emptyDesc': 'Dein Feed füllt sich, sobald du und dein Team trainieren.',
      'memory.emptyTitle': 'Noch keine Aktivität',
      'memory.like': 'Gefällt mir',
      'memory.share': 'Teilen',
      'oracle.errAuth': 'Authentifizierung des KI-Dienstes fehlgeschlagen.',
      'oracle.errGeneric': 'Bild konnte nicht analysiert werden. Versuche es mit einem schärferen Foto.',
      'oracle.errLimit': 'Tägliches Scan-Limit erreicht. Upgrade für unbegrenzte Scans.',
      'oracle.errMissingKey': 'KI-Dienst nicht konfiguriert. Bitte kontaktiere den Support.',
      'oracle.errRate': 'Dienst ausgelastet. Bitte versuche es gleich erneut.',
      'oracle.unlimitedScans': 'Unbegrenzte Scans',
      'paywall.everythingUnlocked': 'Alles freigeschaltet',
      'paywall.freeLaunchNote': 'Alle Pro-Funktionen sind während des Launches kostenlos.',
      'paywall.noCardNeeded': 'Keine Karte nötig',
      'paywall.proFreeTitle': 'Pro — Kostenlos beim Launch',
      'paywall.unlockFree': 'Alles freischalten — kostenlos',
      'paywall.whatsIncluded': 'Was enthalten ist',
      'profile.noPrs': 'Noch keine persönlichen Rekorde',
      'profile.noPrsDesc': 'Deine Bestleistungen erscheinen, während du trainierst.',
      'progress.emptyCta': 'Training starten',
      'progress.emptyDesc': 'Schließe dein erstes Training ab, um deine Statistiken zu sehen.',
      'progress.emptyTitle': 'Dein Fortschritt beginnt hier',
      'referral.copyLinkAria': 'Empfehlungslink kopieren',
      'referral.shareAria': 'Empfehlungslink teilen',
      'settings.cookies': 'Cookie-Richtlinie',
      'settings.deleteAccount': 'Konto löschen',
      'settings.deleteAccountWarning': 'Dadurch werden dein Konto und alle deine Daten (Workouts, Fortschritt, Profil) dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.',
      'settings.deleteConfirm': 'Löschen',
      'settings.deleteError': 'Konto konnte nicht gelöscht werden. Bitte versuche es erneut.',
      'settings.kvkk': 'KVKK / Datenschutz',
      'settings.legalSupport': 'Rechtliches & Support',
      'settings.privacy': 'Datenschutzrichtlinie',
      'settings.support': 'Hilfe & Support',
      'settings.terms': 'Nutzungsbedingungen',
      'shop.celliva.allProducts': 'Gesamtkatalog',
      'shop.celliva.autonomousFulfillment': 'Autonome Abwicklung',
      'shop.celliva.calibrationRecorded': 'Kalibrierung gespeichert. Protokoll verfeinert.',
      'shop.celliva.cart': 'Warenkorb',
      'shop.celliva.closedLoopActive': 'Closed-Loop aktiv',
      'shop.celliva.decrease': 'Menge verringern',
      'shop.celliva.depleteWarning': 'Dein Vorrat an {{product}} ist in {{days}} Tagen aufgebraucht.',
      'shop.celliva.details': 'Details',
      'shop.celliva.dismiss': 'Schließen',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'Elite erforderlich',
      'shop.celliva.increase': 'Menge erhöhen',
      'shop.celliva.noChange': 'Keine Änderung',
      'shop.celliva.outcomeDeepSleep': 'Tiefschlaf',
      'shop.celliva.predictiveEngine': 'Vorhersage-Engine',
      'shop.celliva.protocolCalibration': 'Protokoll-Kalibrierung',
      'shop.celliva.yesOptimal': 'Ja — optimal',
      'shop.tabGameStore': 'Game-Store',
      'shop.tabMarketplace': 'Marktplatz',
      'shop.unlocked': '{{name}} freigeschaltet!',
      'syndicates.createCta': 'Erstellen',
      'syndicates.namePlaceholder': 'Name des Syndikats…',
      'syndicates.newClanDesc': 'Ein neues Syndikat, bereit aufzusteigen.',
      'syndicates.send': 'Senden',
      'syndicates.tagPlaceholder': 'Tag (3–4 Zeichen)',
      'workout.end': 'Beenden',
      'workout.endWorkout': 'Training beenden',
      'workout.noResults': 'Keine Workouts gefunden',
      'workout.noResultsDesc': 'Versuche eine andere Suche oder Kategorie.',

    },
  },

  es: {
    translation: {
      // ── Nuevas claves de interfaz (día de descanso, biometría, compartir, selector de país) ──
      'home.totalWorkouts': 'Entrenamientos totales',
      'restDay.title': 'Día de descanso',
      'restDay.empty': 'Completa un entrenamiento para seguir tu recuperación',
      'restDay.today': 'Entrenaste hoy. Recupérate bien.',
      'restDay.rested': 'Estás recuperado — mantén el ritmo.',
      'restDay.recommendRest': 'Carga semanal alta — considera descansar hoy.',
      'restDay.recommendTrain': 'Bien descansado — listo para entrenar.',
      'restDay.daysSince_one': 'hace {{count}} día',
      'restDay.daysSince_other': 'hace {{count}} días',
      'biometric.noData': 'sin datos',
      'biometric.connectWearable': 'Conecta un wearable para datos en vivo',
      'workout.shareUnavailable': 'Compartir no está disponible en este dispositivo.',
      'workout.shareFailed': 'No se pudo compartir ahora. Inténtalo de nuevo.',
      'country.TR': 'Turquía',
      'country.US': 'Estados Unidos',
      'country.RU': 'Rusia',
      'country.DE': 'Alemania',
      'country.GB': 'Reino Unido',
      'country.FR': 'Francia',
      'country.ES': 'España',
      'country.IT': 'Italia',
      'country.NL': 'Países Bajos',
      'country.SA': 'Arabia Saudita',
      'country.AE': 'Emiratos Árabes Unidos',
      'country.EG': 'Egipto',
      'country.ID': 'Indonesia',
      'country.KR': 'Corea del Sur',
      'country.JP': 'Japón',
      'country.CN': 'China',
      'country.IN': 'India',
      'country.BR': 'Brasil',
      'country.MX': 'México',
      'country.CA': 'Canadá',
      'country.AU': 'Australia',
      'country.NZ': 'Nueva Zelanda',
      'country.ZA': 'Sudáfrica',
      'country.SE': 'Suecia',
      'country.NO': 'Noruega',
      'country.DK': 'Dinamarca',
      'country.FI': 'Finlandia',
      'country.CH': 'Suiza',
      'country.BE': 'Bélgica',
      'country.AT': 'Austria',
      'profile.dayStreak': 'racha de días',
      'profile.companionAlt': 'Tu compañero',
      'profile.ninetyDayActivity': 'Actividad de 90 días',
      'profile.restDay': 'Día de descanso',
      'profile.viewAllRecordsAria': 'Ver todos los récords',
      'profile.copyLinkAria': 'Copiar enlace de referido',
      'profile.shareAria': 'Compartir enlace de referido',
      'referral.tagline': '1 mes Pro — para ti y tu amigo',
      'referral.noLimit': 'Sin límite — refiere a cuantos quieras',
      'shop.celliva.bestSellers': 'Más Vendidos',
      'shop.celliva.featuredTitle': 'Esenciales del Protocolo',
      'shop.celliva.benefits': 'Beneficios',
      'shop.celliva.pairsWith': 'Cómo encaja con tus objetivos',
      'shop.celliva.added': '¡Añadido al carrito!',
      'shop.celliva.cartTitle': 'Tu Carrito',
      'shop.celliva.items': 'artículos',
      'shop.celliva.clearCart': 'Limpiar todo',
      'shop.celliva.emptyCartTitle': 'El carrito está vacío',
      'shop.celliva.emptyCartDesc': 'Añade suplementos del catálogo para construir tu protocolo.',
      'shop.celliva.browseCatalog': 'Explorar Catálogo',
      'shop.celliva.subtotal': 'Subtotal',
      'shop.celliva.fulfillmentNote': 'Cumplido por Celliva Life. Envío calculado en el pago.',
      'shop.celliva.viewCart': 'Ver Carrito',
      'shop.celliva.remove': 'Eliminar',
      'shop.prev': 'Anterior',
      'shop.next': 'Siguiente',
      'avatar.rarityCommon': 'COMÚN',
      'avatar.rarityRare': 'RARO',
      'avatar.rarityEpic': 'ÉPICO',
      'avatar.rarityLegendary': 'LEGENDARIO',
      'avatar.pro': 'PRO',
      'avatar.saved': '¡Guardado!',
      'avatar.skin.default': 'Predeterminado',
      'avatar.skin.cyber': 'Cyber',
      'avatar.skin.neon': 'Neón',
      'avatar.skin.shadow': 'Sombra',
      'avatar.skin.gold': 'Oro',
      'avatar.outfit.basic': 'Equipo Básico',
      'avatar.outfit.cyber': 'Traje Cyber',
      'avatar.outfit.runner': 'Corredor Neón',
      'avatar.outfit.iron': 'Armadura de Hierro',
      'avatar.acc.none': 'Ninguno',
      'avatar.acc.visor': 'Visor',
      'avatar.acc.earbuds': 'Auriculares',
      'avatar.acc.chain': 'Cadena',
      'avatar.acc.halo': 'Halo',
      'coach.selectedLabel': 'ELEGIDO',
      'coach.selectLabel': 'Seleccionar',
      'coach.languageSection': 'IDIOMA DEL ENTRENADOR',
      'coach.languageLabel': 'Seleccionar idioma',
      'coach.languageHint': 'Las frases de voz se reproducen en el idioma seleccionado',
      'workout.exerciseOf': 'Ejercicio {{current}} de {{total}}',
      'workout.paused': 'En pausa',
      'workout.endSessionSub': 'El progreso se guardará hasta este punto.',
      'workout.keepGoing': 'Seguir',
      'workout.endNow': 'Terminar ya',
      'workout.repsLabel': 'reps',
      'workout.next': 'Siguiente',
      'workout.strainElite': 'Esfuerzo élite',
      'workout.strainHard': 'Sesión dura',
      'workout.strainModerate': 'Buen trabajo',
      'workout.selectLevel': 'Seleccionar nivel',
      'common.error_title': 'Algo salió mal',
      'common.error_description': 'Por favor, inténtalo de nuevo.',
      'common.network_error': 'Sin conexión',
      'oracle.subtitle': 'Escáner IA & Seguimiento',
      'oracle.emptyTitle': 'Escáner de Comida IA',
      'oracle.emptyDesc': 'Apunta la cámara a tu comida. Análisis instantáneo.',
      'oracle.scanningSubtitle': 'Analizando con Gemini Vision',
      'oracle.confidence': 'Confianza',
      'oracle.detectedItems': 'Ingredientes Detectados',
      'oracle.macroBreakdown': 'Desglose de Macros',
      'oracle.limitReached': 'Límite Alcanzado',
      'oracle.proUnlimited': 'Pro Ilimitado',
      'oracle.proDesc': 'Escaneos ilimitados + planes de comidas + coaching IA',
      'oracle.kcalRemaining': '{{n}} kcal restantes',
      'oracle.goalReached': '¡Meta alcanzada!',
      'calendar.streakDays': 'Racha de {{n}} días',
      'calendar.april2026': 'Abril 2026',
      'calendar.prevMonth': 'Mes anterior',
      'calendar.nextMonth': 'Mes siguiente',
      'login.tagline': 'TU LONGEVIDAD EMPIEZA',
      'login.otpHint': 'Ingresa el código de 6 dígitos',
      'login.connecting': 'Conectando...',
      'login.connectingLongevity': 'Conectando a Longevity OS...',
      'login.continueLongevity': 'Continuar con Omnisio Longevity ID',
      'paywall.paymentMethod': 'Método de pago',
      'social.timeMin': 'hace {{n}}m',
      'social.timeHour': 'hace {{n}}h',
      'social.timeDay': 'hace {{n}}d',
      'syndicates.joined': 'Unido',
      'syndicates.joinToChat': 'Únete para el chat',
      'syndicates.requirement': 'Mín. {{xp}} XP',
      'syndicates.teamChallenges': 'Retos de equipo',
      'syndicates.myClan': 'Mi Sindicato',
      'syndicates.discover': 'Descubrir',
      'syndicates.createTitle': 'Crear sindicato',
      'biohacks.challenges': 'Retos',
      'biohacks.activeChallenges': 'Activos — {{n}}',
      'biohacks.availableChallenges': 'Disponibles',
      'biohacks.completedChallenges': 'Completados',
      'biohacks.joinChallenge': 'Unirse',
      'biohacks.claimReward': 'Reclamar +{{reward}} XP',
      'memory.tabNEW': 'Nuevo',
      'memory.tabMY': 'Mis',
      'memory.tabTOP': 'Top',
      'memory.tabCORE': 'Core',
      'nav.progress': 'Progreso',
      'home.defaultName': 'Atleta',
      'home.greetingSub': 'Tu cuerpo. Tus metas.',
      'home.greetingSub2': 'Construyamos algo más fuerte hoy.',
      'home.energyScore': 'Puntuación de Energía',
      'home.companionLabel': 'Compañero',
      'home.companionTagline': 'Para entrenar. Para apoyar.',
      'home.companion.phoenix': 'Omni',
      'home.companion.bonsai': 'Sage',
      'home.companion.orb': 'Orb',
      'home.companion.avatar': 'Titán',
      'home.companion.avatar_female': 'Luna',
      'home.moodHigh': 'Alta',
      'home.moodGood': 'Buena',
      'home.moodFair': 'Media',
      'home.moodLow': 'Baja',
      'home.moodHighSub': 'Listo para rendir.',
      'home.moodGoodSub': 'Base sólida — sigue empujando.',
      'home.moodFairSub': 'Calienta suave hoy.',
      'home.moodLowSub': 'Prioriza la recuperación.',
      'home.recommendedForYou': 'Recomendado para Ti',
      'home.aiRecommended': 'Recomendación IA',
      'home.recTitle': 'Fuerza y Equilibrio',
      'home.recSub': 'Gana fuerza. Mejora el control.',
      'home.dayStreak': 'Racha de Días',
      'home.workoutsThisWeek': 'Entrenamientos esta Semana',
      'home.badgesEarned': 'Insignias Ganadas',
      'workout.level.intermediate': 'Intermedio',
      'progress.title': 'Progreso',
      'progress.level': 'Nivel {{level}}',
      'progress.stage1': 'Forma Chispa',
      'progress.stage2': 'Forma Despierta',
      'progress.stage3': 'Forma Evolucionada',
      'progress.stage4': 'Forma Ascendida',
      'progress.stage5': 'Forma Elemental',
      'progress.stage6': 'Forma Mítica',
      'progress.stage7': 'Forma Trascendente',
      'progress.rarityCommon': 'COMÚN',
      'progress.rarityRare': 'RARO',
      'progress.rarityEpic': 'ÉPICO',
      'progress.rarityLegendary': 'LEGENDARIO',
      'progress.stageChip': '{{stage}}. Etapa de Evolución',
      'progress.dayStreakInline': 'racha de {{count}} días',
      'progress.streakSub': '¡Mantén la llama viva!',
      'progress.xpProgress': 'Progreso XP',
      'progress.nextStage': 'Siguiente Etapa: Etapa {{stage}} - {{name}}',
      'progress.dayStreak': 'Racha de Días',
      'progress.workouts': 'Entrenamientos',
      'progress.stagesReached': 'Etapas Alcanzadas',
      'progress.achievements': 'Logros',
      'progress.viewAll': 'Ver Todo',
      'progress.achievement.discipline': 'Disciplina',
      'progress.achievement.consistency': 'Consistencia',
      'progress.achievement.endurance': 'Resistencia',
      'progress.achievement.resilience': 'Resiliencia',
      'progress.achievement.days': 'Días',
      'progress.achievement.workouts': 'Entrenamientos',
      'paywall.disclosureTitle': 'Términos de Suscripción',
      'paywall.disclosureLength': 'La suscripción se renueva automáticamente mensual o anualmente hasta cancelar',
      'paywall.disclosurePrice': 'Se cobra a tu Apple ID al precio mostrado arriba',
      'paywall.disclosureRenewal': 'Se renueva automáticamente dentro de las 24 horas previas al fin del período (a menos que se desactive)',
      'paywall.disclosureCancel': 'Gestiona o cancela en cualquier momento en Ajustes de iPhone → Apple ID → Suscripciones',
      'paywall.disclosureRefund': 'Sin reembolso por la parte no utilizada del período actual',
      'paywall.legalFooter': 'Suscripción gestionada vía Apple ID. Cancela en cualquier momento en Ajustes de iPhone.',
      'profile.editTitle': 'Editar Perfil',
      'profile.firstName': 'Nombre',
      'profile.firstNamePh': 'Tu nombre',
      'profile.lastName': 'Apellido',
      'profile.lastNamePh': 'Tu apellido',
      'profile.displayName': 'Nombre para mostrar',
      'profile.displayNamePh': 'Cómo te ven los demás',
      'profile.email': 'Email',
      'profile.publicId': 'ID Público',
      'common.cancel': 'Cancelar',
      'common.save': 'Guardar',
      'common.saving': 'Guardando…',
      'coach.active': 'ACTIVO',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'Pasos + energía activa',
      'coach.tab.voice': 'Voz',
      'coach.tab.soundscape': 'Paisaje sonoro',
      'coach.tab.music': 'Música',
      'coach.sample.workoutStart': 'Pre-entrenamiento',
      'coach.sample.setComplete': 'Serie completa',
      'coach.sample.halfway': 'Motivación a mitad',
      'coach.sample.finalSet': 'Empuje última serie',
      'coach.sample.workoutDone': 'Entrenamiento terminado',
      'coach.soundscape.focus': 'Foco',
      'coach.soundscape.focusDesc': 'Ondas alfa profundas para concentración láser',
      'coach.soundscape.cardio': 'Impulso Cardio',
      'coach.soundscape.cardioDesc': 'BPM altos para empujar más fuerte',
      'coach.soundscape.recovery': 'Recuperación',
      'coach.soundscape.recoveryDesc': 'Tonos suaves para reparación muscular',
      'coach.soundscape.sleep': 'Preparación Sueño',
      'coach.soundscape.sleepDesc': 'Ondas delta para descanso profundo',
      'coach.service.spotify.desc': 'Beast Mode Workout',
      'coach.service.applemusic.desc': 'Pure Pump',
      'coach.service.ytmusic.desc': 'Lista de Entrenamiento',
      'coach.companion.phoenix.name': 'Fénix',
      'coach.companion.phoenix.desc': 'Épico, motivacional',
      'coach.companion.bonsai.name': 'Bonsái',
      'coach.companion.bonsai.desc': 'Calmado, consciente',
      'coach.companion.orb.name': 'Orbe de Energía',
      'coach.companion.orb.desc': 'Futurista, robótico',
      'coach.companion.avatar.name': 'Guerrero',
      'coach.companion.avatar.desc': 'Fuerte, intenso',
      'coach.companion.avatar_female.name': 'Diosa',
      'coach.companion.avatar_female.desc': 'Empoderante, cálido',
      'coach.musicTitle': 'LISTAS DE ENTRENAMIENTO',
      'coach.openIn': 'Abrir',
      'coach.play': 'Reproducir',
      'coach.playing': 'Reproduciendo',
      'biometric.insufficientScope': 'Permisos faltantes',
      'biometric.missingScopes': 'Faltan: {{scopes}}',
      'biometric.grantScopesCta': 'Conceder',
      'biometric.rateLimited': 'Límite de tasa — reintenta en {{seconds}}s',
      'common.continue': 'Continuar',
      'onboarding.goalTitle': '¿Cuál es tu meta?',
      'onboarding.goalSubtitle': 'Elige tu objetivo principal',
      'onboarding.goal.cut': 'Definir',
      'onboarding.goal.cutSub': 'Perder grasa, marcar músculos',
      'onboarding.goal.bulk': 'Volumen',
      'onboarding.goal.bulkSub': 'Ganar músculo y fuerza',
      'onboarding.goal.maintain': 'Mantener',
      'onboarding.goal.maintainSub': 'Mantener la forma actual',
      'onboarding.awakeningTitle': 'Estás listo',
      'onboarding.awakeningSubtitle': '¿Cómo te llamamos?',
      'onboarding.namePlaceholder': 'Tu nombre o apodo',
      'onboarding.getStarted': 'Empezar',
      'sport.bench_press.name': 'Press de Banca',
      'sport.lunges.name': 'Zancadas',
      'sport.jumping_rope.name': 'Saltar la Cuerda',
      'sport.kickboxing.name': 'Kickboxing',
      'sport.volleyball.name': 'Voleibol',
      'sport.ice_skating.name': 'Patinaje sobre Hielo',
      'sport.crossfit_wod.name': 'CrossFit WOD',
      'sport.foam_rolling.name': 'Rodillo de Espuma',
      'sport.mobility_flow.name': 'Flujo de Movilidad',
      'common.skip': 'Omitir',
      'common.next': 'Siguiente',
      'onboarding.injuryTitle': '¿Tienes lesiones?',
      'onboarding.injurySubtitle': 'Adaptaremos los entrenamientos para no forzar estas zonas. Opcional.',
      'onboarding.injuryNoneSelected': 'Sin lesiones — entrenamientos a máxima intensidad',
      'onboarding.injuryCount_one': '{{count}} zona protegida',
      'onboarding.injuryCount_other': '{{count}} zonas protegidas',
      'onboarding.injuries.neck': 'Cuello',
      'onboarding.injuries.shoulders': 'Hombros',
      'onboarding.injuries.lowerBack': 'Zona lumbar',
      'onboarding.injuries.elbows': 'Codos',
      'onboarding.injuries.wrists': 'Muñecas',
      'onboarding.injuries.hips': 'Caderas',
      'onboarding.injuries.knees': 'Rodillas',
      'onboarding.injuries.ankles': 'Tobillos',
      'common.back': 'Atrás',
      'common.gotIt': 'Entendido',
      'leaderboard.title': 'Clasificación',
      'leaderboard.global': 'Global',
      'leaderboard.friends': 'Amigos',
      'leaderboard.weekly': 'Semanal',
      'leaderboard.you': 'Tú',
      'leaderboard.energy': 'Energía',
      'leaderboard.howItWorks': 'Cómo funciona',
      'leaderboard.noFriends': 'Aún no hay amigos',
      'leaderboard.noFriendsDesc': 'Invita amigos a competir',
      'leaderboard.rule1Title': 'Gana energía',
      'leaderboard.rule1': 'Completa entrenamientos. Más dificultad + rachas largas = más energía.',
      'leaderboard.rule2Title': 'Tres tablas',
      'leaderboard.rule2': 'Global clasifica a todos, Amigos solo a quienes sigues, Semanal se reinicia cada lunes.',
      'leaderboard.rule3Title': 'Regla de caída',
      'leaderboard.rule3': 'La energía cae 5% por día inactivo — la constancia gana al impulso.',
      'leaderboard.rule4Title': 'Recompensas',
      'leaderboard.rule4': 'Los 3 mejores de cada tabla ganan marco de perfil oro/plata/bronce.',
      'referral.title': 'Invita y gana',
      'referral.description': 'Invita a un amigo — gana 1 mes gratis, tú también. Sin límite.',
      'referral.yourId': 'Tu ID',
      'referral.reward': 'Recompensa',
      'referral.daysFree': 'días gratis',
      'referral.copy': 'Copiar',
      'referral.copied': 'Copiado',
      'referral.share': 'Compartir',
      'referral.shareTitle': 'Prueba Omnisio Workout',
      'referral.shareText': 'Únete a Omnisio Workout — ambos recibimos 1 mes Pro gratis.',
      'referral.activeStatus': 'Pro activo hasta',
      'oracle.recentMeals': 'Comidas Recientes',
      'oracle.entryCount_one': '{{count}} entrada',
      'oracle.entryCount_other': '{{count}} entradas',
      'oracle.noScans': 'Sin escaneos aún',
      'oracle.noScansDesc': 'Toca Escanear para registrar tu primera comida',
      'oracle.scanNow': 'Escanear ahora',
      'oracle.todaysTotal': 'Total de Hoy',
      'oracle.kcal': 'kcal',
      'oracle.macro.protein': 'Proteína',
      'oracle.macro.carbs': 'Carbohidratos',
      'oracle.macro.fat': 'Grasa',
      'oracle.macro.calories': 'Calorías',
      'oracle.meal.breakfast': 'Desayuno',
      'oracle.meal.lunch': 'Almuerzo',
      'oracle.meal.dinner': 'Cena',
      'oracle.meal.snack': 'Bocadillo',
      'sport.pushups.name': 'Flexiones',
      'sport.squats.name': 'Sentadillas',
      'sport.plank.name': 'Plancha',
      'sport.running.name': 'Correr',
      'sport.yoga.name': 'Yoga',
      'sport.boxing.name': 'Boxeo',
      'sport.cycling.name': 'Ciclismo',
      'sport.swimming.name': 'Natación',
      'sport.basketball.name': 'Baloncesto',
      'sport.skiing.name': 'Esquí',
      'sport.pullups.name': 'Dominadas',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'Tenis',
      'sport.deadlift.name': 'Peso muerto',
      'sport.pilates.name': 'Pilates',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'Remo',
      'sport.dance.name': 'Baile fitness',
      'sport.stretching.name': 'Estiramiento',
      'sport.kettlebell.name': 'Pesa rusa',
      'sport.football.name': 'Fútbol',
      'workout.cat.all': 'TODOS',
      'workout.cat.strength': 'FUERZA',
      'workout.cat.cardio': 'CARDIO',
      'workout.cat.flexibility': 'FLEXIBILIDAD',
      'workout.cat.combat': 'COMBATE',
      'workout.cat.team': 'EQUIPO',
      'workout.cat.winter': 'INVIERNO',
      'workout.cat.functional': 'FUNCIONAL',
      'workout.noEquipment': 'Sin equipo',
      'workout.instructions': 'Instrucciones',
      'workout.commonMistakes': 'Errores comunes',
      'workout.easier': 'Más fácil',
      'workout.harder': 'Más difícil',
      'workout.repsCount_one': '{{count}} repetición',
      'workout.repsCount_other': '{{count}} repeticiones',
      'workout.countSports_one': '{{count}} deporte',
      'workout.countSports_other': '{{count}} deportes',
      'workout.noSports': 'No se encontraron deportes',
      'settings.general': 'General',
      'settings.proActive': 'Pro Activo',
      'settings.freeTrial': 'Prueba Gratis',
      'settings.allUnlocked': 'Todas las funciones desbloqueadas',
      'settings.upgradeFull': 'Mejora para acceso completo',
      'settings.upgrade': 'Mejorar',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Sincronización de datos',
      'settings.dataSyncDesc': 'Sincroniza tus datos con el ecosistema Omnisio',
      'settings.logout': 'Cerrar sesión',
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Fitness Grupal Privado',
      'nav.home': 'Inicio',
      'nav.workout': 'Entreno',
      'nav.nutri': 'Nutrición',
      'nav.history': 'Historial',
      'nav.memory': 'Memorias',
      'nav.radio': 'Radio',
      'nav.shop': 'Tienda',
      'nav.profile': 'Perfil',
      'nav.more': 'Más',
      'nav.coach': 'Coach',
      'home.welcome': 'Bienvenido, {{name}}',
      'home.dailyEnergy': 'Energía Diaria',
      'home.startWorkout': 'Iniciar Entreno',
      'home.yourTotem': 'Tu Mascota',
      'home.todaysMissions': 'Metas de Hoy',
      'home.leaderboard': 'Clasificación',
      'home.syndicates': 'Equipos',
      'home.biohacks': 'Desafíos',
      'energy.exercise': 'Ejercicio',
      'energy.music': 'Música',
      'energy.total': 'Energía Total',
      'energy.streak': '{{count}} días seguidos',
      'energy.streakFire': 'Racha',
      'workout.title': 'Entreno',
      'workout.camera': 'Seguimiento con Cámara',
      'workout.startSession': 'Iniciar Sesión',
      'workout.endSession': 'Terminar Sesión',
      'workout.reps': 'Repeticiones',
      'workout.calories': 'Calorías',
      'workout.duration': 'Duración',
      'workout.exerciseComplete': '¡Ejercicio Completado!',
      'workout.energyEarned': '+{{amount}} Energía',
      'workout.plank': 'Plancha',
      'workout.pushups': 'Flexiones',
      'workout.squats': 'Sentadillas',
      'workout.overview': 'Resumen',
      'workout.history': 'Historial',
      'workout.progress': 'Progreso',
      'workout.personalRecords': 'Récords Personales',
      'workout.share': 'Compartir',
      'workout.done': 'Hecho',
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Escanear Alimento',
      'oracle.history': 'Historial de Escaneos',
      'oracle.scanning': 'Analizando...',
      'oracle.dailyNorm': 'Norma Diaria',
      'oracle.scansLeft': '{{count}} escaneos restantes',
      'oracle.upgrade': 'Mejora para ilimitado',
      'oracle.protein': 'Proteína',
      'oracle.carbs': 'Carbohidratos',
      'oracle.fat': 'Grasa',
      'oracle.calories': 'Calorías',
      'memory.title': 'Memorias',
      'memory.upload': 'Subir Memoria',
      'memory.stake': 'Apostar Energía',
      'memory.network': 'Red Global Proof-of-Energy',
      'calendar.title': 'Historial',
      'calendar.fitness': 'Fitness',
      'calendar.nutrition': 'Nutrición',
      'calendar.protocols': 'Protocolos',
      'shop.title': 'Tienda',
      'shop.avatars': 'Avatares',
      'shop.boosters': 'Potenciadores',
      'shop.cosmetics': 'Cosméticos',
      'shop.buy': 'Comprar',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Adquirido',
      'shop.equipped': 'Equipado',
      'profile.title': 'Perfil',
      'profile.level': 'Nivel {{level}}',
      'profile.totalWorkouts': 'Total Entrenos',
      'profile.totalTokens': 'Total Tokens',
      'profile.achievements': 'Logros',
      'profile.settings': 'Ajustes',
      'profile.totem': 'Mascota',
      'leaderboard.title': 'Clasificación',
      'leaderboard.global': 'Global',
      'leaderboard.syndicate': 'Equipo',
      'leaderboard.weekly': 'Semanal',
      'leaderboard.allTime': 'Histórico',
      'leaderboard.rank': 'Puesto',
      'syndicates.title': 'Equipos',
      'syndicates.join': 'Unirse',
      'syndicates.create': 'Crear Equipo',
      'syndicates.members': '{{count}} miembros',
      'syndicates.power': 'Poder',
      'biohacks.title': 'Desafíos',
      'biohacks.protocols': 'Programas',
      'biohacks.missions': 'Metas',
      'biohacks.active': 'Activos',
      'biohacks.completed': 'Completados',
      'biohacks.reward': 'Recompensa: {{amount}} TKN',
      'avatar.title': 'Avatar',
      'avatar.customize': 'Personalizar',
      'avatar.skin': 'Aspecto',
      'avatar.outfit': 'Atuendo',
      'avatar.accessories': 'Accesorios',
      'avatar.save': 'Guardar',
      'radio.title': 'Gym Radio',
      'radio.nowPlaying': 'Reproduciendo',
      'radio.stations': 'Estaciones',
      'radio.energyBonus': '+Energía al escuchar',
      'coach.title': 'Coach',
      'coach.subtitle': 'Tu compañero de fitness AI en tu oído',
      'coach.tabVoice': 'Voz',
      'coach.tabSoundscape': 'Ambiente',
      'coach.tabMusic': 'Música',
      'coach.chooseVoice': 'Elige la voz de tu coach',
      'coach.samples': 'Escucha muestras',
      'coach.samplePreWorkout': 'Pre-entrenamiento',
      'coach.sampleSetComplete': 'Serie completa',
      'coach.sampleHalfway': 'A mitad de camino',
      'coach.sampleFinalSet': 'Última serie',
      'coach.sampleWorkoutDone': 'Entrenamiento terminado',
      'coach.voiceCoachToggle': 'Coach de voz durante el entrenamiento',
      'coach.proRequired': 'Pro requerido para todas las voces',
      'coach.upgrade': 'Mejorar',
      'coach.soundscapeFocus': 'Concentración',
      'coach.soundscapeFocusDesc': 'Ondas alfa para concentración profunda',
      'coach.soundscapeCardio': 'Cardio',
      'coach.soundscapeCardioDesc': 'BPM alto para correr y HIIT',
      'coach.soundscapeRecovery': 'Recuperación',
      'coach.soundscapeRecoveryDesc': 'Ritmo lento para enfriamiento y estiramiento',
      'coach.soundscapeSleep': 'Preparación del sueño',
      'coach.soundscapeSleepDesc': 'Ruido rosa y sonidos de la naturaleza',
      'coach.soundscapeComingSoon': 'Próximamente',
      'coach.musicHeader': 'Abre tu app de música favorita',
      'coach.musicSpotify': 'Abrir en Spotify',
      'coach.musicApple': 'Abrir en Apple Music',
      'coach.musicYoutube': 'Abrir en YouTube Music',
      'coach.workoutPlaylist': 'Lista de entrenamiento',
      'settings.title': 'Ajustes',
      'settings.language': 'Idioma',
      'settings.notifications': 'Notificaciones',
      'settings.sound': 'Sonido',
      'settings.haptics': 'Vibración',
      'settings.about': 'Acerca de',
      'settings.version': 'Versión',
      'settings.aiEngine': 'Motor de IA',
      'settings.wearables': 'Bio-Wearables',
      'settings.bioWearables': 'Bio-Wearables',
      'settings.omnisioBand': 'Omnisio Band',
      'settings.omnisioBandDesc': 'SDK nativo · Biometría en tiempo real',
      'settings.omnisioRing': 'Omnisio Ring',
      'settings.omnisioRingDesc': 'SDK nativo · Batería 7 días, sueño + VFC',
      'settings.thirdPartySync': 'Terceros · Conectar para sincronizar',
      'settings.dataSync': 'Sincronización de Datos',
      'settings.upgrade': 'Mejorar',
      'settings.logout': 'Cerrar Sesión',
      'onboarding.welcome': 'Bienvenido a Omnisio Workout',
      'onboarding.subtitle': 'Tu camino fitness privado empieza aquí',
      'onboarding.selectExercise': 'Elige tu primer ejercicio',
      'onboarding.pushups': 'Flexiones',
      'onboarding.squats': 'Sentadillas',
      'onboarding.getStarted': 'Comenzar',
      'onboarding.skip': 'Saltar',
      'common.loading': 'Cargando...',
      'common.error': 'Algo salió mal',
      'common.retry': 'Reintentar',
      'common.back': 'Atrás',
      'common.save': 'Guardar',
      'common.cancel': 'Cancelar',
      'common.confirm': 'Confirmar',
      'common.close': 'Cerrar',
      'common.tokens': 'Tokens',
      'common.soon': 'Pronto',
      'common.viewAll': 'Ver todo',

      // Profile (extended)
      'profile.workouts': 'Entrenamientos',
      'profile.hours': 'Horas',
      'profile.totalXP': 'XP Total',
      'profile.personalRecords': 'Récords Personales',
      'profile.connectedServices': 'Servicios Conectados',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Conectado',
      'profile.connect': 'Conectar',
      'profile.helpSupport': 'Ayuda y Soporte',
      'profile.signOut': 'Cerrar Sesión',
      'profile.contactShipping': 'Contacto y Envío',
      'profile.complete': 'Completo',
      'profile.incompleteForOrders': 'Necesario para pedidos de suplementos',
      'profile.email': 'Correo electrónico',
      'profile.phone': 'Teléfono',
      'profile.address': 'Dirección',
      'profile.country': 'País',
      'profile.addressPlaceholder': 'Calle, Ciudad, Código Postal',
      'profile.privacyNote': 'Tu información de contacto se almacena localmente y solo se comparte con Celliva cuando realizas un pedido. Cumple con KVKK/GDPR.',
      'profile.invalidEmail': 'Formato de email inválido',
      'profile.invalidPhone': 'Teléfono demasiado corto',
      'profile.invalidAddress': 'Dirección demasiado corta',

      // Achievements
      'achievements.firstWorkout': 'Primer Entrenamiento',
      'achievements.sevenDayStreak': 'Racha de 7 Días',
      'achievements.plankMaster': 'Maestro de la Plancha',
      'achievements.earlyBird': 'Madrugador',
      'achievements.perfectionist': 'Perfeccionista',
      'achievements.hundredWorkouts': '100 Entrenamientos',
      'achievements.marathon': 'Maratón',
      'achievements.nightOwl': 'Búho Nocturno',

      // Shop (extended)
      'shop.subtitle': 'Desbloquea compañeros, potenciadores y equipo',
      'shop.tabCompanions': 'Compañeros',
      'shop.tabBoosters': 'Potenciadores',
      'shop.tabOutfits': 'Atuendos',
      'shop.tabThemes': 'Temas',
      'shop.free': 'Gratis',
      'shop.levelRequired': 'Nivel {{level}} requerido',
      'shop.unlockFor': 'Desbloquear por {{price}} ⚡',
      'shop.insufficientXP': 'XP insuficiente (faltan {{price}} ⚡)',
      'shop.viewPack': 'Ver Paquete',
      'shop.recentActivity': 'Actividad reciente',
      'shop.earnMoreXP': 'Gana más XP',
      'shop.completeWorkout': 'Completa un entrenamiento',
      'shop.startWorkout': 'Iniciar Entreno',
      'shop.tabSupplements': 'Suplementos',
      'shop.poweredByCelliva': 'Powered by Celliva',
      'shop.cellivaTagline': 'Suplementos premium · Envío gratis desde $50',
      'shop.buyOnCelliva': 'Comprar en Celliva',
      'shop.supplementsHeader': 'Combustible para tu entrenamiento',
      'shop.supplementsSubtitle': 'Probado en laboratorio, verificado',

      // Catálogo de la tienda de juego (compañeros / potenciadores / atuendos / temas)
      'shop.item.phoenix.name': 'Fénix',
      'shop.item.phoenix.desc': 'Renace de sus cenizas',
      'shop.item.phoenix.long': 'El inmortal Fénix te ha elegido como su compañero. Nacido del fuego y renacido más fuerte cada vez, alimenta tu impulso para superar todos los límites.',
      'shop.item.phoenix.stat.0.label': 'XP extra',
      'shop.item.phoenix.stat.0.value': '+10% en todos los entrenamientos',
      'shop.item.bonsai.name': 'Árbol bonsái',
      'shop.item.bonsai.desc': 'Crece con paciencia',
      'shop.item.bonsai.long': 'Una escultura viva que refleja tu disciplina. El bonsái evoluciona a medida que creas hábitos, recompensando la constancia con mejoras visuales raras.',
      'shop.item.bonsai.stat.0.label': 'Bonus de racha',
      'shop.item.bonsai.stat.0.value': '+15% tras racha de 7 días',
      'shop.item.orb.name': 'Orbe de energía',
      'shop.item.orb.desc': 'Canaliza energía pura',
      'shop.item.orb.long': 'Una esfera de bioenergía condensada que amplifica cada repetición que haces. Late más brillante cuanto más duro entrenas.',
      'shop.item.orb.stat.0.label': 'Regeneración de energía',
      'shop.item.orb.stat.0.value': '+5 de energía por entrenamiento',
      'shop.item.avatar.name': 'Guerrero',
      'shop.item.avatar.desc': 'Forja tu fuerza',
      'shop.item.avatar.long': 'Un avatar curtido en batalla que encarna el máximo potencial físico. Desbloquea animaciones especiales de desafío de guerrero.',
      'shop.item.avatar.stat.0.label': 'XP de fuerza',
      'shop.item.avatar.stat.0.value': '+12% en sesiones de fuerza',
      'shop.item.avatar_female.name': 'Diosa',
      'shop.item.avatar_female.desc': 'Libera tu poder',
      'shop.item.avatar_female.long': 'Ella canaliza todo el espectro del potencial humano: gracia, resistencia y poder puro. Una presencia mítica que eleva cada sesión.',
      'shop.item.avatar_female.stat.0.label': 'Todo el XP',
      'shop.item.avatar_female.stat.0.value': '+20% de cada fuente',
      'shop.item.wolf.name': '???',
      'shop.item.wolf.desc': 'Próximamente',
      'shop.item.wolf.long': 'Una criatura de sombra e instinto. Alcanza el nivel 7 para revelar a este compañero.',
      'shop.item.xp_2x_24h.name': '2× XP por 24 h',
      'shop.item.xp_2x_24h.desc': 'XP doble de todas las fuentes durante 24 horas',
      'shop.item.xp_2x_24h.long': 'Cada entrenamiento, registro de hábito y bonus de racha se duplica durante un día entero. Combínalo con una sesión de entrenamiento para máximas ganancias.',
      'shop.item.xp_2x_24h.stat.0.label': 'Efecto',
      'shop.item.xp_2x_24h.stat.0.value': 'Multiplicador de XP 2×',
      'shop.item.xp_2x_24h.stat.1.label': 'Duración',
      'shop.item.xp_2x_24h.stat.1.value': '24 horas',
      'shop.item.streak_freeze.name': 'Congelar racha',
      'shop.item.streak_freeze.desc': 'Protege tu racha por un día perdido',
      'shop.item.streak_freeze.long': 'La vida pasa. Congelar racha preserva tu racha tan duramente ganada durante un día perdido, sin preguntas.',
      'shop.item.streak_freeze.stat.0.label': 'Efecto',
      'shop.item.streak_freeze.stat.0.value': 'Salta 1 día, racha intacta',
      'shop.item.streak_freeze.stat.1.label': 'Usos',
      'shop.item.streak_freeze.stat.1.value': 'Un solo uso',
      'shop.item.energy_boost.name': '+50 de energía al instante',
      'shop.item.energy_boost.desc': 'Añade 50 de energía a hoy al instante',
      'shop.item.energy_boost.long': 'Una inyección directa de 50 puntos de energía acreditados de inmediato al total de hoy.',
      'shop.item.energy_boost.stat.0.label': 'Efecto',
      'shop.item.energy_boost.stat.0.value': '+50 de energía ahora',
      'shop.item.energy_boost.stat.1.label': 'Usos',
      'shop.item.energy_boost.stat.1.value': 'Un solo uso',
      'shop.item.workout_quick.name': 'Impulso de energía de 5 min',
      'shop.item.workout_quick.desc': 'Salta el calentamiento, empieza fresco',
      'shop.item.workout_quick.long': 'Preactiva tus músculos digitalmente para que puedas saltar directamente a tu entrenamiento con la máxima eficiencia.',
      'shop.item.workout_quick.stat.0.label': 'Efecto',
      'shop.item.workout_quick.stat.0.value': 'Salta la fase de calentamiento',
      'shop.item.workout_quick.stat.1.label': 'Usos',
      'shop.item.workout_quick.stat.1.value': 'Un solo uso',
      'shop.item.cyber.name': 'Piel cíber',
      'shop.item.cyber.desc': 'Atuendo de compañero con neón',
      'shop.item.cyber.long': 'Un traje futurista de rejilla de neón que envuelve a tu compañero en la estética del atleta del mañana.',
      'shop.item.cyber.stat.0.label': 'Visual',
      'shop.item.cyber.stat.0.value': 'Brillo neón + estela de partículas',
      'shop.item.royal.name': 'Túnica real',
      'shop.item.royal.desc': 'Detalles dorados premium',
      'shop.item.royal.long': 'Vestida de carmesí profundo con bordado de hilo de oro, reservada para campeones que se han ganado el derecho a reinar.',
      'shop.item.royal.stat.0.label': 'Visual',
      'shop.item.royal.stat.0.value': 'Aura de brillo dorado',
      'shop.item.royal.stat.1.label': 'Aura de XP',
      'shop.item.royal.stat.1.value': '+5% en días de racha',
      'shop.item.minimal.name': 'Minimal',
      'shop.item.minimal.desc': 'Look monocromático limpio',
      'shop.item.minimal.long': 'Menos es más. Un atuendo monocromático depurado que deja que tus resultados hablen.',
      'shop.item.minimal.stat.0.label': 'Visual',
      'shop.item.minimal.stat.0.value': 'Paleta monocromática',
      'shop.item.cosmic.name': 'Cósmico',
      'shop.item.cosmic.desc': 'Efectos de estrellas y nebulosa',
      'shop.item.cosmic.long': 'Tu compañero se convierte en una galaxia en movimiento: nebulosas en remolino y partículas de campo estelar siguen cada movimiento.',
      'shop.item.cosmic.stat.0.label': 'Visual',
      'shop.item.cosmic.stat.0.value': 'Sistema de partículas de galaxia',
      'shop.item.midnight.name': 'Medianoche',
      'shop.item.midnight.desc': 'Tema oscuro predeterminado',
      'shop.item.midnight.long': 'El clásico tema oscuro de Omnisio. Negros profundos y reflejos turquesa: clínico, preciso, potente.',
      'shop.item.midnight.stat.0.label': 'Paleta',
      'shop.item.midnight.stat.0.value': 'Negro + turquesa',
      'shop.item.aurora.name': 'Aurora',
      'shop.item.aurora.desc': 'Degradado de auroras boreales',
      'shop.item.aurora.long': 'Amplios degradados de verde a violeta inspirados en la aurora boreal. Un cielo vivo sobre ti.',
      'shop.item.aurora.stat.0.label': 'Paleta',
      'shop.item.aurora.stat.0.value': 'Esmeralda + violeta',
      'shop.item.sunset.name': 'Atardecer',
      'shop.item.sunset.desc': 'Oro cálido + magenta',
      'shop.item.sunset.long': 'La última luz del día: ámbar, oro y magenta profundo, superpuestos como un horizonte en llamas.',
      'shop.item.sunset.stat.0.label': 'Paleta',
      'shop.item.sunset.stat.0.value': 'Oro + magenta',
      'shop.item.ocean.name': 'Profundidades oceánicas',
      'shop.item.ocean.desc': 'Estética de verde azulado profundo',
      'shop.item.ocean.long': 'Sumérgete en el abismo. Fondos de verde azulado profundo con acentos azules bioluminiscentes evocan el silencio aplastante del océano profundo.',
      'shop.item.ocean.stat.0.label': 'Paleta',
      'shop.item.ocean.stat.0.value': 'Verde azulado profundo + azul',
      'shop.featuredPack.name': 'Pack de primavera',
      'shop.featuredPack.tagline': 'Paquete de 3 artículos: ahorra 40%',
      'shop.featuredPack.countdown': 'Termina en 3d 14h',
      'shop.featuredPack.item.0': 'Árbol bonsái',
      'shop.featuredPack.item.1': 'Tema Aurora',
      'shop.featuredPack.item.2': '2× XP por 24 h',

      // Celliva Dispensary
      'shop.celliva.title': 'Dispensario Celliva',
      'shop.celliva.eyebrow': 'Suministro Autónomo',
      'shop.celliva.tabMarketplace': 'Marketplace',
      'shop.celliva.tabGameStore': 'Tienda de Juegos',
      'shop.celliva.predictiveTitle': 'Motor Predictivo',
      'shop.celliva.predictiveBody': 'Tu suministro de {{product}} se agotará en {{days}} días.',
      'shop.celliva.authorizeDispatch': 'Autorizar Envío',
      'shop.celliva.calibrationTitle': 'Calibración de Protocolo',
      'shop.celliva.calibrationQuestion': '¿Mejoró {{product}} tu {{outcome}}?',
      'shop.celliva.calibrationYes': 'Sí — óptimo',
      'shop.celliva.calibrationNo': 'Sin cambio',
      'shop.celliva.calibrationDismiss': 'Descartar',
      'shop.celliva.calibrationThanks': 'Calibración registrada. Protocolo refinado.',
      'shop.celliva.closedLoopTitle': 'Bucle Cerrado Activo',
      'shop.celliva.closedLoopBody': 'Los biomarcadores alimentan el dispensario. Los pedidos se ajustan a tus datos.',
      'shop.celliva.targetedInterventions': 'Intervenciones Dirigidas',
      'shop.celliva.viewDetails': 'Detalles',
      'shop.celliva.hideDetails': 'Ocultar detalles',
      'shop.celliva.dosage': 'Dosificación',
      'shop.celliva.ingredients': 'Ingredientes',
      'shop.celliva.studies': 'Referencias clínicas',
      'shop.celliva.addToCart': 'Añadir al carrito',
      'shop.celliva.inCart': 'En el carrito ({{qty}})',
      'shop.celliva.checkout': 'Pagar en Celliva',
      'shop.celliva.cartEmpty': 'El carrito está vacío',
      'shop.celliva.cartTotal': 'Total',
      'shop.celliva.catLongevity': 'Longevidad',
      'shop.celliva.catCognitive': 'Cognitivo',
      'shop.celliva.catRecovery': 'Recuperación',
      'shop.celliva.catPerformance': 'Rendimiento',
      'shop.celliva.catAll': 'Todos',
      'shop.celliva.downloadCatalog': 'Descargar catálogo',
      'shop.celliva.bestseller': 'Más vendido',
      'shop.celliva.clinical': 'Clínico',
      'shop.celliva.verified': 'Verificado en laboratorio',
      'shop.celliva.proRequired': 'El nivel Pro desbloquea Reorden Inteligente y Calibración',
      'shop.celliva.eliteDnaBanner': 'Basado en tu estado APOE ε4, priorizado para soporte cognitivo',
      'shop.celliva.kvkkNote': 'Tus datos de envío solo salen del dispositivo cuando realizas un pedido en Celliva.life.',

      // Rarity
      'rarity.common': 'Común',
      'rarity.rare': 'Raro',
      'rarity.epic': 'Épico',
      'rarity.legendary': 'Legendario',

      // Memory (extended)
      'memory.community': 'Comunidad',
      'memory.demoMode': 'Modo demo · Conecta Supabase para datos reales',
      'memory.boost': 'Boost',
      'memory.boostXPNote': '+10 XP por publicar energía',
      'memory.noPostsTitle': 'Aún no hay publicaciones',
      'memory.noPostsDesc': 'Sé el primero en compartir tu entrenamiento',
      'memory.allCaughtUp': 'Todo al día',

      // Calendar (extended)
      'calendar.history': 'Historial',
      'calendar.workouts': 'Entrenamientos',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'Racha',
      'calendar.energy': 'Energía',
      'calendar.tabFitness': 'Fitness',
      'calendar.tabNutrition': 'Nutrición',
      'calendar.tabProtocols': 'Protocolos',
      'calendar.restDay': 'Día de descanso',
      'calendar.restDayDesc': 'No hay actividad registrada. Todo campeón necesita recuperarse.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'DÉFICIT CALÓRICO',
      'oracle.alertLowProtein': 'ALERTA PROTEÍNA BAJA',
      'oracle.alertPerfectDay': 'DÍA PERFECTO',
      'oracle.dailyCalories': 'Calorías diarias',
      'oracle.tabScan': 'Escanear',
      'oracle.tabHistory': 'Historial',
      'oracle.tapToScan': 'Apunta la cámara a tu comida y pulsa el botón',
      'oracle.freeScans': '{{used}}/{{max}} escaneos gratis',
      'oracle.upgradePro': 'Mejorar a Pro',
      'oracle.scanFood': 'Escanear Comida',
      'oracle.scanAgain': 'Escanear de Nuevo',
      'oracle.addToLog': 'Añadir al Registro',

      // Paywall
      'paywall.chooseLevel': 'Elige tu nivel',
      'paywall.restorePurchase': 'Restaurar Compra',
      'paywall.maybeLater': 'Quizás Después',

      // Workout (extended)
      'workout.searchPlaceholder': 'Buscar deportes...',
      'workout.musclesWorked': 'Músculos Trabajados',
      'workout.primary': 'Primarios',
      'workout.secondary': 'Secundarios',
      'workout.exercises': 'Ejercicios',
      'workout.warmUp': 'Calentamiento',
      'workout.coolDown': 'Enfriamiento',
      'workout.startCTA': 'Iniciar {{sport}} {{level}}',
      'workout.rest': 'Descanso',
      'workout.skipRest': 'Saltar descanso',
      'workout.upNext': 'A continuación',
      'workout.setOf': 'Serie {{current}} de {{total}}',
      'workout.formTips': 'Consejos de Técnica',
      'workout.resume': 'Reanudar',
      'workout.pause': 'Pausar',
      'workout.skip': 'Saltar',
      'workout.complete': 'Entrenamiento completado',
      'workout.sets': 'Series',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Siguiente: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Revisa la forma: {{tip}}',

      // Onboarding — género y edad
      'onboarding.aboutTitle': 'Sobre ti',
      'onboarding.aboutSubtitle': 'Cuéntanos sobre ti',
      'onboarding.gender.male': 'Hombre',
      'onboarding.gender.female': 'Mujer',
      'onboarding.gender.other': 'Otro',
      'onboarding.howOld': '¿Cuántos años tienes?',
      'onboarding.yearsOld': 'años',

      // Onboarding — cuerpo
      'onboarding.bodyTitle': 'Tu cuerpo',
      'onboarding.bodySubtitle': 'Para calcular tu plan',
      'onboarding.weight': 'Peso',
      'onboarding.height': 'Altura',
      'onboarding.targetWeight': 'Peso objetivo (opcional)',

      // Onboarding — nivel de actividad
      'onboarding.activityTitle': 'Nivel de actividad',
      'onboarding.activitySubtitle': 'Afecta tu necesidad calórica diaria',
      'onboarding.activity.sedentary': 'Sedentario',
      'onboarding.activity.sedentarySub': 'Poco o nada de ejercicio',
      'onboarding.activity.light': 'Ligero',
      'onboarding.activity.lightSub': '1–3 días por semana',
      'onboarding.activity.moderate': 'Moderado',
      'onboarding.activity.moderateSub': '3–5 días por semana',
      'onboarding.activity.high': 'Alto',
      'onboarding.activity.highSub': '6–7 días por semana',
      'onboarding.activity.extreme': 'Extremo',
      'onboarding.activity.extremeSub': 'Atleta / dos veces al día',
      'onboarding.calculatePlan': 'Calcular mi plan',

      // Onboarding — cálculo
      'onboarding.calculatingTitle': 'Calculando tu plan…',
      'onboarding.calcMsg1': 'Analizando tu metabolismo…',
      'onboarding.calcMsg2': 'Calculando TDEE…',
      'onboarding.calcMsg3': 'Optimizando distribución de macros…',
      'onboarding.calcMsg4': 'Creando tu plan personalizado…',
      'onboarding.calcMsg5': 'Casi listo…',
      'onboarding.planReadyTitle': '¡Plan listo!',
      'onboarding.planReadySubtitle': 'Tus objetivos diarios personalizados',
      'onboarding.dailyCalories': 'Calorías diarias',
      'onboarding.kcalPerDay': 'kcal / día',
      'onboarding.macroSplit': 'Distribución de macros',
      'onboarding.macroProtein': 'Proteína',
      'onboarding.macroCarbs': 'Carbohidratos',
      'onboarding.macroFat': 'Grasa',
      'onboarding.timeframe': 'Plazo',
      'onboarding.timeframe1m': '1 mes',
      'onboarding.timeframe3m': '3 meses',
      'onboarding.timeframe6m': '6 meses',
      'onboarding.timeframe12m': '1 año',
      'onboarding.chooseCompanion': 'Elegir mi compañero',

      // Onboarding — compañero
      'onboarding.companionTitle': 'Elige tu compañero',
      'onboarding.companionSubtitle': 'Tu compañero evoluciona con tu entrenamiento',

      // Calendario
      'calendar.noMealsTitle': 'Sin comidas registradas',
      'calendar.noMealsDesc': 'Abre la pestaña de nutrición para registrar tu alimentación de hoy.',
      'calendar.noProtocolsTitle': 'Sin protocolos registrados',
      'calendar.noProtocolsDesc': 'No hay biohacks registrados para este día. Mantén tus rutinas.',

      // Memoria
      'memory.loadError': 'No se pudieron cargar las publicaciones',

      // Sindicatos
      'syndicates.messagePlaceholder': 'Mensaje al clan…',
      'syndicates.noClanTitle': 'Sin clan todavía',
      'syndicates.noClanDesc': 'Únete a un sindicato para competir con otros',
      'syndicates.browseCta': 'Explorar clanes',

      // Franja biométrica
      'biometric.recovery': 'Recuperación',
      'biometric.bodyBattery': 'Batería corporal',
      'biometric.hrv': 'VFC',
      'biometric.hrvDelta': '{{delta}} desde la línea base',
      'biometric.todayBadge': 'Hoy',
      'biometric.rest': 'Día de descanso',
      'biometric.moderate': 'Moderado',
      'biometric.intense': 'Intenso',
      'biometric.consentRequired': 'Conectar con Longevity',
      'biometric.consentRequiredDesc': 'Activa el acceso a Workout en la configuración de Longevity',
      'biometric.baselineNotSet': 'Completa la línea base en Longevity',
      'biometric.offline': 'Sin conexión',
      'biometric.demoData': 'Datos demo',
      'biometric.staleBadge': 'hace {{minutes}} min',
      'biometric.connectCta': 'Conectar',
      'biometric.connectingFromYou': 'Mostrar en Workout',

      // Notificaciones
      'notif.morning.title': '¡Buenos días!',
      'notif.morning.body': '{{companion}} está listo para entrenar contigo.',
      'notif.evening.title': '¿Entrenamiento hoy?',
      'notif.evening.body': 'Incluso 10 minutos mantienen viva tu racha.',
      'notif.streak.title': '¡Tu racha de {{streak}} días está en riesgo!',
      'notif.streak.body': 'Un flujo rápido de movilidad salvará tu racha.',
      'notif.companion.title': '{{companion}} está aquí',
      'notif.companion.body': '¿Tienes un momento para moverte hoy?',
      'notif.recovery.title': 'Modo recuperación activo',
      'notif.recovery.body': 'NMN + Magnesio recomendados tras la intensa sesión de ayer.',
      'notif.defaultCompanion': 'Tu compañero',
      'notif.preprompt.title': 'Mantén la constancia',
      'notif.preprompt.subtitle': 'Recordatorios diarios para la disciplina — desactívalos cuando quieras.',
      'notif.preprompt.benefit1': 'Motivación matutina para empezar el día',
      'notif.preprompt.benefit2': 'Protección de racha para no perder tu progreso',
      'notif.preprompt.benefit3': 'Recordatorios de recuperación tras sesiones duras',
      'notif.preprompt.benefit4': 'Tu compañero te contacta 1–2 veces por semana',
      'notif.preprompt.allow': 'Activar notificaciones',
      'notif.preprompt.skip': 'Ahora no',
      'home.longevityId': 'ID de longevidad',
      'home.sleep': 'Sueño',
      'home.water': 'Agua',
      'home.steps': 'Pasos',
      'profile.activity': 'Actividad',
      'profile.emptyJourney': 'Tu viaje comienza con un entrenamiento.',
      'profile.startNow': 'Empieza ahora →',
      'profile.thisWeek': 'esta semana',
      'profile.editProfileAria': 'Editar perfil',
      'profile.phoneCountryAria': 'Código de país del teléfono',
      'memory.energyPoints': 'Puntos de energía',
      'memory.uploadAria': 'Subir recuerdo',
      'calendar.synergy': 'SINERGIA',
      'calendar.today': 'Hoy',
      'biohacks.synergyBonus': 'Bono de sinergia',
      'biohacks.synergyDesc': 'Completa todos los protocolos de una categoría para un bono x1.5 de energía',
      'shop.featured': 'Destacado',
      'syndicates.clanPower': 'Poder del clan',
      'biometric.alternatives': 'Alternativas',
      'biometric.loadingAria': 'Cargando datos biométricos',
      'biometric.overviewAria': 'Resumen biométrico de Longevity',
      'dragon.energy': 'Energía',
      'nav.openSettingsAria': 'Abrir ajustes',
      'nav.dismissAria': 'Descartar',
      'nav.moreOptionsAria': 'Más opciones',
      'nav.closeMenuAria': 'Cerrar menú',
      'nav.primaryAria': 'Navegación principal',
      'nav.moreNavAria': 'Más opciones de navegación',
      'common.copiedToClipboard': '¡Copiado al portapapeles!',
      'paywall.noPreviousPurchase': 'No se encontró ninguna compra previa. Suscríbete para desbloquear las funciones Pro.',
      'common.back': 'Atrás',
      'dragon.stage': 'Etapa',
      'dragon.levelShort': 'Nv.',
      'dragon.evolved': '¡EVOLUCIONADO!',
      'dragon.evolving': 'Evolucionando...',
      'dragon.feeding': 'Alimentando...',
      'dragon.notEnoughEnergy': 'Energía insuficiente',
      'dragon.feedToEvolve': 'Alimentar para evolucionar',
      'dragon.maxEvolution': 'Evolución máxima alcanzada',
      'dragon.elderFormUnlocked': 'Avatar Anciano · Forma Divina Desbloqueada',
      'dragon.stageName.initiate': 'Iniciado',
      'dragon.stageName.apprentice': 'Aprendiz',
      'dragon.stageName.adept': 'Adepto',
      'dragon.stageName.warrior': 'Guerrero',
      'dragon.stageName.master': 'Maestro',
      'dragon.stageName.grandmaster': 'Gran Maestro',
      'dragon.stageName.elder': 'Avatar Anciano',
      'syndicates.roleCommanderShort': 'CMD',
      'syndicates.roleOfficerShort': 'OFC',
      'syndicates.kick': 'Expulsar',
      'syndicates.overview': 'Resumen',
      'syndicates.roster': 'Plantel',
      'syndicates.comms': 'Comms',
      'syndicates.globalRankShort': 'Global',
      'syndicates.membersLabel': 'miembros',
      'syndicates.joinBattle': 'Unirse a la batalla',
      'syndicates.globalRank': 'Rango Global',
      'syndicates.weeklyEp': 'EP Semanal',
      'syndicates.inviteRecruits': 'Invitar Reclutas',
      'syndicates.activeMembers': '{{count}} miembros activos',
      'syndicates.epThisWeek': '{{ep}} EP esta semana',
      'syndicates.clanChat': 'Chat del Clan',
      'syndicates.online': '{{count}} en línea',
      'leaderboard.dayStreak': 'Racha de {{count}} días',
      'leaderboard.lvlShort': 'Nv.',
      'calendar.weeklyEnergy': 'Energía de 7 días',
      'calendar.legendWorkout': 'Entreno',
      'calendar.legendPerfect': 'Perfecto',
      'calendar.legendRest': 'Descanso',
      'calendar.activityLog': 'Registro de actividad',
      'calendar.showAll': 'Mostrar todo',
      'calendar.monthApr': 'Abr',
      'calendar.month.january': 'Enero',
      'calendar.month.february': 'Febrero',
      'calendar.month.march': 'Marzo',
      'calendar.month.april': 'Abril',
      'calendar.month.may': 'Mayo',
      'calendar.month.june': 'Junio',
      'calendar.month.july': 'Julio',
      'calendar.month.august': 'Agosto',
      'calendar.month.september': 'Septiembre',
      'calendar.month.october': 'Octubre',
      'calendar.month.november': 'Noviembre',
      'calendar.month.december': 'Diciembre',
      'calendar.day.sun': 'DOM',
      'calendar.day.mon': 'LUN',
      'calendar.day.tue': 'MAR',
      'calendar.day.wed': 'MIE',
      'calendar.day.thu': 'JUE',
      'calendar.day.fri': 'VIE',
      'calendar.day.sat': 'SAB',
      'biohacks.cat.sport': 'DEPORTE',
      'biohacks.cat.mind': 'MENTE',
      'biohacks.cat.ascetic': 'ASCÉTICO',
      'biohacks.progress': '{{done}}/{{total}} completado',
      'biohacks.synergyX': 'x1.5 Sinergia',
      'biohacks.diff.EASY': 'FÁCIL',
      'biohacks.diff.MEDIUM': 'MEDIO',
      'biohacks.diff.HARD': 'DIFÍCIL',
      'biohacks.diff.LEGEND': 'LEYENDA',
      'biohacks.proto.s1.name': 'Correr',
      'biohacks.proto.s1.desc': '30min carrera al aire libre',
      'biohacks.proto.s2.name': 'Artes Marciales',
      'biohacks.proto.s2.desc': 'Sesión de boxeo o artes marciales',
      'biohacks.proto.s3.name': 'Forja de Hierro',
      'biohacks.proto.s3.desc': 'Sesión de pesas',
      'biohacks.proto.s4.name': 'Flujo Acuático',
      'biohacks.proto.s4.desc': 'Natación 20min+',
      'biohacks.proto.s5.name': 'Protocolo de Flexibilidad',
      'biohacks.proto.s5.desc': 'Estiramiento y movilidad 15min',
      'biohacks.proto.m1.name': 'Meditación',
      'biohacks.proto.m1.desc': '10min de mindfulness',
      'biohacks.proto.m2.name': 'Respiración Wim Hof',
      'biohacks.proto.m2.desc': '3 rondas de respiración',
      'biohacks.proto.m3.name': 'Creación Neural',
      'biohacks.proto.m3.desc': 'Visualización creativa 10min',
      'biohacks.proto.m4.name': 'Lectura Profunda',
      'biohacks.proto.m4.desc': 'Leer 20 páginas de no ficción',
      'biohacks.proto.m5.name': 'Diario',
      'biohacks.proto.m5.desc': 'Escribir entrada de diario',
      'biohacks.proto.a1.name': 'Sin Alcohol / Sin Drogas',
      'biohacks.proto.a1.desc': 'Mantente limpio hoy',
      'biohacks.proto.a2.name': 'Combustible Limpio',
      'biohacks.proto.a2.desc': 'Solo comida real',
      'biohacks.proto.a3.name': 'Detox Digital',
      'biohacks.proto.a3.desc': 'Sin redes sociales 4h+',
      'biohacks.proto.a4.name': 'Exposición al Frío',
      'biohacks.proto.a4.desc': '2min ducha fría',
      'biohacks.proto.a5.name': 'Protocolo de Sueño',
      'biohacks.proto.a5.desc': 'En cama a las 22:00, 7h+ sueño',
      'biohacks.mission.1': '100 Flexiones en un día',
      'biohacks.mission.2': 'Plancha 5 Minutos',
      'biohacks.mission.3': '10 Mil Pasos',
      'biohacks.mission.4': 'Completar todos los protocolos',
      'biohacks.mission.5': 'Racha de 7 Días',
      'memory.timeAgoMin': 'hace {{n}}m',
      'memory.timeAgoHour': 'hace {{n}}h',
      'memory.timeAgoDay': 'hace {{n}}d',
      'memory.lvlShort': 'NVL',
      'memory.energyBoost': '{{amount}} Refuerzo de energía',
      'memory.boostWithEnergy': 'Impulsar con Energía',
      'memory.epMin': '10 EP',
      'memory.epMax': '2.000 EP',
      'memory.boostSent': '¡Impulso enviado!',
      'companion.stage': 'Etapa',
      'companion.evolved': 'Evolucionado',
      'companion.xpProgress': 'PROGRESO XP',
      'companion.nextStage': 'Sig. etapa',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'Evolución máxima alcanzada',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': '¡Todos unidos!',
      'biohacks.todayComplete': 'hoy',
      'coach.chooseCoach': 'ELIGE TU ENTRENADOR',
      'coach.headphonesHint': 'Usa auriculares para el efecto binaural completo',
      'coach.localGenerationHint': 'Generado localmente · Sin internet · Gratis para siempre',
      'coach.musicNote': 'Se abre en tu app de música o navegador',
      'coach.sampleTitle': 'ESCUCHA LA VOZ',
      'coach.settings': 'AJUSTES',
      'coach.soundscapeTitle': 'MODOS BINAURALES',
      'coach.voiceEnabled': 'Entrenador de voz',
      'coach.voiceEnabledDesc': 'Indicaciones de audio durante los entrenamientos',
      'coach.volume': 'Volumen',
      'login.appleError': 'Error al iniciar sesión con Apple',
      'login.continue': 'Continuar',
      'login.continueApple': 'Continuar con Apple',
      'login.continueGoogle': 'Continuar con Google',
      'login.email': 'Correo',
      'login.emailLabel': 'Dirección de correo',
      'login.emailPlaceholder': 'tu@ejemplo.com',
      'login.googleError': 'Error al iniciar sesión con Google',
      'login.hidePassword': 'Ocultar contraseña',
      'login.orContinueWith': 'o',
      'login.password': 'Contraseña',
      'login.passwordMin': 'La contraseña debe tener al menos 6 caracteres',
      'login.passwordPlaceholder': 'Tu contraseña',
      'login.phone': 'Teléfono',
      'login.privacyLink': 'Política de Privacidad',
      'login.showPassword': 'Mostrar contraseña',
      'login.signInError': 'Error al iniciar sesión',
      'login.signingIn': 'Iniciando sesión...',
      'login.terms': 'Al continuar aceptas nuestros',
      'login.termsLink': 'Términos',
      'memory.boostAmount': 'Cantidad de impulso',
      'memory.comment': 'Comentar',
      'memory.emptyDesc': 'Tu feed se llenará a medida que tú y tu equipo entrenéis.',
      'memory.emptyTitle': 'Aún no hay actividad',
      'memory.like': 'Me gusta',
      'memory.share': 'Compartir',
      'oracle.errAuth': 'Error de autenticación del servicio de IA.',
      'oracle.errGeneric': 'No se pudo analizar la imagen. Inténtalo con una foto más nítida.',
      'oracle.errLimit': 'Límite diario de escaneos alcanzado. Mejora para escaneos ilimitados.',
      'oracle.errMissingKey': 'Servicio de IA no configurado. Contacta con soporte.',
      'oracle.errRate': 'Servicio ocupado. Inténtalo de nuevo en un momento.',
      'oracle.unlimitedScans': 'Escaneos ilimitados',
      'paywall.everythingUnlocked': 'Todo desbloqueado',
      'paywall.freeLaunchNote': 'Todas las funciones Pro son gratis durante el lanzamiento.',
      'paywall.noCardNeeded': 'Sin tarjeta',
      'paywall.proFreeTitle': 'Pro — Gratis en el lanzamiento',
      'paywall.unlockFree': 'Desbloquea todo — gratis',
      'paywall.whatsIncluded': 'Qué incluye',
      'profile.noPrs': 'Aún no hay récords personales',
      'profile.noPrsDesc': 'Tus mejores marcas aparecerán a medida que entrenes.',
      'progress.emptyCta': 'Empezar un entrenamiento',
      'progress.emptyDesc': 'Completa tu primer entrenamiento para ver tus estadísticas.',
      'progress.emptyTitle': 'Tu progreso empieza aquí',
      'referral.copyLinkAria': 'Copiar enlace de referido',
      'referral.shareAria': 'Compartir enlace de referido',
      'settings.cookies': 'Política de Cookies',
      'settings.deleteAccount': 'Eliminar cuenta',
      'settings.deleteAccountWarning': 'Esto elimina permanentemente tu cuenta y todos tus datos (entrenamientos, progreso, perfil). No se puede deshacer.',
      'settings.deleteConfirm': 'Eliminar',
      'settings.deleteError': 'No se pudo eliminar la cuenta. Inténtalo de nuevo.',
      'settings.kvkk': 'KVKK / Protección de Datos',
      'settings.legalSupport': 'Legal y Soporte',
      'settings.privacy': 'Política de Privacidad',
      'settings.support': 'Ayuda y Soporte',
      'settings.terms': 'Términos del Servicio',
      'shop.celliva.allProducts': 'Catálogo completo',
      'shop.celliva.autonomousFulfillment': 'Cumplimiento autónomo',
      'shop.celliva.calibrationRecorded': 'Calibración registrada. Protocolo refinado.',
      'shop.celliva.cart': 'Carrito',
      'shop.celliva.closedLoopActive': 'Circuito cerrado activo',
      'shop.celliva.decrease': 'Reducir cantidad',
      'shop.celliva.depleteWarning': 'Tu suministro de {{product}} se agotará en {{days}} días.',
      'shop.celliva.details': 'Detalles',
      'shop.celliva.dismiss': 'Descartar',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'Se requiere Elite',
      'shop.celliva.increase': 'Aumentar cantidad',
      'shop.celliva.noChange': 'Sin cambios',
      'shop.celliva.outcomeDeepSleep': 'sueño profundo',
      'shop.celliva.predictiveEngine': 'Motor predictivo',
      'shop.celliva.protocolCalibration': 'Calibración del protocolo',
      'shop.celliva.yesOptimal': 'Sí — óptimo',
      'shop.tabGameStore': 'Tienda del juego',
      'shop.tabMarketplace': 'Mercado',
      'shop.unlocked': '¡{{name}} desbloqueado!',
      'syndicates.createCta': 'Crear',
      'syndicates.namePlaceholder': 'Nombre del sindicato…',
      'syndicates.newClanDesc': 'Un nuevo sindicato listo para crecer.',
      'syndicates.send': 'Enviar',
      'syndicates.tagPlaceholder': 'Etiqueta (3–4 caracteres)',
      'workout.end': 'Terminar',
      'workout.endWorkout': 'Terminar entrenamiento',
      'workout.noResults': 'No se encontraron entrenamientos',
      'workout.noResultsDesc': 'Prueba con otra búsqueda o categoría.',

    },
  },

  ar: {
    translation: {
      // ── مفاتيح واجهة جديدة (يوم الراحة، القياسات الحيوية، المشاركة، اختيار الدولة) ──
      'home.totalWorkouts': 'إجمالي التمارين',
      'restDay.title': 'يوم راحة',
      'restDay.empty': 'أكمل تمرينًا لتتبّع التعافي',
      'restDay.today': 'تدرّبت اليوم. استرح جيدًا.',
      'restDay.rested': 'لقد تعافيت — حافظ على الزخم.',
      'restDay.recommendRest': 'الحِمل الأسبوعي مرتفع — يُستحسن أن ترتاح اليوم.',
      'restDay.recommendTrain': 'مرتاح تمامًا — جاهز للتدريب.',
      'restDay.daysSince_other': 'منذ {{count}} يوم',
      'biometric.noData': 'لا توجد بيانات',
      'biometric.connectWearable': 'اربط جهازًا قابلاً للارتداء للحصول على بيانات مباشرة',
      'workout.shareUnavailable': 'المشاركة غير متاحة على هذا الجهاز.',
      'workout.shareFailed': 'تعذّرت المشاركة الآن. يرجى المحاولة مرة أخرى.',
      'country.TR': 'تركيا',
      'country.US': 'الولايات المتحدة',
      'country.RU': 'روسيا',
      'country.DE': 'ألمانيا',
      'country.GB': 'المملكة المتحدة',
      'country.FR': 'فرنسا',
      'country.ES': 'إسبانيا',
      'country.IT': 'إيطاليا',
      'country.NL': 'هولندا',
      'country.SA': 'المملكة العربية السعودية',
      'country.AE': 'الإمارات العربية المتحدة',
      'country.EG': 'مصر',
      'country.ID': 'إندونيسيا',
      'country.KR': 'كوريا الجنوبية',
      'country.JP': 'اليابان',
      'country.CN': 'الصين',
      'country.IN': 'الهند',
      'country.BR': 'البرازيل',
      'country.MX': 'المكسيك',
      'country.CA': 'كندا',
      'country.AU': 'أستراليا',
      'country.NZ': 'نيوزيلندا',
      'country.ZA': 'جنوب إفريقيا',
      'country.SE': 'السويد',
      'country.NO': 'النرويج',
      'country.DK': 'الدنمارك',
      'country.FI': 'فنلندا',
      'country.CH': 'سويسرا',
      'country.BE': 'بلجيكا',
      'country.AT': 'النمسا',
      'profile.dayStreak': 'أيام متتالية',
      'profile.companionAlt': 'رفيقك',
      'profile.ninetyDayActivity': 'نشاط 90 يومًا',
      'profile.restDay': 'يوم راحة',
      'profile.viewAllRecordsAria': 'عرض جميع السجلات',
      'profile.copyLinkAria': 'نسخ رابط الإحالة',
      'profile.shareAria': 'مشاركة رابط الإحالة',
      'referral.tagline': 'شهر Pro — لك ولصديقك',
      'referral.noLimit': 'بلا حدود — ادعُ من تشاء',
      'shop.celliva.bestSellers': 'الأكثر مبيعاً',
      'shop.celliva.featuredTitle': 'أساسيات البروتوكول',
      'shop.celliva.benefits': 'الفوائد',
      'shop.celliva.pairsWith': 'كيف يتناسب مع أهدافك',
      'shop.celliva.added': 'أُضيف إلى السلة!',
      'shop.celliva.cartTitle': 'سلتك',
      'shop.celliva.items': 'عناصر',
      'shop.celliva.clearCart': 'مسح الكل',
      'shop.celliva.emptyCartTitle': 'السلة فارغة',
      'shop.celliva.emptyCartDesc': 'أضف المكملات من الكتالوج لبناء بروتوكولك.',
      'shop.celliva.browseCatalog': 'تصفح الكتالوج',
      'shop.celliva.subtotal': 'المجموع الفرعي',
      'shop.celliva.fulfillmentNote': 'تُلبيه Celliva Life. يُحسب الشحن عند الدفع.',
      'shop.celliva.viewCart': 'عرض السلة',
      'shop.celliva.remove': 'إزالة',
      'shop.prev': 'السابق',
      'shop.next': 'التالي',
      'avatar.rarityCommon': 'عادي',
      'avatar.rarityRare': 'نادر',
      'avatar.rarityEpic': 'ملحمي',
      'avatar.rarityLegendary': 'أسطوري',
      'avatar.pro': 'PRO',
      'avatar.saved': 'تم الحفظ!',
      'avatar.skin.default': 'افتراضي',
      'avatar.skin.cyber': 'سايبر',
      'avatar.skin.neon': 'نيون',
      'avatar.skin.shadow': 'ظل',
      'avatar.skin.gold': 'ذهبي',
      'avatar.outfit.basic': 'معدات أساسية',
      'avatar.outfit.cyber': 'بدلة سايبر',
      'avatar.outfit.runner': 'عداء نيون',
      'avatar.outfit.iron': 'درع حديدي',
      'avatar.acc.none': 'لا شيء',
      'avatar.acc.visor': 'واقي',
      'avatar.acc.earbuds': 'سماعات',
      'avatar.acc.chain': 'سلسلة',
      'avatar.acc.halo': 'هالة',
      'coach.selectedLabel': 'محدد',
      'coach.selectLabel': 'اختر',
      'coach.languageSection': 'لغة المدرب',
      'coach.languageLabel': 'اختر اللغة',
      'coach.languageHint': 'تُشغَّل العبارات الصوتية باللغة المختارة',
      'workout.exerciseOf': 'تمرين {{current}} من {{total}}',
      'workout.paused': 'متوقف مؤقتاً',
      'workout.endSessionSub': 'سيتم حفظ التقدم حتى هذه النقطة.',
      'workout.keepGoing': 'واصل',
      'workout.endNow': 'أنهِ الآن',
      'workout.repsLabel': 'تكرار',
      'workout.next': 'التالي',
      'workout.strainElite': 'جهد نخبوي',
      'workout.strainHard': 'جلسة صعبة',
      'workout.strainModerate': 'عمل متين',
      'workout.selectLevel': 'اختر المستوى',
      'common.error_title': 'حدث خطأ ما',
      'common.error_description': 'يرجى المحاولة مرة أخرى.',
      'common.network_error': 'لا يوجد اتصال',
      'oracle.subtitle': 'ماسح الغذاء بالذكاء الاصطناعي',
      'oracle.emptyTitle': 'ماسح الغذاء',
      'oracle.emptyDesc': 'وجّه الكاميرا نحو طعامك. تحليل فوري.',
      'oracle.scanningSubtitle': 'التحليل باستخدام Gemini Vision',
      'oracle.confidence': 'الثقة',
      'oracle.detectedItems': 'العناصر المكتشفة',
      'oracle.macroBreakdown': 'توزيع المغذيات',
      'oracle.limitReached': 'تم الوصول إلى الحد',
      'oracle.proUnlimited': 'برو غير محدود',
      'oracle.proDesc': 'مسح غير محدود + خطط وجبات + تدريب ذكاء اصطناعي',
      'oracle.kcalRemaining': '{{n}} سعرة متبقية',
      'oracle.goalReached': 'تم الوصول للهدف!',
      'calendar.streakDays': '{{n}} أيام متتالية',
      'calendar.april2026': 'أبريل 2026',
      'calendar.prevMonth': 'الشهر السابق',
      'calendar.nextMonth': 'الشهر التالي',
      'login.tagline': 'رحلتك للطول تبدأ هنا',
      'login.otpHint': 'أدخل الرمز المكون من 6 أرقام',
      'login.connecting': 'جاري الاتصال...',
      'login.connectingLongevity': 'الاتصال بـ Longevity OS...',
      'login.continueLongevity': 'المتابعة مع Omnisio Longevity ID',
      'paywall.paymentMethod': 'طريقة الدفع',
      'social.timeMin': 'منذ {{n}}د',
      'social.timeHour': 'منذ {{n}}س',
      'social.timeDay': 'منذ {{n}}ي',
      'syndicates.joined': 'انضممت',
      'syndicates.joinToChat': 'انضم لفتح الدردشة',
      'syndicates.requirement': 'الحد الأدنى {{xp}} XP',
      'syndicates.teamChallenges': 'تحديات الفريق',
      'syndicates.myClan': 'سنديكاتي',
      'syndicates.discover': 'اكتشف',
      'syndicates.createTitle': 'إنشاء سنديكا',
      'biohacks.challenges': 'التحديات',
      'biohacks.activeChallenges': 'نشطة — {{n}}',
      'biohacks.availableChallenges': 'المتاحة',
      'biohacks.completedChallenges': 'المكتملة',
      'biohacks.joinChallenge': 'انضم',
      'biohacks.claimReward': 'احصل على +{{reward}} XP',
      'memory.tabNEW': 'الجديد',
      'memory.tabMY': 'لي',
      'memory.tabTOP': 'الأفضل',
      'memory.tabCORE': 'الأساسية',
      'nav.progress': 'التقدم',
      'home.defaultName': 'الرياضي',
      'home.greetingSub': 'جسدك. أهدافك.',
      'home.greetingSub2': 'لنبنِ شيئاً أقوى اليوم.',
      'home.energyScore': 'نقاط الطاقة',
      'home.companionLabel': 'الرفيق',
      'home.companionTagline': 'للتدريب. للدعم.',
      'home.companion.phoenix': 'أومني',
      'home.companion.bonsai': 'سيج',
      'home.companion.orb': 'أورب',
      'home.companion.avatar': 'تايتن',
      'home.companion.avatar_female': 'لونا',
      'home.moodHigh': 'عالية',
      'home.moodGood': 'جيدة',
      'home.moodFair': 'متوسطة',
      'home.moodLow': 'منخفضة',
      'home.moodHighSub': 'أنت جاهز للأداء.',
      'home.moodGoodSub': 'أساس صلب — استمر بالدفع.',
      'home.moodFairSub': 'تحمَّ بهدوء اليوم.',
      'home.moodLowSub': 'الأولوية للتعافي.',
      'home.recommendedForYou': 'موصى لك',
      'home.aiRecommended': 'توصية الذكاء الاصطناعي',
      'home.recTitle': 'القوة والتوازن',
      'home.recSub': 'اكتسب القوة. حسّن السيطرة.',
      'home.dayStreak': 'سلسلة الأيام',
      'home.workoutsThisWeek': 'تمارين هذا الأسبوع',
      'home.badgesEarned': 'الشارات المكتسبة',
      'workout.level.intermediate': 'متوسط',
      'progress.title': 'التقدم',
      'progress.level': 'المستوى {{level}}',
      'progress.stage1': 'صورة الشرارة',
      'progress.stage2': 'الصورة المستيقظة',
      'progress.stage3': 'الصورة المتطورة',
      'progress.stage4': 'الصورة الصاعدة',
      'progress.stage5': 'الصورة العنصرية',
      'progress.stage6': 'الصورة الأسطورية',
      'progress.stage7': 'الصورة المتعالية',
      'progress.rarityCommon': 'عادي',
      'progress.rarityRare': 'نادر',
      'progress.rarityEpic': 'ملحمي',
      'progress.rarityLegendary': 'أسطوري',
      'progress.stageChip': '{{stage}}. مرحلة التطور',
      'progress.dayStreakInline': 'سلسلة {{count}} يوم',
      'progress.streakSub': 'حافظ على اشتعالها!',
      'progress.xpProgress': 'تقدم XP',
      'progress.nextStage': 'المرحلة التالية: مرحلة {{stage}} - {{name}}',
      'progress.dayStreak': 'سلسلة الأيام',
      'progress.workouts': 'التمارين',
      'progress.stagesReached': 'المراحل المُحقَّقة',
      'progress.achievements': 'الإنجازات',
      'progress.viewAll': 'عرض الكل',
      'progress.achievement.discipline': 'الانضباط',
      'progress.achievement.consistency': 'الثبات',
      'progress.achievement.endurance': 'التحمل',
      'progress.achievement.resilience': 'الصمود',
      'progress.achievement.days': 'يوم',
      'progress.achievement.workouts': 'تمرين',
      'paywall.disclosureTitle': 'شروط الاشتراك',
      'paywall.disclosureLength': 'يتجدد الاشتراك تلقائياً شهرياً أو سنوياً حتى الإلغاء',
      'paywall.disclosurePrice': 'يُخصم من Apple ID الخاص بك بالسعر الموضح أعلاه',
      'paywall.disclosureRenewal': 'يتجدد تلقائياً خلال 24 ساعة قبل انتهاء الفترة (ما لم يتم إيقافه)',
      'paywall.disclosureCancel': 'إدارة أو إلغاء في أي وقت من إعدادات iPhone ← Apple ID ← الاشتراكات',
      'paywall.disclosureRefund': 'لا استرداد عن الجزء غير المستخدم من الفترة الحالية',
      'paywall.legalFooter': 'تتم إدارة الاشتراك عبر Apple ID. ألغ في أي وقت من إعدادات iPhone.',
      'profile.editTitle': 'تعديل الملف الشخصي',
      'profile.firstName': 'الاسم',
      'profile.firstNamePh': 'اسمك',
      'profile.lastName': 'اللقب',
      'profile.lastNamePh': 'لقبك',
      'profile.displayName': 'الاسم المعروض',
      'profile.displayNamePh': 'كيف يراك الآخرون',
      'profile.email': 'البريد الإلكتروني',
      'profile.publicId': 'المعرّف العام',
      'common.cancel': 'إلغاء',
      'common.save': 'حفظ',
      'common.saving': 'جارٍ الحفظ…',
      'coach.active': 'نشط',
      'coach.proLabel': 'PRO',
      'settings.appleHealth': 'Apple Health',
      'settings.appleHealthDesc': 'الخطوات + الطاقة النشطة',
      'coach.tab.voice': 'الصوت',
      'coach.tab.soundscape': 'المشهد الصوتي',
      'coach.tab.music': 'الموسيقى',
      'coach.sample.workoutStart': 'قبل التمرين',
      'coach.sample.setComplete': 'انتهت المجموعة',
      'coach.sample.halfway': 'تحفيز منتصف الطريق',
      'coach.sample.finalSet': 'دفعة آخر مجموعة',
      'coach.sample.workoutDone': 'انتهى التمرين',
      'coach.soundscape.focus': 'التركيز',
      'coach.soundscape.focusDesc': 'موجات ألفا عميقة لتركيز ليزر',
      'coach.soundscape.cardio': 'دفعة كارديو',
      'coach.soundscape.cardioDesc': 'نبضات BPM عالية لدفع أقوى',
      'coach.soundscape.recovery': 'التعافي',
      'coach.soundscape.recoveryDesc': 'نغمات هادئة لإصلاح العضلات',
      'coach.soundscape.sleep': 'استعداد النوم',
      'coach.soundscape.sleepDesc': 'موجات دلتا للراحة العميقة',
      'coach.service.spotify.desc': 'تمرين Beast Mode',
      'coach.service.applemusic.desc': 'Pure Pump',
      'coach.service.ytmusic.desc': 'قائمة تمرين',
      'coach.companion.phoenix.name': 'العنقاء',
      'coach.companion.phoenix.desc': 'ملحمي، محفز',
      'coach.companion.bonsai.name': 'البونساي',
      'coach.companion.bonsai.desc': 'هادئ، متأمل',
      'coach.companion.orb.name': 'كرة الطاقة',
      'coach.companion.orb.desc': 'مستقبلي، آلي',
      'coach.companion.avatar.name': 'المحارب',
      'coach.companion.avatar.desc': 'قوي، مكثف',
      'coach.companion.avatar_female.name': 'الإلهة',
      'coach.companion.avatar_female.desc': 'تمكيني، دافئ',
      'coach.musicTitle': 'قوائم تشغيل التمرين',
      'coach.openIn': 'فتح',
      'coach.play': 'تشغيل',
      'coach.playing': 'يعمل',
      'biometric.insufficientScope': 'أذونات ناقصة',
      'biometric.missingScopes': 'الناقص: {{scopes}}',
      'biometric.grantScopesCta': 'منح',
      'biometric.rateLimited': 'حد المعدل — أعد بعد {{seconds}} ثانية',
      'common.continue': 'متابعة',
      'onboarding.goalTitle': 'ما هدفك؟',
      'onboarding.goalSubtitle': 'اختر هدفك الرئيسي',
      'onboarding.goal.cut': 'التنشيف',
      'onboarding.goal.cutSub': 'فقدان الدهون والتنشيف',
      'onboarding.goal.bulk': 'البلك',
      'onboarding.goal.bulkSub': 'اكتساب العضلات والقوة',
      'onboarding.goal.maintain': 'المحافظة',
      'onboarding.goal.maintainSub': 'الحفاظ على الشكل الحالي',
      'onboarding.awakeningTitle': 'أنت جاهز',
      'onboarding.awakeningSubtitle': 'ماذا نناديك؟',
      'onboarding.namePlaceholder': 'اسمك أو لقبك',
      'onboarding.getStarted': 'ابدأ',
      'sport.bench_press.name': 'البنش برس',
      'sport.lunges.name': 'الاندفاع',
      'sport.jumping_rope.name': 'القفز بالحبل',
      'sport.kickboxing.name': 'الكيك بوكسينغ',
      'sport.volleyball.name': 'الكرة الطائرة',
      'sport.ice_skating.name': 'التزلج على الجليد',
      'sport.crossfit_wod.name': 'كروسفت WOD',
      'sport.foam_rolling.name': 'الفوم رولر',
      'sport.mobility_flow.name': 'تدفق المرونة',
      'common.skip': 'تخطي',
      'common.next': 'التالي',
      'onboarding.injuryTitle': 'هل لديك إصابات؟',
      'onboarding.injurySubtitle': 'سنكيّف التمارين لتجنب إجهاد هذه المناطق. اختياري.',
      'onboarding.injuryNoneSelected': 'لا إصابات — تمارين بكامل الشدة',
      'onboarding.injuryCount_other': '{{count}} منطقة محمية',
      'onboarding.injuries.neck': 'الرقبة',
      'onboarding.injuries.shoulders': 'الأكتاف',
      'onboarding.injuries.lowerBack': 'أسفل الظهر',
      'onboarding.injuries.elbows': 'المرفقان',
      'onboarding.injuries.wrists': 'الرسغان',
      'onboarding.injuries.hips': 'الوركان',
      'onboarding.injuries.knees': 'الركبتان',
      'onboarding.injuries.ankles': 'الكاحلان',
      'common.back': 'رجوع',
      'common.gotIt': 'فهمت',
      'leaderboard.title': 'لوحة المتصدرين',
      'leaderboard.global': 'عالمي',
      'leaderboard.friends': 'الأصدقاء',
      'leaderboard.weekly': 'أسبوعي',
      'leaderboard.you': 'أنت',
      'leaderboard.energy': 'طاقة',
      'leaderboard.howItWorks': 'كيف يعمل',
      'leaderboard.noFriends': 'لا أصدقاء بعد',
      'leaderboard.noFriendsDesc': 'ادعُ أصدقاء للمنافسة',
      'leaderboard.rule1Title': 'اكسب الطاقة',
      'leaderboard.rule1': 'أكمل التمارين. صعوبة أعلى + سلاسل أطول = طاقة أكثر.',
      'leaderboard.rule2Title': 'ثلاث لوحات',
      'leaderboard.rule2': 'العالمي يرتب الجميع، الأصدقاء فقط من تتابعهم، الأسبوعي يُعاد كل اثنين.',
      'leaderboard.rule3Title': 'قاعدة الانخفاض',
      'leaderboard.rule3': 'الطاقة تنخفض 5% لكل يوم خمول — الاستمرار خير من الاندفاع.',
      'leaderboard.rule4Title': 'المكافآت',
      'leaderboard.rule4': 'أفضل 3 في كل لوحة يحصلون على إطار ملف ذهبي/فضي/برونزي.',
      'referral.title': 'ادعُ واكسب',
      'referral.description': 'ادعُ صديقًا — يحصل على شهر مجاني وأنت أيضًا. بلا حدود.',
      'referral.yourId': 'معرفك',
      'referral.reward': 'المكافأة',
      'referral.daysFree': 'يومًا مجانًا',
      'referral.copy': 'نسخ',
      'referral.copied': 'تم النسخ',
      'referral.share': 'مشاركة',
      'referral.shareTitle': 'جرّب Omnisio Workout',
      'referral.shareText': 'انضم إلى Omnisio Workout — كلانا يحصل على شهر Pro مجاني.',
      'referral.activeStatus': 'Pro نشط حتى',
      'oracle.recentMeals': 'الوجبات الأخيرة',
      'oracle.entryCount_other': '{{count}} سجل',
      'oracle.noScans': 'لا توجد عمليات مسح بعد',
      'oracle.noScansDesc': 'اضغط على مسح لتتبع أول وجبة',
      'oracle.scanNow': 'امسح الآن',
      'oracle.todaysTotal': 'إجمالي اليوم',
      'oracle.kcal': 'سعرة',
      'oracle.macro.protein': 'بروتين',
      'oracle.macro.carbs': 'كربوهيدرات',
      'oracle.macro.fat': 'دهون',
      'oracle.macro.calories': 'سعرات',
      'oracle.meal.breakfast': 'فطور',
      'oracle.meal.lunch': 'غداء',
      'oracle.meal.dinner': 'عشاء',
      'oracle.meal.snack': 'وجبة خفيفة',
      'sport.pushups.name': 'تمرين الضغط',
      'sport.squats.name': 'القرفصاء',
      'sport.plank.name': 'البلانك',
      'sport.running.name': 'الجري',
      'sport.yoga.name': 'اليوغا',
      'sport.boxing.name': 'الملاكمة',
      'sport.cycling.name': 'الدراجة',
      'sport.swimming.name': 'السباحة',
      'sport.basketball.name': 'كرة السلة',
      'sport.skiing.name': 'التزلج',
      'sport.pullups.name': 'العقلة',
      'sport.hiit.name': 'HIIT',
      'sport.tennis.name': 'التنس',
      'sport.deadlift.name': 'الرفعة المميتة',
      'sport.pilates.name': 'بيلاتس',
      'sport.mma.name': 'MMA',
      'sport.rowing.name': 'التجديف',
      'sport.dance.name': 'لياقة رقص',
      'sport.stretching.name': 'التمدد',
      'sport.kettlebell.name': 'كيتل بيل',
      'sport.football.name': 'كرة القدم',
      'workout.cat.all': 'الكل',
      'workout.cat.strength': 'القوة',
      'workout.cat.cardio': 'الكارديو',
      'workout.cat.flexibility': 'المرونة',
      'workout.cat.combat': 'القتال',
      'workout.cat.team': 'الفرق',
      'workout.cat.winter': 'الشتاء',
      'workout.cat.functional': 'وظيفي',
      'workout.noEquipment': 'بدون معدات',
      'workout.instructions': 'التعليمات',
      'workout.commonMistakes': 'الأخطاء الشائعة',
      'workout.easier': 'أسهل',
      'workout.harder': 'أصعب',
      'workout.repsCount_other': '{{count}} تكرار',
      'workout.countSports_other': '{{count}} رياضات',
      'workout.noSports': 'لم يتم العثور على رياضات',
      'settings.general': 'عام',
      'settings.proActive': 'Pro مُفعّل',
      'settings.freeTrial': 'تجربة مجانية',
      'settings.allUnlocked': 'كل الميزات مفتوحة',
      'settings.upgradeFull': 'الترقية للوصول الكامل',
      'settings.upgrade': 'ترقية',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'مزامنة البيانات',
      'settings.dataSyncDesc': 'مزامنة بيانات الصحة مع منظومة Omnisio',
      'settings.logout': 'تسجيل الخروج',
      'app.name': 'Omnisio Workout',
      'app.tagline': 'لياقة جماعية خاصة',
      'nav.home': 'الرئيسية',
      'nav.workout': 'تمرين',
      'nav.nutri': 'تغذية',
      'nav.history': 'السجل',
      'nav.memory': 'الذكريات',
      'nav.radio': 'راديو',
      'nav.shop': 'متجر',
      'nav.profile': 'الملف',
      'nav.more': 'المزيد',
      'nav.coach': 'المدرب',
      'home.welcome': 'مرحباً، {{name}}',
      'home.dailyEnergy': 'الطاقة اليومية',
      'home.startWorkout': 'ابدأ التمرين',
      'home.yourTotem': 'شعارك',
      'home.todaysMissions': 'أهداف اليوم',
      'home.leaderboard': 'الترتيب',
      'home.syndicates': 'الفرق',
      'home.biohacks': 'التحديات',
      'energy.exercise': 'تمرين',
      'energy.music': 'موسيقى',
      'energy.total': 'الطاقة الكلية',
      'energy.streak': '{{count}} يوم متتالي',
      'energy.streakFire': 'سلسلة',
      'workout.title': 'تمرين',
      'workout.camera': 'تتبع الكاميرا',
      'workout.startSession': 'بدء الجلسة',
      'workout.endSession': 'إنهاء الجلسة',
      'workout.reps': 'تكرارات',
      'workout.calories': 'سعرات',
      'workout.duration': 'المدة',
      'workout.exerciseComplete': 'تم التمرين!',
      'workout.energyEarned': '+{{amount}} طاقة',
      'workout.plank': 'بلانك',
      'workout.pushups': 'ضغط',
      'workout.squats': 'سكوات',
      'workout.overview': 'نظرة عامة',
      'workout.history': 'السجل',
      'workout.progress': 'التقدم',
      'workout.personalRecords': 'الأرقام القياسية',
      'workout.share': 'مشاركة',
      'workout.done': 'تم',
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'مسح الطعام',
      'oracle.history': 'سجل المسح',
      'oracle.scanning': 'جاري التحليل...',
      'oracle.dailyNorm': 'المعدل اليومي',
      'oracle.scansLeft': '{{count}} مسح متبقي',
      'oracle.upgrade': 'ترقية للحصول على غير محدود',
      'oracle.protein': 'بروتين',
      'oracle.carbs': 'كربوهيدرات',
      'oracle.fat': 'دهون',
      'oracle.calories': 'سعرات حرارية',
      'memory.title': 'الذكريات',
      'memory.upload': 'رفع ذكرى',
      'memory.stake': 'رهن الطاقة',
      'memory.network': 'شبكة إثبات الطاقة العالمية',
      'calendar.title': 'السجل',
      'calendar.fitness': 'لياقة',
      'calendar.nutrition': 'تغذية',
      'calendar.protocols': 'البروتوكولات',
      'shop.title': 'متجر',
      'shop.avatars': 'صور رمزية',
      'shop.boosters': 'معززات',
      'shop.cosmetics': 'مستحضرات',
      'shop.buy': 'شراء',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'مملوك',
      'shop.equipped': 'مجهز',
      'profile.title': 'الملف',
      'profile.level': 'المستوى {{level}}',
      'profile.totalWorkouts': 'مجموع التمارين',
      'profile.totalTokens': 'مجموع التوكنات',
      'profile.achievements': 'الإنجازات',
      'profile.settings': 'الإعدادات',
      'profile.totem': 'الشعار',
      'leaderboard.title': 'الترتيب',
      'leaderboard.global': 'عالمي',
      'leaderboard.syndicate': 'الفريق',
      'leaderboard.weekly': 'أسبوعي',
      'leaderboard.allTime': 'كل الأوقات',
      'leaderboard.rank': 'المرتبة',
      'syndicates.title': 'الفرق',
      'syndicates.join': 'انضمام',
      'syndicates.create': 'إنشاء فريق',
      'syndicates.members': '{{count}} عضو',
      'syndicates.power': 'القوة',
      'biohacks.title': 'التحديات',
      'biohacks.protocols': 'البرامج',
      'biohacks.missions': 'الأهداف',
      'biohacks.active': 'نشط',
      'biohacks.completed': 'مكتمل',
      'biohacks.reward': 'مكافأة: {{amount}} TKN',
      'avatar.title': 'الصورة الرمزية',
      'avatar.customize': 'تخصيص',
      'avatar.skin': 'المظهر',
      'avatar.outfit': 'الزي',
      'avatar.accessories': 'الإكسسوارات',
      'avatar.save': 'حفظ',
      'radio.title': 'راديو الجيم',
      'radio.nowPlaying': 'يعمل الآن',
      'radio.stations': 'المحطات',
      'radio.energyBonus': '+طاقة أثناء الاستماع',
      'coach.title': 'المدرب',
      'coach.subtitle': 'رفيقك الرياضي الذكي في أذنك',
      'coach.tabVoice': 'الصوت',
      'coach.tabSoundscape': 'المشهد الصوتي',
      'coach.tabMusic': 'الموسيقى',
      'coach.chooseVoice': 'اختر صوت مدربك',
      'coach.samples': 'استمع إلى العينات',
      'coach.samplePreWorkout': 'قبل التمرين',
      'coach.sampleSetComplete': 'انتهت المجموعة',
      'coach.sampleHalfway': 'منتصف الطريق',
      'coach.sampleFinalSet': 'المجموعة الأخيرة',
      'coach.sampleWorkoutDone': 'انتهى التمرين',
      'coach.voiceCoachToggle': 'مدرب صوتي أثناء التمارين',
      'coach.proRequired': 'برو مطلوب لجميع الأصوات',
      'coach.upgrade': 'ترقية',
      'coach.soundscapeFocus': 'التركيز',
      'coach.soundscapeFocusDesc': 'موجات ألفا للتركيز العميق',
      'coach.soundscapeCardio': 'كارديو',
      'coach.soundscapeCardioDesc': 'BPM عالي للجري وHIIT',
      'coach.soundscapeRecovery': 'التعافي',
      'coach.soundscapeRecoveryDesc': 'إيقاع بطيء للتمدد',
      'coach.soundscapeSleep': 'تحضير للنوم',
      'coach.soundscapeSleepDesc': 'ضوضاء وردية وأصوات الطبيعة',
      'coach.soundscapeComingSoon': 'قريبًا',
      'coach.musicHeader': 'افتح تطبيق الموسيقى المفضل',
      'coach.musicSpotify': 'فتح في Spotify',
      'coach.musicApple': 'فتح في Apple Music',
      'coach.musicYoutube': 'فتح في YouTube Music',
      'coach.workoutPlaylist': 'قائمة تشغيل التمرين',
      'settings.title': 'الإعدادات',
      'settings.language': 'اللغة',
      'settings.notifications': 'الإشعارات',
      'settings.sound': 'الصوت',
      'settings.haptics': 'الاهتزاز',
      'settings.about': 'حول',
      'settings.version': 'الإصدار',
      'settings.aiEngine': 'محرك الذكاء الاصطناعي',
      'settings.wearables': 'الأجهزة الحيوية القابلة للارتداء',
      'settings.bioWearables': 'الأجهزة الحيوية القابلة للارتداء',
      'settings.omnisioBand': 'أومنيسيو باند',
      'settings.omnisioBandDesc': 'SDK أصلي · قياسات حيوية فورية',
      'settings.omnisioRing': 'أومنيسيو رينج',
      'settings.omnisioRingDesc': 'SDK أصلي · بطارية 7 أيام، النوم + HRV',
      'settings.thirdPartySync': 'طرف ثالث · اتصل للمزامنة',
      'settings.dataSync': 'مزامنة البيانات',
      'settings.upgrade': 'ترقية',
      'settings.logout': 'تسجيل الخروج',
      'onboarding.welcome': 'مرحباً بك في Omnisio Workout',
      'onboarding.subtitle': 'رحلتك الرياضية الخاصة تبدأ هنا',
      'onboarding.selectExercise': 'اختر تمرينك الأول',
      'onboarding.pushups': 'ضغط',
      'onboarding.squats': 'سكوات',
      'onboarding.getStarted': 'ابدأ',
      'onboarding.skip': 'تخطي',
      'common.loading': 'جاري التحميل...',
      'common.error': 'حدث خطأ',
      'common.retry': 'إعادة المحاولة',
      'common.back': 'رجوع',
      'common.save': 'حفظ',
      'common.cancel': 'إلغاء',
      'common.confirm': 'تأكيد',
      'common.close': 'إغلاق',
      'common.tokens': 'توكنات',
      'common.soon': 'قريباً',
      'common.viewAll': 'عرض الكل',

      // Profile (extended)
      'profile.workouts': 'التمارين',
      'profile.hours': 'ساعات',
      'profile.totalXP': 'مجموع XP',
      'profile.personalRecords': 'السجلات الشخصية',
      'profile.connectedServices': 'الخدمات المتصلة',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'متصل',
      'profile.connect': 'اتصال',
      'profile.helpSupport': 'المساعدة والدعم',
      'profile.signOut': 'تسجيل الخروج',
      'profile.contactShipping': 'الاتصال والشحن',
      'profile.complete': 'مكتمل',
      'profile.incompleteForOrders': 'مطلوب لطلبات المكملات',
      'profile.email': 'البريد الإلكتروني',
      'profile.phone': 'الهاتف',
      'profile.address': 'العنوان',
      'profile.country': 'الدولة',
      'profile.addressPlaceholder': 'الشارع، المدينة، الرمز البريدي',
      'profile.privacyNote': 'تُخزن معلومات الاتصال محليًا وتُشارك فقط مع Celliva عند تقديم طلب. متوافق مع KVKK/GDPR.',
      'profile.invalidEmail': 'صيغة بريد إلكتروني غير صالحة',
      'profile.invalidPhone': 'الهاتف قصير جدًا',
      'profile.invalidAddress': 'العنوان قصير جدًا',

      // Achievements
      'achievements.firstWorkout': 'أول تمرين',
      'achievements.sevenDayStreak': 'سلسلة 7 أيام',
      'achievements.plankMaster': 'سيد البلانك',
      'achievements.earlyBird': 'الطائر المبكر',
      'achievements.perfectionist': 'المثالي',
      'achievements.hundredWorkouts': '100 تمرين',
      'achievements.marathon': 'ماراثون',
      'achievements.nightOwl': 'بومة الليل',

      // Shop (extended)
      'shop.subtitle': 'افتح الرفاق والمعززات والمعدات',
      'shop.tabCompanions': 'الرفاق',
      'shop.tabBoosters': 'المعززات',
      'shop.tabOutfits': 'الأزياء',
      'shop.tabThemes': 'السمات',
      'shop.free': 'مجاني',
      'shop.levelRequired': 'المستوى {{level}} مطلوب',
      'shop.unlockFor': 'فتح مقابل {{price}} ⚡',
      'shop.insufficientXP': 'XP غير كافٍ (يلزم {{price}} ⚡)',
      'shop.viewPack': 'عرض الحزمة',
      'shop.recentActivity': 'النشاط الأخير',
      'shop.earnMoreXP': 'اربح المزيد من XP',
      'shop.completeWorkout': 'أكمل تمريناً',
      'shop.startWorkout': 'ابدأ التمرين',
      'shop.tabSupplements': 'المكملات',
      'shop.poweredByCelliva': 'مدعوم من Celliva',
      'shop.cellivaTagline': 'مكملات متميزة · شحن مجاني فوق $50',
      'shop.buyOnCelliva': 'اشترِ من Celliva',
      'shop.supplementsHeader': 'وقود لتدريبك',
      'shop.supplementsSubtitle': 'مختبر، تحقق من طرف ثالث',

      // كتالوج متجر اللعبة (الرفاق / المعزّزات / الأزياء / السمات)
      'shop.item.phoenix.name': 'العنقاء',
      'shop.item.phoenix.desc': 'ينهض من الرماد',
      'shop.item.phoenix.long': 'اختارك طائر العنقاء الخالد ليكون شريكه. وُلد من النار ويُبعث أقوى في كل مرة، فيشحذ عزيمتك لتجاوز كل حد.',
      'shop.item.phoenix.stat.0.label': 'نقاط خبرة إضافية',
      'shop.item.phoenix.stat.0.value': '+10% في جميع التمارين',
      'shop.item.bonsai.name': 'شجرة البونساي',
      'shop.item.bonsai.desc': 'تنمو بالصبر',
      'shop.item.bonsai.long': 'منحوتة حية تعكس انضباطك. تتطور البونساي مع بنائك للعادات، وتكافئ المواظبة بترقيات بصرية نادرة.',
      'shop.item.bonsai.stat.0.label': 'مكافأة السلسلة',
      'shop.item.bonsai.stat.0.value': '+15% بعد سلسلة 7 أيام',
      'shop.item.orb.name': 'كرة الطاقة',
      'shop.item.orb.desc': 'وجِّه الطاقة الخالصة',
      'shop.item.orb.long': 'كرة من الطاقة الحيوية المكثّفة تضخّم كل تكرار تؤديه. تنبض أكثر سطوعًا كلما تدربت بجد أكبر.',
      'shop.item.orb.stat.0.label': 'تجدّد الطاقة',
      'shop.item.orb.stat.0.value': '+5 طاقة لكل تمرين',
      'shop.item.avatar.name': 'المحارب',
      'shop.item.avatar.desc': 'اصقُل قوتك',
      'shop.item.avatar.long': 'صورة رمزية متمرّسة في القتال تجسّد ذروة الإمكانات الجسدية. تفتح رسومًا متحركة خاصة بتحدي المحارب.',
      'shop.item.avatar.stat.0.label': 'خبرة القوة',
      'shop.item.avatar.stat.0.value': '+12% في جلسات القوة',
      'shop.item.avatar_female.name': 'الإلهة',
      'shop.item.avatar_female.desc': 'أطلِق العنان لقوتك',
      'shop.item.avatar_female.long': 'توجّه الطيف الكامل للإمكانات البشرية — الرشاقة والتحمّل والقوة الخام. حضور أسطوري يرفع من شأن كل جلسة.',
      'shop.item.avatar_female.stat.0.label': 'كل الخبرة',
      'shop.item.avatar_female.stat.0.value': '+20% من كل مصدر',
      'shop.item.wolf.name': '؟؟؟',
      'shop.item.wolf.desc': 'قريبًا',
      'shop.item.wolf.long': 'مخلوق من الظل والغريزة. اصِل إلى المستوى 7 لكشف هذا الرفيق.',
      'shop.item.xp_2x_24h.name': 'خبرة مضاعفة ×2 لمدة 24 ساعة',
      'shop.item.xp_2x_24h.desc': 'خبرة مضاعفة من كل المصادر لمدة 24 ساعة',
      'shop.item.xp_2x_24h.long': 'يتضاعف كل تمرين وتسجيل عادة ومكافأة سلسلة طوال يوم كامل. ادمجه مع جلسة تمرين لتحقيق أقصى المكاسب.',
      'shop.item.xp_2x_24h.stat.0.label': 'التأثير',
      'shop.item.xp_2x_24h.stat.0.value': 'مضاعف خبرة ×2',
      'shop.item.xp_2x_24h.stat.1.label': 'المدة',
      'shop.item.xp_2x_24h.stat.1.value': '24 ساعة',
      'shop.item.streak_freeze.name': 'تجميد السلسلة',
      'shop.item.streak_freeze.desc': 'احمِ سلسلتك مقابل يوم واحد فائت',
      'shop.item.streak_freeze.long': 'الحياة تحدث. يحفظ تجميد السلسلة سلسلتك التي حققتها بشق الأنفس عبر يوم واحد فائت — دون أي أسئلة.',
      'shop.item.streak_freeze.stat.0.label': 'التأثير',
      'shop.item.streak_freeze.stat.0.value': 'تخطَّ يومًا واحدًا، تبقى السلسلة سليمة',
      'shop.item.streak_freeze.stat.1.label': 'الاستخدامات',
      'shop.item.streak_freeze.stat.1.value': 'استخدام واحد',
      'shop.item.energy_boost.name': '+50 طاقة فورية',
      'shop.item.energy_boost.desc': 'أضِف 50 طاقة لليوم فورًا',
      'shop.item.energy_boost.long': 'حقنة مباشرة من 50 نقطة طاقة تُضاف فورًا إلى إجمالي اليوم.',
      'shop.item.energy_boost.stat.0.label': 'التأثير',
      'shop.item.energy_boost.stat.0.value': '+50 طاقة الآن',
      'shop.item.energy_boost.stat.1.label': 'الاستخدامات',
      'shop.item.energy_boost.stat.1.value': 'استخدام واحد',
      'shop.item.workout_quick.name': 'دفعة طاقة 5 دقائق',
      'shop.item.workout_quick.desc': 'تخطَّ الإحماء، ابدأ من جديد',
      'shop.item.workout_quick.long': 'يُنشّط عضلاتك رقميًا مسبقًا لتنتقل مباشرة إلى تمرينك بأقصى كفاءة.',
      'shop.item.workout_quick.stat.0.label': 'التأثير',
      'shop.item.workout_quick.stat.0.value': 'تخطَّ مرحلة الإحماء',
      'shop.item.workout_quick.stat.1.label': 'الاستخدامات',
      'shop.item.workout_quick.stat.1.value': 'استخدام واحد',
      'shop.item.cyber.name': 'الكسوة السيبرانية',
      'shop.item.cyber.desc': 'زيّ رفيق مضاء بالنيون',
      'shop.item.cyber.long': 'بدلة شبكية نيونية مستقبلية تغلّف رفيقك بجماليات رياضي الغد.',
      'shop.item.cyber.stat.0.label': 'بصري',
      'shop.item.cyber.stat.0.value': 'توهّج نيوني + أثر جسيمات',
      'shop.item.royal.name': 'الرداء الملكي',
      'shop.item.royal.desc': 'لمسات ذهبية فاخرة',
      'shop.item.royal.long': 'مكسوّ بالقرمزي الغامق مع تطريز بخيوط ذهبية — مخصص للأبطال الذين استحقوا حق الحكم.',
      'shop.item.royal.stat.0.label': 'بصري',
      'shop.item.royal.stat.0.value': 'هالة بريق ذهبية',
      'shop.item.royal.stat.1.label': 'هالة الخبرة',
      'shop.item.royal.stat.1.value': '+5% من أيام السلسلة',
      'shop.item.minimal.name': 'بسيط',
      'shop.item.minimal.desc': 'مظهر أحادي اللون أنيق',
      'shop.item.minimal.long': 'القليل أفضل. زيّ أحادي اللون مبسّط يدع نتائجك تتحدث عنك.',
      'shop.item.minimal.stat.0.label': 'بصري',
      'shop.item.minimal.stat.0.value': 'لوحة أحادية اللون',
      'shop.item.cosmic.name': 'كوني',
      'shop.item.cosmic.desc': 'تأثيرات النجوم والسديم',
      'shop.item.cosmic.long': 'يتحول رفيقك إلى مجرة متحركة — سُدُم دوّارة وجسيمات حقل نجمي تتبع كل حركة.',
      'shop.item.cosmic.stat.0.label': 'بصري',
      'shop.item.cosmic.stat.0.value': 'نظام جسيمات مجري',
      'shop.item.midnight.name': 'منتصف الليل',
      'shop.item.midnight.desc': 'السمة الداكنة الافتراضية',
      'shop.item.midnight.long': 'سمة Omnisio الداكنة الكلاسيكية. أسود عميق ولمسات فيروزية — دقيقة وصارمة وقوية.',
      'shop.item.midnight.stat.0.label': 'اللوحة',
      'shop.item.midnight.stat.0.value': 'أسود + فيروزي',
      'shop.item.aurora.name': 'أورورا',
      'shop.item.aurora.desc': 'تدرّج الشفق القطبي',
      'shop.item.aurora.long': 'تدرّجات منسابة من الأخضر إلى البنفسجي مستوحاة من الشفق القطبي الشمالي. سماء حية فوق رأسك.',
      'shop.item.aurora.stat.0.label': 'اللوحة',
      'shop.item.aurora.stat.0.value': 'زمردي + بنفسجي',
      'shop.item.sunset.name': 'الغروب',
      'shop.item.sunset.desc': 'ذهبي دافئ + أرجواني',
      'shop.item.sunset.long': 'آخر ضوء النهار — كهرماني وذهبي وأرجواني عميق، متطبّقة كأفق مشتعل.',
      'shop.item.sunset.stat.0.label': 'اللوحة',
      'shop.item.sunset.stat.0.value': 'ذهبي + أرجواني',
      'shop.item.ocean.name': 'أعماق المحيط',
      'shop.item.ocean.desc': 'جمالية أزرق مخضرّ عميق',
      'shop.item.ocean.long': 'اغُص في الهاوية. خلفيات بلون أزرق مخضرّ عميق مع لمسات زرقاء متوهجة حيويًا تستحضر السكون الساحق لأعماق المحيط.',
      'shop.item.ocean.stat.0.label': 'اللوحة',
      'shop.item.ocean.stat.0.value': 'أزرق مخضرّ عميق + أزرق',
      'shop.featuredPack.name': 'حزمة الربيع',
      'shop.featuredPack.tagline': 'حزمة من 3 عناصر — وفّر 40%',
      'shop.featuredPack.countdown': 'تنتهي خلال 3 أيام و14 ساعة',
      'shop.featuredPack.item.0': 'شجرة البونساي',
      'shop.featuredPack.item.1': 'سمة أورورا',
      'shop.featuredPack.item.2': 'خبرة مضاعفة ×2 لمدة 24 ساعة',

      // Celliva Dispensary
      'shop.celliva.title': 'صيدلية Celliva',
      'shop.celliva.eyebrow': 'إمداد ذاتي',
      'shop.celliva.tabMarketplace': 'السوق',
      'shop.celliva.tabGameStore': 'متجر الألعاب',
      'shop.celliva.predictiveTitle': 'محرك التنبؤ',
      'shop.celliva.predictiveBody': 'سينفد مخزون {{product}} خلال {{days}} أيام.',
      'shop.celliva.authorizeDispatch': 'تفويض الشحن',
      'shop.celliva.calibrationTitle': 'معايرة البروتوكول',
      'shop.celliva.calibrationQuestion': 'هل حسّن {{product}} نتيجة {{outcome}}؟',
      'shop.celliva.calibrationYes': 'نعم — مثالي',
      'shop.celliva.calibrationNo': 'لا تغيير',
      'shop.celliva.calibrationDismiss': 'تجاهل',
      'shop.celliva.calibrationThanks': 'تم تسجيل المعايرة. تم تحسين البروتوكول.',
      'shop.celliva.closedLoopTitle': 'الحلقة المغلقة نشطة',
      'shop.celliva.closedLoopBody': 'تغذي المؤشرات الحيوية الصيدلية. تتكيف الطلبات مع بياناتك.',
      'shop.celliva.targetedInterventions': 'تدخلات موجّهة',
      'shop.celliva.viewDetails': 'التفاصيل',
      'shop.celliva.hideDetails': 'إخفاء التفاصيل',
      'shop.celliva.dosage': 'الجرعة',
      'shop.celliva.ingredients': 'المكونات',
      'shop.celliva.studies': 'المراجع الكلينيكية',
      'shop.celliva.addToCart': 'أضف إلى السلة',
      'shop.celliva.inCart': 'في السلة ({{qty}})',
      'shop.celliva.checkout': 'الدفع على Celliva',
      'shop.celliva.cartEmpty': 'السلة فارغة',
      'shop.celliva.cartTotal': 'الإجمالي',
      'shop.celliva.catLongevity': 'طول العمر',
      'shop.celliva.catCognitive': 'إدراكي',
      'shop.celliva.catRecovery': 'التعافي',
      'shop.celliva.catPerformance': 'الأداء',
      'shop.celliva.catAll': 'الكل',
      'shop.celliva.downloadCatalog': 'تحميل الكتالوج',
      'shop.celliva.bestseller': 'الأكثر مبيعاً',
      'shop.celliva.clinical': 'كليني',
      'shop.celliva.verified': 'موثّق مختبرياً',
      'shop.celliva.proRequired': 'مستوى Pro يتيح الطلب الذكي والمعايرة',
      'shop.celliva.eliteDnaBanner': 'بناءً على حالة APOE ε4 لديك، مُعطى أولوية للدعم الإدراكي',
      'shop.celliva.kvkkNote': 'تغادر بيانات الشحن الجهاز فقط عند تقديم طلب على Celliva.life.',

      // Rarity
      'rarity.common': 'عادي',
      'rarity.rare': 'نادر',
      'rarity.epic': 'ملحمي',
      'rarity.legendary': 'أسطوري',

      // Memory (extended)
      'memory.community': 'المجتمع',
      'memory.demoMode': 'وضع تجريبي · اربط Supabase للبيانات الحقيقية',
      'memory.boost': 'تعزيز',
      'memory.boostXPNote': '+10 XP لنشر الطاقة',
      'memory.noPostsTitle': 'لا توجد منشورات بعد',
      'memory.noPostsDesc': 'كن أول من يشارك تمرينه',
      'memory.allCaughtUp': 'تم اللحاق بكل شيء',

      // Calendar (extended)
      'calendar.history': 'السجل',
      'calendar.workouts': 'التمارين',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'سلسلة',
      'calendar.energy': 'الطاقة',
      'calendar.tabFitness': 'لياقة',
      'calendar.tabNutrition': 'تغذية',
      'calendar.tabProtocols': 'البروتوكولات',
      'calendar.restDay': 'يوم راحة',
      'calendar.restDayDesc': 'لم يتم تسجيل أي نشاط. كل بطل يحتاج إلى التعافي.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'عجز السعرات',
      'oracle.alertLowProtein': 'تنبيه: بروتين منخفض',
      'oracle.alertPerfectDay': 'يوم مثالي',
      'oracle.dailyCalories': 'السعرات اليومية',
      'oracle.tabScan': 'مسح',
      'oracle.tabHistory': 'السجل',
      'oracle.tapToScan': 'وجّه الكاميرا نحو طعامك واضغط الزر أدناه',
      'oracle.freeScans': '{{used}}/{{max}} مسح مجاني',
      'oracle.upgradePro': 'الترقية إلى Pro',
      'oracle.scanFood': 'مسح الطعام',
      'oracle.scanAgain': 'مسح مرة أخرى',
      'oracle.addToLog': 'أضف إلى سجل الطعام',

      // Paywall
      'paywall.chooseLevel': 'اختر مستواك',
      'paywall.restorePurchase': 'استعادة الشراء',
      'paywall.maybeLater': 'ربما لاحقاً',

      // Workout (extended)
      'workout.searchPlaceholder': 'ابحث عن رياضة...',
      'workout.musclesWorked': 'العضلات المستهدفة',
      'workout.primary': 'أساسية',
      'workout.secondary': 'ثانوية',
      'workout.exercises': 'التمارين',
      'workout.warmUp': 'إحماء',
      'workout.coolDown': 'تهدئة',
      'workout.startCTA': 'ابدأ {{sport}} {{level}}',
      'workout.rest': 'راحة',
      'workout.skipRest': 'تخطي الراحة',
      'workout.upNext': 'التالي',
      'workout.setOf': 'المجموعة {{current}} من {{total}}',
      'workout.formTips': 'نصائح الأداء',
      'workout.resume': 'استئناف',
      'workout.pause': 'إيقاف مؤقت',
      'workout.skip': 'تخطي',
      'workout.complete': 'اكتمل التمرين',
      'workout.sets': 'مجموعات',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'التالي: {{exercise}}. {{tip}}',
      'coach.formReminder': 'تحقق من الشكل: {{tip}}',

      // الإعداد — الجنس والعمر
      'onboarding.aboutTitle': 'عنك',
      'onboarding.aboutSubtitle': 'أخبرنا عن نفسك',
      'onboarding.gender.male': 'ذكر',
      'onboarding.gender.female': 'أنثى',
      'onboarding.gender.other': 'آخر',
      'onboarding.howOld': 'كم عمرك؟',
      'onboarding.yearsOld': 'سنة',

      // الإعداد — الجسم
      'onboarding.bodyTitle': 'جسدك',
      'onboarding.bodySubtitle': 'لنتمكن من حساب خطتك',
      'onboarding.weight': 'الوزن',
      'onboarding.height': 'الطول',
      'onboarding.targetWeight': 'الوزن المستهدف (اختياري)',

      // الإعداد — مستوى النشاط
      'onboarding.activityTitle': 'مستوى النشاط',
      'onboarding.activitySubtitle': 'يؤثر في احتياجك اليومي من السعرات',
      'onboarding.activity.sedentary': 'خامل',
      'onboarding.activity.sedentarySub': 'نشاط قليل أو معدوم',
      'onboarding.activity.light': 'خفيف',
      'onboarding.activity.lightSub': '1–3 أيام في الأسبوع',
      'onboarding.activity.moderate': 'متوسط',
      'onboarding.activity.moderateSub': '3–5 أيام في الأسبوع',
      'onboarding.activity.high': 'مرتفع',
      'onboarding.activity.highSub': '6–7 أيام في الأسبوع',
      'onboarding.activity.extreme': 'مكثف',
      'onboarding.activity.extremeSub': 'رياضي / مرتين يومياً',
      'onboarding.calculatePlan': 'احسب خطتي',

      // الإعداد — الحساب
      'onboarding.calculatingTitle': 'جارٍ حساب خطتك…',
      'onboarding.calcMsg1': 'تحليل عملية الأيض…',
      'onboarding.calcMsg2': 'حساب TDEE…',
      'onboarding.calcMsg3': 'تحسين توزيع المغذيات الكبرى…',
      'onboarding.calcMsg4': 'بناء خطتك الشخصية…',
      'onboarding.calcMsg5': 'اكتمل تقريباً…',
      'onboarding.planReadyTitle': 'الخطة جاهزة!',
      'onboarding.planReadySubtitle': 'أهدافك اليومية المخصصة',
      'onboarding.dailyCalories': 'السعرات اليومية',
      'onboarding.kcalPerDay': 'سعرة / يوم',
      'onboarding.macroSplit': 'توزيع المغذيات',
      'onboarding.macroProtein': 'البروتين',
      'onboarding.macroCarbs': 'الكربوهيدرات',
      'onboarding.macroFat': 'الدهون',
      'onboarding.timeframe': 'الإطار الزمني',
      'onboarding.timeframe1m': 'شهر واحد',
      'onboarding.timeframe3m': '3 أشهر',
      'onboarding.timeframe6m': '6 أشهر',
      'onboarding.timeframe12m': 'سنة واحدة',
      'onboarding.chooseCompanion': 'اختر رفيقي',

      // الإعداد — الرفيق
      'onboarding.companionTitle': 'اختر رفيقك',
      'onboarding.companionSubtitle': 'رفيقك يتطور مع تدريباتك',

      // التقويم
      'calendar.noMealsTitle': 'لا وجبات مسجلة',
      'calendar.noMealsDesc': 'افتح تبويب التغذية لتسجيل طعامك لهذا اليوم.',
      'calendar.noProtocolsTitle': 'لا بروتوكولات مسجلة',
      'calendar.noProtocolsDesc': 'لا توجد سجلات بيوهاك لهذا اليوم. واصل روتينك.',

      // الذاكرة
      'memory.loadError': 'تعذّر تحميل المنشورات',

      // النقابات
      'syndicates.messagePlaceholder': 'أرسل رسالة إلى الفصيل…',
      'syndicates.noClanTitle': 'لا فصيل بعد',
      'syndicates.noClanDesc': 'انضم إلى نقابة للتنافس مع الآخرين',
      'syndicates.browseCta': 'تصفح الفصائل',

      // شريط البيانات الحيوية
      'biometric.recovery': 'التعافي',
      'biometric.bodyBattery': 'طاقة الجسم',
      'biometric.hrv': 'تقلب معدل ضربات القلب',
      'biometric.hrvDelta': '{{delta}} من خط الأساس',
      'biometric.todayBadge': 'اليوم',
      'biometric.rest': 'يوم راحة',
      'biometric.moderate': 'متوسط',
      'biometric.intense': 'مكثّف',
      'biometric.consentRequired': 'الاتصال بـ Longevity',
      'biometric.consentRequiredDesc': 'فعّل الوصول للتمارين في إعدادات Longevity',
      'biometric.baselineNotSet': 'أكمل خط الأساس في Longevity',
      'biometric.offline': 'غير متصل',
      'biometric.demoData': 'بيانات تجريبية',
      'biometric.staleBadge': 'منذ {{minutes}} دقيقة',
      'biometric.connectCta': 'اتصال',
      'biometric.connectingFromYou': 'عرض في التمارين',

      // الإشعارات
      'notif.morning.title': 'صباح الخير!',
      'notif.morning.body': '{{companion}} جاهز للتدريب معك.',
      'notif.evening.title': 'هل تدربت اليوم؟',
      'notif.evening.body': 'حتى 10 دقائق تحافظ على سلسلتك.',
      'notif.streak.title': 'سلسلة {{streak}} يوم في خطر!',
      'notif.streak.body': 'تمرين مرونة سريع سيحافظ على سلسلتك.',
      'notif.companion.title': '{{companion}} هنا',
      'notif.companion.body': 'هل لديك وقت للتحرك اليوم؟',
      'notif.recovery.title': 'وضع التعافي نشط',
      'notif.recovery.body': 'يُنصح بـ NMN + المغنيسيوم بعد جلسة أمس المكثفة.',
      'notif.defaultCompanion': 'رفيقك',
      'notif.preprompt.title': 'ابقَ ثابتاً',
      'notif.preprompt.subtitle': 'تذكيرات يومية للالتزام — يمكنك إيقافها في أي وقت.',
      'notif.preprompt.benefit1': 'تحفيز صباحي لبداية يومك',
      'notif.preprompt.benefit2': 'حماية سلسلتك حتى لا تفقد تقدمك',
      'notif.preprompt.benefit3': 'تذكيرات التعافي بعد الجلسات الشاقة',
      'notif.preprompt.benefit4': 'رفيقك يتابعك مرة أو مرتين في الأسبوع',
      'notif.preprompt.allow': 'تفعيل الإشعارات',
      'notif.preprompt.skip': 'ليس الآن',
      'home.longevityId': 'معرّف طول العمر',
      'home.sleep': 'النوم',
      'home.water': 'الماء',
      'home.steps': 'الخطوات',
      'profile.activity': 'النشاط',
      'profile.emptyJourney': 'تبدأ رحلتك بتمرين واحد.',
      'profile.startNow': 'ابدأ الآن →',
      'profile.thisWeek': 'هذا الأسبوع',
      'profile.editProfileAria': 'تعديل الملف الشخصي',
      'profile.phoneCountryAria': 'رمز بلد الهاتف',
      'memory.energyPoints': 'نقاط الطاقة',
      'memory.uploadAria': 'تحميل ذاكرة',
      'calendar.synergy': 'تآزر',
      'calendar.today': 'اليوم',
      'biohacks.synergyBonus': 'مكافأة التآزر',
      'biohacks.synergyDesc': 'أكمل جميع البروتوكولات في فئة للحصول على مكافأة طاقة ×1.5',
      'shop.featured': 'مميّز',
      'syndicates.clanPower': 'قوة العشيرة',
      'biometric.alternatives': 'بدائل',
      'biometric.loadingAria': 'جارٍ تحميل البيانات الحيوية',
      'biometric.overviewAria': 'نظرة عامة حيوية من Longevity',
      'dragon.energy': 'الطاقة',
      'nav.openSettingsAria': 'فتح الإعدادات',
      'nav.dismissAria': 'إغلاق',
      'nav.moreOptionsAria': 'خيارات أكثر',
      'nav.closeMenuAria': 'إغلاق القائمة',
      'nav.primaryAria': 'التنقل الرئيسي',
      'nav.moreNavAria': 'خيارات تنقل إضافية',
      'common.copiedToClipboard': 'تم النسخ إلى الحافظة!',
      'paywall.noPreviousPurchase': 'لم يُعثر على عملية شراء سابقة. اشترك لفتح ميزات Pro.',
      'common.back': 'رجوع',
      'dragon.stage': 'مرحلة',
      'dragon.levelShort': 'مس.',
      'dragon.evolved': '!تطور',
      'dragon.evolving': '...يتطور',
      'dragon.feeding': '...يأكل',
      'dragon.notEnoughEnergy': 'طاقة غير كافية',
      'dragon.feedToEvolve': 'أطعم للتطور',
      'dragon.maxEvolution': 'تم الوصول إلى أقصى تطور',
      'dragon.elderFormUnlocked': 'أفاتار حكيم · تم فتح الشكل الإلهي',
      'dragon.stageName.initiate': 'مبتدئ',
      'dragon.stageName.apprentice': 'متدرب',
      'dragon.stageName.adept': 'ماهر',
      'dragon.stageName.warrior': 'محارب',
      'dragon.stageName.master': 'أستاذ',
      'dragon.stageName.grandmaster': 'أستاذ كبير',
      'dragon.stageName.elder': 'أفاتار حكيم',
      'syndicates.roleCommanderShort': 'قائد',
      'syndicates.roleOfficerShort': 'ضابط',
      'syndicates.kick': 'إخراج',
      'syndicates.overview': 'نظرة عامة',
      'syndicates.roster': 'القائمة',
      'syndicates.comms': 'محادثة',
      'syndicates.globalRankShort': 'عالمي',
      'syndicates.membersLabel': 'أعضاء',
      'syndicates.joinBattle': 'انضم للمعركة',
      'syndicates.globalRank': 'الترتيب العالمي',
      'syndicates.weeklyEp': 'نقاط أسبوعية',
      'syndicates.inviteRecruits': 'ادعُ مجندين',
      'syndicates.activeMembers': '{{count}} عضو نشط',
      'syndicates.epThisWeek': '{{ep}} نقطة هذا الأسبوع',
      'syndicates.clanChat': 'دردشة العشيرة',
      'syndicates.online': '{{count}} متصل',
      'leaderboard.dayStreak': 'سلسلة {{count}} يوم',
      'leaderboard.lvlShort': 'مس.',
      'calendar.weeklyEnergy': 'طاقة 7 أيام',
      'calendar.legendWorkout': 'تمرين',
      'calendar.legendPerfect': 'مثالي',
      'calendar.legendRest': 'راحة',
      'calendar.activityLog': 'سجل النشاط',
      'calendar.showAll': 'عرض الكل',
      'calendar.monthApr': 'أبر',
      'calendar.month.january': 'يناير',
      'calendar.month.february': 'فبراير',
      'calendar.month.march': 'مارس',
      'calendar.month.april': 'أبريل',
      'calendar.month.may': 'مايو',
      'calendar.month.june': 'يونيو',
      'calendar.month.july': 'يوليو',
      'calendar.month.august': 'أغسطس',
      'calendar.month.september': 'سبتمبر',
      'calendar.month.october': 'أكتوبر',
      'calendar.month.november': 'نوفمبر',
      'calendar.month.december': 'ديسمبر',
      'calendar.day.sun': 'أحد',
      'calendar.day.mon': 'إثن',
      'calendar.day.tue': 'ثلا',
      'calendar.day.wed': 'أرب',
      'calendar.day.thu': 'خمس',
      'calendar.day.fri': 'جمع',
      'calendar.day.sat': 'سبت',
      'biohacks.cat.sport': 'رياضة',
      'biohacks.cat.mind': 'العقل',
      'biohacks.cat.ascetic': 'نسك',
      'biohacks.progress': '{{done}}/{{total}} مكتمل',
      'biohacks.synergyX': 'x1.5 تآزر',
      'biohacks.diff.EASY': 'سهل',
      'biohacks.diff.MEDIUM': 'متوسط',
      'biohacks.diff.HARD': 'صعب',
      'biohacks.diff.LEGEND': 'أسطورة',
      'biohacks.proto.s1.name': 'الجري',
      'biohacks.proto.s1.desc': '30 دقيقة جري في الهواء الطلق',
      'biohacks.proto.s2.name': 'فنون قتالية',
      'biohacks.proto.s2.desc': 'جلسة ملاكمة أو فنون قتالية',
      'biohacks.proto.s3.name': 'مصنع الحديد',
      'biohacks.proto.s3.desc': 'جلسة تدريب بالأثقال',
      'biohacks.proto.s4.name': 'تدفق الماء',
      'biohacks.proto.s4.desc': 'السباحة 20 دقيقة+',
      'biohacks.proto.s5.name': 'بروتوكول المرونة',
      'biohacks.proto.s5.desc': 'الإطالة والحركة 15 دقيقة',
      'biohacks.proto.m1.name': 'تأمل',
      'biohacks.proto.m1.desc': '10 دقائق وعي ذهني',
      'biohacks.proto.m2.name': 'تنفس فيم هوف',
      'biohacks.proto.m2.desc': '3 جولات من التنفس',
      'biohacks.proto.m3.name': 'إبداع عصبي',
      'biohacks.proto.m3.desc': 'تصور إبداعي 10 دقائق',
      'biohacks.proto.m4.name': 'قراءة عميقة',
      'biohacks.proto.m4.desc': 'اقرأ 20 صفحة غير خيالية',
      'biohacks.proto.m5.name': 'تدوين يومي',
      'biohacks.proto.m5.desc': 'كتابة مدخل يومي',
      'biohacks.proto.a1.name': 'بلا كحول / بلا مخدرات',
      'biohacks.proto.a1.desc': 'ابقَ نظيفًا اليوم',
      'biohacks.proto.a2.name': 'وقود نظيف',
      'biohacks.proto.a2.desc': 'تناول الأطعمة الكاملة فقط',
      'biohacks.proto.a3.name': 'تخلص رقمي',
      'biohacks.proto.a3.desc': 'بلا وسائل تواصل 4 ساعات+',
      'biohacks.proto.a4.name': 'التعرض للبرد',
      'biohacks.proto.a4.desc': '2 دقيقة دش بارد',
      'biohacks.proto.a5.name': 'بروتوكول النوم',
      'biohacks.proto.a5.desc': 'في السرير قبل 10م، 7 ساعات+ نوم',
      'biohacks.mission.1': '100 تمرين ضغط في يوم',
      'biohacks.mission.2': 'بلانك 5 دقائق',
      'biohacks.mission.3': '10 آلاف خطوة',
      'biohacks.mission.4': 'أكمل جميع البروتوكولات',
      'biohacks.mission.5': 'سلسلة 7 أيام',
      'memory.timeAgoMin': 'منذ {{n}} د',
      'memory.timeAgoHour': 'منذ {{n}} س',
      'memory.timeAgoDay': 'منذ {{n}} يوم',
      'memory.lvlShort': 'مس',
      'memory.energyBoost': '{{amount}} تعزيز الطاقة',
      'memory.boostWithEnergy': 'ادعم بالطاقة',
      'memory.epMin': '10 EP',
      'memory.epMax': '2,000 EP',
      'memory.boostSent': '!تم إرسال الدعم',
      'companion.stage': 'مرحلة',
      'companion.evolved': 'تطور',
      'companion.xpProgress': 'تقدم XP',
      'companion.nextStage': 'المرحلة التالية',
      'companion.xpAmount': '{{n}} XP',
      'companion.maxEvolution': 'تم الوصول إلى أقصى تطور',
      // --- added: missing UI translations ---
      'biohacks.noneAvailable': 'تم الانضمام إلى الكل!',
      'biohacks.todayComplete': 'اليوم',
      'coach.chooseCoach': 'اختر مدربك',
      'coach.headphonesHint': 'استخدم سماعات الرأس للحصول على التأثير ثنائي الأذن الكامل',
      'coach.localGenerationHint': 'يُنشأ محليًا · لا يتطلب إنترنت · مجاني للأبد',
      'coach.musicNote': 'يُفتح في تطبيق الموسيقى المثبّت لديك أو المتصفح',
      'coach.sampleTitle': 'استمع إلى الصوت',
      'coach.settings': 'الإعدادات',
      'coach.soundscapeTitle': 'الأوضاع ثنائية الأذن',
      'coach.voiceEnabled': 'المدرب الصوتي',
      'coach.voiceEnabledDesc': 'إشارات صوتية أثناء التمارين',
      'coach.volume': 'مستوى الصوت',
      'login.appleError': 'فشل تسجيل الدخول عبر Apple',
      'login.continue': 'متابعة',
      'login.continueApple': 'المتابعة عبر Apple',
      'login.continueGoogle': 'المتابعة عبر Google',
      'login.email': 'البريد الإلكتروني',
      'login.emailLabel': 'عنوان البريد الإلكتروني',
      'login.emailPlaceholder': 'you@example.com',
      'login.googleError': 'فشل تسجيل الدخول عبر Google',
      'login.hidePassword': 'إخفاء كلمة المرور',
      'login.orContinueWith': 'أو',
      'login.password': 'كلمة المرور',
      'login.passwordMin': 'يجب أن تتكوّن كلمة المرور من 6 أحرف على الأقل',
      'login.passwordPlaceholder': 'كلمة المرور الخاصة بك',
      'login.phone': 'الهاتف',
      'login.privacyLink': 'سياسة الخصوصية',
      'login.showPassword': 'إظهار كلمة المرور',
      'login.signInError': 'فشل تسجيل الدخول',
      'login.signingIn': 'جارٍ تسجيل الدخول...',
      'login.terms': 'بالمتابعة فإنك توافق على',
      'login.termsLink': 'الشروط',
      'memory.boostAmount': 'مقدار التعزيز',
      'memory.comment': 'تعليق',
      'memory.emptyDesc': 'ستمتلئ خلاصتك كلما تدرّبت أنت وفريقك.',
      'memory.emptyTitle': 'لا يوجد نشاط بعد',
      'memory.like': 'إعجاب',
      'memory.share': 'مشاركة',
      'oracle.errAuth': 'فشلت مصادقة خدمة الذكاء الاصطناعي.',
      'oracle.errGeneric': 'تعذّر تحليل الصورة. حاول مرة أخرى بصورة أوضح.',
      'oracle.errLimit': 'تم بلوغ الحد اليومي للمسح. قم بالترقية للحصول على مسح غير محدود.',
      'oracle.errMissingKey': 'لم تُهيّأ خدمة الذكاء الاصطناعي. يرجى التواصل مع الدعم.',
      'oracle.errRate': 'الخدمة مشغولة. يرجى المحاولة بعد لحظات.',
      'oracle.unlimitedScans': 'مسح غير محدود',
      'paywall.everythingUnlocked': 'كل شيء مفتوح',
      'paywall.freeLaunchNote': 'جميع ميزات Pro مجانية خلال فترة الإطلاق.',
      'paywall.noCardNeeded': 'لا حاجة لبطاقة',
      'paywall.proFreeTitle': 'Pro — مجاني خلال الإطلاق',
      'paywall.unlockFree': 'افتح كل شيء — مجانًا',
      'paywall.whatsIncluded': 'ما المتضمَّن',
      'profile.noPrs': 'لا توجد أرقام قياسية شخصية بعد',
      'profile.noPrsDesc': 'ستظهر أفضل نتائجك كلما تدرّبت.',
      'progress.emptyCta': 'ابدأ تمرينًا',
      'progress.emptyDesc': 'أكمل تمرينك الأول لرؤية إحصاءاتك.',
      'progress.emptyTitle': 'يبدأ تقدّمك من هنا',
      'referral.copyLinkAria': 'نسخ رابط الإحالة',
      'referral.shareAria': 'مشاركة رابط الإحالة',
      'settings.cookies': 'سياسة ملفات تعريف الارتباط',
      'settings.deleteAccount': 'حذف الحساب',
      'settings.deleteAccountWarning': 'سيؤدي هذا إلى حذف حسابك وجميع بياناتك (التمارين، التقدّم، الملف الشخصي) نهائيًا. لا يمكن التراجع عن ذلك.',
      'settings.deleteConfirm': 'حذف',
      'settings.deleteError': 'تعذّر حذف الحساب. يرجى المحاولة مرة أخرى.',
      'settings.kvkk': 'KVKK / حماية البيانات',
      'settings.legalSupport': 'القانوني والدعم',
      'settings.privacy': 'سياسة الخصوصية',
      'settings.support': 'المساعدة والدعم',
      'settings.terms': 'شروط الخدمة',
      'shop.celliva.allProducts': 'الكتالوج الكامل',
      'shop.celliva.autonomousFulfillment': 'تلبية ذاتية',
      'shop.celliva.calibrationRecorded': 'تم تسجيل المعايرة. تم تحسين البروتوكول.',
      'shop.celliva.cart': 'السلة',
      'shop.celliva.closedLoopActive': 'الحلقة المغلقة نشطة',
      'shop.celliva.decrease': 'تقليل الكمية',
      'shop.celliva.depleteWarning': 'سينفد مخزونك من {{product}} خلال {{days}} يومًا.',
      'shop.celliva.details': 'التفاصيل',
      'shop.celliva.dismiss': 'إغلاق',
      'shop.celliva.dispensaryTitle': 'Celliva Dispensary',
      'shop.celliva.eliteRequired': 'يتطلب Elite',
      'shop.celliva.increase': 'زيادة الكمية',
      'shop.celliva.noChange': 'لا تغيير',
      'shop.celliva.outcomeDeepSleep': 'نوم عميق',
      'shop.celliva.predictiveEngine': 'محرك تنبؤي',
      'shop.celliva.protocolCalibration': 'معايرة البروتوكول',
      'shop.celliva.yesOptimal': 'نعم — مثالي',
      'shop.tabGameStore': 'متجر اللعبة',
      'shop.tabMarketplace': 'السوق',
      'shop.unlocked': 'تم فتح {{name}}!',
      'syndicates.createCta': 'إنشاء',
      'syndicates.namePlaceholder': 'اسم النقابة…',
      'syndicates.newClanDesc': 'نقابة جديدة جاهزة للصعود.',
      'syndicates.send': 'إرسال',
      'syndicates.tagPlaceholder': 'وسم (3–4 أحرف)',
      'workout.end': 'إنهاء',
      'workout.endWorkout': 'إنهاء التمرين',
      'workout.noResults': 'لم يتم العثور على تمارين',
      'workout.noResultsDesc': 'جرّب بحثًا أو فئة مختلفة.',

    },
  },

  id: {
    translation: {
      'settings.general': 'Umum',
      'settings.proActive': 'Pro Aktif',
      'settings.freeTrial': 'Uji Coba Gratis',
      'settings.allUnlocked': 'Semua fitur terbuka',
      'settings.upgradeFull': 'Tingkatkan untuk akses penuh',
      'settings.upgrade': 'Upgrade',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': 'Sinkronisasi Data',
      'settings.dataSyncDesc': 'Sinkronkan data kesehatan dengan ekosistem Omnisio',
      'settings.logout': 'Keluar',
      // App
      'app.name': 'Omnisio Workout',
      'app.tagline': 'Fitness Grup Pribadi',

      // Navigation
      'nav.home': 'Beranda',
      'nav.workout': 'Latihan',
      'nav.nutri': 'Nutrisi',
      'nav.history': 'Riwayat',
      'nav.memory': 'Kenangan',
      'nav.radio': 'Radio',
      'nav.shop': 'Toko',
      'nav.profile': 'Profil',
      'nav.more': 'Lainnya',
      'nav.coach': 'Pelatih',

      // Home
      'home.welcome': 'Selamat datang, {{name}}',
      'home.dailyEnergy': 'Energi Harian',
      'home.startWorkout': 'Mulai Latihan',
      'home.yourTotem': 'Maskot Kamu',
      'home.todaysMissions': 'Target Hari Ini',
      'home.leaderboard': 'Papan Peringkat',
      'home.syndicates': 'Tim',
      'home.biohacks': 'Tantangan',

      // Energy
      'energy.exercise': 'Olahraga',
      'energy.music': 'Musik',
      'energy.total': 'Total Energi',
      'energy.streak': '{{count}} hari beruntun',
      'energy.streakFire': 'Streak',

      // Workout
      'workout.title': 'Latihan',
      'workout.camera': 'Pelacakan Kamera',
      'workout.startSession': 'Mulai Sesi',
      'workout.endSession': 'Akhiri Sesi',
      'workout.reps': 'Repetisi',
      'workout.calories': 'Kalori',
      'workout.duration': 'Durasi',
      'workout.exerciseComplete': 'Latihan Selesai!',
      'workout.energyEarned': '+{{amount}} Energi',
      'workout.plank': 'Plank',
      'workout.pushups': 'Push-up',
      'workout.squats': 'Squat',
      'workout.overview': 'Ikhtisar',
      'workout.history': 'Riwayat',
      'workout.progress': 'Kemajuan',
      'workout.personalRecords': 'Rekor Pribadi',
      'workout.share': 'Bagikan',
      'workout.done': 'Selesai',

      // Oracle / Nutri Vision
      'oracle.title': 'Nutri Vision',
      'oracle.scan': 'Scan Makanan',
      'oracle.history': 'Riwayat Scan',
      'oracle.scanning': 'Menganalisis...',
      'oracle.dailyNorm': 'Norma Harian',
      'oracle.scansLeft': '{{count}} scan tersisa',
      'oracle.upgrade': 'Upgrade untuk tak terbatas',
      'oracle.protein': 'Protein',
      'oracle.carbs': 'Karbohidrat',
      'oracle.fat': 'Lemak',
      'oracle.calories': 'Kalori',

      // Memory
      'memory.title': 'Kenangan',
      'memory.upload': 'Unggah Kenangan',
      'memory.stake': 'Stake Energi',
      'memory.network': 'Jaringan Proof-of-Energy Global',

      // Calendar / History
      'calendar.title': 'Riwayat',
      'calendar.fitness': 'Fitness',
      'calendar.nutrition': 'Nutrisi',
      'calendar.protocols': 'Protokol',

      // Shop
      'shop.title': 'Toko',
      'shop.avatars': 'Avatar',
      'shop.boosters': 'Booster',
      'shop.cosmetics': 'Kosmetik',
      'shop.buy': 'Beli',
      'shop.price': '{{price}} TKN',
      'shop.owned': 'Dimiliki',
      'shop.equipped': 'Dipakai',

      // Profile
      'profile.title': 'Profil',
      'profile.level': 'Level {{level}}',
      'profile.totalWorkouts': 'Total Latihan',
      'profile.totalTokens': 'Total Token',
      'profile.achievements': 'Pencapaian',
      'profile.settings': 'Pengaturan',
      'profile.totem': 'Maskot',

      // Leaderboard
      'leaderboard.title': 'Papan Peringkat',
      'leaderboard.global': 'Global',
      'leaderboard.syndicate': 'Tim',
      'leaderboard.weekly': 'Mingguan',
      'leaderboard.allTime': 'Sepanjang Masa',
      'leaderboard.rank': 'Peringkat',

      // Syndicates/Teams
      'syndicates.title': 'Tim',
      'syndicates.join': 'Bergabung',
      'syndicates.create': 'Buat Tim',
      'syndicates.members': '{{count}} anggota',
      'syndicates.power': 'Kekuatan',

      // Biohacks/Challenges
      'biohacks.title': 'Tantangan',
      'biohacks.protocols': 'Program',
      'biohacks.missions': 'Target',
      'biohacks.active': 'Aktif',
      'biohacks.completed': 'Selesai',
      'biohacks.reward': 'Hadiah: {{amount}} TKN',

      // Avatar
      'avatar.title': 'Avatar',
      'avatar.customize': 'Kustomisasi',
      'avatar.skin': 'Tampilan',
      'avatar.outfit': 'Pakaian',
      'avatar.accessories': 'Aksesori',
      'avatar.save': 'Simpan',

      // Radio
      'radio.title': 'Gym Radio',
      'radio.nowPlaying': 'Sedang Diputar',
      'radio.stations': 'Stasiun',
      'radio.energyBonus': '+Energi saat mendengarkan',

      // Coach
      'coach.title': 'Pelatih',
      'coach.subtitle': 'Pendamping fitness AI di telingamu',
      'coach.tabVoice': 'Suara',
      'coach.tabSoundscape': 'Lanskap Suara',
      'coach.tabMusic': 'Musik',
      'coach.chooseVoice': 'Pilih suara pelatihmu',
      'coach.samples': 'Dengarkan contoh',
      'coach.samplePreWorkout': 'Sebelum latihan',
      'coach.sampleSetComplete': 'Set selesai',
      'coach.sampleHalfway': 'Setengah jalan',
      'coach.sampleFinalSet': 'Set terakhir',
      'coach.sampleWorkoutDone': 'Latihan selesai',
      'coach.voiceCoachToggle': 'Pelatih suara saat latihan',
      'coach.proRequired': 'Pro diperlukan untuk semua suara',
      'coach.upgrade': 'Tingkatkan',
      'coach.soundscapeFocus': 'Fokus',
      'coach.soundscapeFocusDesc': 'Gelombang alfa untuk konsentrasi mendalam',
      'coach.soundscapeCardio': 'Kardio',
      'coach.soundscapeCardioDesc': 'BPM tinggi untuk lari dan HIIT',
      'coach.soundscapeRecovery': 'Pemulihan',
      'coach.soundscapeRecoveryDesc': 'Ritme lambat untuk pendinginan',
      'coach.soundscapeSleep': 'Persiapan Tidur',
      'coach.soundscapeSleepDesc': 'Pink noise dan suara alam',
      'coach.soundscapeComingSoon': 'Segera hadir',
      'coach.musicHeader': 'Buka aplikasi musik favoritmu',
      'coach.musicSpotify': 'Buka di Spotify',
      'coach.musicApple': 'Buka di Apple Music',
      'coach.musicYoutube': 'Buka di YouTube Music',
      'coach.workoutPlaylist': 'Playlist latihan',

      // Settings
      'settings.title': 'Pengaturan',
      'settings.language': 'Bahasa',
      'settings.notifications': 'Notifikasi',
      'settings.sound': 'Suara',
      'settings.haptics': 'Haptics',
      'settings.about': 'Tentang',
      'settings.version': 'Versi',
      'settings.aiEngine': 'Mesin AI',
      'settings.wearables': 'Bio-Wearables',
      'settings.bioWearables': 'Bio-Wearables',
      'settings.omnisioBand': 'Omnisio Band',
      'settings.omnisioBandDesc': 'SDK Native · Biometrik real-time',
      'settings.omnisioRing': 'Omnisio Ring',
      'settings.omnisioRingDesc': 'SDK Native · Baterai 7 hari, tidur + HRV',
      'settings.thirdPartySync': 'Pihak ketiga · Hubungkan untuk sinkronisasi',
      'settings.dataSync': 'Sinkronisasi Data',
      'settings.upgrade': 'Upgrade',
      'settings.logout': 'Keluar',

      // Onboarding
      'onboarding.welcome': 'Selamat Datang di Omnisio Workout',
      'onboarding.subtitle': 'Perjalanan fitness pribadi kamu dimulai di sini',
      'onboarding.selectExercise': 'Pilih latihan pertama kamu',
      'onboarding.pushups': 'Push-up',
      'onboarding.squats': 'Squat',
      'onboarding.getStarted': 'Mulai',
      'onboarding.skip': 'Lewati',

      // Common
      'common.loading': 'Memuat...',
      'common.error': 'Terjadi kesalahan',
      'common.retry': 'Coba Lagi',
      'common.back': 'Kembali',
      'common.save': 'Simpan',
      'common.cancel': 'Batal',
      'common.confirm': 'Konfirmasi',
      'common.close': 'Tutup',
      'common.tokens': 'Token',
      'common.soon': 'Segera',
      'common.viewAll': 'Lihat semua',

      // Profile (extended)
      'profile.workouts': 'Latihan',
      'profile.hours': 'Jam',
      'profile.totalXP': 'Total XP',
      'profile.personalRecords': 'Rekor Pribadi',
      'profile.connectedServices': 'Layanan Terhubung',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': 'Terhubung',
      'profile.connect': 'Hubungkan',
      'profile.helpSupport': 'Bantuan & Dukungan',
      'profile.signOut': 'Keluar',
      'profile.contactShipping': 'Kontak & Pengiriman',
      'profile.complete': 'Lengkap',
      'profile.incompleteForOrders': 'Diperlukan untuk pesanan suplemen',
      'profile.email': 'Email',
      'profile.phone': 'Telepon',
      'profile.address': 'Alamat',
      'profile.country': 'Negara',
      'profile.addressPlaceholder': 'Jalan, Kota, Kode Pos',
      'profile.privacyNote': 'Info kontakmu disimpan lokal dan hanya dibagikan ke Celliva saat memesan. Sesuai KVKK/GDPR.',
      'profile.invalidEmail': 'Format email tidak valid',
      'profile.invalidPhone': 'Telepon terlalu pendek',
      'profile.invalidAddress': 'Alamat terlalu pendek',

      // Achievements
      'achievements.firstWorkout': 'Latihan Pertama',
      'achievements.sevenDayStreak': 'Streak 7 Hari',
      'achievements.plankMaster': 'Master Plank',
      'achievements.earlyBird': 'Bangun Pagi',
      'achievements.perfectionist': 'Perfeksionis',
      'achievements.hundredWorkouts': '100 Latihan',
      'achievements.marathon': 'Maraton',
      'achievements.nightOwl': 'Burung Hantu',

      // Shop (extended)
      'shop.subtitle': 'Buka pendamping, booster, dan perlengkapan',
      'shop.tabCompanions': 'Pendamping',
      'shop.tabBoosters': 'Booster',
      'shop.tabOutfits': 'Pakaian',
      'shop.tabThemes': 'Tema',
      'shop.free': 'Gratis',
      'shop.levelRequired': 'Butuh level {{level}}',
      'shop.unlockFor': 'Buka dengan {{price}} ⚡',
      'shop.insufficientXP': 'XP kurang (butuh {{price}} ⚡)',
      'shop.viewPack': 'Lihat Paket',
      'shop.recentActivity': 'Aktivitas terbaru',
      'shop.earnMoreXP': 'Dapatkan lebih banyak XP',
      'shop.completeWorkout': 'Selesaikan satu latihan',
      'shop.startWorkout': 'Mulai Latihan',
      'shop.tabSupplements': 'Suplemen',
      'shop.poweredByCelliva': 'Didukung oleh Celliva',
      'shop.cellivaTagline': 'Suplemen premium · Gratis ongkir di atas $50',
      'shop.buyOnCelliva': 'Beli di Celliva',
      'shop.supplementsHeader': 'Bahan bakar latihanmu',
      'shop.supplementsSubtitle': 'Teruji laboratorium, terverifikasi',

      // Celliva Dispensary
      'shop.celliva.title': 'Dispensari Celliva',
      'shop.celliva.eyebrow': 'Pengiriman Otomatis',
      'shop.celliva.tabMarketplace': 'Marketplace',
      'shop.celliva.tabGameStore': 'Toko Game',
      'shop.celliva.predictiveTitle': 'Mesin Prediktif',
      'shop.celliva.predictiveBody': 'Stok {{product}} kamu akan habis dalam {{days}} hari.',
      'shop.celliva.authorizeDispatch': 'Izinkan Pengiriman',
      'shop.celliva.calibrationTitle': 'Kalibrasi Protokol',
      'shop.celliva.calibrationQuestion': 'Apakah {{product}} meningkatkan {{outcome}} kamu?',
      'shop.celliva.calibrationYes': 'Ya — optimal',
      'shop.celliva.calibrationNo': 'Tidak ada perubahan',
      'shop.celliva.calibrationDismiss': 'Tutup',
      'shop.celliva.calibrationThanks': 'Kalibrasi tersimpan. Protokol diperhalus.',
      'shop.celliva.closedLoopTitle': 'Siklus Tertutup Aktif',
      'shop.celliva.closedLoopBody': 'Biomarker memberi umpan ke dispensari. Pemesanan ulang menyesuaikan data kamu.',
      'shop.celliva.targetedInterventions': 'Intervensi Terarah',
      'shop.celliva.viewDetails': 'Detail',
      'shop.celliva.hideDetails': 'Sembunyikan detail',
      'shop.celliva.dosage': 'Dosis',
      'shop.celliva.ingredients': 'Bahan',
      'shop.celliva.studies': 'Referensi klinis',
      'shop.celliva.addToCart': 'Tambah ke keranjang',
      'shop.celliva.inCart': 'Di keranjang ({{qty}})',
      'shop.celliva.checkout': 'Bayar di Celliva',
      'shop.celliva.cartEmpty': 'Keranjang kosong',
      'shop.celliva.cartTotal': 'Total',
      'shop.celliva.catLongevity': 'Umur Panjang',
      'shop.celliva.catCognitive': 'Kognitif',
      'shop.celliva.catRecovery': 'Pemulihan',
      'shop.celliva.catPerformance': 'Performa',
      'shop.celliva.catAll': 'Semua',
      'shop.celliva.downloadCatalog': 'Unduh katalog',
      'shop.celliva.bestseller': 'Terlaris',
      'shop.celliva.clinical': 'Klinis',
      'shop.celliva.verified': 'Terverifikasi lab',
      'shop.celliva.proRequired': 'Tier Pro membuka Smart Reorder dan Kalibrasi',
      'shop.celliva.eliteDnaBanner': 'Berdasarkan status APOE ε4 kamu, diprioritaskan untuk dukungan kognitif',
      'shop.celliva.kvkkNote': 'Data pengiriman hanya meninggalkan perangkat saat kamu memesan di Celliva.life.',

      // Rarity
      'rarity.common': 'Umum',
      'rarity.rare': 'Langka',
      'rarity.epic': 'Epik',
      'rarity.legendary': 'Legendaris',

      // Memory (extended)
      'memory.community': 'Komunitas',
      'memory.demoMode': 'Mode demo · Hubungkan Supabase untuk data nyata',
      'memory.boost': 'Boost',
      'memory.boostXPNote': '+10 XP karena posting energi',
      'memory.noPostsTitle': 'Belum ada postingan',
      'memory.noPostsDesc': 'Jadilah yang pertama membagikan latihanmu',
      'memory.allCaughtUp': 'Semua sudah dibaca',

      // Calendar (extended)
      'calendar.history': 'Riwayat',
      'calendar.workouts': 'Latihan',
      'calendar.kcal': 'kcal',
      'calendar.streak': 'Streak',
      'calendar.energy': 'Energi',
      'calendar.tabFitness': 'Fitness',
      'calendar.tabNutrition': 'Nutrisi',
      'calendar.tabProtocols': 'Protokol',
      'calendar.restDay': 'Hari istirahat',
      'calendar.restDayDesc': 'Tidak ada aktivitas tercatat. Setiap juara butuh pemulihan.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': 'DEFISIT KALORI',
      'oracle.alertLowProtein': 'PERINGATAN PROTEIN RENDAH',
      'oracle.alertPerfectDay': 'HARI SEMPURNA',
      'oracle.dailyCalories': 'Kalori harian',
      'oracle.tabScan': 'Pindai',
      'oracle.tabHistory': 'Riwayat',
      'oracle.tapToScan': 'Arahkan kamera ke makananmu dan tekan tombol di bawah',
      'oracle.freeScans': '{{used}}/{{max}} scan gratis',
      'oracle.upgradePro': 'Upgrade Pro',
      'oracle.scanFood': 'Pindai Makanan',
      'oracle.scanAgain': 'Pindai Lagi',
      'oracle.addToLog': 'Tambah ke Log Makanan',

      // Paywall
      'paywall.chooseLevel': 'Pilih levelmu',
      'paywall.restorePurchase': 'Pulihkan Pembelian',
      'paywall.maybeLater': 'Mungkin Nanti',

      // Workout (extended)
      'workout.searchPlaceholder': 'Cari olahraga...',
      'workout.musclesWorked': 'Otot yang Bekerja',
      'workout.primary': 'Utama',
      'workout.secondary': 'Sekunder',
      'workout.exercises': 'Latihan',
      'workout.warmUp': 'Pemanasan',
      'workout.coolDown': 'Pendinginan',
      'workout.startCTA': 'Mulai {{sport}} {{level}}',
      'workout.rest': 'Istirahat',
      'workout.skipRest': 'Lewati istirahat',
      'workout.upNext': 'Selanjutnya',
      'workout.setOf': 'Set {{current}} dari {{total}}',
      'workout.formTips': 'Tips Teknik',
      'workout.resume': 'Lanjutkan',
      'workout.pause': 'Jeda',
      'workout.skip': 'Lewati',
      'workout.complete': 'Latihan selesai',
      'workout.sets': 'Set',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': 'Berikutnya: {{exercise}}. {{tip}}',
      'coach.formReminder': 'Periksa bentuk: {{tip}}',
    },
  },

  ko: {
    translation: {
      'settings.general': '일반',
      'settings.proActive': 'Pro 활성',
      'settings.freeTrial': '무료 체험',
      'settings.allUnlocked': '모든 기능 잠금 해제',
      'settings.upgradeFull': '전체 액세스로 업그레이드',
      'settings.upgrade': '업그레이드',
      'settings.longevityOS': 'Omnisio Longevity OS',
      'settings.dataSync': '데이터 동기화',
      'settings.dataSyncDesc': 'Omnisio 생태계와 건강 데이터 동기화',
      'settings.logout': '로그아웃',
      // App
      'app.name': 'Omnisio Workout',
      'app.tagline': '프라이빗 그룹 피트니스',

      // Navigation
      'nav.home': '홈',
      'nav.workout': '운동',
      'nav.nutri': '영양',
      'nav.history': '기록',
      'nav.memory': '추억',
      'nav.radio': '라디오',
      'nav.shop': '상점',
      'nav.profile': '프로필',
      'nav.more': '더보기',
      'nav.coach': '코치',

      // Home
      'home.welcome': '환영합니다, {{name}}',
      'home.dailyEnergy': '일일 에너지',
      'home.startWorkout': '운동 시작',
      'home.yourTotem': '나의 마스코트',
      'home.todaysMissions': '오늘의 목표',
      'home.leaderboard': '리더보드',
      'home.syndicates': '팀',
      'home.biohacks': '챌린지',

      // Energy
      'energy.exercise': '운동',
      'energy.music': '음악',
      'energy.total': '총 에너지',
      'energy.streak': '{{count}}일 연속',
      'energy.streakFire': '스트릭',

      // Workout
      'workout.title': '운동',
      'workout.camera': '카메라 트래킹',
      'workout.startSession': '세션 시작',
      'workout.endSession': '세션 종료',
      'workout.reps': '횟수',
      'workout.calories': '칼로리',
      'workout.duration': '지속 시간',
      'workout.exerciseComplete': '운동 완료!',
      'workout.energyEarned': '+{{amount}} 에너지',
      'workout.plank': '플랭크',
      'workout.pushups': '푸시업',
      'workout.squats': '스쿼트',
      'workout.overview': '개요',
      'workout.history': '기록',
      'workout.progress': '진행상황',
      'workout.personalRecords': '개인 기록',
      'workout.share': '공유',
      'workout.done': '완료',

      // Oracle / Nutri Vision
      'oracle.title': 'Nutri Vision',
      'oracle.scan': '음식 스캔',
      'oracle.history': '스캔 기록',
      'oracle.scanning': '분석 중...',
      'oracle.dailyNorm': '일일 기준량',
      'oracle.scansLeft': '{{count}}회 스캔 남음',
      'oracle.upgrade': '무제한 업그레이드',
      'oracle.protein': '단백질',
      'oracle.carbs': '탄수화물',
      'oracle.fat': '지방',
      'oracle.calories': '칼로리',

      // Memory
      'memory.title': '추억',
      'memory.upload': '추억 업로드',
      'memory.stake': '에너지 스테이킹',
      'memory.network': '글로벌 에너지 증명 네트워크',

      // Calendar / History
      'calendar.title': '기록',
      'calendar.fitness': '피트니스',
      'calendar.nutrition': '영양',
      'calendar.protocols': '프로토콜',

      // Shop
      'shop.title': '상점',
      'shop.avatars': '아바타',
      'shop.boosters': '부스터',
      'shop.cosmetics': '코스메틱',
      'shop.buy': '구매',
      'shop.price': '{{price}} TKN',
      'shop.owned': '보유 중',
      'shop.equipped': '착용 중',

      // Profile
      'profile.title': '프로필',
      'profile.level': '레벨 {{level}}',
      'profile.totalWorkouts': '총 운동 횟수',
      'profile.totalTokens': '총 토큰',
      'profile.achievements': '업적',
      'profile.settings': '설정',
      'profile.totem': '마스코트',

      // Leaderboard
      'leaderboard.title': '리더보드',
      'leaderboard.global': '글로벌',
      'leaderboard.syndicate': '팀',
      'leaderboard.weekly': '주간',
      'leaderboard.allTime': '전체 기간',
      'leaderboard.rank': '순위',

      // Syndicates/Teams
      'syndicates.title': '팀',
      'syndicates.join': '참가',
      'syndicates.create': '팀 만들기',
      'syndicates.members': '{{count}}명',
      'syndicates.power': '파워',

      // Biohacks/Challenges
      'biohacks.title': '챌린지',
      'biohacks.protocols': '프로그램',
      'biohacks.missions': '목표',
      'biohacks.active': '진행 중',
      'biohacks.completed': '완료됨',
      'biohacks.reward': '보상: {{amount}} TKN',

      // Avatar
      'avatar.title': '아바타',
      'avatar.customize': '커스터마이즈',
      'avatar.skin': '스킨',
      'avatar.outfit': '의상',
      'avatar.accessories': '액세서리',
      'avatar.save': '저장',

      // Radio
      'radio.title': 'Gym 라디오',
      'radio.nowPlaying': '재생 중',
      'radio.stations': '방송국',
      'radio.energyBonus': '청취 중 +에너지',

      // Coach
      'coach.title': '코치',
      'coach.subtitle': '귓가에 AI 피트니스 동반자',
      'coach.tabVoice': '음성',
      'coach.tabSoundscape': '사운드스케이프',
      'coach.tabMusic': '음악',
      'coach.chooseVoice': '코치 음성 선택',
      'coach.samples': '샘플 듣기',
      'coach.samplePreWorkout': '운동 전',
      'coach.sampleSetComplete': '세트 완료',
      'coach.sampleHalfway': '절반',
      'coach.sampleFinalSet': '마지막 세트',
      'coach.sampleWorkoutDone': '운동 완료',
      'coach.voiceCoachToggle': '운동 중 음성 코치',
      'coach.proRequired': '모든 음성에는 Pro 필요',
      'coach.upgrade': '업그레이드',
      'coach.soundscapeFocus': '집중',
      'coach.soundscapeFocusDesc': '깊은 집중을 위한 알파파',
      'coach.soundscapeCardio': '카디오',
      'coach.soundscapeCardioDesc': '달리기와 HIIT를 위한 높은 BPM',
      'coach.soundscapeRecovery': '회복',
      'coach.soundscapeRecoveryDesc': '쿨다운과 스트레칭을 위한 느린 리듬',
      'coach.soundscapeSleep': '수면 준비',
      'coach.soundscapeSleepDesc': '핑크 노이즈와 자연 소리',
      'coach.soundscapeComingSoon': '곧 출시',
      'coach.musicHeader': '좋아하는 음악 앱 열기',
      'coach.musicSpotify': 'Spotify에서 열기',
      'coach.musicApple': 'Apple Music에서 열기',
      'coach.musicYoutube': 'YouTube Music에서 열기',
      'coach.workoutPlaylist': '운동 플레이리스트',

      // Settings
      'settings.title': '설정',
      'settings.language': '언어',
      'settings.notifications': '알림',
      'settings.sound': '사운드',
      'settings.haptics': '햅틱',
      'settings.about': '정보',
      'settings.version': '버전',
      'settings.aiEngine': 'AI 엔진',
      'settings.wearables': '바이오 웨어러블',
      'settings.bioWearables': '바이오 웨어러블',
      'settings.omnisioBand': '옴니시오 밴드',
      'settings.omnisioBandDesc': '네이티브 SDK · 실시간 생체 측정',
      'settings.omnisioRing': '옴니시오 링',
      'settings.omnisioRingDesc': '네이티브 SDK · 7일 배터리, 수면 + HRV',
      'settings.thirdPartySync': '타사 · 동기화하려면 연결',
      'settings.dataSync': '데이터 동기화',
      'settings.upgrade': '업그레이드',
      'settings.logout': '로그아웃',

      // Onboarding
      'onboarding.welcome': 'Omnisio Workout에 오신 것을 환영합니다',
      'onboarding.subtitle': '나만의 그룹 피트니스 여정이 여기서 시작됩니다',
      'onboarding.selectExercise': '첫 번째 운동을 선택하세요',
      'onboarding.pushups': '푸시업',
      'onboarding.squats': '스쿼트',
      'onboarding.getStarted': '시작하기',
      'onboarding.skip': '건너뛰기',

      // Common
      'common.loading': '로딩 중...',
      'common.error': '오류가 발생했습니다',
      'common.retry': '다시 시도',
      'common.back': '뒤로',
      'common.save': '저장',
      'common.cancel': '취소',
      'common.confirm': '확인',
      'common.close': '닫기',
      'common.tokens': '토큰',
      'common.soon': '곧 출시',
      'common.viewAll': '전체 보기',

      // Profile (extended)
      'profile.workouts': '운동',
      'profile.hours': '시간',
      'profile.totalXP': '총 XP',
      'profile.personalRecords': '개인 기록',
      'profile.connectedServices': '연결된 서비스',
      'profile.appleHealth': 'Apple Health',
      'profile.healthConnect': 'Health Connect',
      'profile.longevityOS': 'Longevity OS',
      'profile.connected': '연결됨',
      'profile.connect': '연결',
      'profile.helpSupport': '도움말 및 지원',
      'profile.signOut': '로그아웃',
      'profile.contactShipping': '연락처 및 배송',
      'profile.complete': '완료',
      'profile.incompleteForOrders': '보충제 주문에 필요',
      'profile.email': '이메일',
      'profile.phone': '전화',
      'profile.address': '주소',
      'profile.country': '국가',
      'profile.addressPlaceholder': '거리, 도시, 우편번호',
      'profile.privacyNote': '연락처 정보는 로컬에 저장되며 주문 시에만 Celliva와 공유됩니다. KVKK/GDPR 준수.',
      'profile.invalidEmail': '잘못된 이메일 형식',
      'profile.invalidPhone': '전화번호가 너무 짧음',
      'profile.invalidAddress': '주소가 너무 짧음',

      // Achievements
      'achievements.firstWorkout': '첫 운동',
      'achievements.sevenDayStreak': '7일 연속',
      'achievements.plankMaster': '플랭크 마스터',
      'achievements.earlyBird': '아침형 인간',
      'achievements.perfectionist': '완벽주의자',
      'achievements.hundredWorkouts': '100회 운동',
      'achievements.marathon': '마라톤',
      'achievements.nightOwl': '올빼미',

      // Shop (extended)
      'shop.subtitle': '동반자, 부스터, 장비를 잠금 해제하세요',
      'shop.tabCompanions': '동반자',
      'shop.tabBoosters': '부스터',
      'shop.tabOutfits': '의상',
      'shop.tabThemes': '테마',
      'shop.free': '무료',
      'shop.levelRequired': '레벨 {{level}} 필요',
      'shop.unlockFor': '{{price}} ⚡로 잠금 해제',
      'shop.insufficientXP': 'XP 부족 ({{price}} ⚡ 필요)',
      'shop.viewPack': '팩 보기',
      'shop.recentActivity': '최근 활동',
      'shop.earnMoreXP': 'XP 더 얻기',
      'shop.completeWorkout': '운동을 완료하세요',
      'shop.startWorkout': '운동 시작',
      'shop.tabSupplements': '보충제',
      'shop.poweredByCelliva': 'Celliva 제공',
      'shop.cellivaTagline': '프리미엄 보충제 · $50 이상 무료 배송',
      'shop.buyOnCelliva': 'Celliva에서 구매',
      'shop.supplementsHeader': '훈련에 연료를',
      'shop.supplementsSubtitle': '실험실 테스트, 제3자 검증',

      // Celliva Dispensary
      'shop.celliva.title': 'Celliva 디스펜서리',
      'shop.celliva.eyebrow': '자율 공급',
      'shop.celliva.tabMarketplace': '마켓플레이스',
      'shop.celliva.tabGameStore': '게임 스토어',
      'shop.celliva.predictiveTitle': '예측 엔진',
      'shop.celliva.predictiveBody': '{{product}} 재고가 {{days}}일 후 소진됩니다.',
      'shop.celliva.authorizeDispatch': '발송 승인',
      'shop.celliva.calibrationTitle': '프로토콜 보정',
      'shop.celliva.calibrationQuestion': '{{product}}가 {{outcome}}을 개선했나요?',
      'shop.celliva.calibrationYes': '예 — 최적',
      'shop.celliva.calibrationNo': '변화 없음',
      'shop.celliva.calibrationDismiss': '닫기',
      'shop.celliva.calibrationThanks': '보정이 기록되었습니다. 프로토콜이 정밀해졌습니다.',
      'shop.celliva.closedLoopTitle': '폐쇄 루프 활성',
      'shop.celliva.closedLoopBody': '생체 지표가 디스펜서리를 구동합니다. 재주문이 데이터에 맞게 조정됩니다.',
      'shop.celliva.targetedInterventions': '표적 개입',
      'shop.celliva.viewDetails': '세부 정보',
      'shop.celliva.hideDetails': '세부 정보 숨기기',
      'shop.celliva.dosage': '용량',
      'shop.celliva.ingredients': '성분',
      'shop.celliva.studies': '임상 참고문헌',
      'shop.celliva.addToCart': '장바구니에 추가',
      'shop.celliva.inCart': '장바구니 ({{qty}})',
      'shop.celliva.checkout': 'Celliva에서 결제',
      'shop.celliva.cartEmpty': '장바구니가 비어 있습니다',
      'shop.celliva.cartTotal': '합계',
      'shop.celliva.catLongevity': '장수',
      'shop.celliva.catCognitive': '인지',
      'shop.celliva.catRecovery': '회복',
      'shop.celliva.catPerformance': '퍼포먼스',
      'shop.celliva.catAll': '전체',
      'shop.celliva.downloadCatalog': '카탈로그 다운로드',
      'shop.celliva.bestseller': '베스트셀러',
      'shop.celliva.clinical': '임상',
      'shop.celliva.verified': '실험실 검증',
      'shop.celliva.proRequired': 'Pro 등급이 스마트 재주문 및 보정을 잠금 해제합니다',
      'shop.celliva.eliteDnaBanner': 'APOE ε4 상태를 기반으로 인지 지원을 위해 우선순위 지정됨',
      'shop.celliva.kvkkNote': '배송 데이터는 Celliva.life에서 주문할 때만 기기에서 전송됩니다.',

      // Rarity
      'rarity.common': '일반',
      'rarity.rare': '희귀',
      'rarity.epic': '에픽',
      'rarity.legendary': '전설',

      // Memory (extended)
      'memory.community': '커뮤니티',
      'memory.demoMode': '데모 모드 · 실제 데이터를 위해 Supabase 연결',
      'memory.boost': '부스트',
      'memory.boostXPNote': '에너지 게시 시 +10 XP',
      'memory.noPostsTitle': '아직 게시물이 없습니다',
      'memory.noPostsDesc': '운동을 가장 먼저 공유해보세요',
      'memory.allCaughtUp': '모두 확인했습니다',

      // Calendar (extended)
      'calendar.history': '기록',
      'calendar.workouts': '운동',
      'calendar.kcal': 'kcal',
      'calendar.streak': '연속',
      'calendar.energy': '에너지',
      'calendar.tabFitness': '피트니스',
      'calendar.tabNutrition': '영양',
      'calendar.tabProtocols': '프로토콜',
      'calendar.restDay': '휴식일',
      'calendar.restDayDesc': '활동이 기록되지 않았습니다. 모든 챔피언에게는 회복이 필요합니다.',

      // Oracle (extended)
      'oracle.alertCalorieDeficit': '칼로리 부족',
      'oracle.alertLowProtein': '단백질 부족 경고',
      'oracle.alertPerfectDay': '완벽한 하루',
      'oracle.dailyCalories': '일일 칼로리',
      'oracle.tabScan': '스캔',
      'oracle.tabHistory': '기록',
      'oracle.tapToScan': '카메라를 음식에 향하게 하고 아래 버튼을 누르세요',
      'oracle.freeScans': '무료 스캔 {{used}}/{{max}}',
      'oracle.upgradePro': 'Pro 업그레이드',
      'oracle.scanFood': '음식 스캔',
      'oracle.scanAgain': '다시 스캔',
      'oracle.addToLog': '식단 일지에 추가',

      // Paywall
      'paywall.chooseLevel': '레벨을 선택하세요',
      'paywall.restorePurchase': '구매 복원',
      'paywall.maybeLater': '나중에',

      // Workout (extended)
      'workout.searchPlaceholder': '스포츠 검색...',
      'workout.musclesWorked': '사용된 근육',
      'workout.primary': '주요',
      'workout.secondary': '보조',
      'workout.exercises': '운동',
      'workout.warmUp': '워밍업',
      'workout.coolDown': '쿨다운',
      'workout.startCTA': '{{level}} {{sport}} 시작',
      'workout.rest': '휴식',
      'workout.skipRest': '휴식 건너뛰기',
      'workout.upNext': '다음',
      'workout.setOf': '세트 {{current}} / {{total}}',
      'workout.formTips': '자세 팁',
      'workout.resume': '재개',
      'workout.pause': '일시정지',
      'workout.skip': '건너뛰기',
      'workout.complete': '운동 완료',
      'workout.sets': '세트',

      // Voice coach — dynamic form cue wrappers
      'coach.nextExercise': '다음: {{exercise}}. {{tip}}',
      'coach.formReminder': '자세 확인: {{tip}}',
    },
  },
};

// Public language list (May 2026 trim — ID/KO removed).
// Translation resources for ID/KO remain in `resources` so we can re-enable
// without re-translating; just add them back here + supportedLngs.
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'ru', label: 'Русский' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'ar', label: 'العربية' },
];

// One-time migration: clear cached language if it's no longer supported
// (e.g. user previously had id/ko selected in older build).
try {
  const cached = localStorage.getItem('i18nextLng');
  if (cached && !['en', 'tr', 'ru', 'de', 'es', 'ar'].includes(cached.split('-')[0].toLowerCase())) {
    localStorage.removeItem('i18nextLng');
  }
} catch (_) { /* localStorage unavailable */ }

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'tr', 'ru', 'de', 'es', 'ar'],
    nonExplicitSupportedLngs: true, // tr-TR -> tr, de-AT -> de, etc.
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      // Strip locale region (en-GB → en, de-AT → de) before matching against
      // supportedLngs so device-language detection works for any region.
      convertDetectedLanguage: (lng) => (lng || 'en').split('-')[0].toLowerCase(),
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Sync <html lang> and dir with i18n language
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Set initial lang/dir
document.documentElement.lang = i18n.language || 'en';
document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';

export default i18n;
